/* eslint-disable eqeqeq */
/* eslint-disable default-case */
/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-concat */
/* eslint-disable no-eval */
import $ from "jquery";
import React from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import admin, { getEntities, getProductionLine, colors, getNameForQuantity, menuItemReferences, getMenuItemById, getMenuCategoryById, addMenuItem, getFeature, hasRole, getMenuItem } from "../admin";
import { I18n } from "react-redux-i18n";
import SortedSet from "js-sorted-set";
import auth, { choiceDialog2, featureEnabled, getLocale, post, messageDialog, get, ajaxCallStart, ajaxCallEnd, _floatTableHead, _unfloatTableHead, getLocale2, touchStart, settingEnabled, confirmDialog, getImageById, getGlobal, startpoll, choiceDialog, _log, getInputDialog } from "../auth";
import { formatChangeField, formatChangeValue, formatModifier, formatModifierOption, formatEntityName } from "./menuChangeFormat";
import utils from "../menuitem-utils";
import Cleave from "cleave.js";
import { saveAs } from "file-saver";
import { crop, onPhotoDataSuccess } from "../camera-util";
import Chart from "chart.js";
import "bootstrap-colorpicker";
import { tmplparams } from "../order-list-util";
import { orderMenuItem } from "../orderMenuItem";
import { createTree } from "jquery.fancytree";
import removeAccents from "remove-accents";
import JsBarcode from "jsbarcode";
import Color from "color";
import languages from "../../langs/languages";
import MenuItemGraph from "../../main/menuItemGraph/MenuItemGraph";
import CategoryTemplate from "../../components/CategoryTemplate";
import { store } from "../..";
import EatWithMeActions from "../../actions/EatWithMeActions";
import { type } from "@linways/table-to-excel";
import CategoryList from "../../components/CategoryList";
import { getInventoryQuantity } from "./stocklist";
import { truncateSync } from "fs";
const { admin_local } = languages;

const menuitemAutomationFallback = {
  bindAutomationActionLogger: () => { },
  initializeAutomationValueAttributes: () => { },
  toggleRecording: () => false,
  startRecording: () => false,
  stopRecording: () => false,
  replayRecording: () => false,
  getActions: () => [],
  openWorkflowWizardFromMenuEditor: () => { },
  closeWorkflowWizardFromMenuEditor: () => { },
  consumeWorkflowWizardReopenOnMenuEditorEnter: () => false
};

let menuitemAutomationRuntime = menuitemAutomationFallback;
let menuitemAutomationRuntimePromise = null;

function isNativeMobilePlatform() {
  const platform = (auth?.device?.platform || "").toString().toLowerCase();
  if (platform === "ios" || platform === "android") {
    return true;
  }

  if (typeof navigator !== "undefined") {
    const ua = (navigator.userAgent || "").toLowerCase();
    if (/iphone|ipad|ipod|android/.test(ua)) {
      return true;
    }
  }

  return false;
}

function canLoadMenuitemAutomationRuntime() {
  return !isNativeMobilePlatform();
}

function getMenuitemAutomationRuntime() {
  if (!canLoadMenuitemAutomationRuntime()) {
    return Promise.resolve(menuitemAutomationRuntime);
  }

  if (menuitemAutomationRuntimePromise) {
    return menuitemAutomationRuntimePromise;
  }

  menuitemAutomationRuntimePromise = import("./menuitem_automation")
    .then(mod => {
      menuitemAutomationRuntime = {
        bindAutomationActionLogger: mod.bindAutomationActionLogger || menuitemAutomationFallback.bindAutomationActionLogger,
        initializeAutomationValueAttributes: mod.initializeAutomationValueAttributes || menuitemAutomationFallback.initializeAutomationValueAttributes,
        toggleRecording: mod.toggleRecording || menuitemAutomationFallback.toggleRecording,
        startRecording: mod.startRecording || menuitemAutomationFallback.startRecording,
        stopRecording: mod.stopRecording || menuitemAutomationFallback.stopRecording,
        replayRecording: mod.replayRecording || menuitemAutomationFallback.replayRecording,
        getActions: mod.getActions || menuitemAutomationFallback.getActions,
        openWorkflowWizardFromMenuEditor: mod.openWorkflowWizardFromMenuEditor || menuitemAutomationFallback.openWorkflowWizardFromMenuEditor,
        closeWorkflowWizardFromMenuEditor: mod.closeWorkflowWizardFromMenuEditor || menuitemAutomationFallback.closeWorkflowWizardFromMenuEditor,
        consumeWorkflowWizardReopenOnMenuEditorEnter: mod.consumeWorkflowWizardReopenOnMenuEditorEnter || menuitemAutomationFallback.consumeWorkflowWizardReopenOnMenuEditorEnter
      };
      return menuitemAutomationRuntime;
    })
    .catch(() => menuitemAutomationRuntime);

  return menuitemAutomationRuntimePromise;
}

function invokeMenuitemAutomation(methodName, args = []) {
  const immediate = menuitemAutomationRuntime && typeof menuitemAutomationRuntime[methodName] === "function"
    ? menuitemAutomationRuntime[methodName]
    : null;
  if (immediate && menuitemAutomationRuntime !== menuitemAutomationFallback) {
    return immediate(...args);
  }

  if (!canLoadMenuitemAutomationRuntime()) {
    const fallbackFn = menuitemAutomationFallback[methodName];
    return typeof fallbackFn === "function" ? fallbackFn(...args) : undefined;
  }

  getMenuitemAutomationRuntime().then(runtime => {
    const fn = runtime && typeof runtime[methodName] === "function" ? runtime[methodName] : null;
    if (fn) {
      fn(...args);
    }
  });

  const fallbackFn = menuitemAutomationFallback[methodName];
  return typeof fallbackFn === "function" ? fallbackFn(...args) : undefined;
}

function darken(color, ratio) {
  return new Color(color).darken(ratio);
}

function isNightMode() {
  return localStorage.daynight === "true";
}

function invertChartColor(color) {
  try {
    const normalized = color && typeof color === "object" && typeof color.string === "function"
      ? color.string()
      : color;
    const parsed = new Color(normalized);
    return new Color({
      r: 255 - parsed.red(),
      g: 255 - parsed.green(),
      b: 255 - parsed.blue()
    }).alpha(parsed.alpha()).rgb().string();
  } catch (e) {
    return color;
  }
}

function invertChartColorValue(value) {
  if (Array.isArray(value)) {
    return value.map(v => invertChartColorValue(v));
  }
  return invertChartColor(value);
}

function applyNightChartDatasetColors(datasets) {
  if (!isNightMode()) {
    return;
  }
  datasets.forEach(dataset => {
    ["backgroundColor", "borderColor", "pointBorderColor", "pointBackgroundColor", "hoverBackgroundColor", "hoverBorderColor"].forEach(prop => {
      if (typeof dataset[prop] !== "undefined") {
        dataset[prop] = invertChartColorValue(dataset[prop]);
      }
    });
  });
}

const menuitemSections = [
  { id: "settings", selector: "#menuitem-settings-section" },
  { id: "details", selector: "#menuitem-details-section" },
  { id: "pictures", selector: "#menuitem-pictures-section" },
  { id: "pricing", selector: "#menuitem-pricing-section" },
  { id: "quantities", selector: "#menuitem-quantities-section" },
  { id: "recipes", selector: "#menuitem-recipes-section" },
  { id: "excerpt", selector: "#menuitem-excerpt-section" },
  { id: "links", selector: "#menuitem-links-section" },
  { id: "history", selector: "#menuitem-history-section" }
];

const menucategorySections = [
  { id: "settings", selector: "#menucategory-settings-section" },
  { id: "details", selector: "#menucategory-details-section" },
  { id: "pictures", selector: "#menucategory-pictures-section" },
  { id: "pricing", selector: "#menucategory-pricing-section" },
  { id: "recipes", selector: "#menucategory-recipes-section" },
  { id: "links", selector: "#menucategory-links-section" },
  { id: "history", selector: "#menucategory-history-section" }
];

function applyColorSelection(modal, color) {
  const normalized = (color || "").toString().toLowerCase();
  const colorContainer = modal.find("#color").first();
  const swatches = colorContainer.find(".menuitem-color-swatch");

  colorContainer.find("input#color").val(normalized || "#ffffff");
  colorContainer.find("input#colorCheckbox").prop("checked", !!normalized);
  colorContainer.find("input#colorCheckbox").val(normalized || "#ffffff");

  swatches.removeClass("active");
  const selected = swatches.filter(function () {
    return (($(this).data("color") || "").toString().toLowerCase() === normalized);
  }).first();
  if (selected.length) {
    selected.addClass("active");
  } else {
    swatches.filter("[data-color='']").first().addClass("active");
  }

  modal.find(".modal-content").css("background-color", normalized || "");
}

function bindColorPalette(modal) {
  modal.off("click.menuitemColorPalette", ".menuitem-color-swatch").on("click.menuitemColorPalette", ".menuitem-color-swatch", function () {
    const selectedColor = (($(this).data("color") || "").toString() || "").toLowerCase();
    applyColorSelection(modal, selectedColor || null);
  });
}

function getLocalizedNameFromInputs(modal, inputPrefix) {
  const nameMap = {};
  (auth.myStatus.restaurant_languages || []).forEach(lang => {
    const value = (modal.find(inputPrefix + lang).val() || "").toString().trim();
    if (value) {
      nameMap[lang] = value;
    }
  });
  const allValue = (modal.find(inputPrefix + "all").val() || "").toString().trim();
  if (allValue) {
    nameMap.all = allValue;
  }
  return nameMap;
}

function wrapTokenizerLabelText(label) {
  return "<text>" + (label == null ? "" : String(label)) + "</text>";
}

function getUpsellMenuItemOptions(base = admin.adminCategories) {
  const options = [];
  const visitedMenuItems = new Set();
  const visitedCategories = new Set();

  const visitNodes = nodes => {
    if (!Array.isArray(nodes)) {
      return;
    }

    nodes.forEach(node => {
      if (!node || !node.id) {
        return;
      }

      const isCategory = (node.entityType || "").toString().toLowerCase().indexOf("category") >= 0
        || typeof node.activeMenuCategories !== "undefined"
        || typeof node.activeMenuItems !== "undefined"
        || Array.isArray(node.children);

      if (isCategory) {
        if (visitedCategories.has(node.id)) {
          return;
        }
        visitedCategories.add(node.id);

        let text = "";
        try {
          text = menuitemutil._getPath(node, base) || getLocale(node.name) || String(node.id);
        } catch (e) {
          text = getLocale(node.name) || String(node.id);
        }
        options.push({
          id: "menuCategory:" + String(node.id),
          value: "menuCategory;-2;" + node.id + ";;" + (node.entityType || (menuitemutil.entityType + "Category")).toLowerCase(),
          text,
          clazz: "category"
        });
      }

      if (!isCategory) {
        if (visitedMenuItems.has(node.id)) {
          return;
        }
        visitedMenuItems.add(node.id);

        let text = "";
        try {
          text = menuitemutil._getPath(node, base) || getLocale(node.name) || String(node.id);
        } catch (e) {
          text = getLocale(node.name) || String(node.id);
        }
        const quantity = Array.isArray(node.availableQuantities) && node.availableQuantities.length && Number(node.availableQuantities[0].quantity)
          ? Number(node.availableQuantities[0].quantity)
          : 1;
        options.push({
          id: String(node.id),
          value: "menuItem;-1;" + node.id + ";" + quantity + ";" + (node.entityType || "Meal").toLowerCase(),
          text
        });
      }

      const children = [];
      if (Array.isArray(node.children)) children.push(...node.children);
      if (Array.isArray(node.activeMenuCategories)) children.push(...node.activeMenuCategories);
      if (Array.isArray(node.activeMenuItems)) children.push(...node.activeMenuItems);
      visitNodes(children);
    });
  };

  visitNodes(base?.children || base?.activeMenuCategories || base?.activeMenuItems || []);
  return options.sort((a, b) => a.text.localeCompare(b.text));
}

function applyUpsellMenuItems(modal, data, base = admin.adminCategories) {
  const select = modal.find("#upsellMenuItems");
  if (!select.length) {
    return;
  }

  select.data("upsellBase", base);
  const selectedUpsellItems = [];
  const selectedIds = selectedUpsellItems.map(item => String(item.id || item)).filter(Boolean);
  const selectedTypedIds = selectedUpsellItems.map(item => {
    if (!item || typeof item !== "object") {
      return null;
    }
    const typeValue = (item.type || item.entityType || "").toString().toLowerCase();
    if (typeValue.indexOf("category") >= 0) {
      return "menuCategory:" + String(item.id || "");
    }
    if (item.id) {
      return "menuItem:" + String(item.id);
    }
    return null;
  }).filter(Boolean);
  (data?.menuItemAdditions || [])
    .filter(addition => addition?.additionType === "upsell" && addition?.additionId)
    .forEach(addition => selectedTypedIds.push("menuItem:" + String(addition.additionId)));
  (data?.menuCategoryAdditions || [])
    .filter(addition => addition?.additionType === "upsell" && addition?.additionId)
    .forEach(addition => selectedTypedIds.push("menuCategory:" + String(addition.additionId)));
  const currentItemId = data?.id ? String(data.id) : null;
  const tokenize = select.tokenize2();

  clearTokens(tokenize);
  getUpsellMenuItemOptions(base)
    .filter(option => {
      if (option.value && option.value.startsWith("menuItem;") && option.value.split(";")[2] === currentItemId) {
        return false;
      }
      const optionItemId = (option.value || "").startsWith("menuItem;") ? (option.value || "").split(";")[2] : null;
      return selectedTypedIds.includes(option.id) || (optionItemId && selectedIds.includes(optionItemId));
    })
    .forEach(option => {
      select.trigger("tokenize:tokens:add", [option.value || option.id, wrapTokenizerLabelText(option.text)]);
    });
}

export const shouldDisplayUpsellField = () => {
  const superAdminEnabled = hasRole("superadmin") || hasRole(["superadmin"]);
  const orderingEnabled = featureEnabled("ordering") || featureEnabled("ordering/enabled");
  const webshopEnabled = orderingEnabled
    && ((featureEnabled("pickup/enabled") && featureEnabled("pickup/webshop"))
      || (featureEnabled("homedelivery/enabled") && featureEnabled("homedelivery/webshop")));
  return superAdminEnabled && (orderingEnabled || webshopEnabled || featureEnabled("kiosk"));
}

function collectUpsellMenuItemsFromCategory(category) {
  const result = [];
  const visitedCategories = new Set();
  const visitedItems = new Set();

  const visitNodes = nodes => {
    if (!Array.isArray(nodes)) {
      return;
    }
    nodes.forEach(node => {
      if (!node || !node.id) {
        return;
      }
      const isCategory = (node.entityType || "").toString().toLowerCase().indexOf("category") >= 0
        || typeof node.activeMenuCategories !== "undefined"
        || typeof node.activeMenuItems !== "undefined"
        || Array.isArray(node.children);
      if (isCategory) {
        if (visitedCategories.has(node.id)) {
          return;
        }
        visitedCategories.add(node.id);
        if (Array.isArray(node.activeMenuItems) && node.activeMenuItems.length) {
          visitNodes(node.activeMenuItems);
        }
        if (Array.isArray(node.children) && node.children.length) {
          visitNodes(node.children);
        }
        if (Array.isArray(node.activeMenuCategories) && node.activeMenuCategories.length) {
          visitNodes(node.activeMenuCategories);
        }
        if (Array.isArray(node.menuItems) && node.menuItems.length) {
          visitNodes(node.menuItems);
        }
        if (Array.isArray(node.menuCategories) && node.menuCategories.length) {
          visitNodes(node.menuCategories);
        }
        return;
      }

      if (visitedItems.has(node.id)) {
        return;
      }
      visitedItems.add(node.id);
      result.push(node);
    });
  };

  visitNodes([category]);
  return result;
}

function getSelectedUpsellReferences(modal) {
  const menuItems = [];
  const menuCategories = [];
  const seenMenuItems = new Set();
  const seenMenuCategories = new Set();
  const currentItemId = Number(modal.find("#id").val());

  modal
    .find("#upsellMenuItems")
    .tokenize2()
    .toArray()
    .forEach(itemId => {
      const tokenValue = (itemId == null ? "" : String(itemId)).trim();
      if (!tokenValue || tokenValue.toLowerCase() === "undefined" || tokenValue.toLowerCase() === "null") {
        return;
      }

      const tokenParts = tokenValue.split(";");
      const tokenType = tokenParts[0];
      const tokenEntityId = tokenParts.length >= 3 ? Number(tokenParts[2]) : Number(tokenValue);
      if (!Number.isFinite(tokenEntityId) || tokenEntityId <= 0) {
        return;
      }

      if (tokenType === "menuCategory") {
        if (seenMenuCategories.has(tokenEntityId)) {
          return;
        }
        seenMenuCategories.add(tokenEntityId);
        const menuCategory = menuitemutil.getMenuCategory(tokenEntityId)
          || (admin.getMenuCategoryAdmin ? admin.getMenuCategoryAdmin(tokenEntityId) : null);
        menuCategories.push({
          id: tokenEntityId,
          globalId: menuCategory ? (menuCategory.globalId || null) : null,
          type: menuCategory ? menuCategory.entityType : (menuitemutil.entityType + "Category")
        });
        return;
      }

      const id = tokenType === "menuItem" ? tokenEntityId : Number(tokenValue);
      if (!Number.isFinite(id) || id <= 0 || (Number.isFinite(currentItemId) && id === currentItemId) || seenMenuItems.has(id)) {
        return;
      }
      seenMenuItems.add(id);
      const menuItem = menuitemutil.getMenuItem(id) || admin.getMenuItemAdmin(id);
      menuItems.push({
        id,
        globalId: menuItem ? (menuItem.globalId || null) : null,
        type: menuItem ? menuItem.entityType : menuitemutil.entityType
      });
    });

  return { menuItems, menuCategories };
}

function appendUpsellAdditionsFromSelection(modal, menuItemAdditions, menuCategoryAdditions) {
  const selectedUpsell = getSelectedUpsellReferences(modal);

  let itemOrder = menuItemAdditions.length;
  selectedUpsell.menuItems.forEach(selectedItem => {
    const menuItem = menuitemutil.getMenuItem(selectedItem.id) || admin.getMenuItemAdmin(selectedItem.id);
    const entityType = (menuItem?.entityType || selectedItem.type || menuitemutil.entityType || "Meal").toLowerCase();
    menuItemAdditions.push({
      id: 0,
      addition: {
        id: selectedItem.id,
        type: entityType
      },
      order: itemOrder++,
      proportional: false,
      local: true,
      takeaway: true,
      type: entityType + "_addition",
      additionType: "upsell",
      quantity: 1
    });
  });

  let categoryOrder = menuCategoryAdditions.length;
  selectedUpsell.menuCategories.forEach(selectedCategory => {
    const menuCategory = menuitemutil.getMenuCategory(selectedCategory.id)
      || (admin.getMenuCategoryAdmin ? admin.getMenuCategoryAdmin(selectedCategory.id) : null);
    const entityType = (menuCategory?.entityType || selectedCategory.type || (menuitemutil.entityType + "Category")).toLowerCase();
    menuCategoryAdditions.push({
      id: 0,
      addition: {
        id: selectedCategory.id,
        type: entityType
      },
      order: categoryOrder++,
      proportional: false,
      type: entityType + "_addition",
      additionType: "upsell",
      optionType: "multiple",
      min: 0,
      max: 100
    });
  });
}

function formatHeaderPriceValue(price) {
  const numeric = Number(price);
  if (!Number.isFinite(numeric)) {
    return "";
  }
  const rounded = Math.round(numeric * 100) / 100;
  return Number.isInteger(rounded) ? String(rounded) : String(rounded);
}

function getMenuItemHeaderPriceEntries(modal, menuItem) {
  if (!menuItem || !Array.isArray(menuItem.availableQuantities)) {
    return [];
  }

  const quantities = menuItem.availableQuantities.filter(q => q && typeof q.quantity !== "undefined");
  if (!quantities.length || quantities.length > 2) {
    return [];
  }

  const normalizeQuantityKey = quantity => {
    const n = Number(quantity);
    return Number.isFinite(n) ? String(n) : String(quantity);
  };

  const unitPriceInputValue = (modal.find("#unit_price").val() || "").toString().trim();
  const liveUnitPrice = unitPriceInputValue !== "" ? Number(unitPriceInputValue) : Number(menuItem.unitPrice);

  const livePricesByQuantity = {};
  modal.find("#menuItemQuantities input").each(function () {
    const input = $(this);
    const explicitQuantity = input.attr("quantity");
    const rowNodeData = $(input.closest("tr")).data("node")?.data;
    const rowQuantity = rowNodeData?.quantity;
    const quantity = typeof explicitQuantity !== "undefined" ? explicitQuantity : rowQuantity;
    if (typeof quantity === "undefined") {
      return;
    }
    const key = normalizeQuantityKey(quantity);
    const value = (($(this).val() || "").toString()).trim();
    if (value === "") {
      return;
    }
    const numeric = Number(value);
    if (Number.isFinite(numeric)) {
      livePricesByQuantity[key] = numeric;
    }
  });

  const currencyName = auth?.myStatus?.restaurant_base_currency?.name ? " " + auth.myStatus.restaurant_base_currency.name : "";
  const entries = quantities.map(q => {
    const quantityKey = normalizeQuantityKey(q.quantity);
    const quantityLabel = q?.quantityType?.name ? getLocale(q.quantityType.name) : (q.quantity != null ? String(q.quantity) : "");

    let price = typeof livePricesByQuantity[quantityKey] !== "undefined" ? livePricesByQuantity[quantityKey] : q.price;
    if (price === "" || price == null) {
      const baseUnitPrice = liveUnitPrice;
      const quantityValue = Number(q.quantity);
      if (Number.isFinite(baseUnitPrice) && Number.isFinite(quantityValue)) {
        price = baseUnitPrice * quantityValue;
      }
    }

    const formattedPrice = formatHeaderPriceValue(price);
    if (!formattedPrice) {
      return {
        label: quantityLabel,
        value: ""
      };
    }

    return {
      label: quantityLabel,
      value: formattedPrice + currencyName
    };
  }).filter(Boolean);

  return entries;
}

function setModalHeaderContext(modal, categoryPath, localizedName, priceEntries = []) {
  const context = modal.find(".menuitem-header-context").first();
  const priceColumn = modal.find(".menuitem-header-price-column").first();
  if (!context.length) {
    return;
  }

  const safePath = (categoryPath || "").toString().trim();
  const safeName = (localizedName || "").toString().trim();
  const entries = Array.isArray(priceEntries) ? priceEntries : [];

  context.find(".menuitem-header-context-path").text(safePath);
  context.find(".menuitem-header-context-name").text(safeName);

  if (priceColumn.length) {
    const html = entries
      .filter(entry => entry && entry.value)
      .map(entry => `<div class="menuitem-header-price-entry"><span class="menuitem-header-price-label">${entry.label || ""}</span><span class="menuitem-header-price-value">${entry.value}</span></div>`)
      .join("");
    priceColumn.html(html);
    priceColumn.toggleClass("empty", !html);
  }

  context.toggleClass("empty", !safePath && !safeName);
}

function escapeExcerptHtml(value) {
  return (value == null ? "" : String(value))
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function formatShopLabelMoney(value) {
  const amount = Number(value);
  if (!Number.isFinite(amount)) {
    return "";
  }
  return String(Math.round(amount));
}

function parseShopLabelPayload(payload) {
  if (!payload) {
    return null;
  }
  try {
    return JSON.parse(decodeURIComponent(payload));
  } catch (e) {
    return null;
  }
}

function buildShopLabelCode128Value(productCodeDigits, newPrice) {
  const codePart = String(productCodeDigits || "").replace(/\D/g, "") || "0";
  const pricePart = String(Math.max(0, Math.round(Number(newPrice) || 0)));
  const codeLength = String(Math.min(codePart.length, 99)).padStart(1, "0");
  const priceLength = String(Math.min(pricePart.length, 99)).padStart(1, "0");
  return "23" + codeLength + codePart + priceLength + pricePart;
}

function formatLabelInt(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) {
    return "0";
  }
  return String(Math.round(number)).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

function toZplField(value, maxLength = 80) {
  return String(value == null ? "" : value)
    .replace(/[\r\n]+/g, " ")
    .replace(/[\^~]/g, " ")
    .trim()
    .substring(0, maxLength);
}

function renderZplToJpgDataUrl(zplText) {
  const endpoint = "https://api.labelary.com/v1/printers/8dpmm/labels/2.25x1.8/0/";
  return fetch(endpoint, {
    method: "POST",
    headers: {
      Accept: "image/png",
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    },
    body: zplText
  })
    .then(response => {
      if (!response.ok) {
        throw new Error("ZPL render failed: " + response.status);
      }
      return response.blob();
    })
    .then(blob => new Promise((resolve, reject) => {
      const objectUrl = URL.createObjectURL(blob);
      const image = new Image();
      image.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = image.naturalWidth || image.width;
          canvas.height = image.naturalHeight || image.height;
          const context = canvas.getContext("2d");
          context.fillStyle = "#ffffff";
          context.fillRect(0, 0, canvas.width, canvas.height);
          context.drawImage(image, 0, 0);
          const jpgDataUrl = canvas.toDataURL("image/jpeg", 0.92);
          URL.revokeObjectURL(objectUrl);
          resolve(jpgDataUrl);
        } catch (error) {
          URL.revokeObjectURL(objectUrl);
          reject(error);
        }
      };
      image.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject(new Error("Unable to load rendered ZPL image"));
      };
      image.src = objectUrl;
    }));
}

function getShopLabelTexts(language) {
  const lang = String(language || "").toLowerCase();
  if (lang.startsWith("hu")) {
    return {
      salesUnitDefault: "db",
      unitPriceLabel: "Egységár:",
      packageLabel: "Kiszerelés:",
      salesUnitLabelText: "M.E.:",
      consumerPriceLabel: "Kedvezményes ár",
      originalPriceLabel: "Eredeti ár:",
      validUntilLabel: "Az ár érvényes:"
    };
  }
  if (lang.startsWith("de")) {
    return {
      salesUnitDefault: "Stk",
      unitPriceLabel: "Einheitspreis:",
      packageLabel: "Packung:",
      salesUnitLabelText: "Einh.:",
      consumerPriceLabel: "Verbraucherpreis",
      originalPriceLabel: "Originalpreis:",
      validUntilLabel: "Preis gultig bis:"
    };
  }
  if (lang.startsWith("it")) {
    return {
      salesUnitDefault: "pz",
      unitPriceLabel: "Prezzo unitario:",
      packageLabel: "Confezione:",
      salesUnitLabelText: "U.M.:",
      consumerPriceLabel: "Prezzo al consumo",
      originalPriceLabel: "Prezzo originale:",
      validUntilLabel: "Prezzo valido fino al:"
    };
  }
  if (lang.startsWith("cn") || lang.startsWith("zh")) {
    return {
      salesUnitDefault: "件",
      unitPriceLabel: "单价:",
      packageLabel: "包装:",
      salesUnitLabelText: "单位:",
      consumerPriceLabel: "现价",
      originalPriceLabel: "原价:",
      validUntilLabel: "价格有效期至:"
    };
  }

  return {
    salesUnitDefault: "pcs",
    unitPriceLabel: "Unit price:",
    packageLabel: "Package:",
    salesUnitLabelText: "U.M.:",
    consumerPriceLabel: "Consumer price",
    originalPriceLabel: "Original price:",
    validUntilLabel: "Price valid until:"
  };
}

function buildShopLabelZpl(data, newPrice) {
  const currency = auth?.myStatus?.restaurant_base_currency?.name || "";
  const language = String(localStorage.languageSelected || "").toLowerCase();
  const labelTexts = getShopLabelTexts(language);
  const quantityValue = Number(data.quantityValue);
  const quantityUnitLabel = (data.quantityUnitLabel || "").toString().trim();
  const salesUnitLabel = (data.salesUnitLabel || I18n.t("local.pcs") || labelTexts.salesUnitDefault).toString().trim() || labelTexts.salesUnitDefault;

  const packageText = Number.isFinite(quantityValue)
    ? `${quantityValue} ${quantityUnitLabel}`.trim()
    : (data.quantityText || "").toString().trim();

  const unitPriceNumeric = Number.isFinite(quantityValue) && quantityValue > 0
    ? Math.round(Number(data.originalPrice || 0) / quantityValue)
    : Number(data.originalPrice || 0);
  const unitPriceText = `${formatLabelInt(unitPriceNumeric)} ${currency}${quantityUnitLabel ? "/" + quantityUnitLabel : ""}`.trim();
  const consumerPriceText = `${formatLabelInt(newPrice)} ${currency}/${salesUnitLabel}`;
  const originalPriceText = `${formatLabelInt(Number(data.originalPrice || 0))} ${currency}/${salesUnitLabel}`;
  const validUntil = data.validUntil
    ? moment(data.validUntil).format("YYYY. MM. DD.")
    : moment().format("YYYY. MM. DD.");

  const unitPriceLabel = labelTexts.unitPriceLabel;
  const packageLabel = labelTexts.packageLabel;
  const salesUnitLabelText = labelTexts.salesUnitLabelText;
  const consumerPriceLabel = labelTexts.consumerPriceLabel;
  const originalPriceLabel = labelTexts.originalPriceLabel;
  const validUntilLabel = labelTexts.validUntilLabel;

  const productCodeDigits = (data.productCode != null && data.productCode !== "" ? String(data.productCode) : String(data.menuItemId || "")).replace(/\D/g, "") || String(data.menuItemId || "").replace(/\D/g, "");
  const barcodeValue = buildShopLabelCode128Value(productCodeDigits, newPrice);

  return [
    "^XA",
    "^CI28",
    "^PW450",
    "^LL360",
    `^FO5,10^FB450,1,0,L,0^AN,24,24^FD${toZplField(data.productName || "")}^FS`,
    `^FO5,52^AN,12,12^FD${toZplField(unitPriceLabel)}^FS`,
    `^FO130,52^AN,12,12^FD${toZplField(packageLabel)}^FS`,
    `^FO250,52^AN,12,12^FD${toZplField(packageText)}^FS`,
    `^FO340,52^AN,12,12^FD${toZplField(salesUnitLabelText)}^FS`,
    `^FO400,52^AN,12,12^FD${toZplField(salesUnitLabel)}^FS`,
    `^FO5,80^AN,16,16^FD${toZplField(unitPriceText)}^FS`,
    `^FO145,120^FB480,1,0,L,0^AN,13,13^FD${toZplField(originalPriceLabel + " " + originalPriceText)}^FS`,
    `^FO0,148^FB480,1,0,C,0^AN,14,14^FD^AN,18,18^FD${toZplField(consumerPriceLabel)}         ^FS`,
    `^FO0,178^FB450,1,0,C,0^A0N,50,60^FD${toZplField(consumerPriceText)}^FS`,
    `^BY2,2,66^FB450,1,0,C,0^FO20,230^BCN,66,Y,N,N^FD${toZplField(barcodeValue, 120)}^FS`,
    `^FO0,342^FB480,1,0,C,0^AN,14,14^FD${toZplField(validUntilLabel + " " + validUntil, 120)}           ^FS`,
    "^XZ"
  ].join("\n");
}

function showShopLabelPreview(zplText) {
  const popup = window.open("", "_blank", "width=900,height=760");
  if (!popup) {
    alert("Popup blocked");
    return;
  }

  popup.document.write(`
    <html>
      <head>
        <title>Zebra Raw Label</title>
        <style>
          body { font-family: Menlo, Monaco, Consolas, monospace; margin: 0; padding: 12px; background: #f5f6f8; }
          h2 { margin: 0 0 8px; font-size: 18px; }
          .note { margin: 0 0 10px; font-family: Arial, sans-serif; font-size: 13px; color: #333; }
          .img-wrap { margin: 8px 0 12px; background: #fff; border: 1px solid #bbb; padding: 10px; }
          .img-wrap img { display: block; max-width: 100%; height: auto; border: 1px dashed #ddd; }
          .status { margin: 0 0 8px; font-family: Arial, sans-serif; font-size: 12px; color: #444; }
          textarea { width: 100%; min-height: 280px; box-sizing: border-box; border: 1px solid #bbb; padding: 10px; font-size: 13px; line-height: 1.35; resize: vertical; }
          @page { margin: 0; }
        </style>
      </head>
      <body>
        <h2>Zebra raw label preview</h2>
        <div class="note">Rendered JPG from raw ZPL (Labelary). Edit the raw text below and the image regenerates automatically.</div>
        <div class="img-wrap">
          <div id="renderStatus" class="status">Rendering ZPL to JPG...</div>
          <img id="zplJpgPreview" alt="ZPL JPG preview" />
        </div>
        <textarea id="zplTextInput" spellcheck="false">${escapeExcerptHtml(zplText)}</textarea>
      </body>
    </html>
  `);
  popup.document.close();

  const imageElement = popup.document.getElementById("zplJpgPreview");
  const statusElement = popup.document.getElementById("renderStatus");
  const zplTextInput = popup.document.getElementById("zplTextInput");
  let debounceTimer;
  let renderToken = 0;

  const regeneratePreview = () => {
    const token = ++renderToken;
    if (statusElement) {
      statusElement.textContent = "Rendering ZPL to JPG...";
    }
    renderZplToJpgDataUrl(zplTextInput ? zplTextInput.value : zplText)
      .then(jpgDataUrl => {
        if (token !== renderToken) {
          return;
        }
        if (imageElement) {
          imageElement.src = jpgDataUrl;
        }
        if (statusElement) {
          statusElement.textContent = "Rendered successfully.";
        }
      })
      .catch(error => {
        if (token !== renderToken) {
          return;
        }
        if (statusElement) {
          statusElement.textContent = "JPG render failed: " + (error?.message || "Unknown error");
        }
      });
  };

  if (zplTextInput) {
    zplTextInput.addEventListener("input", () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(regeneratePreview, 300);
    });
  }

  regeneratePreview();
}

function getShopLabelPrinter(data) {
  const menuItem = getMenuItem(Number(data.menuItemId));
  const defaultProductionLineIds = menuItem.defaultProductionLineIds
    .split(",")
    .map(id => Number(id))
    .filter(id => Number.isFinite(id));

  for (const productionLineId of defaultProductionLineIds) {
    const productionLine = getProductionLine(productionLineId);
    const printer = productionLine?.labelPrinter;
    if (printer?.id || printer?.name) {
      return printer;
    }
  }

  return null;
}

function printShopLabel(zplText, data) {
  const printer = getShopLabelPrinter(data)
    || admin.getNonLocalPrinterForPrinterAction("printTableSlip")
    || admin.getNonLocalPrinterForPrinterAction("printInvoice")
    || auth?.myStatus?.restaurant_printer_actions?.printTableSlip
    || auth?.myStatus?.restaurant_printer_actions?.printInvoice;
  const printerId = printer?.name;
  if (!printerId) {
    alert(admin_local.no_printer_selected || "No printer selected");
    return;
  }

  const url = `printerServerClient/${localStorage.restaurantSelected}/print/${encodeURIComponent(printerId)}?printer=${encodeURIComponent(printerId)}&productionLine=shop-label&orderIds=${encodeURIComponent(data.menuItemId || "")}&reprint=false`;
  post(url, zplText, {
    Accept: "application/json",
    "Content-Type": "text/html; charset=utf-8"
  }, undefined, 2, undefined, 60000);
}

function generateShopLabel(eventOrPayload, maybePayload) {
  const payload = typeof maybePayload === "undefined" ? eventOrPayload : maybePayload;
  const event = typeof maybePayload === "undefined" ? null : eventOrPayload;
  const shiftPressed = !!event?.shiftKey;
  if (event?.preventDefault) {
    event.preventDefault();
  }
  if (event?.stopPropagation) {
    event.stopPropagation();
  }
  const data = parseShopLabelPayload(payload);
  if (!data) {
    alert("Invalid label data");
    return;
  }

  const oldPriceDefault = formatShopLabelMoney(data.originalPrice);
  const promptTitle = I18n.t("local.question") || admin_local.price || "Price";
  const promptMessage = admin_local.new_price || promptTitle;
  getInputDialog(promptTitle, promptMessage, oldPriceDefault, "number").done((choice, enteredPrice) => {
    const normalizedInput = String(enteredPrice).replace(",", ".").replace(/[^\d.]/g, "");
    const numericPrice = Number(normalizedInput);
    if (!Number.isFinite(numericPrice) || numericPrice <= 0) {
      alert(admin_local.invalid_value || "Invalid price");
      return;
    }

    const newPrice = Math.round(numericPrice);
    const zplText = buildShopLabelZpl(data, newPrice);

    if (shiftPressed) {
      showShopLabelPreview(zplText);
      return;
    }

    printShopLabel(zplText, data);
  });
}

function getTokenValues(modal, selector) {
  try {
    const tokenize = modal.find(selector).tokenize2();
    if (tokenize && typeof tokenize.toArray === "function") {
      return tokenize.toArray();
    }
  } catch (e) {
    // Ignore tokenize read errors while modal is initializing.
  }
  return [];
}

function resolveMenuItemNameById(id) {
  const numericId = Number(id);
  const menuItem = menuitemutil.getMenuItem(numericId) || admin.getMenuItemAdmin(numericId);
  if (!menuItem) {
    return "#" + numericId;
  }
  return getLocale(menuItem.name) || menuItem.shortName || ("#" + numericId);
}

function resolveMenuCategoryById(id) {
  const numericId = Number(id);
  return menuitemutil.getMenuCategory(numericId) || admin.getMenuCategoryAdmin(numericId);
}

function resolveMenuCategoryNameById(id) {
  const category = resolveMenuCategoryById(id);
  if (!category) {
    return "#" + id;
  }
  return menuitemutil.getPath(category) || getLocale(category.name) || ("#" + id);
}

function getOptionalCategoryRule(modal, tokenValue) {
  if (modal.find('input[id="check' + tokenValue + '"]').prop("checked")) {
    return "multiple";
  }
  if (modal.find('input[id="check2' + tokenValue + '"]').prop("checked")) {
    const min = modal.find('li.token[data-value="' + tokenValue + '"] input#min').val();
    const max = modal.find('li.token[data-value="' + tokenValue + '"] input#max').val();
    return "separate" + ((min || max) ? " [" + (min || "0") + "-" + (max || "*") + "]" : "");
  }
  if (modal.find('input[id="radio' + tokenValue + '"]').prop("checked")) {
    return "maxone";
  }
  return "one";
}

const optionalReductionDialogId = "menuitemOptionalReductionDialog";

function parseAdditionTokenValue(tokenValue) {
  const parts = (tokenValue || "").split(";");
  if (!parts.length) {
    return null;
  }
  return {
    kind: parts[0] || "",
    id: parts[1] || "",
    additionId: Number(parts[2] || 0),
    quantity: parts[3] || "",
    additionEntityType: parts[4] || ""
  };
}

function getDefaultOnMenuQuantity(menuItem) {
  if (!menuItem || !Array.isArray(menuItem.availableQuantities) || !menuItem.availableQuantities.length) {
    return 1;
  }
  const onMenu = menuItem.availableQuantities.find(q => q && q.onMenu !== false);
  if (onMenu && typeof onMenu.quantity !== "undefined") {
    return onMenu.quantity;
  }
  const fallback = menuItem.availableQuantities[0];
  return fallback && typeof fallback.quantity !== "undefined" ? fallback.quantity : 1;
}

function getOnMenuQuantities(menuItem) {
  if (!menuItem || !Array.isArray(menuItem.availableQuantities) || !menuItem.availableQuantities.length) {
    return [1];
  }

  const quantities = menuItem.availableQuantities
    .filter(q => q && q.onMenu !== false && typeof q.quantity !== "undefined")
    .map(q => q.quantity);

  if (quantities.length) {
    return quantities;
  }

  return [getDefaultOnMenuQuantity(menuItem)];
}

function buildReductionEntryKey(menuItemId, quantity) {
  return String(menuItemId) + ";" + String(quantity);
}

function normalizeReductionAdditionEntityType(entityType, fallbackEntityType) {
  const raw = (entityType || "").toString().toLowerCase();
  const normalized = raw.endsWith("category") ? raw.substring(0, raw.length - "category".length) : raw;
  if (normalized === "drink" || normalized === "meal") {
    return normalized;
  }

  const fallbackRaw = (fallbackEntityType || "").toString().toLowerCase();
  const fallback = fallbackRaw.endsWith("category")
    ? fallbackRaw.substring(0, fallbackRaw.length - "category".length)
    : fallbackRaw;

  return fallback === "drink" || fallback === "meal" ? fallback : "meal";
}

function isReductionNodeActive(node) {
  if (!node || typeof node !== "object") {
    return true;
  }
  const state = (node.recordState == null ? "" : String(node.recordState)).trim().toUpperCase();
  if (!state) {
    return true;
  }
  return state === "ACTIVE";
}

function collectCategoryOptionMenuItems(category, result = [], visited = new Set()) {
  if (!category || visited.has(category.id)) {
    return result;
  }
  visited.add(category.id);

  const activeItems = (category.activeMenuItems || category.menuItems || [])
    .filter(item => isReductionNodeActive(item));
  activeItems.forEach(item => {
    const resolved = menuitemutil.getMenuItem(item.id || item);
    if (!resolved || !Array.isArray(resolved.availableQuantities) || !resolved.availableQuantities.length) {
      return;
    }
    getOnMenuQuantities(resolved).forEach(quantity => {
      const key = buildReductionEntryKey(resolved.id, quantity);
      if (result.find(existing => existing.reductionKey === key)) {
        return;
      }
      result.push({
        ...resolved,
        reductionQuantity: quantity,
        reductionKey: key
      });
    });
  });

  const activeCategories = (category.activeMenuCategories || category.menuCategories || [])
    .filter(subCategory => isReductionNodeActive(subCategory));
  activeCategories.forEach(subCategory => {
    const resolvedSubCategory = menuitemutil.getMenuCategory(subCategory.id || subCategory);
    collectCategoryOptionMenuItems(resolvedSubCategory, result, visited);
  });

  const children = (category.children || []).filter(child => isReductionNodeActive(child));
  children.forEach(child => {
    if (!child) {
      return;
    }
    const childId = child.id || child;
    const resolvedItem = menuitemutil.getMenuItem(childId);
    if (resolvedItem && Array.isArray(resolvedItem.availableQuantities) && resolvedItem.availableQuantities.length) {
      getOnMenuQuantities(resolvedItem).forEach(quantity => {
        const key = buildReductionEntryKey(resolvedItem.id, quantity);
        if (result.find(existing => existing.reductionKey === key)) {
          return;
        }
        result.push({
          ...resolvedItem,
          reductionQuantity: quantity,
          reductionKey: key
        });
      });
      return;
    }
    const resolvedCategory = menuitemutil.getMenuCategory(childId);
    collectCategoryOptionMenuItems(resolvedCategory, result, visited);
  });

  return result;
}

function buildOptionalReductionTokenLabel(menuItem, quantity, tokenKey) {
  const safeQuantity = Number.isFinite(Number(quantity)) ? Number(quantity) : getDefaultOnMenuQuantity(menuItem);
  return wrapTokenizerLabelText(menuitemutil.getPath(menuItem)) +
    menuitemutil.getLocalOption("al_" + tokenKey, true) +
    menuitemutil.getTakeawayOption("at_" + tokenKey, true) +
    menuitemutil.getProportionalOption("aa_" + tokenKey, false) +
    "\n" +
    menuitemutil.getQuantityLabel2("optional", safeQuantity, menuItem.quantityType, getLocale(getNameForQuantity(menuItem, safeQuantity))) +
    (menuItem.costEstimation * safeQuantity > 0 ? "<span class='cost'>&nbsp;" + Math.round(menuItem.costEstimation * safeQuantity * 1000) / 1000 + " " + auth.myStatus.restaurant_base_currency.name + "</span>" : "<span/>") +
    "<span class='calorie'>&nbsp;" + Math.round(menuItem.calorie * safeQuantity * 10) / 10 + " kcal</span>";
}

function ensureOptionalReductionDialog() {
  let dialog = $("#" + optionalReductionDialogId);
  if (dialog.length) {
    return dialog;
  }

  dialog = $(`
    <div class="modal fade" id="${optionalReductionDialogId}" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="optional-reduction-description" style="margin-bottom:.65rem;padding:.5rem .6rem;background:rgba(0,120,212,.07);border-left:3px solid rgba(0,120,212,.45);border-radius:.25rem;font-size:.88rem;line-height:1.45;"></div>
            <div class="optional-reduction-actions" style="display:flex;gap:.45rem;align-items:center;margin:0 0 .55rem;">
              <button type="button" class="btn btn-sm btn-outline-primary optional-reduction-select-all"></button>
              <button type="button" class="btn btn-sm btn-outline-secondary optional-reduction-deselect-all"></button>
            </div>
            <div class="optional-reduction-list" style="max-height:22rem;overflow:auto;border:1px solid #dee2e6;border-radius:.35rem;padding:.35rem .5rem;"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary optional-reduction-cancel" data-dismiss="modal"></button>
            <button type="button" class="btn btn-primary optional-reduction-apply"></button>
          </div>
        </div>
      </div>
    </div>
  `);

  $("body").append(dialog);
  return dialog;
}

function openOptionalReductionDialog(selectElement, categoryTokenValue) {
  const parsedToken = parseAdditionTokenValue(categoryTokenValue);
  if (!parsedToken || parsedToken.kind !== "menuCategory" || !parsedToken.additionId) {
    return;
  }

  const category = menuitemutil.getMenuCategory(parsedToken.additionId);
  if (!category) {
    return;
  }

  const candidateItems = collectCategoryOptionMenuItems(category)
    .sort((a, b) => {
      const orderA = Number.isFinite(Number(a?.globalOrder)) ? Number(a.globalOrder) : Number.MAX_SAFE_INTEGER;
      const orderB = Number.isFinite(Number(b?.globalOrder)) ? Number(b.globalOrder) : Number.MAX_SAFE_INTEGER;
      if (orderA !== orderB) {
        return orderA - orderB;
      }
      return (getLocale(a.name) || "").localeCompare(getLocale(b.name) || "");
    });

  const tokenize = selectElement.tokenize2();
  const existingTokens = tokenize.toArray();
  const candidateKeys = new Set(candidateItems.map(item => item.reductionKey || buildReductionEntryKey(item.id, item.reductionQuantity)));
  const selectedTokenByMenuItem = {};
  existingTokens.forEach(tokenValue => {
    const parsed = parseAdditionTokenValue(tokenValue);
    if (!parsed || parsed.kind !== "menuItem") {
      return;
    }
    const selectedKey = buildReductionEntryKey(parsed.additionId, parsed.quantity);
    if (!candidateKeys.has(selectedKey)) {
      return;
    }
    selectedTokenByMenuItem[selectedKey] = tokenValue;
  });

  // When no explicit item tokens exist for this category, the reduction is not active → show all checked.
  // When some explicit item tokens exist, only those are checked (reduction is active).
  const reductionIsActive = Object.keys(selectedTokenByMenuItem).length > 0;
  const selectedIds = new Set(Object.keys(selectedTokenByMenuItem));
  const dialog = ensureOptionalReductionDialog();
  const title = admin_local.select_optional_options || admin_local.optional || "Select optional options";
  const applyLabel = admin_local.select || admin_local.ok || "Apply";
  const cancelLabel = admin_local.cancel || "Cancel";
  const selectAllLabel = admin_local.select_all || "Select all";
  const deselectAllLabel = admin_local.deselect_all || "Deselect all";

  const listHtml = candidateItems.length
    ? candidateItems.map(menuItem => {
      const quantity = typeof menuItem.reductionQuantity !== "undefined" ? menuItem.reductionQuantity : getDefaultOnMenuQuantity(menuItem);
      const reductionKey = menuItem.reductionKey || buildReductionEntryKey(menuItem.id, quantity);
      // All checked when no reduction active; only selected ones when reduction is active
      const isChecked = !reductionIsActive || selectedIds.has(reductionKey);
      const checked = isChecked ? "checked" : "";
      const name = escapeExcerptHtml(getLocale(menuItem.name) || menuItem.shortName || ("#" + menuItem.id));
      const quantityLabel = escapeExcerptHtml(menuitemutil.getQuantityLabel3("optional", quantity, menuItem.quantityType) || "");
      const displayName = quantityLabel ? (name + " " + quantityLabel) : name;
      return `<label class="optional-reduction-row" style="display:flex;align-items:center;gap:.5rem;padding:.35rem .2rem;margin:0;border-bottom:1px solid rgba(0,0,0,.04);cursor:pointer;">
          <input type="checkbox" class="optional-reduction-item" data-menuitem-id="${menuItem.id}" data-quantity="${quantity}" data-reduction-key="${reductionKey}" ${checked} style="margin-top:.18rem;" />
          <span style="display:flex;flex-direction:column;min-width:0;">
            <span style="line-height:1.2;">${displayName}</span>
          </span>
        </label>`;
    }).join("")
    : `<div style="padding:.45rem .2rem;opacity:.7;">${escapeExcerptHtml(admin_local.noResultsMessageText || "No options found")}</div>`;

  const descriptionText = admin_local.reduce_optional_options_description || "By default all options from the referenced category are offered. Uncheck specific items here to limit the selection to only the checked ones. If all are checked, the full category is offered (no restriction).";

  dialog.find(".modal-title").text(title + " - " + (menuitemutil._getPath(category) || ""));
  dialog.find(".optional-reduction-description").text(descriptionText);
  dialog.find(".optional-reduction-apply").text(applyLabel);
  dialog.find(".optional-reduction-cancel").text(cancelLabel);
  dialog.find(".optional-reduction-select-all").text(selectAllLabel);
  dialog.find(".optional-reduction-deselect-all").text(deselectAllLabel);
  dialog.find(".optional-reduction-list").html(listHtml);

  dialog.data("optionalReductionState", {
    selectId: selectElement.attr("id"),
    candidateIds: Array.from(candidateKeys),
    totalCandidateCount: candidateItems.length,
    selectedTokenByMenuItem,
    additionEntityType: normalizeReductionAdditionEntityType(parsedToken.additionEntityType, menuitemutil.entitytype),
    candidateItems: candidateItems.map(item => ({ id: item.id, quantity: item.reductionQuantity, reductionKey: item.reductionKey }))
  });

  dialog.find(".optional-reduction-select-all").off("click.optionalReductionBulk").on("click.optionalReductionBulk", function () {
    dialog.find(".optional-reduction-item").prop("checked", true);
  });

  dialog.find(".optional-reduction-deselect-all").off("click.optionalReductionBulk").on("click.optionalReductionBulk", function () {
    dialog.find(".optional-reduction-item").prop("checked", false);
  });

  dialog.modal("show");
}

function applyOptionalReductionDialogSelection() {
  const dialog = $("#" + optionalReductionDialogId);
  const state = dialog.data("optionalReductionState");
  if (!state || !state.selectId) {
    hideModalWhenReady(dialog);
    return;
  }

  const select = $("#" + state.selectId);
  if (!select.length) {
    hideModalWhenReady(dialog);
    return;
  }

  const checkedEntries = dialog.find(".optional-reduction-item:checked").map((_, checkbox) => {
    const element = $(checkbox);
    return {
      menuItemId: Number(element.data("menuitemId")),
      quantity: element.data("quantity")
    };
  }).toArray();
  if (!checkedEntries.length) {
    messageDialog(admin_local.error || "Error", admin_local.select_optional_options || admin_local.optional || "Select optional options");
    return;
  }
  const totalCandidateCount = state.totalCandidateCount || (state.candidateIds || []).length;
  const allSelected = checkedEntries.length >= totalCandidateCount;
  const candidateIdSet = new Set((state.candidateIds || []).map(id => String(id)));
  const tokenize = select.tokenize2();
  const tokenValues = tokenize.toArray();

  // Remove all existing explicit item tokens that belong to this category
  tokenValues.forEach(tokenValue => {
    const parsed = parseAdditionTokenValue(tokenValue);
    const tokenKey = parsed ? buildReductionEntryKey(parsed.additionId, parsed.quantity) : "";
    if (!parsed || parsed.kind !== "menuItem" || !candidateIdSet.has(tokenKey)) {
      return;
    }
    select.trigger("tokenize:tokens:remove", tokenValue);
  });

  // When all items are selected, no explicit tokens are needed (full category behavior)
  if (!allSelected) {
    checkedEntries.forEach((entry, index) => {
      const menuItemId = Number(entry.menuItemId);
      const menuItem = menuitemutil.getMenuItem(menuItemId);
      if (!menuItem) {
        return;
      }
      const quantity = typeof entry.quantity !== "undefined" ? entry.quantity : getDefaultOnMenuQuantity(menuItem);
      const additionEntityType = normalizeReductionAdditionEntityType(state.additionEntityType, menuItem.entityType || menuitemutil.entitytype);
      const tokenKey = "reduce_" + menuItemId + "_" + quantity + "_" + Date.now() + "_" + index;
      const tokenValue = "menuItem;0;" + menuItemId + ";" + quantity + ";" + additionEntityType;
      const tokenLabel = buildOptionalReductionTokenLabel(menuItem, quantity, tokenKey);
      select.trigger("tokenize:tokens:add", [tokenValue, tokenLabel, true]);
    });
  }

  select.trigger("tokenize:tokens:reorder");
  hideModalWhenReady(dialog);
}

function getReferencedCategoryOptionsExcerpt(category) {
  if (!category) {
    return "";
  }
  const candidates = [];
  if (Array.isArray(category.activeMenuItems)) {
    candidates.push(...category.activeMenuItems);
  }
  if (Array.isArray(category.children)) {
    candidates.push(...category.children.filter(child => child && child.availableQuantities));
  }

  const options = candidates
    .filter(option => option && option.availableQuantities)
    .map(option => getLocale(option.name) || option.shortName || ("#" + option.id));

  if (!options.length) {
    return "no direct options";
  }

  const visible = options.slice(0, 6).join(", ");
  const remaining = options.length - 6;
  return remaining > 0 ? (visible + " +" + remaining) : visible;
}

function renderSettingsRows(rows) {
  return rows
    .map(row => '<div class="menuitem-excerpt-row"><span class="menuitem-excerpt-key">' + escapeExcerptHtml(row.key) + '</span><span class="menuitem-excerpt-value">' + escapeExcerptHtml(row.value) + '</span></div>')
    .join("");
}

function renderCategorySettingsExcerpt(modal) {
  const target = modal.find(".menuitem-settings-excerpt[data-excerpt-kind='category']").first();
  if (!target.length) {
    return;
  }

  const timingText = modal.find("#ctiming option:selected").first().text() || "";
  const vatText = modal.find("#cvat_category option:selected").first().text() || "";
  const takeawayVatText = modal.find("#ctakeaway_vat_category option:selected").first().text() || "";
  const rows = [
    { key: admin_local.active || "Active", value: modal.find("#mc_active").prop("checked") ? "Yes" : "No" },
    { key: admin_local.online || "Online", value: modal.find("#mc_online").prop("checked") ? "Yes" : "No" },
    { key: admin_local.available || "Available", value: modal.find("#mc_available").prop("checked") ? "Yes" : "No" },
    { key: admin_local.timing || "Timing", value: timingText || "-" },
    { key: admin_local.default_vat_category || "VAT", value: vatText || "-" },
    { key: admin_local.default_takeaway_vat_category || "Takeaway VAT", value: takeawayVatText || "-" }
  ];

  target.html(renderSettingsRows(rows));
}

function renderMenuItemSettingsExcerpt(modal) {
  const settingsTarget = modal.find(".menuitem-settings-excerpt[data-excerpt-kind='item']").first();
  const receiptTarget = modal.find(".menuitem-receipt-excerpt[data-excerpt-kind='item']").first();
  if (!receiptTarget.length) {
    return;
  }

  // --- Settings summary ---
  const timingText = modal.find("#timing option:selected").first().text() || "";
  const vatText = modal.find("#vat_category option:selected").first().text() || "";
  const takeawayVatText = modal.find("#takeaway_vat_category option:selected").first().text() || "";
  const rows = [
    { key: admin_local.active || "Active", value: modal.find("#mi_active").prop("checked") ? "Yes" : "No" },
    { key: admin_local.online || "Online", value: modal.find("#mi_online").prop("checked") ? "Yes" : "No" },
    { key: admin_local.available || "Available", value: modal.find("#mi_available").prop("checked") ? "Yes" : "No" },
    { key: admin_local.isInventoryItem2 || "Inventory item", value: modal.find("#mi_isInventoryItem").prop("indeterminate") ? "Inherited" : (modal.find("#mi_isInventoryItem").prop("checked") ? "Yes" : "No") },
    { key: admin_local.timing || "Timing", value: timingText || "-" },
    { key: admin_local.default_vat_category || "VAT", value: vatText || "-" },
    { key: admin_local.default_takeaway_vat_category || "Takeaway VAT", value: takeawayVatText || "-" }
  ];
  if (settingsTarget.length) {
    settingsTarget.html(renderSettingsRows(rows));
  }

  // --- Ordering interface preview via chooseMates template ---
  const savedItem = menuitemutil.data;
  if (!savedItem) {
    receiptTarget.html('<em style="opacity:0.6;font-size:0.8rem">Mentsd el először a terméket a preview megtekintéséhez</em>');
    return;
  }

  let liveItem = null;
  try {
    const candidate = saveMenuItem(undefined, true, true);
    if (candidate && typeof candidate.then !== "function") {
      liveItem = candidate;
    }
  } catch (e) { }

  // Build preview from saved item first, then layer unsaved form changes on top.
  // This keeps required template fields that may be missing in saveMenuItem(test=true) snapshots.
  const previewItem = JSON.parse(JSON.stringify(savedItem));
  if (liveItem) {
    Object.assign(previewItem, JSON.parse(JSON.stringify(liveItem)));
    if (Array.isArray(liveItem.availableQuantities) && liveItem.availableQuantities.length) {
      previewItem.availableQuantities = JSON.parse(JSON.stringify(liveItem.availableQuantities));
    }
  }
  if (!previewItem.entityType && savedItem.entityType) {
    previewItem.entityType = savedItem.entityType;
  }
  if (!previewItem.id && savedItem.id) {
    previewItem.id = savedItem.id;
  }

  const unitPriceVal = modal.find("#unit_price").val();
  if (unitPriceVal !== "" && !isNaN(Number(unitPriceVal))) {
    previewItem.unitPrice = Number(unitPriceVal);
  }
  if (typeof menuItemQuantities !== 'undefined' && menuItemQuantities) {
    try {
      const rootNode = menuItemQuantities.getRootNode();
      if (rootNode && rootNode.getChildren()) {
        rootNode.getChildren().forEach(node => {
          const q = previewItem.availableQuantities.find(q => String(q.quantity) === String(node.data.quantity));
          if (q) {
            const priceVal = $(node.tr).find("#menuItem_price").val();
            if (priceVal !== "" && !isNaN(Number(priceVal))) q.price = priceVal;
          }
        });
      }
    } catch (e) { }
  }

  // jQuery template in orderMenuItem expects localPrice/takeawayPrice on each quantity row.
  // saveMenuItem(test=true) may only provide price, so normalize here for preview stability.
  if (!Array.isArray(previewItem.availableQuantities) || !previewItem.availableQuantities.length) {
    previewItem.availableQuantities = JSON.parse(JSON.stringify(savedItem.availableQuantities || []));
  }

  previewItem.menuItemAdditions = previewItem.menuItemAdditions.map(addition => {
    addition.addition.id = Number(addition.addition.id);
    addition.additionId = Number(addition?.additionId) || Number(addition?.addition?.id);
    addition.id = Number(addition.id);
    addition.quantity = Number(addition.quantity);
    return addition;
  });
  previewItem.menuCategoryAdditions = previewItem.menuCategoryAdditions.map(addition => {
    addition.addition.id = Number(addition.addition.id);
    addition.additionId = Number(addition?.additionId) || Number(addition?.addition?.id);
    addition.id = Number(addition.id);
    return addition;
  });

  previewItem.id = Number(previewItem.id);

  const unitPriceNumber = Number(previewItem.unitPrice);
  const hasUnitPrice = Number.isFinite(unitPriceNumber);
  previewItem.availableQuantities = (previewItem.availableQuantities || []).map(q => {
    const quantityNumber = Number(q?.quantity);
    const fallbackByUnit = hasUnitPrice && Number.isFinite(quantityNumber) ? unitPriceNumber * quantityNumber : undefined;

    q.quantity = Number(q.quantity);

    const localPriceCandidate = Number(q?.localPrice);
    const priceCandidate = Number(q?.price);
    const localPrice = Number.isFinite(localPriceCandidate)
      ? localPriceCandidate
      : (Number.isFinite(priceCandidate) ? priceCandidate : (Number.isFinite(fallbackByUnit) ? fallbackByUnit : 0));

    const takeawayPriceCandidate = Number(q?.takeawayPrice);
    const takeawayPrice = Number.isFinite(takeawayPriceCandidate) ? takeawayPriceCandidate : localPrice;

    return {
      ...q,
      price: localPrice,
      localPrice,
      takeawayPrice,
      onMenu: q?.onMenu !== false,
    };
  });

  if (!previewItem.availableQuantities.length) {
    previewItem.availableQuantities = [{
      quantity: 1,
      def: true,
      onMenu: true,
      localPrice: hasUnitPrice ? unitPriceNumber : 0,
      takeawayPrice: hasUnitPrice ? unitPriceNumber : 0,
      price: hasUnitPrice ? unitPriceNumber : 0
    }];
  }

  if (!previewItem.availableQuantities.some(q => q.onMenu !== false)) {
    previewItem.availableQuantities[0].onMenu = true;
  }

  // Temporarily register a fake tableMate so getTableMate(id) inside the template works.
  const PREVIEW_MATE_ID = -9999;
  const fakeMate = {
    id: PREVIEW_MATE_ID,
    name: admin_local.menuitem_tab_preview || admin_local.preview || 'Preview',
    email: '',
    active: true,
    count: 1,
    selected: true,
    seqNr: 1,
    tableOccupationId: sessionStorage.tableOccupationSelected,
    tableNumber: sessionStorage.tableNumberSelected,
    payingMateId: PREVIEW_MATE_ID
  };
  admin.tableMatesMap.set(PREVIEW_MATE_ID, fakeMate);

  const timings = (auth.myStatus.restaurant_timings || []).filter(t => auth.myStatus.restaurant_settings?.timings?.[t]?.enabled);
  const firstTiming = timings[0] || (auth.myStatus.restaurant_timings || [])[0];
  const firstQty = previewItem.availableQuantities.find(q => q.def && q.onMenu !== false)
    || previewItem.availableQuantities.find(q => q.onMenu !== false)
    || previewItem.availableQuantities[0];
  const quantity = firstQty ? Number(firstQty.quantity) : 1;

  try {
    // Reuse orderMenuItem rendering and option-handling behavior directly (same as test flow).
    receiptTarget.empty();
    orderMenuItem(
      null,
      previewItem.entityType || previewItem.entitytype || 'Meal',
      previewItem.id,
      quantity,
      true,
      fakeMate.id,
      firstTiming,
      '',
      [],
      '',
      [],
      undefined,
      false,
      false,
      false,
      true,
      new $.Deferred(),
      receiptTarget,
      previewItem
    );

    const previewRoot = receiptTarget.children('.chooseOption').last().detach();
    const orderRoot = previewRoot.find('#orderMenuItem.modal').first();

    receiptTarget.empty().toggleClass('has-preview', orderRoot.length > 0);
    if (previewRoot.length) {
      previewRoot.addClass('menuitem-order-preview-host');
      orderRoot.addClass('menuitem-order-preview-modal');
      receiptTarget.append(previewRoot);
    }
  } catch (e) {
    console.error('Order preview render error:', e);
    receiptTarget.html('<em>' + escapeExcerptHtml('Preview error: ' + e.message) + '</em>');
  } finally {
    admin.tableMatesMap.delete(PREVIEW_MATE_ID);
  }
}

function refreshMenuitemExcerpt(modal) {
  if (!modal || !modal.length) {
    return;
  }
  if (modal.attr("id") === "editMenuItem") {
    if (!isMenuitemExcerptVisible(modal) || !isMenuitemExcerptEnabled(modal)) {
      const receiptTarget = modal.find(".menuitem-receipt-excerpt[data-excerpt-kind='item']").first();
      receiptTarget.removeClass("has-preview").empty();
      return;
    }
    renderMenuItemSettingsExcerpt(modal);
  } else if (modal.attr("id") === "editMenuCategory") {
    renderCategorySettingsExcerpt(modal);
  }
}

const MENUITEM_EXCERPT_ZOOM_STORAGE_KEY = "menuitemExcerptItemZoom";
const MENUITEM_EXCERPT_MODE_STORAGE_KEY = "menuitemExcerptItemMode";
const MENUITEM_EXCERPT_ENABLED_STORAGE_KEY = "menuitemExcerptItemEnabled";

function normalizeMenuitemExcerptMode(value) {
  return value === "live" ? "live" : "on-demand";
}

function isMenuitemExcerptVisible(modal) {
  if (!modal || !modal.length || modal.attr("id") !== "editMenuItem") {
    return true;
  }
  const parentCategoryId = Number(modal.find("#parentCategoryId").val()) || 0;
  if (parentCategoryId) {
    const menuItem = $.extend(true, {}, menuitemutil.data || {}, { menuCategoryId: parentCategoryId });
    if (menuItem.connectedRestaurants) {
      Object.keys(menuItem.connectedRestaurants).forEach(key => {
        if (menuItem.connectedRestaurants[key]) {
          menuItem.connectedRestaurants[key].menuCategoryId = parentCategoryId;
        }
      });
    }
    const parentCategory = getMenuCategory(menuItem);
    if (!parentCategory || !parentCategory.defaultTop) {
      return false;
    }
  }

  const topToggle = modal.find("#mi_isTop").first();
  return !topToggle.length || !!topToggle.prop("checked");
}

function applyMenuitemExcerptVisibility(modal) {
  const visible = isMenuitemExcerptVisible(modal);
  const sectionPanel = modal.find("#menuitem-excerpt-section").closest(".menuitem-section-panel");
  const tab = modal.find(".menuitem-section-nav [data-menuitem-section='excerpt']");

  sectionPanel.toggle(visible);
  tab.toggle(visible);

  if (!visible) {
    setMenuitemExcerptMaximized(modal, false);
    const active = modal.find(".menuitem-section-nav [data-menuitem-section].active").data("menuitem-section");
    if (active === "excerpt") {
      setMenuitemSectionTabActive(modal, "links");
    }
  }
  return visible;
}

function applyMenuitemExcerptMode(modal, value, persist = false) {
  const mode = normalizeMenuitemExcerptMode(value);
  const liveToggle = modal.find(".menuitem-excerpt-live-toggle");

  modal.data("menuitemExcerptMode", mode);
  liveToggle.toggleClass("btn-primary active", mode === "live");
  liveToggle.toggleClass("btn-light", mode !== "live");
  liveToggle.attr("aria-pressed", mode === "live" ? "true" : "false");

  if (persist) {
    localStorage.setItem(MENUITEM_EXCERPT_MODE_STORAGE_KEY, mode);
  }
  return mode;
}

function setMenuitemExcerptRefreshNeeded(modal, needed) {
  const refreshBtn = modal.find(".menuitem-excerpt-refresh");
  refreshBtn.toggleClass("menuitem-excerpt-refresh--needs", !!needed);
  modal.data("menuitemExcerptNeedsRefresh", !!needed);
}

function isMenuitemExcerptEnabled(modal) {
  const enabled = modal && modal.data("menuitemExcerptEnabled");
  return enabled !== false;
}

function applyMenuitemExcerptEnabled(modal, value, persist = false) {
  const enabled = !(value === false || value === "false");
  const toggleBtn = modal.find(".menuitem-excerpt-toggle");
  const controls = modal.find(".menuitem-excerpt-controls[data-excerpt-kind='item']");
  const block = modal.find(".menuitem-excerpt-block[data-excerpt-kind='item']").first();
  const receiptTarget = modal.find(".menuitem-receipt-excerpt[data-excerpt-kind='item']").first();
  const toggleLabel = enabled
    ? (admin_local.switch_off_preview || "Switch off preview")
    : (admin_local.switch_on_preview || "Switch on preview");

  modal.data("menuitemExcerptEnabled", enabled);
  toggleBtn.text(toggleLabel);
  toggleBtn.toggleClass("btn-primary active", enabled);
  toggleBtn.toggleClass("btn-light", !enabled);
  toggleBtn.attr("aria-pressed", enabled ? "true" : "false");
  controls.toggleClass("menuitem-excerpt-controls--preview-off", !enabled);
  block.toggle(enabled);

  receiptTarget.toggleClass("menuitem-receipt-excerpt--collapsed", !enabled);
  if (!enabled) {
    receiptTarget.removeClass("has-preview").empty();
    setMenuitemExcerptMaximized(modal, false);
    setMenuitemExcerptRefreshNeeded(modal, false);
  }

  if (persist) {
    localStorage.setItem(MENUITEM_EXCERPT_ENABLED_STORAGE_KEY, enabled ? "true" : "false");
  }
  return enabled;
}

function normalizeMenuitemExcerptZoom(value) {
  const parsed = Number(value);
  if (isNaN(parsed)) {
    return 0.85;
  }
  return Math.min(1, Math.max(0.6, parsed));
}

function applyMenuitemExcerptZoom(modal, value, persist = false) {
  const zoom = normalizeMenuitemExcerptZoom(value);
  modal.find(".menuitem-receipt-excerpt[data-excerpt-kind='item']")
    .css("--menuitem-excerpt-zoom", zoom.toFixed(2));
  modal.find(".menuitem-excerpt-controls[data-excerpt-kind='item'] .menuitem-excerpt-zoom-input")
    .val(zoom.toFixed(2));
  modal.find(".menuitem-excerpt-controls[data-excerpt-kind='item'] .menuitem-excerpt-zoom-value")
    .text(Math.round(zoom * 100) + "%");
  if (persist) {
    localStorage.setItem(MENUITEM_EXCERPT_ZOOM_STORAGE_KEY, zoom.toFixed(2));
  }
}

function setMenuitemExcerptMaximized(modal, maximized) {
  const block = modal.find(".menuitem-excerpt-block[data-excerpt-kind='item']").first();
  const controls = modal.find(".menuitem-excerpt-controls[data-excerpt-kind='item']").first();
  const toggle = modal.find(".menuitem-excerpt-controls[data-excerpt-kind='item'] .menuitem-excerpt-maximize-toggle").first();
  if (!block.length || !toggle.length) {
    return;
  }

  block.toggleClass("menuitem-excerpt-block--maximized", !!maximized);
  controls.toggleClass("menuitem-excerpt-controls--floating", !!maximized);
  modal.toggleClass("menuitem-excerpt-maximized", !!maximized);
  toggle.toggleClass("icon-resize-full", !maximized).toggleClass("icon-resize-small", !!maximized);
  const label = maximized ? (admin_local.restore || "Restore") : (admin_local.maximize || "Maximize");
  toggle.attr("title", label).attr("aria-label", label);
}

function bindMenuitemExcerpt(modal) {
  if (!modal || !modal.length) {
    return;
  }

  const storedZoom = localStorage.getItem(MENUITEM_EXCERPT_ZOOM_STORAGE_KEY);
  const storedMode = localStorage.getItem(MENUITEM_EXCERPT_MODE_STORAGE_KEY);
  const storedEnabled = localStorage.getItem(MENUITEM_EXCERPT_ENABLED_STORAGE_KEY);
  applyMenuitemExcerptZoom(modal, storedZoom || 0.85, false);
  const initialMode = applyMenuitemExcerptMode(modal, storedMode || "on-demand", false);
  applyMenuitemExcerptEnabled(modal, storedEnabled == null ? true : storedEnabled, false);
  setMenuitemExcerptRefreshNeeded(modal, false);
  applyMenuitemExcerptVisibility(modal);
  setMenuitemExcerptMaximized(modal, false);

  const schedule = force => {
    if (!isMenuitemExcerptVisible(modal) || !isMenuitemExcerptEnabled(modal)) {
      return;
    }
    const mode = normalizeMenuitemExcerptMode(modal.data("menuitemExcerptMode") || initialMode);
    if (!force && mode !== "live") {
      setMenuitemExcerptRefreshNeeded(modal, true);
      return;
    }
    const pending = modal.data("menuitemExcerptRefreshTimer");
    if (pending) {
      clearTimeout(pending);
    }
    // 350ms debounce: chooseMates template render is more expensive than simple HTML.
    modal.data("menuitemExcerptRefreshTimer", setTimeout(() => {
      setMenuitemExcerptRefreshNeeded(modal, false);
      refreshMenuitemExcerpt(modal);
    }, 350));
  };

  // Listen on meaningful form changes only (not every input event).
  modal.off(".menuitemExcerpt")
    .on("change.menuitemExcerpt", "input,select", function (event) {
      if ($(event.target).closest('.menuitem-receipt-excerpt[data-excerpt-kind="item"]').length) {
        return;
      }
      schedule();
    })
    .on("tokenize:tokens:added.menuitemExcerpt tokenize:tokens:removed.menuitemExcerpt tokenize:tokens:reorder.menuitemExcerpt", "*", function (event) {
      if ($(event.target).closest('.menuitem-receipt-excerpt[data-excerpt-kind="item"]').length) {
        return;
      }
      schedule();
    })
    .on("input.menuitemExcerpt change.menuitemExcerpt", ".menuitem-excerpt-zoom-input", function (event) {
      event.stopPropagation();
      applyMenuitemExcerptZoom(modal, $(this).val(), true);
    })
    .on("click.menuitemExcerpt", ".menuitem-excerpt-toggle", function (event) {
      event.preventDefault();
      const nextEnabled = !isMenuitemExcerptEnabled(modal);
      applyMenuitemExcerptEnabled(modal, nextEnabled, true);
      if (nextEnabled) {
        schedule(true);
      }
    })
    .on("click.menuitemExcerpt", ".menuitem-excerpt-live-toggle", function (event) {
      event.preventDefault();
      const current = normalizeMenuitemExcerptMode(modal.data("menuitemExcerptMode") || "on-demand");
      const mode = applyMenuitemExcerptMode(modal, current === "live" ? "on-demand" : "live", true);
      if (mode === "live" && isMenuitemExcerptEnabled(modal)) {
        setMenuitemExcerptRefreshNeeded(modal, false);
        schedule(true);
      }
    })
    .on("click.menuitemExcerpt", ".menuitem-excerpt-refresh", function (event) {
      event.preventDefault();
      applyMenuitemExcerptMode(modal, "on-demand", true);
      setMenuitemExcerptRefreshNeeded(modal, false);
      if (isMenuitemExcerptEnabled(modal)) {
        schedule(true);
      }
    })
    .on("click.menuitemExcerpt", ".menuitem-excerpt-maximize-toggle", function (event) {
      event.preventDefault();
      const block = modal.find(".menuitem-excerpt-block[data-excerpt-kind='item']").first();
      setMenuitemExcerptMaximized(modal, !block.hasClass("menuitem-excerpt-block--maximized"));
    });

  modal.find("#mi_isTop")
    .off("change.menuitemExcerptVisibility")
    .on("change.menuitemExcerptVisibility", () => {
      const visible = applyMenuitemExcerptVisibility(modal);
      if (visible) {
        schedule(true);
      }
    });

  modal.find("#parent_category")
    .off("change.menuitemExcerptVisibility")
    .on("change.menuitemExcerptVisibility", () => {
      const visible = applyMenuitemExcerptVisibility(modal);
      if (visible && isMenuitemExcerptEnabled(modal)) {
        schedule(true);
      }
    });

  // Watch the quantity table for row additions/removals.
  const prevObserver = modal.data("menuitemExcerptObserver");
  if (prevObserver) {
    prevObserver.disconnect();
  }
  const observer = new MutationObserver(schedule);
  modal.find("#menuItemQuantities tbody").each((_, target) => {
    if (target) observer.observe(target, { childList: true, subtree: false });
  });
  modal.data("menuitemExcerptObserver", observer);

  if (initialMode === "live") {
    schedule(true);
  } else {
    refreshMenuitemExcerpt(modal);
  }
}

function setMenuitemSectionTabActive(modal, sectionId) {
  const tabs = modal.find(".menuitem-section-nav [data-menuitem-section]");
  tabs.removeClass("btn-primary active").addClass("btn-light");
  tabs.filter(`[data-menuitem-section='${sectionId}']`).removeClass("btn-light").addClass("btn-primary active");
}

function bindMenuitemSectionSpy(modal, sections = menuitemSections) {
  const scrollContainer = modal.find(".menuitem-section-content").get(0) || modal.find(".modal-body.menu-dialog-body").get(0);
  if (!scrollContainer) {
    return;
  }

  const tabs = modal.find(".menuitem-section-nav [data-menuitem-section]");

  const cleanup = modal.data("menuitemSectionSpyCleanup");
  if (cleanup) {
    cleanup();
  }

  const updateActiveTab = () => {
    const containerRect = scrollContainer.getBoundingClientRect();
    const threshold = scrollContainer.scrollTop + Math.max(96, containerRect.height * 0.18);
    let activeSection = sections[0].id;

    sections.forEach(section => {
      const element = modal.find(section.selector).get(0);
      if (!element || !$(element).is(":visible")) {
        return;
      }
      const top = element.getBoundingClientRect().top - containerRect.top + scrollContainer.scrollTop;
      if (top <= threshold) {
        activeSection = section.id;
      }
    });

    setMenuitemSectionTabActive(modal, activeSection);
  };

  const onTabClick = event => {
    const sectionId = $(event.currentTarget).data("menuitem-section");
    if (sectionId) {
      setMenuitemSectionTabActive(modal, sectionId);
    }
  };

  const onScroll = () => updateActiveTab();
  scrollContainer.addEventListener("scroll", onScroll, { passive: true });
  tabs.off("click.menuitemSectionSpy").on("click.menuitemSectionSpy", onTabClick);
  modal.data("menuitemSectionSpyCleanup", () => {
    scrollContainer.removeEventListener("scroll", onScroll);
    tabs.off("click.menuitemSectionSpy", onTabClick);
  });
  updateActiveTab();
}

function ensureMenuEditorChangeTrackingStyles() {
  if (document.getElementById("menuitem-editor-change-tracking-style")) {
    return;
  }
  const style = document.createElement("style");
  style.id = "menuitem-editor-change-tracking-style";
  style.textContent = `
    .menuitem-field-changed {
      background: rgba(251, 191, 36, .22) !important;
      box-shadow: inset 0 0 0 1px rgba(245, 158, 11, .55);
      border-radius: .3rem;
      transition: background .15s ease, box-shadow .15s ease;
    }
    .menuitem-change-summary-popup {
      position: absolute;
      top: .55rem;
      right: .55rem;
      z-index: 6;
      width: min(30rem, calc(100% - 1.1rem));
      max-height: 34vh;
      overflow: auto;
      background: rgba(15, 23, 42, .96);
      color: #e2e8f0;
      border: 1px solid rgba(148, 163, 184, .35);
      border-radius: .45rem;
      box-shadow: 0 10px 24px rgba(0, 00, 0, .32);
      padding: .45rem .5rem;
      font-size: .68rem;
      line-height: 1.35;
      display: none !important;
    }
    .menuitem-change-summary-popup .menuitem-change-summary-title {
      font-weight: 700;
      margin-bottom: .25rem;
      opacity: .95;
    }
    .menuitem-change-summary-popup .menuitem-change-summary-row {
      display: grid;
      grid-template-columns: minmax(7rem, 10rem) minmax(0, 1fr);
      gap: .35rem;
      margin-bottom: .18rem;
      align-items: start;
    }
    .menuitem-change-summary-popup .menuitem-change-summary-label {
      color: #f8fafc;
      font-weight: 600;
      word-break: break-word;
    }
    .menuitem-change-summary-popup .menuitem-change-summary-diff {
      color: #fcd34d;
      word-break: break-word;
    }
  `;
  document.head.appendChild(style);
}

function formatMenuEditorTrackedValue(value) {
  if (value === null || typeof value === "undefined") {
    return "";
  }
  if (Array.isArray(value)) {
    return value.map(item => (item == null ? "" : String(item))).join(", ");
  }
  if (typeof value === "boolean") {
    return value ? "true" : "false";
  }
  return String(value).trim();
}

function shouldNormalizeMenuEditorTrackedArrayOrder(control) {
  if (!control || !control.length) {
    return false;
  }

  const id = (control.attr("id") || "").toString().toLowerCase();
  if (id === "upsellmenuitems") {
    return true;
  }
  return /^(item|category)_additions_(mandatory|included|optional)$/.test(id);
}

function isMenuEditorTokenizerControl(control) {
  if (!control || !control.length) {
    return false;
  }

  const node = control.first();
  if (node.closest(".tokenize").length) {
    return node.is("select,textarea") || !!node.attr("data-tr-key") || !!node.attr("data-tokenize2");
  }

  return shouldNormalizeMenuEditorTrackedArrayOrder(control);
}

function tMenuEditor(key, fallback = "") {
  const table = admin_local?.menu_editor_texts || admin_local?.menuEditorTexts || {};
  if (typeof table[key] !== "undefined") {
    return table[key];
  }
  return fallback || key;
}

function localizeMenuEditorEntityType(typeValue) {
  const normalized = (typeValue || "").toString().trim().toLowerCase();
  if (normalized === "meal") {
    return tMenuEditor("meal", typeValue);
  }
  if (normalized === "drink") {
    return tMenuEditor("drink", typeValue);
  }
  if (normalized === "mealcategory") {
    return tMenuEditor("mealCategory", "meal category");
  }
  if (normalized === "drinkcategory") {
    return tMenuEditor("drinkCategory", "drink category");
  }
  return typeValue;
}

function getMenuEditorTokenizerTargetLabel(control) {
  if (!control || !control.length) {
    return tMenuEditor("options", "options");
  }

  const id = (control.attr("id") || "").toString().toLowerCase();
  if (id === "upsellmenuitems") {
    return admin_local?.upsell_items || "upsell items";
  }
  if (id.endsWith("_mandatory")) {
    return tMenuEditor("mandatoryOptions", "mandatory options");
  }
  if (id.endsWith("_included")) {
    return tMenuEditor("includedOptions", "included options");
  }
  if (id.endsWith("_optional")) {
    return tMenuEditor("optionalAdditions", "optional additions");
  }
  return tMenuEditor("options", "options");
}

function getMenuEditorTokenizerSettingLabel(control) {
  if (!control || !control.length) {
    return "";
  }

  const id = (control.attr("id") || "").toString().toLowerCase();
  if (id === "quantity") {
    return tMenuEditor("quantity", "quantity");
  }
  if (id === "min") {
    return tMenuEditor("min", "min");
  }
  if (id === "max") {
    return tMenuEditor("max", "max");
  }
  if (id.startsWith("check2") || id.startsWith("check") || id.startsWith("radio2") || id.startsWith("radio")) {
    return tMenuEditor("type", "type");
  }
  if (control.hasClass("local")) {
    return tMenuEditor("local", "local");
  }
  if (control.hasClass("takeaway")) {
    return tMenuEditor("takeaway", "takeaway");
  }
  if (control.hasClass("proportional")) {
    return tMenuEditor("proportional", "proportional");
  }
  return "";
}

function getMenuEditorTokenizerControlStateLabel(control, value) {
  if (!control || !control.length) {
    return formatMenuEditorTrackedValue(value);
  }

  if (control.is(":checkbox")) {
    return value === "true" || value === true ? tMenuEditor("enabled", "enabled") : tMenuEditor("disabled", "disabled");
  }

  if (control.is(":radio")) {
    return value === "true" || value === true ? tMenuEditor("selected", "selected") : tMenuEditor("notSelected", "not selected");
  }

  return formatMenuEditorTrackedValue(value);
}

function getMenuEditorTokenizerTokenNode(control, tokenValue = "") {
  if (!control || !control.length) {
    return $();
  }

  const tokenItem = control.closest("li.token[data-value]");
  if (tokenItem.length) {
    return tokenItem.first();
  }

  const safeValue = (tokenValue || "").toString();
  const tokenNode = control.next().find("li.token").filter(function () {
    return (($(this).attr("data-value") || "").toString() === safeValue);
  }).first();
  return tokenNode;
}

function getMenuEditorTokenizerEntityLabel(control) {
  const key = getMenuEditorTokenizerEntityKey(control);
  if (key === "category") {
    return tMenuEditor("categoryAddition", "category addition");
  }
  if (key === "item") {
    return tMenuEditor("menuitemAddition", "menuitem addition");
  }
  return tMenuEditor("token", "token");
}

function getMenuEditorTokenizerEntityKey(control) {
  if (!control || !control.length) {
    return "token";
  }

  const id = (control.attr("id") || "").toString().toLowerCase();
  if (id.indexOf("category_additions") >= 0) {
    return "category";
  }
  if (id.indexOf("item_additions") >= 0) {
    return "item";
  }
  return "token";
}

function getMenuEditorTokenizerTokenKind(tokenValue) {
  const parts = (tokenValue || "").toString().split(";");
  return (parts[0] || "").toString().trim().toLowerCase();
}

function extractMenuEditorTokenLabel(rawValue) {
  const input = (rawValue || "").toString();
  if (!input.trim()) {
    return "";
  }

  const decoded = input.indexOf("&") >= 0
    ? $("<textarea>").html(input).text()
    : "";
  const candidates = [input, decoded].filter(Boolean);

  for (let i = 0; i < candidates.length; i++) {
    const candidate = candidates[i];
    const taggedTextParts = [];
    candidate.replace(/<text>(.*?)<\/text>/gi, (_, value) => {
      const normalized = (value || "").toString().replace(/\s+/g, " ").trim();
      if (normalized) {
        taggedTextParts.push(normalized);
      }
      return _;
    });
    if (taggedTextParts.length) {
      return taggedTextParts[0];
    }

    const cleanedText = candidate
      .replace(/<[^>]+>/g, " ")
      .replace(/\s+/g, " ")
      .trim();
    if (cleanedText) {
      return cleanedText;
    }
  }

  return "";
}

function getMenuEditorTokenizerDisplayName(control, tokenValue) {
  const rawTokenValue = (tokenValue || "").toString().trim();

  // Prefer semantic lookup from token value to avoid merged text from token internals
  // (e.g. min/max control labels leaking into the display name).
  if (rawTokenValue) {
    const parts = rawTokenValue.split(";");
    const tokenKind = (parts[0] || "").toString().trim().toLowerCase();
    const targetId = Number(parts[2] || 0);

    if (Number.isFinite(targetId) && targetId > 0) {
      if (tokenKind === "menucategory") {
        const categoryPath = resolveMenuCategoryNameById(targetId);
        if (categoryPath) {
          return categoryPath;
        }
      }

      if (tokenKind === "menuitem") {
        const menuItem = menuitemutil.getMenuItem(targetId) || admin.getMenuItemAdmin(targetId);
        if (menuItem) {
          const path = menuitemutil.getPath(menuItem);
          if (path) {
            return path;
          }
        }
        const fallbackName = resolveMenuItemNameById(targetId);
        if (fallbackName) {
          return fallbackName;
        }
      }
    }
  }

  const extractedFromValue = extractMenuEditorTokenLabel(rawTokenValue);
  if (extractedFromValue) {
    return extractedFromValue;
  }

  if (!control || !control.length) {
    return rawTokenValue || "token";
  }

  const safeValue = rawTokenValue;
  const tokenNode = getMenuEditorTokenizerTokenNode(control, safeValue);
  if (!tokenNode.length) {
    return safeValue || "token";
  }

  const tokenText = (tokenNode.text() || "").toString();
  if (!tokenText.trim()) {
    return safeValue || "token";
  }

  const extractedFromNode = extractMenuEditorTokenLabel(tokenText);
  if (extractedFromNode) {
    return extractedFromNode;
  }

  const firstLine = tokenText.split("\n").map(line => line.trim()).filter(Boolean)[0];
  return firstLine || safeValue || "token";
}

function buildMenuEditorTokenizerChangePhrase(control, action, tokenValue, stateSignature = "{}") {
  const rawDisplayName = getMenuEditorTokenizerDisplayName(control, tokenValue);
  const displayName = extractMenuEditorTokenLabel(rawDisplayName) || rawDisplayName;
  const entityLabel = getMenuEditorTokenizerEntityLabel(control);
  const targetLabel = getMenuEditorTokenizerTargetLabel(control);
  const actionLabel = action === "removed_from"
    ? tMenuEditor("removedFrom", "was removed from")
    : tMenuEditor("addedTo", "was added to");
  return `${displayName} | ${entityLabel} | ${actionLabel} ${targetLabel}${getMenuEditorTokenizerSettingsSummary(control, tokenValue, stateSignature)}`;
}

function buildMenuEditorTokenizerControlChangePhrase(control, label, originalValue, currentValue) {
  const normalizedLabel = (label || "").toString().trim() || tMenuEditor("tokenOption", "token option");
  const fromText = extractMenuEditorTokenLabel(getMenuEditorTokenizerControlStateLabel(control, originalValue))
    || getMenuEditorTokenizerControlStateLabel(control, originalValue);
  const toText = extractMenuEditorTokenLabel(getMenuEditorTokenizerControlStateLabel(control, currentValue))
    || getMenuEditorTokenizerControlStateLabel(control, currentValue);
  return `${normalizedLabel}: ${fromText || getMenuEditorEmptyText()} -> ${toText || getMenuEditorEmptyText()}`;
}

function getMenuEditorTokenizerSettingsSummary(control, tokenValue, stateSignature = "{}") {
  const entityKey = getMenuEditorTokenizerEntityKey(control);
  const tokenKind = getMenuEditorTokenizerTokenKind(tokenValue);
  const isCategoryOptionToken = tokenKind === "menucategory";
  const tokenNode = getMenuEditorTokenizerTokenNode(control, tokenValue);
  const trackedState = parseMenuEditorTokenizerOptionState(stateSignature);

  const parts = (tokenValue || "").toString().split(";");
  const details = [];

  if (entityKey === "item" && !isCategoryOptionToken) {
    const quantity = (trackedState.quantity == null ? (parts[3] || "") : trackedState.quantity).toString().trim();
    const additionType = (trackedState.type == null ? (parts[4] || "") : trackedState.type).toString().trim();
    if (additionType) {
      details.push(`${tMenuEditor("typeLabel", "type")}: ${localizeMenuEditorEntityType(additionType)}`);
    }
    if (quantity) {
      details.push(`${tMenuEditor("quantityLabel", "quantity")}: ${quantity}`);
    }
    const localEnabled = typeof trackedState.local === "boolean"
      ? trackedState.local
      : (tokenNode.length ? !!tokenNode.find("input.local").prop("checked") : false);
    const takeawayEnabled = typeof trackedState.takeaway === "boolean"
      ? trackedState.takeaway
      : (tokenNode.length ? !!tokenNode.find("input.takeaway").prop("checked") : false);
    const proportionalEnabled = typeof trackedState.proportional === "boolean"
      ? trackedState.proportional
      : (tokenNode.length ? !!tokenNode.find("input.proportional").prop("checked") : false);
    if (localEnabled) {
      details.push(tMenuEditor("local", "local"));
    }
    if (takeawayEnabled) {
      details.push(tMenuEditor("takeaway", "takeaway"));
    }
    if (proportionalEnabled) {
      details.push(tMenuEditor("proportional", "proportional"));
    }
  } else if (entityKey === "category" || isCategoryOptionToken) {
    let optionType = (trackedState.type || "").toString().trim().toLowerCase();
    let min = (trackedState.min == null ? "" : trackedState.min).toString().trim();
    let max = (trackedState.max == null ? "" : trackedState.max).toString().trim();
    if (tokenNode.length) {
      if (!optionType && tokenNode.find('input[id="check' + tokenValue + '"]').prop("checked")) {
        optionType = "multiple";
      } else if (!optionType && tokenNode.find('input[id="check2' + tokenValue + '"]').prop("checked")) {
        optionType = "separate";
      } else if (!optionType && tokenNode.find('input[id="radio' + tokenValue + '"]').prop("checked")) {
        optionType = "maxone";
      } else if (!optionType && tokenNode.find('input[id="radio2' + tokenValue + '"]').prop("checked")) {
        optionType = "one";
      }
      if (!min) {
        min = (tokenNode.find("input#min").val() || "").toString().trim();
      }
      if (!max) {
        max = (tokenNode.find("input#max").val() || "").toString().trim();
      }
    }

    const proportionalEnabled = typeof trackedState.proportional === "boolean"
      ? trackedState.proportional
      : (tokenNode.length ? !!tokenNode.find("input.proportional").prop("checked") : false);

    if (optionType) {
      const mappedType = optionType === "multiple"
        ? tMenuEditor("categoryTypeMultiple", "multiple")
        : optionType === "separate"
          ? tMenuEditor("categoryTypeSeparate", "separate")
          : optionType === "maxone"
            ? tMenuEditor("categoryTypeMaxOne", "max one")
            : optionType === "one"
              ? tMenuEditor("categoryTypeOne", "exactly one")
              : optionType;
      details.push(`${tMenuEditor("typeLabel", "type")}: ${mappedType}`);
    }

    if (proportionalEnabled) {
      details.push(tMenuEditor("proportional", "proportional"));
    }

    if (optionType === "separate" && (min || max)) {
      details.push(`${tMenuEditor("minLabel", "min")}: ${min || "0"}`);
      details.push(`${tMenuEditor("maxLabel", "max")}: ${max || "*"}`);
    }
  }

  return details.length ? ` [${details.join(" | ")}]` : "";
}

function getMenuEditorTokenizerOptionState(control, tokenValue) {
  const entityKey = getMenuEditorTokenizerEntityKey(control);
  const tokenKind = getMenuEditorTokenizerTokenKind(tokenValue);
  const isCategoryOptionToken = tokenKind === "menucategory";
  const tokenNode = getMenuEditorTokenizerTokenNode(control, tokenValue);
  const parts = (tokenValue || "").toString().split(";");
  const state = {};

  if (entityKey === "item" && !isCategoryOptionToken) {
    state.type = (parts[4] || "").toString().trim().toLowerCase();
    state.quantity = (parts[3] || "").toString().trim();
    if (tokenNode.length) {
      const quantityInput = (tokenNode.find("input#quantity").first().val() || "").toString().trim();
      if (quantityInput !== "") {
        state.quantity = quantityInput;
      }
      state.local = !!tokenNode.find("input.local").prop("checked");
      state.takeaway = !!tokenNode.find("input.takeaway").prop("checked");
      state.proportional = !!tokenNode.find("input.proportional").prop("checked");
    }
  } else if (entityKey === "category" || isCategoryOptionToken) {
    let optionType = "";
    if (tokenNode.length) {
      if (tokenNode.find('input[id="check' + tokenValue + '"]').prop("checked")) {
        optionType = "multiple";
      } else if (tokenNode.find('input[id="check2' + tokenValue + '"]').prop("checked")) {
        optionType = "separate";
      } else if (tokenNode.find('input[id="radio' + tokenValue + '"]').prop("checked")) {
        optionType = "maxone";
      } else if (tokenNode.find('input[id="radio2' + tokenValue + '"]').prop("checked")) {
        optionType = "one";
      }
      state.proportional = !!tokenNode.find("input.proportional").prop("checked");
      state.min = (tokenNode.find("input#min").val() || "").toString().trim();
      state.max = (tokenNode.find("input#max").val() || "").toString().trim();
    }
    state.type = optionType;
  }

  return state;
}

function serializeMenuEditorTokenizerOptionState(state) {
  if (!state || typeof state !== "object") {
    return "{}";
  }
  const normalized = {};
  Object.keys(state).sort().forEach(key => {
    normalized[key] = state[key];
  });
  return JSON.stringify(normalized);
}

function parseTrackedTokenizerEntry(entry) {
  const raw = (entry || "").toString();
  const separator = "@@";
  const index = raw.indexOf(separator);
  if (index < 0) {
    return { tokenValue: raw.trim(), stateSignature: "{}" };
  }
  return {
    tokenValue: raw.slice(0, index).trim(),
    stateSignature: raw.slice(index + separator.length).trim() || "{}"
  };
}

function parseMenuEditorTokenizerOptionState(signature) {
  try {
    const parsed = JSON.parse((signature || "{}").toString());
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (error) {
    return {};
  }
}

function mapMenuEditorTokenizerOptionType(type) {
  if (type === "multiple") {
    return tMenuEditor("categoryTypeMultiple", "multiple");
  }
  if (type === "separate") {
    return tMenuEditor("categoryTypeSeparate", "separate");
  }
  if (type === "maxone") {
    return tMenuEditor("categoryTypeMaxOne", "max one");
  }
  if (type === "one") {
    return tMenuEditor("categoryTypeOne", "exactly one");
  }
  return type || "";
}

function formatMenuEditorTokenizerStateDiff(control, beforeState, afterState, tokenValue = "") {
  const entityKey = getMenuEditorTokenizerEntityKey(control);
  const tokenKind = getMenuEditorTokenizerTokenKind(tokenValue);
  const isCategoryOptionToken = tokenKind === "menucategory";
  const beforeType = ((beforeState && beforeState.type) || "").toString().trim().toLowerCase();
  const afterType = ((afterState && afterState.type) || "").toString().trim().toLowerCase();
  const showMinMaxDiff = beforeType === "separate" || afterType === "separate";
  const keys = Array.from(new Set([
    ...Object.keys(beforeState || {}),
    ...Object.keys(afterState || {})
  ])).sort();

  const diffs = [];
  keys.forEach(key => {
    if ((key === "min" || key === "max") && !showMinMaxDiff) {
      return;
    }

    const from = beforeState ? beforeState[key] : undefined;
    const to = afterState ? afterState[key] : undefined;
    if (String(from) === String(to)) {
      return;
    }

    const label = key === "quantity"
      ? tMenuEditor("quantityLabel", "quantity")
      : key === "type"
        ? tMenuEditor("typeLabel", "type")
        : key === "min"
          ? tMenuEditor("minLabel", "min")
          : key === "max"
            ? tMenuEditor("maxLabel", "max")
            : key === "local"
              ? tMenuEditor("local", "local")
              : key === "takeaway"
                ? tMenuEditor("takeaway", "takeaway")
                : key === "proportional"
                  ? tMenuEditor("proportional", "proportional")
                  : key;

    const mapValue = value => {
      if (value === true || value === "true") {
        return tMenuEditor("enabled", "enabled");
      }
      if (value === false || value === "false") {
        return tMenuEditor("disabled", "disabled");
      }
      if (key === "type") {
        return (entityKey === "item" && !isCategoryOptionToken)
          ? localizeMenuEditorEntityType(value)
          : mapMenuEditorTokenizerOptionType(value);
      }
      return (value == null || value === "") ? "-" : String(value);
    };

    diffs.push(`${label}: ${mapValue(from)} -> ${mapValue(to)}`);
  });

  return diffs.length ? ` [${diffs.join(" | ")}]` : "";
}

function buildMenuEditorTokenizerUpdatePhrase(control, tokenValue, beforeSignature, afterSignature) {
  const displayName = getMenuEditorTokenizerDisplayName(control, tokenValue);
  const entityLabel = getMenuEditorTokenizerEntityLabel(control);
  const targetLabel = getMenuEditorTokenizerTargetLabel(control);
  const beforeState = parseMenuEditorTokenizerOptionState(beforeSignature);
  const afterState = parseMenuEditorTokenizerOptionState(afterSignature);
  const diff = formatMenuEditorTokenizerStateDiff(control, beforeState, afterState, tokenValue);
  const contextSummary = getMenuEditorTokenizerSettingsSummary(control, tokenValue, afterSignature);
  const suffix = diff
    ? (contextSummary && contextSummary !== diff ? `${diff}${contextSummary}` : diff)
    : contextSummary;
  return `${displayName} | ${entityLabel} | ${tMenuEditor("updatedIn", "was updated in")} ${targetLabel}${suffix}`;
}

function splitMenuEditorTrackedTokenList(value) {
  const text = formatMenuEditorTrackedValue(value);
  if (!text) {
    return [];
  }

  return text
    .split(/\n+/)
    .map(item => item.trim())
    .filter(Boolean);
}

function summarizeMenuEditorTokenizerChange(control, label, originalValue, currentValue) {
  const beforeEntries = splitMenuEditorTrackedTokenList(originalValue).map(parseTrackedTokenizerEntry);
  const afterEntries = splitMenuEditorTrackedTokenList(currentValue).map(parseTrackedTokenizerEntry);
  const beforeByToken = new Map(beforeEntries.map(entry => [entry.tokenValue, entry.stateSignature]));
  const afterByToken = new Map(afterEntries.map(entry => [entry.tokenValue, entry.stateSignature]));

  const added = [];
  const removed = [];
  const updated = [];

  afterByToken.forEach((stateSignature, tokenValue) => {
    if (!beforeByToken.has(tokenValue)) {
      added.push(tokenValue);
      return;
    }
    const beforeSignature = beforeByToken.get(tokenValue) || "{}";
    if (beforeSignature !== stateSignature) {
      updated.push({ tokenValue, beforeSignature, afterSignature: stateSignature });
    }
  });

  beforeByToken.forEach((_stateSignature, tokenValue) => {
    if (!afterByToken.has(tokenValue)) {
      removed.push(tokenValue);
    }
  });

  const normalizedLabel = (label || "").toString().trim() || getMenuEditorTokenizerTargetLabel(control);

  const phrases = [];
  added.forEach(tokenValue => {
    const stateSignature = afterByToken.get(tokenValue) || "{}";
    phrases.push(buildMenuEditorTokenizerChangePhrase(control, "added_to", tokenValue, stateSignature));
  });
  removed.forEach(tokenValue => {
    const stateSignature = beforeByToken.get(tokenValue) || "{}";
    phrases.push(buildMenuEditorTokenizerChangePhrase(control, "removed_from", tokenValue, stateSignature));
  });
  updated.forEach(change => {
    phrases.push(buildMenuEditorTokenizerUpdatePhrase(control, change.tokenValue, change.beforeSignature, change.afterSignature));
  });

  if (!phrases.length) {
    return `${normalizedLabel}: ${tMenuEditor("noTokenChanges", "no token changes")}`;
  }

  return phrases.join(" • ");
}

function isMenuEditorTokenizerInnerControl(control) {
  if (!control || !control.length) {
    return false;
  }

  const node = control.first();
  const nodeId = (node.attr("id") || "").toString().trim().toLowerCase();
  const nodeName = (node.attr("name") || "").toString().trim().toLowerCase();
  const looksLikeTokenizerOptionField = /^(quantity|min|max|type|local|takeaway|proportional)$/.test(nodeId)
    || /^(quantity|min|max|type|local|takeaway|proportional)$/.test(nodeName);

  const tokenNode = control.closest("li.token[data-value]");
  if (!tokenNode.length) {
    if (!looksLikeTokenizerOptionField) {
      return false;
    }

    if (control.closest(".tokenize, .token, .tokens-container, .tokenize-control, .tokenize-dropdown").length) {
      return true;
    }

    const tokenizerSource = control.closest("tr,td,th,.form-group,.input-group").find(
      "select[id^='item_additions_'],select[id^='category_additions_'],textarea[id^='item_additions_'],textarea[id^='category_additions_']"
    );
    return !!tokenizerSource.length;
  }

  return control.is(":checkbox,:radio,:input") || looksLikeTokenizerOptionField;
}

function isTrackableMenuEditorControl(control) {
  if (!control || !control.length) {
    return false;
  }

  const node = control.first();
  const type = (node.attr("type") || "").toLowerCase();
  if (type === "hidden" || type === "button" || type === "submit" || type === "reset") {
    return false;
  }

  // Tokenize2 renders transient/search/token-internal inputs; ignore them to avoid false positives.
  if (node.closest("li.token[data-value], li.token-search, .tokenize .token, .tokenize .token-search, .tokens-container, .tokenize-dropdown").length) {
    return false;
  }

  return true;
}

function isMenuEditorAllergenControl(control) {
  if (!control || !control.length) {
    return false;
  }
  return control.is("#allergens,#category_allergens");
}

function getMenuEditorAllergenState(control) {
  if (!isMenuEditorAllergenControl(control)) {
    return "";
  }

  const direct = control.children("*.has:not(.removable)")
    .map((_, item) => (item?.id || "").toString().trim())
    .get()
    .filter(Boolean)
    .sort();
  const removable = control.children("*.has.removable")
    .map((_, item) => (item?.id || "").toString().trim())
    .get()
    .filter(Boolean)
    .sort();

  return `default:${direct.join(",")}|removable:${removable.join(",")}`;
}

function getMenuEditorAllergenDisplayValue(control) {
  if (!isMenuEditorAllergenControl(control)) {
    return "";
  }

  const direct = control.children("*.has:not(.removable)")
    .map((_, item) => (item?.id || "").toString().trim())
    .get()
    .filter(Boolean)
    .sort();
  const removable = control.children("*.has.removable")
    .map((_, item) => (item?.id || "").toString().trim())
    .get()
    .filter(Boolean)
    .sort();

  if (!direct.length && !removable.length) {
    return "(none)";
  }

  const directLabel = direct.length ? direct.map(localizeMenuEditorAllergenToken).join(", ") : "-";
  const removableLabel = removable.length ? removable.map(localizeMenuEditorAllergenToken).join(", ") : "-";
  return `default: ${directLabel}; removable: ${removableLabel}`;
}

function localizeMenuEditorAllergenToken(token) {
  const key = (token || "").toString().trim().toLowerCase();
  if (!key) {
    return "";
  }
  const localized = I18n.t(`admin_local.${key}`);
  return localized || token;
}
function getMenuEditorRemovableAllergenLabel() {
  const withoutAllergenPattern = (admin_local?.without_allergen || "").toString();
  if (withoutAllergenPattern) {
    const cleaned = withoutAllergenPattern
      .replace(/\{\s*0\s*\}/g, "")
      .replace(/\s+/g, " ")
      .trim();
    if (cleaned) {
      return cleaned;
    }
  }
  return admin_local?.optional || "removable";
}

function parseMenuEditorAllergenState(stateValue) {
  const text = formatMenuEditorTrackedValue(stateValue);
  const result = { default: new Set(), removable: new Set() };
  if (!text) {
    return result;
  }

  const parts = text.split("|");
  parts.forEach(part => {
    const [rawKey, rawValues] = part.split(":");
    const key = (rawKey || "").toString().trim().toLowerCase();
    const values = (rawValues || "")
      .split(",")
      .map(value => value.trim())
      .filter(Boolean);

    if (key === "default") {
      values.forEach(value => result.default.add(value));
    }
    if (key === "removable") {
      values.forEach(value => result.removable.add(value));
    }
  });

  return result;
}

function formatMenuEditorAllergenDiffSummary(beforeValue, afterValue) {
  const beforeState = parseMenuEditorAllergenState(beforeValue);
  const afterState = parseMenuEditorAllergenState(afterValue);

  const formatBucketList = values => {
    const list = Array.from(values || []).sort().map(localizeMenuEditorAllergenToken).filter(Boolean);
    return list.length ? list.join(", ") : "-";
  };

  const buildBucketSummary = (bucketKey, label) => {
    const before = beforeState[bucketKey] || new Set();
    const after = afterState[bucketKey] || new Set();
    const beforeLabel = formatBucketList(before);
    const afterLabel = formatBucketList(after);
    if (beforeLabel === afterLabel) {
      return "";
    }
    return label ? `${label}: ${beforeLabel} -> ${afterLabel}` : `${beforeLabel} -> ${afterLabel}`;
  };

  const defaultSummary = buildBucketSummary("default", "");
  const removableSummary = buildBucketSummary("removable", getMenuEditorRemovableAllergenLabel());
  const summary = [defaultSummary, removableSummary].filter(Boolean).join("; ");
  return summary || "no allergen changes";
}

function collectMenuEditorTrackedControls(modal) {
  let controls = modal.find("input:not(.hidden),select:not(.hidden),textarea:not(.hidden)").filter(function () {
    const control = $(this);
    return isTrackableMenuEditorControl(control) && !isMenuEditorTokenizerInnerControl(control);
  });

  const allergenControls = modal.find("#allergens,#category_allergens").filter(function () {
    return !!$(this).length;
  });

  controls = controls.add(allergenControls);
  return controls;
}

function getMenuEditorNormalizedAdditionTokens(control) {
  if (!control || !control.length || !shouldNormalizeMenuEditorTrackedArrayOrder(control)) {
    return null;
  }

  let values = [];
  try {
    const tokenize = control.tokenize2();
    if (tokenize && typeof tokenize.toArray === "function") {
      values = tokenize.toArray() || [];
    }
  } catch (e) {
    values = [];
  }

  if (!values.length) {
    const fallbackValue = control.val();
    if (Array.isArray(fallbackValue)) {
      values = fallbackValue;
    } else if (typeof fallbackValue === "string" && fallbackValue) {
      values = fallbackValue.split(",");
    }
  }

  return values
    .map(item => {
      const tokenValue = formatMenuEditorTrackedValue(item);
      const optionState = getMenuEditorTokenizerOptionState(control, tokenValue);
      return `${tokenValue}@@${serializeMenuEditorTokenizerOptionState(optionState)}`;
    })
    .filter(item => item !== "")
    .sort()
    .join("\n");
}

function getMenuEditorControlTrackedValue(control) {
  if (!control || !control.length) {
    return "";
  }
  if (isMenuEditorAllergenControl(control)) {
    return getMenuEditorAllergenState(control);
  }
  if (control.is(":checkbox") || control.is(":radio")) {
    const isIndeterminate = !!control.prop("indeterminate");
    const checked = !!control.prop("checked");
    return isIndeterminate ? "indeterminate" : (checked ? "true" : "false");
  }
  const normalizedAdditionTokens = getMenuEditorNormalizedAdditionTokens(control);
  if (normalizedAdditionTokens !== null) {
    return normalizedAdditionTokens;
  }
  const value = control.val();
  return formatMenuEditorTrackedValue(value);
}

function getMenuEditorBooleanStatusText(isEnabled) {
  const texts = admin_local && admin_local.menu_editor_texts ? admin_local.menu_editor_texts : null;
  if (isEnabled) {
    return (texts && (texts.enabled || texts.selected)) || "Beállítva";
  }
  return (texts && (texts.disabled || texts.notSelected)) || "Kikapcsolva";
}

function getMenuEditorEmptyText() {
  return (admin_local && admin_local.empty) || "(empty)";
}

function getMenuEditorControlDisplayValue(control) {
  if (!control || !control.length) {
    return "";
  }

  if (isMenuEditorAllergenControl(control)) {
    return getMenuEditorAllergenDisplayValue(control);
  }

  // In production line matrix, booleans are not user-friendly.
  // Show lane + human-readable status instead of true/false.
  if ((control.is(":checkbox") || control.is(":radio")) && control.closest("#production_lines").length) {
    const isChecked = !!control.prop("checked");
    const statusText = getMenuEditorBooleanStatusText(isChecked);

    const row = control.closest("tr");
    if (row.length) {
      const firstCellText = row.children("td,th").first().text().replace(/\s+/g, " ").trim();
      if (firstCellText) {
        return `${firstCellText} (${statusText})`;
      }
    }

    const parentText = control.parent().text().replace(/\s+/g, " ").trim();
    if (parentText) {
      return `${parentText} (${statusText})`;
    }

    return statusText;
  }

  if (control.is(":checkbox") || control.is(":radio")) {
    return getMenuEditorBooleanStatusText(!!control.prop("checked"));
  }

  if (control.is("select")) {
    const selectedTexts = control.find("option:selected").map((_, option) => {
      return ($(option).text() || "").replace(/\s+/g, " ").trim();
    }).get().filter(Boolean);
    return selectedTexts.join(", ");
  }

  return getMenuEditorControlTrackedValue(control);
}

function getMenuEditorFieldLabel(modal, control) {
  if (!control || !control.length) {
    return "";
  }

  const id = (control.attr("id") || "").toString().trim();
  if (id === "allergens" || id === "category_allergens") {
    return admin_local.allergens || "Allergens";
  }
  if (/^menuItem_containerChargeOnsite_/i.test(id)) {
    return admin_local.container_charge_onsite || "Also in case of local consumption";
  }
  const scopedTable = control.closest("table");
  if (id) {
    const langMatch = id.match(/^(c?name|c?description)_([a-z]{2,}|all)$/i);
    if (langMatch) {
      const fieldToken = langMatch[1].toLowerCase();
      const langTokenRaw = (langMatch[2] || "").toLowerCase();
      const isCategory = fieldToken.startsWith("c");
      const isDescription = fieldToken.includes("description");
      const localizedName = (admin_local && admin_local._name) || "Name";
      const localizedDescription = (admin_local && admin_local._description) || "Description";
      const localizedCategory = (admin_local && admin_local.category) || "Category";
      const base = isDescription
        ? (isCategory
          ? `${localizedCategory} ${localizedDescription}`
          : localizedDescription)
        : (isCategory
          ? `${localizedCategory} ${localizedName}`
          : localizedName);
      const langLabel = langTokenRaw === "all" ? "default" : langTokenRaw;
      return `${base} (${langLabel})`;
    }
  }

  if (id) {
    // Prefer labels from the nearest section to avoid cross-matching duplicate ids.
    const localContainers = [
      control.closest(".form-group"),
      control.closest(".input-group"),
      control.closest("td,th"),
      control.closest("tr"),
      control.closest(".language-grid"),
      control.closest(".category-language-grid")
    ];
    for (let i = 0; i < localContainers.length; i++) {
      const container = localContainers[i];
      if (!container || !container.length) {
        continue;
      }
      if (scopedTable.length) {
        const containerTable = container.closest("table");
        if (containerTable.length && containerTable.get(0) !== scopedTable.get(0)) {
          continue;
        }
      }
      const localLabel = container.find(`label[for='${id}']`).first();
      if (localLabel.length) {
        const text = localLabel.text().replace(/\s+/g, " ").trim();
        if (text) {
          return text;
        }
      }
    }

    if (scopedTable.length) {
      const tableLabel = scopedTable.find(`label[for='${id}']`).first();
      if (tableLabel.length) {
        const text = tableLabel.text().replace(/\s+/g, " ").trim();
        if (text) {
          return text;
        }
      }
    } else {
      const directLabel = modal.find(`label[for='${id}']`).first();
      if (directLabel.length) {
        const text = directLabel.text().replace(/\s+/g, " ").trim();
        if (text) {
          return text;
        }
      }
    }
  }

  const groupLabel = control.closest(".input-group").find(".input-group-text").first();
  if (groupLabel.length) {
    const text = groupLabel.text().replace(/\s+/g, " ").trim();
    if (text) {
      return text;
    }
  }

  const tokenNode = control.closest("li.token[data-value]");
  if (tokenNode.length) {
    const tokenLabel = getMenuEditorTokenizerDisplayName(tokenNode, tokenNode.attr("data-value") || "");
    const settingLabel = getMenuEditorTokenizerSettingLabel(control);
    if (tokenLabel && settingLabel) {
      return `${tokenLabel} ${settingLabel}`;
    }
    if (tokenLabel) {
      return tokenLabel;
    }
  }

  const cell = control.closest("td,th");
  const row = control.closest("tr");
  const cellTable = control.closest("table");
  if (cell.length && row.length && cellTable.length) {
    const cellIndex = cell.get(0).cellIndex;
    const headerCell = cellTable.find("thead tr").last().children().eq(cellIndex);
    if (headerCell.length) {
      const text = headerCell.text().replace(/\s+/g, " ").trim();
      if (text) {
        return text;
      }
    }
  }

  const fallbackLabel = (id || control.attr("name") || control.attr("data-tr-key") || "field").toString();
  if (modal && modal.length && modal.attr("id") === "editMenuCategory") {
    return fallbackLabel.startsWith("Category ") ? fallbackLabel : `Category ${fallbackLabel}`;
  }
  return fallbackLabel;
}

function getMenuEditorHighlightTargets(modal, control) {
  const targets = $();
  if (!control || !control.length) {
    return targets;
  }

  let resolved = targets.add(control);
  if (isMenuEditorAllergenControl(control)) {
    const controlId = (control.attr("id") || "").toString().trim();
    if (controlId) {
      resolved = resolved.add(modal.find(`label[for='${controlId}']`).first());
    }
    resolved = resolved.add(control.children("*.has"));
    return resolved;
  }
  if (control.is(":checkbox,:radio")) {
    const customControl = control.closest(".custom-control");
    if (customControl.length) {
      resolved = targets.add(customControl);
    }
  }
  const id = (control.attr("id") || "").toString().trim();
  const scopedTable = control.closest("table");
  if (id) {
    // Prefer labels from nearby containers first to avoid duplicate-id collisions.
    const localContainers = [
      control.closest(".form-group"),
      control.closest(".input-group"),
      control.closest("td,th"),
      control.closest("tr"),
      control.closest(".language-grid"),
      control.closest(".category-language-grid")
    ];
    let foundLocalLabel = false;
    for (let i = 0; i < localContainers.length; i++) {
      const container = localContainers[i];
      if (!container || !container.length) {
        continue;
      }
      if (scopedTable.length) {
        const containerTable = container.closest("table");
        if (containerTable.length && containerTable.get(0) !== scopedTable.get(0)) {
          continue;
        }
      }
      const localLabels = container.find(`label[for='${id}']`);
      if (localLabels.length) {
        if (!control.is(":checkbox,:radio")) {
          resolved = resolved.add(localLabels);
        }
        foundLocalLabel = true;
      }
    }
    if (!foundLocalLabel) {
      if (scopedTable.length) {
        if (!control.is(":checkbox,:radio")) {
          resolved = resolved.add(scopedTable.find(`label[for='${id}']`).first());
        }
      } else {
        if (!control.is(":checkbox,:radio")) {
          resolved = resolved.add(modal.find(`label[for='${id}']`).first());
        }
      }
    }

    const langMatch = id.match(/^(c?name|c?description)_([a-z]{2,}|all)$/i);
    if (langMatch) {
      const fieldToken = (langMatch[1] || "").toLowerCase();
      const section = control.closest(".language-grid-name, .language-grid-description, .category-language-grid .language-grid-name, .category-language-grid .language-grid-description");
      if (section.length) {
        // Highlight the per-language badge (e.g. HU/EN) in the language grid row.
        resolved = resolved.add(section.siblings(".language-grid-lang").first());
      }

      const grid = control.closest(".language-grid, .category-language-grid");
      if (grid.length) {
        // Also highlight the relevant column header (name vs description).
        if (fieldToken.includes("description")) {
          resolved = resolved.add(grid.find(".language-grid-header.description").first());
        } else {
          resolved = resolved.add(grid.find(".language-grid-header.name").first());
        }
      }
    }
  }

  //if (!control.is(":checkbox,:radio,select")) {
  if (!resolved.filter(".input-group-text").length) {
    resolved = resolved.add(control.closest(".input-group").find(".input-group-text").first());
  }

  const cell = control.closest("td,th");
  const row = control.closest("tr");
  const table = control.closest("table");
  if (cell.length && row.length && table.length) {
    const cellIndex = cell.get(0).cellIndex;
    resolved = resolved.add(table.find("thead tr").last().children().eq(cellIndex));
  }

  return resolved;
}

function getMenuEditorControlTrackingKey(modal, control) {
  let base = (control.attr("id") || control.attr("name") || control.attr("data-tr-key") || control.prop("tagName") || "field").toString();

  const controlId = (control.attr("id") || "").toString();
  if (controlId && modal && modal.length) {
    const idMatches = modal.find("[id]").filter(function () {
      const node = $(this);
      return (node.attr("id") || "") === controlId && isTrackableMenuEditorControl(node);
    });
    if (idMatches.length > 1) {
      base = `${base}#${idMatches.index(control)}`;
    }
  }

  const tokenItem = control.closest("li.token[data-value]");
  if (tokenItem.length) {
    base = `token:${tokenItem.attr("data-value") || ""}::${base}`;
  }

  const table = control.closest("table");
  const row = control.closest("tr");
  if (table.length && row.length) {
    const tableId = (table.attr("id") || "table").toString();
    return `${tableId}[${row.index()}]::${base}`;
  }
  return base;
}

function clearMenuEditorChangeTooltips(modal) {
  if (!modal || !modal.length) {
    return;
  }

  modal.find('[data-menuitem-change-tooltip="1"]').each(function () {
    const node = $(this);
    if ($.fn && typeof $.fn.tooltip === "function") {
      try {
        node.tooltip("dispose");
      } catch (error) {
        // Ignore tooltip dispose failures for non-bootstrap nodes.
      }
    }
    node
      .removeAttr("title")
      .removeAttr("data-menuitem-change-tooltip")
      .removeAttr("data-menuitem-change-tooltip-priority");
  });
}

function applyMenuEditorChangeTooltip(targets, label, originalValue, currentValue, overrideText = "", priority = 0) {
  if (!targets || !targets.length) {
    return;
  }

  const customText = (overrideText || "").toString().trim();
  const fromText = formatMenuEditorTrackedValue(originalValue) || getMenuEditorEmptyText();
  const toText = formatMenuEditorTrackedValue(currentValue) || getMenuEditorEmptyText();
  const normalizedLabel = (label || "").toString().trim();
  const tooltipText = customText || (normalizedLabel ? `${normalizedLabel}: ${fromText} > ${toText}` : `${fromText} > ${toText}`);
  const incomingPriority = Number.isFinite(Number(priority)) ? Number(priority) : (customText ? 2 : 1);
  const genericNoisePattern = /(^|:)\s*\(?empty\)?\s*>\s*1\s*$/i;
  const isLikelyGenericNoise = !customText && genericNoisePattern.test(tooltipText);

  targets.each(function () {
    const node = $(this);
    const existingPriority = Number(node.attr("data-menuitem-change-tooltip-priority") || "0");
    const existingTitle = (node.attr("title") || "").toString().trim();

    if (existingPriority > incomingPriority) {
      return;
    }

    if (existingPriority === incomingPriority && isLikelyGenericNoise && existingTitle && existingTitle !== tooltipText) {
      return;
    }

    node.attr("title", tooltipText).attr("data-menuitem-change-tooltip", "1");
    node.attr("data-menuitem-change-tooltip-priority", String(incomingPriority));
    if ($.fn && typeof $.fn.tooltip === "function") {
      try {
        node.tooltip("dispose").tooltip({
          container: "body",
          trigger: "hover",
          placement: "auto"
        });
      } catch (error) {
        // Fallback is native title tooltip.
      }
    }
  });
}

function ensureMenuEditorChangeSummaryPopup(modal) {
  const content = modal.find(".modal-content").first();
  if (!content.length) {
    return $();
  }
  if (content.css("position") === "static") {
    content.css("position", "relative");
  }

  let popup = content.find(".menuitem-change-summary-popup").first();
  if (!popup.length) {
    popup = $("<div class='menuitem-change-summary-popup' aria-live='polite' />");
    content.append(popup);
  }
  return popup;
}

function renderMenuEditorChangeSummary(modal, changeRows) {
  const popup = ensureMenuEditorChangeSummaryPopup(modal);
  if (!popup.length) {
    return;
  }

  const rows = Array.isArray(changeRows) ? changeRows : [];
  if (!rows.length) {
    popup.hide().empty();
    return;
  }

  const popupTitle = modal && modal.length && modal.attr("id") === "editMenuCategory"
    ? tMenuEditor("categoryChanges", "Category changes")
    : tMenuEditor("changedFields", "Changed Fields");

  const cappedRows = rows.slice(0, 18);
  const listHtml = cappedRows.map(change => {
    const fromText = formatMenuEditorTrackedValue(change.originalDisplayValue || change.originalValue) || getMenuEditorEmptyText();
    const toText = formatMenuEditorTrackedValue(change.currentDisplayValue || change.currentValue) || getMenuEditorEmptyText();
    const summaryText = (change.summary || "").toString().trim();
    const shouldUseSummary = !!summaryText && (change.isTokenizer || change.isAllergen);
    return `
      <div class='menuitem-change-summary-row'>
        <div class='menuitem-change-summary-label'>${escapeExcerptHtml(change.label || change.key || "field")}</div>
        <div class='menuitem-change-summary-diff'>${shouldUseSummary ? escapeExcerptHtml(summaryText) : `${escapeExcerptHtml(fromText)} &gt; ${escapeExcerptHtml(toText)}`}</div>
      </div>
    `;
  }).join("");

  const overflowText = rows.length > cappedRows.length
    ? `<div class='menuitem-change-summary-row'><div class='menuitem-change-summary-label'>...</div><div class='menuitem-change-summary-diff'>+${rows.length - cappedRows.length} more changes</div></div>`
    : "";

  popup.html(`
    <div class='menuitem-change-summary-title'>${escapeExcerptHtml(popupTitle)} (${rows.length})</div>
    ${listHtml}
    ${overflowText}
  `).show();
}

function refreshMenuEditorChangeTracking(modal) {
  if (!modal || !modal.length) {
    return;
  }

  const isCategory = modal.is("#editMenuCategory");
  if (typeof window !== "undefined" && window.menuitemAutomationReplayActive) {
    console.log(`[MenuEditor ChangeTracking] Refresh for ${isCategory ? "CATEGORY" : "ITEM"} modal during automation`);
  }

  const baseline = modal.data("menuEditorChangeTrackingBaseline") || {};
  const controls = collectMenuEditorTrackedControls(modal);

  modal.find(".menuitem-field-changed").removeClass("menuitem-field-changed");
  clearMenuEditorChangeTooltips(modal);

  const changes = [];
  controls.each(function () {
    const control = $(this);
    const key = getMenuEditorControlTrackingKey(modal, control);
    const currentValue = getMenuEditorControlTrackedValue(control);
    const currentDisplayValue = getMenuEditorControlDisplayValue(control);
    const hasBaseline = Object.prototype.hasOwnProperty.call(baseline, key);
    const baselineValue = hasBaseline ? baseline[key].value : "";
    const baselineDisplayValue = hasBaseline
      ? (typeof baseline[key].displayValue === "undefined" ? baselineValue : baseline[key].displayValue)
      : "";
    const changed = currentValue !== baselineValue;
    if (!changed) {
      return;
    }

    const label = hasBaseline ? baseline[key].label : getMenuEditorFieldLabel(modal, control);
    const targets = hasBaseline && baseline[key].targets && baseline[key].targets.length
      ? baseline[key].targets
      : getMenuEditorHighlightTargets(modal, control);
    const isAllergenControl = isMenuEditorAllergenControl(control);
    const isTokenizerControl = isMenuEditorTokenizerControl(control);
    const isTokenizerInnerControl = isMenuEditorTokenizerInnerControl(control);
    const changeSummary = isAllergenControl
      ? formatMenuEditorAllergenDiffSummary(baselineValue, currentValue)
      : isTokenizerControl
        ? summarizeMenuEditorTokenizerChange(control, label, baselineValue, currentValue)
        : isTokenizerInnerControl
          ? buildMenuEditorTokenizerControlChangePhrase(control, label, baselineValue, currentValue)
          : `${label || key || "field"}: ${baselineDisplayValue || baselineValue || getMenuEditorEmptyText()} -> ${currentDisplayValue || currentValue || getMenuEditorEmptyText()}`;

    targets.addClass("menuitem-field-changed");
    applyMenuEditorChangeTooltip(
      targets,
      label,
      baselineDisplayValue,
      currentDisplayValue,
      (isAllergenControl || isTokenizerControl || isTokenizerInnerControl) ? changeSummary : "",
      (isAllergenControl || isTokenizerControl || isTokenizerInnerControl) ? 2 : 1
    );

    if (control.parents("option").length === 0) {

      changes.push({
        key,
        label,
        originalValue: baselineValue,
        currentValue,
        originalDisplayValue: baselineDisplayValue,
        currentDisplayValue,
        summary: changeSummary,
        isTokenizer: isTokenizerControl,
        isAllergen: isAllergenControl
      });
    }

  });

  renderMenuEditorChangeSummary(modal, changes);
  const existingRows = Array.isArray(modal.data("menuEditorChangeTrackingRows")) ? modal.data("menuEditorChangeTrackingRows") : [];
  const historyKeys = new Set(existingRows.map(change => `${change.key || ""}::${change.summary || ""}`));
  const nextRows = changes.filter(change => {
    const historyKey = `${change.key || ""}::${change.summary || ""}`;
    if (historyKeys.has(historyKey)) {
      return false;
    }
    historyKeys.add(historyKey);
    return true;
  });
  const mergedRows = existingRows.concat(nextRows);
  modal.data("menuEditorChangeTrackingRows", mergedRows);
  modal.trigger("menuitem:change-tracking-updated", [{
    modal,
    changeRows: mergedRows,
    currentRows: changes,
    baseline: modal.data("menuEditorChangeTrackingBaseline") || {}
  }]);
}

function captureMenuEditorChangeTrackingBaseline(modal) {
  if (!modal || !modal.length) {
    return;
  }

  const baseline = {};
  const controls = collectMenuEditorTrackedControls(modal);

  controls.each(function () {
    const control = $(this);
    const key = getMenuEditorControlTrackingKey(modal, control);
    baseline[key] = {
      value: getMenuEditorControlTrackedValue(control),
      displayValue: getMenuEditorControlDisplayValue(control),
      label: getMenuEditorFieldLabel(modal, control),
      targets: getMenuEditorHighlightTargets(modal, control)
    };
  });

  modal.data("menuEditorChangeTrackingBaseline", baseline);
  modal.data("menuEditorChangeTrackingRows", []);
  modal.data("menuEditorChangeTrackingCurrentRows", []);
  modal.find(".menuitem-field-changed").removeClass("menuitem-field-changed");
  clearMenuEditorChangeTooltips(modal);
  renderMenuEditorChangeSummary(modal, []);
}

function resetMenuEditorChangeTrackingOnRepopulation(modal) {
  if (!modal || !modal.length) {
    return;
  }

  captureMenuEditorChangeTrackingBaseline(modal);
  modal.data("menuEditorChangeTrackingRows", []);
  modal.data("menuEditorChangeTrackingCurrentRows", []);
  refreshMenuEditorChangeTracking(modal);
}

function bindMenuEditorChangeTracking(modal) {
  if (!modal || !modal.length) {
    return;
  }

  ensureMenuEditorChangeTrackingStyles();
  ensureMenuEditorChangeSummaryPopup(modal);

  const scheduleRefresh = () => {
    // During repopulation, binding can happen before baseline reset.
    // Skip refresh until baseline is explicitly captured post-populate.
    if (!modal.data("menuEditorChangeTrackingBaseline")) {
      return;
    }
    const timer = modal.data("menuEditorChangeTrackingTimer");
    if (timer) {
      clearTimeout(timer);
    }
    if (typeof window !== "undefined" && window.menuitemAutomationReplayActive) {
      refreshMenuEditorChangeTracking(modal);
      return;
    }
    modal.data("menuEditorChangeTrackingTimer", setTimeout(() => {
      refreshMenuEditorChangeTracking(modal);
    }, 80));
  };

  modal.off(".menuEditorChangeTracking")
    .on("input.menuEditorChangeTracking change.menuEditorChangeTracking", "input,select,textarea", scheduleRefresh)
    .on("click.menuEditorChangeTracking", "#allergens > *, #category_allergens > *", scheduleRefresh)
    .on("tokenize:tokens:added.menuEditorChangeTracking tokenize:tokens:removed.menuEditorChangeTracking tokenize:tokens:reorder.menuEditorChangeTracking", "*", scheduleRefresh);

  const previousDocHandler = modal.data("menuEditorChangeTrackingDocHandler");
  if (previousDocHandler) {
    $(document).off("menuitem:automation-applied.menuEditorChangeTracking", previousDocHandler);
  }
  const docHandler = () => scheduleRefresh();
  $(document).on("menuitem:automation-applied.menuEditorChangeTracking", docHandler);
  modal.data("menuEditorChangeTrackingDocHandler", docHandler);

  const previousObserver = modal.data("menuEditorChangeTrackingObserver");
  if (previousObserver) {
    previousObserver.disconnect();
  }

  const observer = new MutationObserver(scheduleRefresh);
  modal.find("#menuItemQuantities tbody, #production_lines, #menuitem-settings-section, #menucategory-settings-section").each((_, target) => {
    if (target) {
      observer.observe(target, { childList: true, subtree: true });
    }
  });
  modal.data("menuEditorChangeTrackingObserver", observer);

}
function unbindMenuEditorChangeTracking(modal) {
  if (!modal || !modal.length) {
    return;
  }

  modal.off(".menuEditorChangeTracking");
  const timer = modal.data("menuEditorChangeTrackingTimer");
  if (timer) {
    clearTimeout(timer);
    modal.removeData("menuEditorChangeTrackingTimer");
  }
  const observer = modal.data("menuEditorChangeTrackingObserver");
  if (observer) {
    observer.disconnect();
    modal.removeData("menuEditorChangeTrackingObserver");
  }
  const docHandler = modal.data("menuEditorChangeTrackingDocHandler");
  if (docHandler) {
    $(document).off("menuitem:automation-applied.menuEditorChangeTracking", docHandler);
    modal.removeData("menuEditorChangeTrackingDocHandler");
  }
  modal.removeData("menuEditorChangeTrackingBaseline");
  modal.find(".menuitem-field-changed").removeClass("menuitem-field-changed");
  clearMenuEditorChangeTooltips(modal);
  const popup = modal.find(".menuitem-change-summary-popup").first();
  if (popup.length) {
    popup.hide().empty();
  }
}

function bindMenuitemSectionHelp(modal) {
  const icons = modal.find(".menuitem-section-help[data-help-section]");
  if (!icons.length) {
    return;
  }

  // Detect second click before Bootstrap's click handler runs.
  icons.off("mousedown.menuitemHelpToggle").on("mousedown.menuitemHelpToggle", function () {
    $(this).data("menuitemHelpWasOpen", !!$(this).attr("aria-describedby"));
  });

  icons.popover("dispose");
  icons.popover({
    trigger: "click",
    html: true,
    container: "body",
    sanitize: false,
    placement: "auto",
    template: '<div class="popover menuitem-help-popover" role="tooltip"><div class="arrow"></div><div class="popover-body"></div></div>',
    content: function () {
      const sectionId = $(this).data("help-section");
      if (!sectionId) {
        return "";
      }
      return modal.find("#menuitem-section-help-content-" + sectionId).html() || "";
    }
  });

  icons.off("click.menuitemHelpToggle").on("click.menuitemHelpToggle", function (event) {
    if ($(this).data("menuitemHelpWasOpen")) {
      event.preventDefault();
      event.stopPropagation();
      $(this).popover("hide");
      $(this).removeData("menuitemHelpWasOpen");
      return false;
    }
    $(this).removeData("menuitemHelpWasOpen");
  });

  icons.off("show.bs.popover.menuitemHelp").on("show.bs.popover.menuitemHelp", function () {
    icons.not(this).popover("hide");
  });

  const closeHandler = event => {
    if ($(event.target).closest(".menuitem-section-help").length) {
      return;
    }
    if ($(event.target).closest(".menuitem-help-popover").length) {
      icons.popover("hide");
      return;
    }
    icons.popover("hide");
  };

  $(document).on("mousedown.menuitemSectionHelp", closeHandler);

  modal.data("menuitemSectionHelpCleanup", () => {
    $(document).off("mousedown.menuitemSectionHelp", closeHandler);
    icons.off("mousedown.menuitemHelpToggle");
    icons.off("click.menuitemHelpToggle");
    icons.off("show.bs.popover.menuitemHelp");
    icons.popover("dispose");
  });
}

///var timing = ["inherit", "asap", "appetizer", "maincourse", "desert", "last"];
export const availableQuantities = {
  Meal: ["pcs", "g", "dkg", "kg", "ml", "cl", "dl", "l", "day", "hour", "min", "none"],
  Drink: ["pcs", "g", "dkg", "kg", "ml", "cl", "dl", "l", "day", "hour", "min", "none"],
  all: ["pcs", "ml", "cl", "dl", "l", "g", "dkg", "kg", "day", "hour", "min", "none"]
};

if (typeof localStorage.languageSelected == "undefined" || localStorage.languageSelected == "undefined") localStorage.languageSelected = localStorage.language;

if (typeof localStorage.menuitems_chart_height == "undefined") {
  localStorage.menuitems_chart_height = 300;
}

export const menuitemutil = {
  entityType: undefined,
  entitytype: undefined,
  filter: {},
  synchronizedProperties: ["mandatoryoptions", "includedoptions", "optionaloptions", "upselloptions"],
  synchronizeProperties: sessionStorage.synchronizeProperties ? JSON.parse(sessionStorage.synchronizeProperties) : [],
  toggleAutomationRecording: () => invokeMenuitemAutomation("toggleRecording"),
  startAutomationRecording: () => invokeMenuitemAutomation("startRecording"),
  stopAutomationRecording: () => invokeMenuitemAutomation("stopRecording"),
  replayAutomationRecording: () => invokeMenuitemAutomation("replayRecording"),
  getAutomationActions: () => invokeMenuitemAutomation("getActions"),
  openAutomationWizardDialog: () => invokeMenuitemAutomation("openWorkflowWizardFromMenuEditor"),
  closeAutomationWizardDialog: options => invokeMenuitemAutomation("closeWorkflowWizardFromMenuEditor", [options]),
  consumeAutomationWizardReopenOnEnter: () => invokeMenuitemAutomation("consumeWorkflowWizardReopenOnMenuEditorEnter"),
  canUseAutomationWizard: () => featureEnabled("wizard/enabled") && canLoadMenuitemAutomationRuntime(),
  captureMenuEditorChangeTrackingBaseline,
  refreshMenuEditorChangeTracking,
  bindMenuEditorChangeTracking,
  unbindMenuEditorChangeTracking,
  getMenuEditorChangeTrackingRows(modal) {
    if (!modal || !modal.length) {
      return [];
    }
    return Array.isArray(modal.data("menuEditorChangeTrackingRows")) ? modal.data("menuEditorChangeTrackingRows") : [];
  },

  serverSideMessageHandler: message => {
    if (message.type == "timeout" && message.message == "true") return;
    //console.log(message.message, message);
    if (message.type == "refresh" && message.message == "menu changed") {
      $("button#refresh").addClass("btn-danger");
      $("button#refresh").addClass("blink");
      auth.myStatus.restaurant_menumodification_timestamp = message.timestamp;
    } else if (message.type == "refresh" && message.message == "menu changed by chatgpt") {
      // the menu was modified through the MCP tools: reload it automatically (several changes in a row cause one reload)
      // and draw attention to what changed; a single changed menu item or category is also focused
      const changes = menuitemutil.chatgptChanges || (menuitemutil.chatgptChanges = new Map());
      const entityId = Number(message.entityId);
      if (message.entityType && entityId > 0)
        changes.set(message.entityType + ":" + entityId, { entityType: message.entityType, id: entityId });
      else
        changes.set("other", null);
      // the server time of the first change of the batch, the change log is read from there (server clock on both sides)
      const timestamp = Number(message.timestamp);
      if (timestamp > 0 && (!menuitemutil.chatgptSince || timestamp < menuitemutil.chatgptSince))
        menuitemutil.chatgptSince = timestamp;
      clearTimeout(menuitemutil.chatgptRefreshTimer);
      menuitemutil.chatgptRefreshTimer = setTimeout(() => {
        menuitemutil.chatgptRefreshTimer = undefined;
        const changed = Array.from(changes.values());
        changes.clear();
        const since = menuitemutil.chatgptSince;
        menuitemutil.chatgptSince = undefined;
        menuitemutil.pendingChangedNodes = {
          nodes: changed.filter(c => c),
          focus: changed.length === 1 && changed[0] != null
        };
        (menuitemutil.reload || menuitemutil._reload)();
        showChatgptChangesBubble(since);
      }, 500);
    }
  },

  /**
   * After a reload caused by a menu modification through MCP (see serverSideMessageHandler): flashes the changed menu
   * items and categories, and when exactly one thing changed, expands its parents, scrolls to it and focuses it.
   */
  highlightChangedNodes: () => {
    const pending = menuitemutil.pendingChangedNodes;
    menuitemutil.pendingChangedNodes = undefined;
    if (!pending || !pending.nodes.length || !menuitemutil.menuItems)
      return;
    // the tree is rebuilt asynchronously by the reload
    setTimeout(() => {
      const tree = menuitemutil.menuItems;
      pending.nodes.forEach(change => {
        let node = null;
        tree.visit(n => {
          if (n.data && n.data.id == change.id && n.data.entityType == change.entityType) {
            node = n;
            return false;
          }
        });
        if (!node)
          return; // for example deleted
        const flash = () => {
          const cells = $(node.tr).children("td");
          cells.css({ transition: "background-color 0.4s", backgroundColor: "#fff3a0" });
          setTimeout(() => cells.css({ transition: "background-color 3s", backgroundColor: "" }), 2500);
        };
        if (pending.focus) {
          $.when(node.makeVisible({ scrollIntoView: true })).always(() => {
            node.setActive(true);
            node.setFocus(true);
            flash();
          });
        } else {
          // only visible rows can be flashed, the hidden ones are not expanded on purpose
          flash();
        }
      });
    }, 150);
  },

  recoverFromEventSourceError: () => {

  },

  initialize: function (props) {

    startpoll(menuitemutil.serverSideMessageHandler, [
      {
        Restaurant: localStorage.restaurantSelected,
        Menu: "*"
      },
      {
        Restaurant: localStorage.restaurantSelected,
        Menu: "*"
      },
    ], undefined, menuitemutil.recoverFromEventSourceError);

    connectedRestaurants = {}
    menuitemutil.props = props;
    menuitemutil.filter = {};

    menuitemutil.reload = menuitemutil._reload;
    menuitemutil.updateMenu = menuitemutil._updateMenu;

    menuitemutil.getBarcodes();

    if (auth?.myStatus?.restaurant_settings?.["shop-mode"]) {
      menuitemutil.synchronizeProperties = menuitemutil.synchronizeProperties.filter(p =>
        p !== "productionline");
    }

    $("#menuItemsFreezeTable thead th input[type = 'checkbox']").prop("indeterminate", true);

    var pp = $(`#root > div > div#${menuitemutil.entitytype}s`);

    if (auth?.myStatus?.restaurant_settings?.["shop-mode"]) {
      pp.addClass("shop-mode");
      pp.removeClass("restaurant-mode");
    } else {
      pp.removeClass("shop-mode");
      pp.addClass("restaurant-mode");
    }

    invokeMenuitemAutomation("bindAutomationActionLogger", [pp, "product", featureEnabled("wizard/enabled")]);

    $(".btn.btn-positive.restaurant-properties").on("click", event => {
      const prop = $(event.currentTarget).attr("for");
      if (!$(event.currentTarget).hasClass("active")) {
        if (menuitemutil.synchronizeProperties.indexOf(prop) === -1) {
          menuitemutil.synchronizeProperties.push(prop);
        }
      } else {
        menuitemutil.synchronizeProperties = menuitemutil.synchronizeProperties.filter(p => p !== prop);
      }
      if (menuitemutil.synchronizeProperties.includes("price") && menuitemutil.synchronizeProperties.length === 1) {
        $("#root > div:not(.menuItemHeader)").addClass("synchronizingPrice");
      } else {
        $("#root > div:not(.menuItemHeader)").removeClass("synchronizingPrice");
      }
      sessionStorage.synchronizeProperties = JSON.stringify(menuitemutil.synchronizeProperties);
      processMenuItems({ children: admin.categories.children });
    });

    const DEPENDENCIES = {
      price: ["availablequantity"],
      promotion: ["availablequantity"]
    };
    const REVERSE_DEPENDENCIES = {
      availablequantity: ["price", "promotion"]
    };

    $("table#menuItems th[prop]").on("click", event => {
      const $th = $(event.currentTarget);
      const prop = $th.attr("prop");
      const props = new Set(menuitemutil.synchronizeProperties);

      const enabled = !$th.hasClass("synchronize");

      $("th[prop='" + prop + "']").toggleClass("synchronize", enabled);

      if (enabled) {
        props.add(prop);

        (DEPENDENCIES[prop] || []).forEach(dep => {
          props.add(dep);
          $("th[prop='" + dep + "']").addClass("synchronize");
        });
      } else {
        props.delete(prop);

        (REVERSE_DEPENDENCIES[prop] || []).forEach(dependent => {
          props.delete(dependent);
          $("th[prop='" + dependent + "']").removeClass("synchronize");
        });
      }

      menuitemutil.synchronizeProperties = [...props];

      $("#root > div:not(.menuItemHeader)").toggleClass(
        "synchronizingPrice",
        props.size === 1 && props.has("price")
      );

      sessionStorage.synchronizeProperties =
        JSON.stringify(menuitemutil.synchronizeProperties);

      processMenuItems({ children: admin.adminCategories.children });
    });

    menuitemutil.synchronizeProperties.forEach(prop => {
      $("table#menuItems th[prop='" + prop + "']").addClass("synchronize");
      $(".btn.btn-positive.restaurant-properties#" + prop).addClass("synchronize");
    });

    menuitemutil.menuItems = null;
    getEntities("Stores", function (data) {
      admin.stores = data;
      if (typeof localStorage.menuitems_start == "undefined") {
        var t = moment();
        localStorage.menuitems_end = moment()
          .toDate()
          .getTime();
        localStorage.menuitems_start = moment()
          .subtract(1, "month")
          .toDate()
          .getTime();
      }
      var start = moment(Number(localStorage.menuitems_start));
      var end = moment(Number(localStorage.menuitems_end));

      function cb(start, end) {
        $("#daterange span").html(start.format("MMMM D, YYYY") + " - " + end.format("MMMM D, YYYY"));
      }
      var ranges = {};
      ranges[I18n.t("admin_local.today")] = [moment(), moment()];
      ranges[I18n.t("admin_local.yesterday")] = [moment().subtract(1, "days"), moment().subtract(1, "days")];
      ranges[I18n.t("admin_local.last_7_days")] = [moment().subtract(6, "days"), moment()];
      ranges[I18n.t("admin_local.last_30_days")] = [moment().subtract(29, "days"), moment()];
      ranges[I18n.t("admin_local.last_3_months")] = [
        moment()
          .subtract(2, "month")
          .startOf("month"),
        moment()
      ];
      ranges[I18n.t("admin_local.this_month")] = [moment().startOf("month"), moment().endOf("month")];
      ranges[I18n.t("admin_local.last_month")] = [
        moment()
          .subtract(1, "month")
          .startOf("month"),
        moment()
          .subtract(1, "month")
          .endOf("month")
      ];

      $('#from_date.datepicker').datepicker({
        format: 'yyyy-mm-dd',
        uiLibrary: 'bootstrap4'
      });
      $('#to_date.datepicker').datepicker({
        format: 'yyyy-mm-dd',
        uiLibrary: 'bootstrap4'
      });
      $('#m_from_date.datepicker').datepicker({
        format: 'yyyy-mm-dd',
        uiLibrary: 'bootstrap4'
      });
      $('#m_to_date.datepicker').datepicker({
        format: 'yyyy-mm-dd',
        uiLibrary: 'bootstrap4'
      });

      $("#cntak_main_category").on('change', event => {
        menuitemutil.updateNtakCategories("c");
      });
      $("#mntak_main_category").on('change', event => {
        menuitemutil.updateNtakCategories("m");
      });


      $("#daterange").daterangepicker(
        {
          timePicker: false,
          autoApply: true,
          startDate: start,
          endDate: end,
          locale: {
            format: "MMM/DD",
            customRangeLabel: I18n.t("admin_local.customRange")
          },
          showButtonPanel: true,
          drops: "up",
          ranges: ranges
        },
        function (start, end, label) {
          localStorage.menuitems_start = start._d.getTime();
          localStorage.menuitems_end = end._d.getTime();
          cb(moment(Number(localStorage.menuitems_start)), moment(Number(localStorage.menuitems_end)));
          if (isCategory) populateCategoryCharts();
          else populateCharts();
        }
      );

      if (typeof localStorage.menuitems_range != "undefined") {
        $("[name='range'][id='" + localStorage.menuitems_range + "']")
          .parent()
          .button("toggle");
      }

      $("[name='range']").change(event => {
        localStorage.menuitems_range = $("[name='range']:checked").attr("id");
        drawChart();
      });

      $(".resizable").resizable({
        handles: "n",
        height: 2,
        resize: function () {
          var height = $(this)
            .css("height")
            .split("px")[0];
          localStorage.menuitems_chart_height = height;
          $(this).css("top", 0);
        }
      });

      cb(start, end);
    });
  },

  updateNtakCategories: (prefix, modal = $(".modal.show"), data) => {
    const main_category_item = $("#" + prefix + "ntak_main_category");
    const sub_category_item = $("#" + prefix + "ntak_sub_category");
    var main_category_id = main_category_item.val();

    var parentMenuCategoryId = data?.menuCategoryId | 0;

    if (parentMenuCategoryId > 0) {
      var parentMenuCategory = getMenuCategory(data);
      if (parentMenuCategory && parentMenuCategory.defaultMainCategoryId) {
        const main_category = admin_local.ntak.main_categories.find(c => c.id == parentMenuCategory.defaultMainCategoryId);
        if (main_category) {
          main_category_item.find("option[value='0']").html(admin_local.inherit + " (" + main_category.name + ")")
          if (parentMenuCategory.defaultSubCategoryId) {
            const sub_category = main_category.sub_categories.find(c => c.id == parentMenuCategory.defaultSubCategoryId);
            if (sub_category)
              sub_category_item.find("option[value='0']").html(admin_local.inherit + " (" + sub_category.name + ")")
          }
        }
      }

      if (!main_category_id) {
        main_category_id = parentMenuCategory.defaultMainCategoryId;
      }

    }


    const main_category = admin_local.ntak.main_categories.find(c => c.id == main_category_id);
    if (main_category) {
      sub_category_item.find("option[value != '0']").remove();
      main_category.sub_categories.forEach(sub => {
        $("<option value='" + sub.id + "'>" + sub.name + "</option>").appendTo(sub_category_item);
      })
    }
  },

  _reload: function (data) {
    $("button#refresh").removeClass('blink');
    $("button#refresh").removeClass('btn-danger');
    if (auth?.myStatus?.restaurant_settings?.["shop-mode"])
      $('[data-toggle="tooltip"]').tooltip("hide");
    const def = $.Deferred();
    if (data && data.entityType) {
      menuitemutil.updateMenu(data)
      def.resolve();
      return def.promise();
    }
    if (data && data.length) {
      var ok = false;
      data.forEach(d => {
        if (d.entityType) {
          if (menuitemutil.updateMenu(d))
            ok = true;
        }
      })
      if (ok) {
        def.resolve();
        return def.promise();
      }
    }


    if (processMenuItems) {
      admin.getMenuItems((data) => {
        admin.getActiveMenuItems(data => {
          store.dispatch(EatWithMeActions.menuCategories(data.activeMenuCategories));
        });

        menuitemutil.filterByType(data);

        refreshConnectedRestaurants().done(() => {
          processMenuItems(data);
          menuitemutil.highlightChangedNodes();
        });
        def.resolve()
      }, undefined, menuitemutil.filter.deleted);
    } else
      def.resolve();
    admin.getLabels(function (data) {
      admin.labels = data;
    });
    return def.promise();
  },

  filterByType: (data) => {
    if (data.children) {
      data.children = data.children.filter(node => node.recordState == "ACTIVE" || menuitemutil.filter.deleted);
      data.children.forEach(menuitemutil.filterByType);
    }
  },

  getRecursiveReferencers: (d, data) => {
    try {
      menuItemReferences(d, ['mandatory']).filter(dd => data.filter(d => d.id == dd.id && d.entityType == dd.entityType).length === 0).forEach(dd => {
        data.push(dd.menuItem);
        menuitemutil.getRecursiveReferencers(dd.menuItem, data);
      });
    } catch (ex) {

    }

    return data;

  },

  getBarcodes() {
    get("adminService/" + localStorage.restaurantSelected + "/getBarcodes", localStorage.restaurantSelected).done(data => {
      if (data === null) {
        console.log("Failed to get barcodes!");
      } else {
        menuitemutil.barcodes = data;
      }
    });
  },

  findBarcodes(term) {
    var t = menuitemutil.barcodes.map(b => { return { text: b.name + " " + b.quantity + "cl (" + b.id + ")", value: "" + b.id } });
    const result = [];
    t.filter(b => b.text && b.value).filter(b => b.text.indexOf(term) >= 0).forEach(b => result.push(b));
    return result;
  },

  getFlatMenuItems: (array = [], categories = admin.adminCategories.children) => {
    categories.forEach(c => {
      if (c.entityType == menuitemutil.entityType || (!menuitemutil.entityType && c.entityType.indexOf("Category") === -1))
        array.push(c);
      else if (c.children || c.activeMenuCategories || c.activeMenuItems)
        menuitemutil.getFlatMenuItems(array, c.children || [...(c.activeMenuCategories || []), ...(c.activeMenuItems || [])]);
    });
    return array;
  },

  getMenuItems: function (search, proportional = true, type) {
    if (!search)
      return;
    //s = search;
    var set = new SortedSet({
      comparator: function (a, b) {
        if (a.value.split(";")[0] != b.value.split(";")[0])
          return a.value.localeCompare(b.value);
        if (a.text.toLowerCase().startsWith(search.toLowerCase()) && !b.text.toLowerCase().startsWith(search.toLowerCase())) return -1;
        if (b.text.toLowerCase().startsWith(search.toLowerCase()) && !a.text.toLowerCase().startsWith(search.toLowerCase())) return 1;
        return a.text.localeCompare(b.text);
      }
    });
    var menuItem = menuitemutil._getMenuItems(search, proportional, set, admin.categories.activeMenuCategories ? admin.categories.activeMenuCategories : admin.categories.children, type);
    if (menuItem == "") {
      return null;
    }
    var result = [];
    set.forEach(function (e) {
      result[result.length] = e;
    });
    //filter our recursive elements
    if (menuitemutil.references)
      result = result.filter(r => {
        let rr = r.value.split(";");
        return menuitemutil.references.filter(d => d != null && Number(rr[2]) == d.id && rr[4] == d.entityType).length === 0
      })
    return result;
  },

  getPath: (item, base = admin.adminCategories) => {
    if (!item.defaultAllergens) item.defaultAllergens = [];
    if (!item) return "";
    return "<span><text>" + ((item.menuCategoryId ? (menuitemutil._getPath(menuitemutil.getMenuCategory(item.menuCategoryId, base), base) + "/") : "") + getLocale(item.name) + (item.manufacturer ? " (" + item.manufacturer + ")" : "")) + "</text><text>" + item.defaultAllergens.map(i => "<text class='allergen-" + i.toLowerCase() + "'/>").join("") + "</text></span>";
  },
  _getPath: (item, base = admin.adminCategories) => {
    if (!item) return "";
    return ((item.menuCategoryId ? (menuitemutil._getPath(menuitemutil.getMenuCategory(item.menuCategoryId, base), base) + "/") : "") + getLocale(item.name) + (item.manufacturer ? " (" + item.manufacturer + ")" : ""));
  },
  getOrder: (item, base = admin.adminCategories) => {
    if (!item) return "";
    return (item.menuCategoryId ? (menuitemutil.getMenuCategory(item.menuCategoryId, base).order * 1000 + "/") : "") + getLocale(item.name) + (item.manufacturer ? " (" + item.manufacturer + ")" : "");
  },

  openItem: item => {
    const value = $(item.currentTarget).attr("data-value").split(";");
    const type = value[0];
    const id = value[2];
    if (type === "menuItem") {
      const menuItem = admin.getMenuItemAdmin(id);
      const oldModal = $('.modal.show');
      const modal = $('#editMenuItem.modal');
      if (menuItem) {
        const newContent = JSON.stringify(saveMenuItem(undefined, true, true));
        if (newContent === menuitemutil.oldMenuItemData) {
          populateEditMenuItem(modal, "edit", menuItem, menuItem.menuCategoryId);
        } else {
          choiceDialog2(I18n.t("local.warning"), I18n.t("admin_local.product_modified_save_it"), [I18n.t("admin_local.drop"), I18n.t("admin_local.save")]).done(choice => {
            switch (choice) {
              case 0:
                populateEditMenuItem(modal, "edit", menuItem, menuItem.menuCategoryId);
                break;
              case 1:
                saveMenuItem((data) => {
                  menuitemutil.reload(data);
                  populateEditMenuItem(modal, "edit", menuItem, menuItem.menuCategoryId);
                }, true, false);
                break;
              default:
            }
          })
        }
      }
    } else {
      const menuCategory = menuitemutil.getMenuCategory(id);
      const oldModal = $('.modal.show');
      const modal = $('#editMenuCategory.modal');
      if (menuCategory) {
        const newContent = JSON.stringify(saveMenuItem(undefined, true, true));
        if (newContent === menuitemutil.oldMenuItemData) {
          hideModalWhenReady(oldModal);
          modal.modal("show");
          populateEditCategory(modal, "edit", menuCategory, menuCategory.menuCategoryId);
        } else {
          choiceDialog2(I18n.t("local.warning"), I18n.t("admin_local.product_modified_save_it"), [I18n.t("admin_local.drop"), I18n.t("admin_local.save")]).done(choice => {
            switch (choice) {
              case 0:
                hideModalWhenReady(oldModal);
                modal.modal("show");
                populateEditCategory(modal, "edit", menuCategory, menuCategory.menuCategoryId);
                break;
              case 1:
                saveMenuItem((data) => {
                  menuitemutil.reload(data);
                  hideModalWhenReady(oldModal);
                  modal.modal("show");
                  populateEditCategory(modal, "edit", menuCategory, menuCategory.menuCategoryId);
                }, true, false);
                break;
              default:
            }
          })
        }
      }
    }
  },

  openItemCategory: item => {
    const value = $(item.currentTarget).attr("data-value").split(";");
    const type = value[0];
    const id = value[2];
    if (type === "menuItem") {
      const menuItem = admin.getMenuItemAdmin(id);
      const oldModal = $('.modal.show');
      const modal = $('#editMenuItem.modal');
      if (menuItem) {
        const newContent = JSON.stringify(saveMenuCategory(undefined, true));
        if (newContent === menuitemutil.oldMenuCategoryData) {
          if (oldModal.attr("id") !== "editMenuItem") {
            hideModalWhenReady(oldModal);
            modal.modal("show");
          }
          populateEditMenuItem(modal, "edit", menuItem, menuItem.menuCategoryId);
        } else {
          choiceDialog2(I18n.t("local.warning"), I18n.t("admin_local.product_modified_save_it"), [I18n.t("admin_local.drop"), I18n.t("admin_local.save")]).done(choice => {
            switch (choice) {
              case 0:
                if (oldModal.attr("id") !== "editMenuItem") {
                  hideModalWhenReady(oldModal);
                  modal.modal("show");
                }
                populateEditMenuItem(modal, "edit", menuItem, menuItem.menuCategoryId);
                break;
              case 1:
                saveMenuItem((data) => {
                  menuitemutil.reload(data);
                  if (oldModal.attr("id") !== "editMenuItem") {
                    hideModalWhenReady(oldModal);
                    modal.modal("show");
                  }
                  populateEditMenuItem(modal, "edit", menuItem, menuItem.menuCategoryId);
                }, true, false);
                break;
              default:
            }
          })
        }
      }
    } else {
      const menuCategory = menuitemutil.getMenuCategory(id);
      const oldModal = $('.modal.show');
      const modal = $('#editMenuCategory.modal');
      if (menuCategory) {
        const newContent = JSON.stringify(saveMenuCategory(undefined, true, true));
        if (newContent === menuitemutil.oldMenuCategoryData) {
          populateEditCategory(modal, "edit", menuCategory, menuCategory.menuCategoryId);
        } else {
          choiceDialog2(I18n.t("local.warning"), I18n.t("admin_local.product_modified_save_it"), [I18n.t("admin_local.drop"), I18n.t("admin_local.save")]).done(choice => {
            switch (choice) {
              case 0:
                populateEditCategory(modal, "edit", menuCategory, menuCategory.menuCategoryId);
                break;
              case 1:
                saveMenuItem((data) => {
                  menuitemutil.reload(data);
                  populateEditCategory(modal, "edit", menuCategory, menuCategory.menuCategoryId);
                }, true, false);
                break;
              default:
            }
          })
        }
      }
    }
  },

  previousItem: () => {
    var modal = $("#editMenuItem.modal");
    var node = menuitemutil.menuItems.getActiveNode().getPrevSibling();
    const newContent = JSON.stringify(saveMenuItem(undefined, true, true));
    if (node) {
      if (newContent === menuitemutil.oldMenuItemData) {
        node.setActive(true);
        populateEditMenuItem(modal, "edit", menuitemutil.getMenuItem(node.data.id), node.data.menuCategoryId);
      } else {
        choiceDialog2(I18n.t("local.warning"), I18n.t("admin_local.product_modified_save_it"), [I18n.t("admin_local.drop"), I18n.t("admin_local.save")]).done(choice => {
          switch (choice) {
            case 0:
              node.setActive(true);
              populateEditMenuItem(modal, "edit", menuitemutil.getMenuItem(node.data.id), node.data.menuCategoryId);
              break;
            case 1:
              saveMenuItem((data) => {
                menuitemutil.reload(data);
                node.setActive(true);
                populateEditMenuItem(modal, "edit", node.data, node.data.menuCategoryId);
              }, true, false);
              break;
            default:
          }
        })
      }
    }
  },

  nextItem: () => {
    var modal = $("#editMenuItem.modal");
    var node = menuitemutil.menuItems.getActiveNode().getNextSibling();
    const newContent = JSON.stringify(saveMenuItem(undefined, true, true));
    if (node) {
      if (newContent === menuitemutil.oldMenuItemData) {
        node.setActive(true);
        populateEditMenuItem(modal, "edit", menuitemutil.getMenuItem(node.data.id), node.data.menuCategoryId);
      } else {
        choiceDialog2(I18n.t("local.warning"), I18n.t("admin_local.product_modified_save_it"), [I18n.t("admin_local.drop"), I18n.t("admin_local.save")]).done(choice => {
          switch (choice) {
            case 0:
              node.setActive(true);
              populateEditMenuItem(modal, "edit", menuitemutil.getMenuItem(node.data.id), node.data.menuCategoryId);
              break;
            case 1:
              saveMenuItem((data) => {
                menuitemutil.reload(data);
                node.setActive(true);
                populateEditMenuItem(modal, "edit", node.data, node.data.menuCategoryId);
              }, true, false);
              break;
            default:
          }
        })
      }
    }
  },

  _getMenuItems: function (s, proportional, set, categories, type, start = new Date().getTime()) {
    var local = true;
    var takeaway = true;
    if (new Date().getTime() - start > 1000) {
      return;
    }
    categories.forEach(function (item) {
      s = s.replace(/ /g, ".*");
      var regexp = new RegExp(s, "ig");
      if (typeof item.activeMenuItems == "undefined" && typeof item.children == "undefined") {
        var name = menuitemutil.getPath(item);
        var t = true; // item.entityType.startsWith(entityType);
        var r = regexp.test(name);
        if (t && r) {
          if (item.availableQuantities.length == 1)
            set.insert({
              value: "menuItem;0;" + item.id + ";" + (type == "mandatory" ? "" : item.availableQuantities[0].quantity) + ";" + item.entityType,
              text: menuitemutil.getPath(item) + menuitemutil.getLocalOption("", local) + menuitemutil.getTakeawayOption("", local) + menuitemutil.getProportionalOption("", proportional) + " " + menuitemutil.getQuantityLabel2(type, Math.round(1000 * parseFloat(item.availableQuantities[0].quantity)) / 1000, item.quantityType, getLocale(item.availableQuantities[0].name))
            });
          else if (item.availableQuantities.length == 0)
            set.insert({
              value: "menuItem;0;" + item.id + ";" + (type == "mandatory" ? "" : 1) + ";" + item.entityType,
              text: menuitemutil.getPath(item) + menuitemutil.getLocalOption("", local) + menuitemutil.getTakeawayOption("", local) + menuitemutil.getProportionalOption("", proportional) + " " + menuitemutil.getQuantityLabel2(type, 1, item.quantityType)
            });
          else {
            item.availableQuantities.forEach(function (q) {
              set.insert({
                value: "menuItem;0;" + item.id + ";" + (type == "mandatory" ? "" : q.quantity) + ";" + item.entityType,
                text: menuitemutil.getPath(item) + menuitemutil.getLocalOption("", local) + menuitemutil.getTakeawayOption("", local) + menuitemutil.getProportionalOption("", proportional) + " " + menuitemutil.getQuantityLabel2(type, Math.round(1000 * parseFloat(q.quantity)) / 1000, item.quantityType, getLocale(q.quantityType.name))
              });
            });
          }
        }
      } else {
        var name = menuitemutil.getPath(item);
        var t = true; // item.entityType.startsWith(entityType);
        var r = regexp.test(name);
        if (t && r && type !== "mandatory" && type !== "included") {
          set.insert({
            value: "menuCategory;0;" + item.id + ";" + ";" + item.entityType,
            text: menuitemutil.getPath(item) + menuitemutil.getProportionalOption(""),
            clazz: "category"
          });
        }
        if (item.activeMenuCategories && item.activeMenuCategories.length > 0) menuitemutil._getMenuItems(s, proportional, set, item.activeMenuCategories, type, start);
        if (item.activeMenuItems && item.activeMenuItems.length > 0) menuitemutil._getMenuItems(s, proportional, set, item.activeMenuItems, type, start);
        if (item.children && item.children.length > 0) menuitemutil._getMenuItems(s, proportional, set, item.children, type, start);
      }
    });
  },

  getLabels: function (search) {
    //s = search;
    var set = new SortedSet({
      comparator: function (a, b) {
        if (a.text.toLowerCase().startsWith(search.toLowerCase()) && !b.text.toLowerCase().startsWith(search.toLowerCase())) return -1;
        if (b.text.toLowerCase().startsWith(search.toLowerCase()) && !a.text.toLowerCase().startsWith(search.toLowerCase())) return 1;
        return a.text.localeCompare(b.text);
      }
    });
    var label = menuitemutil._getLabels(search, set, admin.labels);
    if (label == "") {
      return null;
    }
    var result = [];
    set.forEach(function (e) {
      result[result.length] = e;
    });
    return result;
  },

  _getLabels: function (s, set, labels) {
    labels.forEach(function (item) {

      function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
      }

      var regexp = new RegExp(escapeRegExp(s), "ig");
      var name = item.name;
      var r = regexp.test(name);
      if (r) {
        set.insert({
          value: "label;" + item.id + ";",
          text: name
        });
      }
    });
  },

  getLanguage: function () {
    return localStorage.languageSelected;
  },

  _updateMenu: function (item, cats) {
    if (item.children)
      menuitemutil.filterByType(item);
    admin.updateMenuItemMapAdmin([item]);
    admin.updateMenuItemMap([{ ...item, name: getLocale(item.name), description: getLocale(item.description) }]);
    var found = false;
    if (cats == undefined) {
      cats = admin.adminCategories.children;
    }
    if (cats)
      if (Array.isArray(item)) {
        item.forEach(item => {
          cats.forEach((i, ind) => {
            if (i.id == item.id && i.entityType == item.entityType) {
              cats[ind] = item;
              if (item.availableQuantities)
                addMenuItem(item);
              found = true;
              processMenuItems(admin.adminCategories);
            }
            if (i.children) found |= menuitemutil.updateMenu(item, i.children);
          });
        });
      } else {
        cats.forEach((i, ind) => {
          if (i.id == item.id && i.entityType == item.entityType) {
            cats[ind] = item;
            if (item.availableQuantities)
              addMenuItem(item);
            found = true;
            processMenuItems(admin.adminCategories);
          }
          if (i.children) found |= menuitemutil.updateMenu(item, i.children);
        });
      }
    return found;
  },

  toggleChart: function () {
    var active = $("#graph").hasClass("btn-positive");
    $("#graph-block").addClass("hidden");
    $("#mgraph").addClass("btn-info");
    $("#mgraph").removeClass("btn-positive");
    if (ReactDOM.findDOMNode($("#graph-block").get(0)) !== null) ReactDOM.unmountComponentAtNode($("#graph-block").get(0));
    if (active) {
      $("#chart-block").addClass("hidden");
      $("#graph").addClass("btn-info");
      $("#graph").removeClass("btn-positive");
    } else {
      $("#chart-block").removeClass("hidden");
      $("#graph").addClass("btn-positive");
      $("#graph").removeClass("btn-info");
      if (typeof oldData == "undefined") populateCharts();
      else drawChart();
    }
  },

  toggleGraph: function () {
    var active = $("#mgraph").hasClass("btn-positive");
    const target = $("#graph-block");
    $("#chart-block").addClass("hidden");
    $("#graph").addClass("btn-info");
    $("#graph").removeClass("btn-positive");
    if (active) {
      target.addClass("hidden");
      $("#mgraph").addClass("btn-info");
      $("#mgraph").removeClass("btn-positive");
      if (ReactDOM.findDOMNode(target.get(0)) !== null) ReactDOM.unmountComponentAtNode(target.get(0));
    } else {
      target.removeClass("hidden");
      $("#mgraph").addClass("btn-positive");
      $("#mgraph").removeClass("btn-info");
      if (ReactDOM.findDOMNode(target.get(0)) !== null) ReactDOM.unmountComponentAtNode(target.get(0));
      ReactDOM.render(<MenuItemGraph categories={admin.categories.children} selected={menuitemutil.selected} />, target.get(0));
    }
  },

  populateGraph: function () {
    const target = $("#graph-block");
    if (target.hasClass("hidden")) return;
    if (ReactDOM.findDOMNode(target.get(0)) !== null) ReactDOM.unmountComponentAtNode(target.get(0));
    ReactDOM.render(<MenuItemGraph categories={admin.categories.children} selected={menuitemutil.selected} />, target.get(0));
  },

  toggleView: function () {
    var active = $("#menuitemview").hasClass("btn-positive");
    if (active) {
      $("#right_pane").addClass("hidden");
      $("#menuitemview").addClass("btn-info");
      $("#menuitemview").removeClass("btn-positive");
    } else {
      $("#right_pane").removeClass("hidden");
      $("#menuitemview").addClass("btn-positive");
      $("#menuitemview").removeClass("btn-info");
      renderCategories();
    }
  },

  tablehooks: function () {

    if (auth?.myStatus?.restaurant_settings?.["shop-mode"])
      tooltip($("[data-toggle='tooltip']"));
    $("table td.availablequantity1 text").unbind("click");
    if (hasRole("administration.products.fullaccess"))
      $("table td.availablequantity1 text span#serving").click(event => {
        var t = event.target.parentElement.parentElement;
        if ($(t).find("select").lenght > 0) return;
        var data = $($(t).parents('tr')[0]).data('node').data;
        const quantity = $(event.target).parents('text').attr("id");
        var value = null;
        data.availableQuantities.forEach(q => {
          if (q.quantity == quantity) value = q.quantityType;
        });
        var select = '<select id="quantityType' + data.id + '">';
        auth.myStatus.restaurant_quantity_types_all.forEach(q => {
          select += '<option id="' + q.id + '" value="' + q.id + '" ' + (value !== null && q.id == value.id ? "selected" : "") + ">" + getLocale(q.name, localStorage.languageSelected) + "</option>";
        });
        select += "</select>";
        var s = $(select);
        $(t)
          .find("select")
          .remove();
        var serv = $(t).find("span#serving");
        s.insertBefore(serv);
        serv.hide();

        $(t)
          .find("select")
          .click(event => {
            event.stopPropagation();
          });

        $(t).find("select").on('change', t => {
          serv.html(s.find("option:selected").html());
          var value = s.find("option:selected").attr("value");
          data.availableQuantities.forEach(q => {
            if (q.quantity == quantity) q.quantityType = { id: value };
          });
          s.remove();
          serv.show();
          utils.modifyMenuItem(
            data.menuCategoryId,
            data,
            d => {
              menuitemutil.updateMenu(d);
            },
            menuitemutil.reload
          );
        });
      });
    $("table td.description input").unbind("change");
    $("table td.description input").change(function (data) {
      var t = this;
      var data = $($(t).parents('tr')[0]).data('node').data;
      var value = $(t).val();
      var description = (data.description[localStorage.languageSelected] = value);

      data.description[localStorage.languageSelected] = value;
      if (data.entityType.indexOf("Category") < 0) {
        utils.modifyMenuItem(
          data.menuCategoryId,
          data,
          d => {
            menuitemutil.updateMenu(d);
          },
          menuitemutil.reload
        );
      } else {
        utils.modifyMenuCategory(
          data,
          d => {
            menuitemutil.updateMenu(d);
          }
        );
      }
    });
    $("table td.unitprice input").unbind("change");
    $("table td.unitprice input").change(function (data) {
      var t = this;
      var data = $($(t).parents('tr')[0]).data('node').data;
      var value = $(t).val();
      data.unitPrice = value;
      utils.modifyMenuItem(
        data.menuCategoryId,
        data,
        d => {
          menuitemutil.updateMenu(d);
        },
        menuitemutil.reload
      );
    });

    $("table td.availablequantity2 input").unbind("change");
    $("table td.availablequantity2 input").change(function (data) {
      var t = this;
      var data = $($(t).parents('tr')[0]).data('node').data;
      var value = $(t).val();
      if ($(t).hasClass("unitPrice")) {
        data.unitPrice = value;
        utils.modifyMenuItem(
          data.menuCategoryId,
          data,
          d => {
            menuitemutil.updateMenu(d);
          },
          menuitemutil.reload
        );
      } else {
        var quantity = $(t).attr("quantity");
        data.availableQuantities.forEach(q => {
          if (q.quantity == quantity) q.price = value;
        });
        utils.modifyMenuItem(
          data.menuCategoryId,
          data,
          d => {
            menuitemutil.updateMenu(d);
          },
          menuitemutil.reload
        );
      }
    });

    $("table td.promotionPrice input").unbind("change");
    $("table td.promotionPrice input").change(function (data) {
      var t = this;
      var data = $($(t).parents('tr')[0]).data('node').data;
      var value = $(t).val();
      var quantity = $(t).attr("quantity");
      data.availableQuantities.forEach(q => {
        if (q.quantity == quantity) {
          q.promotionPrice = value;
          if (!q.promotionName && menuitemutil.lastPromotionName) q.promotionName = menuitemutil.lastPromotionName;
          if (!q.promotionStart && menuitemutil.lastPromotionStart) q.promotionStart = menuitemutil.lastPromotionStart;
          if (!q.promotionEnd && menuitemutil.lastPromotionEnd) q.promotionEnd = menuitemutil.lastPromotionEnd;
        }

      });
      utils.modifyMenuItem(
        data.menuCategoryId,
        data,
        d => {
          menuitemutil.updateMenu(d);
        },
        menuitemutil.reload
      );
    });
    $("table td.promotionName input").unbind("change");
    $("table td.promotionName input").change(function (data) {
      var t = this;
      var data = $($(t).parents('tr')[0]).data('node').data;
      var value = $(t).val();
      menuitemutil.lastPromotionName = value;
      var quantity = $(t).attr("quantity");
      data.availableQuantities.forEach(q => {
        if (q.quantity == quantity) q.promotionName = value;
      });
      utils.modifyMenuItem(
        data.menuCategoryId,
        data,
        d => {
          menuitemutil.updateMenu(d);
        },
        menuitemutil.reload
      );
    });
    $("table td.promotionStart input").unbind("change");
    $("table td.promotionStart input").change(function (data) {
      var t = this;
      var data = $($(t).parents('tr')[0]).data('node').data;
      var value = $(t).val();
      menuitemutil.lastPromotionStart = value;
      var quantity = $(t).attr("quantity");
      data.availableQuantities.forEach(q => {
        if (q.quantity == quantity) q.promotionStart = value;
      });
      utils.modifyMenuItem(
        data.menuCategoryId,
        data,
        d => {
          menuitemutil.updateMenu(d);
        },
        menuitemutil.reload
      );
    });
    $("table td.promotionEnd input").unbind("change");
    $("table td.promotionEnd input").change(function (data) {
      var t = this;
      var data = $($(t).parents('tr')[0]).data('node').data;
      var value = $(t).val();
      menuitemutil.lastPromotionEnd = value;
      var quantity = $(t).attr("quantity");
      data.availableQuantities.forEach(q => {
        if (q.quantity == quantity) q.promotionEnd = value;
      });
      utils.modifyMenuItem(
        data.menuCategoryId,
        data,
        d => {
          menuitemutil.updateMenu(d);
        },
        menuitemutil.reload
      );
    });

    $("input.checkbox.isInventoryItem").unbind("change");
    $("input.checkbox.isInventoryItem").change(function (data) {
      handleCheckBoxChange(this, function (t) {
        var data = $($(t).parents('tr')[0]).data('node').data;
        if (data.entityType.indexOf("Category") < 0) {
          data.inventoryItem = $(t).prop("indeterminate") ? undefined : $(t).prop("checked");
          utils.modifyMenuItem(
            data.menuCategoryId,
            data,
            d => {
              menuitemutil.updateMenu(d);
            },
            menuitemutil.reload
          );
        } else {
          data.inventoryItem = $(t).prop("indeterminate") ? undefined : $(t).prop("checked");
          utils.modifyMenuCategory(
            data,
            d => {
              menuitemutil.updateMenu(d);
            });
        }
      });
    });
    $("input.checkbox.isActive").unbind("change");
    $("input.checkbox.isActive").change(function (event) {
      event.stopPropagation();
      event.preventDefault();
      var t = this;
      var data = $($(t).parents('tr')[0]).data('node').data;
      data.isActive = $(t).prop("checked");
      if (data.entityType.indexOf("Category") < 0) {
        utils.modifyMenuItemActivity(
          data.id, data.isActive,
          d => {
            menuitemutil.updateMenu(d);
          }
        );
      } else {
        utils.modifyMenuCategoryActivity(
          data.id, data.isActive,
          d => {
            menuitemutil.updateMenu(d);
          }
        );
      }
    });
    $("input.checkbox.thirdParty").unbind("change");
    $("input.checkbox.thirdParty").change(function (event) {
      var t = this;
      var data = $($(t).parents('tr')[0]).data('node').data;
      const id = event.currentTarget.id.split("-");
      const platform = id[0];
      const name = id[1];
      const quantity = id[2];
      const settings = data.availableQuantities.find(q => q.quantity == quantity).settings;
      if (!settings[platform]) settings[platform] = {}
      settings[platform][name] = { ...settings[platform][name], enabled: event.target.checked }
      if (data.entityType.indexOf("Category") < 0) {
        utils.modifyMenuItem(
          data.menuCategoryId,
          data,
          d => {
            menuitemutil.updateMenu(d);
          },
          menuitemutil.reload
        );
      } else {
        utils.modifyMenuCategory(
          data,
          d => {
            menuitemutil.updateMenu(d);
          }
        );
      }
    });
    $("input.checkbox.isTop").unbind("change");
    $("input.checkbox.isTop").change(function (data) {
      var t = this;
      var data = $($(t).parents('tr')[0]).data('node').data;
      data.isTop = $(t).prop("checked");
      if (data.entityType.indexOf("Category") < 0) {
        utils.modifyMenuItem(
          data.menuCategoryId,
          data,
          d => {
            menuitemutil.updateMenu(d);
          },
          menuitemutil.reload
        );
      } else {
        utils.modifyMenuCategory(
          data,
          d => {
            menuitemutil.updateMenu(d);
          },
          menuitemutil.reload
        );
      }
    });
    $("input.checkbox.pos").unbind("change");
    $("input.checkbox.pos").change(function (data) {
      var t = this;
      var data = $($(t).parents('tr')[0]).data('node').data;
      data.pos = $(t).prop("checked");

      if (data.entityType.indexOf("Category") < 0) {
        utils.modifyMenuItemPos(
          data.id, data.pos,
          d => {
            menuitemutil.updateMenu(d);
          }
        );
      } else {
        utils.modifyMenuCategoryPos(
          data.id, data.pos,
          d => {
            menuitemutil.updateMenu(d);
          }
        );
      }
    });
    $("input.checkbox.kiosk").unbind("change");
    $("input.checkbox.kiosk").change(function (data) {
      var t = this;
      var data = $($(t).parents('tr')[0]).data('node').data;
      data.kiosk = $(t).prop("checked");
      if (data.entityType.indexOf("Category") < 0) {
        utils.modifyMenuItem(
          data.menuCategoryId,
          data,
          d => {
            menuitemutil.updateMenu(d);
          },
          menuitemutil.reload
        );
      } else {
        utils.modifyMenuCategory(
          data,
          d => {
            menuitemutil.updateMenu(d);
          },
          menuitemutil.reload
        );
      }
    });
    $("input.checkbox.online").unbind("change");
    $("input.checkbox.online").change(function (data) {
      var t = this;
      var data = $($(t).parents('tr')[0]).data('node').data;
      data.online = $(t).prop("checked");
      if (data.entityType.indexOf("Category") < 0) {
        utils.modifyMenuItem(
          data.menuCategoryId,
          data,
          d => {
            menuitemutil.updateMenu(d);
          }
        );
      } else {
        utils.modifyMenuCategory(
          data,
          d => {
            menuitemutil.updateMenu(d);
          },
          menuitemutil.reload
        );
      }
    });
    $("input.checkbox.available").unbind("change");
    $("input.checkbox.available").change(function (data) {
      var t = this;
      var data = $($(t).parents('tr')[0]).data('node').data;
      data.available = $(t).prop("checked");
      if (data.entityType.indexOf("Category") < 0) {
        utils.modifyMenuItemAvailabilty(
          data.id, data.available,
          d => {
            menuitemutil.updateMenu(d);
          }
        );
      } else {
        utils.modifyMenuCategoryAvailabilty(
          data.id, data.available,
          d => {
            menuitemutil.updateMenu(d);
          }
        );
      }
    });
    $("input.checkbox.freeQuantity").unbind("change");
    $("input.checkbox.freeQuantity").change(function (data) {
      var t = this;
      var data = $($(t).parents('tr')[0]).data('node').data;
      data.freeQuantity = !$(t).prop("checked");
      if (data.entityType.indexOf("Category") < 0) {
        utils.modifyMenuItem(
          data.menuCategoryId,
          data,
          d => {
            menuitemutil.updateMenu(d);
          }
        );
      }
    });
    $("td.cost div.approve").off("dblclick");
    $("td.cost div.approve").on("dblclick", function (event) {
      event.stopPropagation();
      event.preventDefault();
      var data = $($(event.target).parents('tr')[0]).data('node').data;
      const quantity = Number($(event.target).attr("quantity") || $(event.target).parents("div.approve").attr("quantity"));
      if (data.entityType.indexOf("Category") < 0) {
        data.availableQuantities.find(q => q.quantity === quantity).approvedCost = data.availableQuantities.find(q => q.quantity === quantity).cost;
        utils.modifyMenuItem(
          data.menuCategoryId,
          data,
          d => {
            menuitemutil.updateMenu(d);
          }
        );
      } else {
      }
    });
    $("td.cost .approveCategory button").off("click");
    $("td.cost .approveCategory button").on("click", function (event) {
      event.stopPropagation();
      event.preventDefault();
      var data = $($(event.target).parents('tr')[0]).data('node').data;
      utils.approveCostChange(data.id, menuitemutil._reload);
    });
    function fw(t, type) {
      var data = $($(t).parents('tr')[0]).data('node').data;
      if (!data.settings)
        data.settings = { foodpanda: {}, wolt: {}, falatozz: {}, choiceqr: {}, takeaway: {} }
      var z = data.settings[type];
      if (!z)
        data.settings[type] = z = {};
      if (data.entityType.indexOf("Category") < 0) {
        if (![$(t).prop("name")])
          z[$(t).prop("name")] = {};
        z[$(t).prop("name")].enabled = $(t).prop("checked");
        utils.modifyMenuItem(
          data.menuCategoryId,
          data,
          d => {
            menuitemutil.updateMenu(d);
          },
        );
      } else {
        if (!z[$(t).prop("name")])
          z[$(t).prop("name")] = {};
        z[$(t).prop("name")].enabled = $(t).prop("checked");
        utils.modifyMenuCategory(
          data,
          d => {
            menuitemutil.updateMenu(d);
          },
        );
      }
    }
    $("input.checkbox.foodpanda").unbind("change");
    $("input.checkbox.foodpanda").change(function (data) {
      fw(this, "foodpanda");
    });
    $("input.checkbox.wolt").unbind("change");
    $("input.checkbox.wolt").change(function (data) {
      fw(this, "wolt");
    });
    $("input.checkbox.falatozz").unbind("change");
    $("input.checkbox.falatozz").change(function (data) {
      fw(this, "falatozz");
    });
    $("input.checkbox.choiceqr").unbind("change");
    $("input.checkbox.choiceqr").change(function (data) {
      fw(this, "choiceqr");
    });

  },

  getRestaurant: id => {
    return menuitemutil.props.restaurants.find(rr => rr.globalId === id);
  },

  localFromGlobal: {

  },
  getLocalFromGlobal: (restaurant) => {
    const def = $.Deferred();
    if (menuitemutil.localFromGlobal[restaurant.globalId])
      def.resolve(menuitemutil.localFromGlobal[restaurant.globalId]);
    else
      return get(restaurant.serverUrl + "eatwithme.server/" + restaurant.instance + "/tableService/getLocalFromGlobalId/" + restaurant.globalId + "?instance=" + restaurant.instance, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false).done(id => {
        menuitemutil.localFromGlobal[restaurant.globalId] = id;
        def.resolve(id);
      })
    return def.promise();
  },

  updateMenuItemAdditionToGlobalIdRemote: (additions, globalId) => {
    additions = additions.map(a => {
      a = { ...a };
      if (a.additionGlobalId) {
        a.additionId = a.additionGlobalId;
        a.additionGlobalId = null;
      } else {
        a.additionGlobalId = a.additionId;
        a.additionId = null;
      }
      delete a.addition;
      delete a.id;
      return a;
    })
    return additions;
  },

  updateMenuCategoryAdditionToGlobalIdRemote: (additions, globalId) => {
    additions = additions.map(a => {
      a = { ...a };
      if (a.additionGlobalId) {
        a.additionId = a.additionGlobalId;
        a.additionGlobalId = null;
      } else {
        a.additionGlobalId = a.additionId;
        a.additionId = null;
      }
      delete a.addition;
      delete a.id;
      return a;
    })
    return additions;
  },

  updateRemote: (entity, globalId, node) => {
    return menuitemutil._updateRemote(entity, entity, globalId, node).done(() => refreshConnectedRestaurants(globalId, true));
  },

  fetchImage: (imageUrl, entity, remoteEntity, key, image, globalId, node, instance, def, u) => {
    fetch(imageUrl + image + "?instance=" + instance)
      .then(res => res.blob())
      .then(blob => {
        let reader = new FileReader();
        reader.onloadend = () => {
          let imgSrc = reader.result; // pl. "data:image/png;base64,iVBORw0..."
          remoteEntity[key] = null;
          remoteEntity[key + "Src"] = imgSrc;
          u(entity, remoteEntity, globalId, node, def);
        };
        reader.readAsDataURL(blob);
      });
  },

  _updateRemote: (entity, remoteEntity, globalId, node, def) => {
    def = def || $.Deferred();
    const restaurant = menuitemutil.getRestaurant(globalId);

    const imageUrl = auth.server + "/eatwithme.server/tableService/" + auth.myStatus.restaurant_id + "/getImage/";

    if (entity.availableQuantities) {
      var {
        entityType,
        id,
        barcodes,
        action,
        shortName,
        manufacturer,
        name,
        description,
        image,
        imageSrc,
        bigImage,
        bigImageSrc,
        quantityType,
        cost,
        unitPrice,
        availableQuantities,
        timing,
        production_lines,
        vatCategory,
        takeawayVatCategory,
        isActive,
        isTop,
        kiosk,
        above18,
        online,
        available,
        inventoryItem,
        freeQuantity,
        menuItemAdditions,
        menuCategoryAdditions,
        labels,
        pricePerCostRatio,
        color,
        mandatory_volume,
        places,
        preorder,
        toDate,
        fromDate,
        mainCategoryId,
        subCategoryId,
        woltImage,
        woltImageSrc,
        foodpandaImage,
        foodpandaImageSrc,
        falatozzImage,
        falatozzImageSrc,
        choiceqrImage,
        choiceqrImageSrc,
        minimumPrice,
        pos
      } = entity;

      function arrayBufferToBase64(buffer) {
        let binary = '';
        let bytes = new Uint8Array(buffer);
        let chunk = 0x8000;
        for (let i = 0; i < bytes.length; i += chunk) {
          let sub = bytes.subarray(i, i + chunk);
          binary += String.fromCharCode.apply(null, sub);
        }
        return btoa(binary);
      }

      if (image && !imageSrc) {
        menuitemutil.fetchImage(imageUrl, entity, entity, "image", image, globalId, node, localStorage.instance, def, menuitemutil._updateRemote);
        return def.promise();
      };

      if (woltImage && !woltImageSrc) {
        menuitemutil.fetchImage(imageUrl, entity, entity, "woltImage", woltImage, globalId, node, localStorage.instance, def, menuitemutil._updateRemote);
        return def.promise();
      };
      if (foodpandaImage && !foodpandaImageSrc) {
        menuitemutil.fetchImage(imageUrl, entity, entity, "foodpandaImage", foodpandaImage, globalId, node, localStorage.instance, def, menuitemutil._updateRemote);
        return def.promise();
      };
      if (falatozzImage && !falatozzImageSrc) {
        menuitemutil.fetchImage(imageUrl, entity, entity, "falatozzImage", falatozzImage, globalId, node, localStorage.instance, def, menuitemutil._updateRemote);
        return def.promise();
      };
      if (choiceqrImage && !choiceqrImageSrc) {
        menuitemutil.fetchImage(imageUrl, entity, entity, "choiceqrImage", choiceqrImage, globalId, node, localStorage.instance, def, menuitemutil._updateRemote);
        return def.promise();
      };

      if (bigImage && !bigImageSrc) {
        menuitemutil.fetchImage(imageUrl, entity, entity, "bigImage", bigImage, globalId, node, localStorage.instance, def, menuitemutil._updateRemote);
        return def.promise();
      };
      if (menuItemAdditions)
        menuItemAdditions = menuitemutil.updateMenuItemAdditionToGlobalIdRemote(menuItemAdditions, globalId);
      if (menuCategoryAdditions)
        menuCategoryAdditions = menuitemutil.updateMenuCategoryAdditionToGlobalIdRemote(menuCategoryAdditions, globalId);
      const e = {
        type: entityType.toLowerCase(),
        globalId: id,
        barcodes,
        action,
        shortName,
        manufacturer,
        name,
        description,
        imageSrc,
        bigImageSrc,
        quantityType,
        cost,
        unitPrice,
        availableQuantities,
        timing,
        production_lines,
        vatCategory,
        takeawayVatCategory,
        isActive,
        isTop,
        kiosk,
        above18,
        online,
        available,
        inventoryItem,
        freeQuantity,
        menuItemAdditions,
        menuCategoryAdditions,
        labels,
        pricePerCostRatio,
        color,
        mandatory_volume,
        places,
        preorder,
        toDate,
        fromDate,
        woltImageSrc,
        foodpandaImageSrc,
        falatozzImageSrc,
        choiceqrImageSrc,
        minimumPrice,
        mainCategory: mainCategoryId,
        subCategory: subCategoryId,
        pos: pos
      }
      menuitemutil.getLocalFromGlobal(restaurant).done(id => {

        const menuCategory = getMenuCategory(entity);

        if (entity.connectedRestaurants[0]) {
          if (entity.connectedRestaurants[restaurant.globalId]) {
            post(restaurant.serverUrl + auth.war + "/" + restaurant.instance + "/mergeService/" + id + "/" + (entity.menuCategoryId || 0) + "/modifyMenuItem?instance=" + restaurant.instance + "&properties=" + menuitemutil.synchronizeProperties.join(","), e)
              .done(def.resolve)
              .fail(() => {
                auth.ajaxError = false;
              });
          } else {
            post(restaurant.serverUrl + auth.war + "/" + restaurant.instance + "/mergeService/" + id + "/" + (menuCategory.id || 0) + "/addMenuItem?instance=" + restaurant.instance, e)
              .done(def.resolve)
              .fail(() => {
                auth.ajaxError = false;
              });
          }
        }

      });
    } else {
      var {
        entityType,
        id,
        name,
        description,
        image,
        timing,
        productionLines,
        vatCategory,
        takeawayVatCategory,
        isActive: active,
        isTop,
        kiosk,
        above18,
        online,
        available,
        inventoryItem,
        menuItemAdditions,
        menuCategoryAdditions,
        labels,
        pricePerCostRatio,
        color,
        settings,
        fromDate,
        toDate,
        preorder,
        mainCategoryId,
        subCategoryId,
        pos
      } = entity;
      if (menuItemAdditions)
        menuItemAdditions = menuitemutil.updateMenuItemAdditionToGlobalIdRemote(menuItemAdditions, globalId);
      if (menuCategoryAdditions)
        menuCategoryAdditions = menuitemutil.updateMenuCategoryAdditionToGlobalIdRemote(menuCategoryAdditions, globalId);
      const e = {
        id: remoteEntity?.id,
        globalId: id,
        type: entityType.toLowerCase(),
        name,
        description,
        imageSrc: image ? auth.myStatus.local_url + "eatwithme.server/tableService/1/getImage/" + image + "?instance=" + localStorage.instance : null,
        timing,
        productionLines,
        vatCategory,
        takeawayVatCategory,
        isActive: active,
        isTop,
        kiosk,
        pos,
        above18,
        online,
        available,
        inventoryItem,
        menuItemAdditions,
        menuCategoryAdditions,
        labels,
        pricePerCostRatio,
        color,
        settings,
        fromDate,
        toDate,
        preorder,
        mainCategory: mainCategoryId,
        subCategory: subCategoryId
      }
      menuitemutil.getLocalFromGlobal(restaurant).done(id => {
        if (!entity.connectedRestaurants[0])
          return;
        function login() {
          getGlobal("login/getLoginTokenNew/" + restaurant.globalId + "?l=menuitem").done(token => {
            post(restaurant.serverUrl + "eatwithme.server/" + restaurant.instance + "/login?instance=" + restaurant.instance, "username=" + encodeURIComponent("authtoken:" + restaurant.globalId + "/" + token.token) + "&password=" + encodeURIComponent(token.token) + "&user=true", {}, true, 0, false, 30000).done(() => {
              updateOrder();
            })
          })
        }

        function updateOrder() {
          if (node && node.children) {
            const ids = [];
            node.children.forEach(function (d) {
              if (d.data.connectedRestaurants[globalId]) {
                if (d.data.connectedRestaurants[globalId].id) {
                  ids.push(d.data.entityType == menuitemutil.entityType ? 0 : 1);
                  ids.push(d.data.connectedRestaurants[globalId].id);
                }
              }
            });
            post(restaurant.serverUrl + auth.war + "/" + restaurant.instance + "/mergeService/" + id + "/updateCategoryOrders?instance=" + restaurant.instance, ids, undefined, undefined, 2, true, 60000).done(function (data) {
              def.resolve();
            }).fail(data => {
              auth.ajaxError = false;
              if (data.status == 403)
                login();
            });
          } else {
            def.resolve();
          }
        }
        const menuCategory = entity.menuCategoryId;
        delete e.id;

        if (entity.connectedRestaurants[restaurant.globalId]) {
          post(restaurant.serverUrl + auth.war + "/" + restaurant.instance + "/mergeService/" + id + "/" + (menuCategory || 0) + "/modifyCategory?instance=" + restaurant.instance + "&properties=" + menuitemutil.synchronizeProperties.join(","), e).done(() => updateOrder());
        } else {
          post(restaurant.serverUrl + auth.war + "/" + restaurant.instance + "/mergeService/" + id + "/" + (menuCategory || 0) + "/addCategory?instance=" + restaurant.instance, e).done(() => updateOrder());
        }


      });
    }
    return def.promise();
  },

  updateMenuItemAdditionToGlobalIdLocal: (additions, globalId) => {
    additions.forEach(a => {
      if (a.additionGlobalId) {
        a.additionId = a.additionGlobalId;
        a.additionGlobalId = null;
      } else {
        a.additionGlobalId = a.additionId;
        a.additionId = null;
      }
      delete a.id;
      delete a.addition;
    })
    return additions;
  },

  updateMenuCategoryAdditionToGlobalIdLocal: (additions, globalId) => {
    additions.forEach(a => {
      if (a.additionGlobalId) {
        a.additionId = a.additionGlobalId;
        a.additionGlobalId = null;
      } else {
        a.additionGlobalId = a.additionId;
        a.additionId = null;
      }
      delete a.id;
      delete a.addition;
    })
    return additions;
  },

  updateLocal: (entity, globalId, node, def) => {
    let remoteEntity = entity.connectedRestaurants[globalId];
    return menuitemutil._updateLocal(entity, remoteEntity, globalId, node, def).done(() => {
      auth.myStatus.restaurant_modification_timestamp++; menuitemutil._reload();
    });
  },

  __updateLocal: (entity, globalId, node, def) => {
    let remoteEntity = entity.connectedRestaurants[globalId];
    return menuitemutil._updateLocal(entity, remoteEntity, globalId, node, def);
  },

  _updateLocal: (entity, remoteEntity, _globalId, node, def) => {
    def = def || $.Deferred();

    const restaurant = menuitemutil.getRestaurant(_globalId);

    const imageUrl = restaurant.serverUrl + "eatwithme.server/tableService/" + restaurant.localId + "/getImage/";

    if (remoteEntity.availableQuantities) {
      var {
        entityType,
        id,
        globalId,
        barcodes,
        action,
        shortName,
        manufacturer,
        name,
        description,
        image,
        imageSrc,
        bigImage,
        bigImageSrc,
        quantityType,
        cost,
        unitPrice,
        availableQuantities,
        timing,
        production_lines,
        vatCategory,
        takeawayVatCategory,
        isActive,
        isTop,
        kiosk,
        above18,
        online,
        available,
        inventoryItem,
        freeQuantity,
        menuItemAdditions,
        menuCategoryAdditions,
        labels,
        pricePerCostRatio,
        color,
        mandatory_volume,
        places,
        preorder,
        toDate,
        fromDate,
        mainCategoryId,
        subCategoryId,
        woltImage,
        foodpandaImage,
        falatozzImage,
        choiceqrImage,
        woltImageSrc,
        foodpandaImageSrc,
        falatozzImageSrc,
        choiceqrImageSrc,
        minimumPrice,
        pos
      } = remoteEntity;

      if (image && !imageSrc) {
        menuitemutil.fetchImage(imageUrl, entity, remoteEntity, "image", image, _globalId, node, restaurant.instance, def, menuitemutil._updateLocal);
        return def.promise();
      };

      if (woltImage && !woltImageSrc) {
        menuitemutil.fetchImage(imageUrl, entity, remoteEntity, "woltImage", woltImage, _globalId, node, restaurant.instance, def, menuitemutil._updateLocal);
        return def.promise();
      };
      if (foodpandaImage && !foodpandaImageSrc) {
        menuitemutil.fetchImage(imageUrl, entity, remoteEntity, "foodpandaImage", foodpandaImage, _globalId, node, restaurant.instance, def, menuitemutil._updateLocal);
        return def.promise();
      };
      if (falatozzImage && !falatozzImageSrc) {
        menuitemutil.fetchImage(imageUrl, entity, remoteEntity, "falatozzImage", falatozzImage, _globalId, node, restaurant.instance, def, menuitemutil._updateLocal);
        return def.promise();
      };
      if (choiceqrImage && !choiceqrImageSrc) {
        menuitemutil.fetchImage(imageUrl, entity, remoteEntity, "choiceqrImage", choiceqrImage, _globalId, node, restaurant.instance, def, menuitemutil._updateLocal);
        return def.promise();
      };
      if (bigImage && !bigImageSrc) {
        menuitemutil.fetchImage(imageUrl, entity, remoteEntity, "bigImage", bigImage, _globalId, node, restaurant.instance, def, menuitemutil._updateLocal);
        return def.promise();
      };

      menuItemAdditions = menuitemutil.updateMenuItemAdditionToGlobalIdLocal(menuItemAdditions, globalId);
      menuCategoryAdditions = menuitemutil.updateMenuCategoryAdditionToGlobalIdLocal(menuCategoryAdditions, globalId);
      const e = {
        type: entityType.toLowerCase(),
        id: entity.id,
        //globalId: id,
        barcodes,
        action,
        shortName,
        manufacturer,
        name,
        description,
        imageSrc: imageSrc,
        bigImageSrc: bigImageSrc,
        quantityType,
        cost,
        unitPrice,
        availableQuantities,
        timing,
        production_lines,
        vatCategory,
        takeawayVatCategory,
        isActive: isActive,
        isTop,
        kiosk,
        above18,
        online,
        available,
        inventoryItem,
        freeQuantity,
        menuItemAdditions,
        menuCategoryAdditions,
        labels,
        pricePerCostRatio,
        color,
        mandatory_volume,
        places,
        preorder,
        toDate,
        fromDate,
        woltImageSrc,
        foodpandaImageSrc,
        falatozzImageSrc,
        choiceqrImageSrc,
        minimumPrice,
        mainCategory: mainCategoryId,
        subCategory: subCategoryId,
        pos
      }
      const remoteCategory = getMenuCategory(remoteEntity);
      if (entity.connectedRestaurants[0]) {
        //e.globalId = e.id;
        //delete e.id;
        post(localStorage.instance + "/mergeService/" + localStorage.restaurantSelected + "/" + (remoteCategory.globalId || remoteCategory.id) + "/modifyMenuItem?properties=" + menuitemutil.synchronizeProperties.join(","), e, undefined, true, undefined, true)
          .done(def.resolve)
          .fail(res => {
            auth.ajaxError = false;
            if (res.status == 403) {
              // login and retry
              getGlobal("login/getLoginTokenNew/" + auth.myStatus.restaurant_global_id + "?l=menuitem").done(token => {
                post(localStorage.instance + "/login?instance=" + localStorage.instance, "username=" + encodeURIComponent("authtoken:" + auth.myStatus.restaurant_global_id + "/" + token.token) + "&password=" + encodeURIComponent(token.token) + "&user=true", {}, true, 0, false, 30000).done(() => {
                  post(localStorage.instance + "/mergeService/" + localStorage.instance + "/" + (remoteCategory.globalId || remoteCategory.id) + "/modifyMenuItem?properties=" + menuitemutil.synchronizeProperties.join(","), e).done(def.resolve);
                })
              });
            }
          })
      } else {
        delete e.id;
        post(localStorage.instance + "/mergeService/" + localStorage.restaurantSelected + "/" + (remoteCategory.globalId || remoteCategory.id) + "/addMenuItem", e, undefined, true, undefined, true)
          .done(data => {
            get(restaurant.serverUrl + auth.war + "/" + restaurant.instance + "/mergeService/" + restaurant.localId + "/updateMenuItemGlobalId/" + entity.id + "/" + data.id + "?instance=" + restaurant.instance).done(() => def.resolve(data));
          })
          .fail(res => {
            auth.ajaxError = false;
            if (res.status == 403) {
              getGlobal("login/getLoginTokenNew/" + auth.myStatus.restaurant_global_id + "?l=menuitem").done(token => {
                post(localStorage.instance + "/login?instance=" + localStorage.instance, "username=" + encodeURIComponent("authtoken:" + auth.myStatus.restaurant_global_id + "/" + token.token) + "&password=" + encodeURIComponent(token.token) + "&user=true", {}, true, 0, false, 30000).done(() => {
                  post(localStorage.instance + "/mergeService/" + localStorage.restaurantSelected + "/" + (remoteCategory.globalId || remoteCategory.id) + "/addMenuItem", e, undefined, undefined, undefined, true).done(data => {
                    get(restaurant.serverUrl + auth.war + "/" + restaurant.instance + "/mergeService/" + restaurant.localId + "/updateMenuItemGlobalId/" + entity.id + "/" + data.id + "?instance=" + restaurant.instance).done(() => def.resolve(data));
                  }).fail(() => {
                    auth.ajaxError = false;
                  })
                })
              })
            }
          });
      }
    } else {
      var {
        entityType,
        globalId,
        id,
        name,
        description,
        image,
        imageSrc,
        timing,
        productionLines,
        vatCategory,
        takeawayVatCategory,
        isActive: active,
        isTop,
        kiosk,
        above18,
        online,
        available,
        inventoryItem,
        menuItemAdditions,
        menuCategoryAdditions,
        labels,
        pricePerCostRatio,
        color,
        settings,
        fromDate,
        toDate,
        preorder,
        mainCategoryId,
        subCategoryId
      } = remoteEntity;
      menuItemAdditions = menuitemutil.updateMenuItemAdditionToGlobalIdLocal(menuItemAdditions, globalId);
      menuCategoryAdditions = menuitemutil.updateMenuCategoryAdditionToGlobalIdLocal(menuCategoryAdditions, globalId);
      if (image && !imageSrc) {
        menuitemutil.fetchImage(imageUrl, entity, remoteEntity, "image", image, _globalId, node, restaurant.instance, def, menuitemutil._updateLocal);
        return def.promise();
      };

      const e = {
        id: entity.id,
        globalId: id,
        type: entityType.toLowerCase(),
        name,
        description,
        imageSrc,
        timing,
        productionLines,
        vatCategory,
        takeawayVatCategory,
        isActive: active,
        isTop,
        kiosk,
        above18,
        online,
        available,
        inventoryItem,
        menuItemAdditions,
        menuCategoryAdditions,
        labels,
        pricePerCostRatio,
        color,
        settings,
        fromDate,
        toDate,
        preorder,
        mainCategory: mainCategoryId,
        subCategory: subCategoryId
      }
      e.globalId = null;
      if (entity.connectedRestaurants[0]) {
        const menuCategory = getMenuCategory(entity, _globalId)?.globalId;
        const modifyCategory = () => {
          return post(
            `${localStorage.instance}/mergeService/${localStorage.restaurantSelected}/${menuCategory || 0}/modifyCategory?properties=${menuitemutil.synchronizeProperties.join(",")}`,
            e,
            undefined,
            true,
            undefined,
            true
          ).then(data => {

            const ids = remoteEntity.connectedRestaurants.self.children
              .flatMap(c => {
                const localEntity = c.connectedRestaurants?.[_globalId];

                return localEntity?.globalId
                  ? [
                    localEntity.entityType === menuitemutil.entityType ? 0 : 1,
                    localEntity.globalId
                  ]
                  : [];
              });

            return post(
              `${localStorage.instance}/mergeService/${localStorage.restaurantSelected}/updateCategoryOrders`,
              ids
            ).then(() => data);
          });
        };

        modifyCategory()
          .done(data => def.resolve(data))
          .fail(res => {

            if (res.status !== 403) {
              return;
            }

            auth.ajaxError = false;

            getGlobal("login/getLoginTokenNew/" + auth.myStatus.restaurant_global_id + "?l=menuitem")
              .done(token => {

                const username = `authtoken:${auth.myStatus.restaurant_global_id}/${token.token}`;

                post(
                  `${localStorage.instance}/login?instance=${localStorage.instance}`,
                  `username=${encodeURIComponent(username)}&password=${encodeURIComponent(token.token)}&user=true`,
                  {},
                  true,
                  0,
                  false,
                  30000
                ).done(() => {
                  modifyCategory()
                    .done(data => def.resolve(data))
                    .fail(err => def.reject(err));
                });
              });
          });
      } else {
        delete e.id;
        const menuCategory = getMenuCategory(entity)?.globalId;
        const addCategory = () => {
          return post(
            `${localStorage.instance}/mergeService/${localStorage.restaurantSelected}/${menuCategory || 0}/addCategory`,
            e
          ).then(data => {
            return get(
              `${restaurant.serverUrl}${auth.war}/${restaurant.instance}/mergeService/${restaurant.localId}/updateCategoryGlobalId/${entity.id}/${data.id}?instance=${restaurant.instance}`
            ).then(() => "refresh");
          });
        };

        addCategory()
          .done(result => def.resolve(result))
          .fail(res => {

            if (res.status !== 403) {
              def.reject(res);
              return;
            }

            auth.ajaxError = false;

            getGlobal("login/getLoginTokenNew/" + auth.myStatus.restaurant_global_id + "?l=menuitem")
              .done(token => {

                const username =
                  `authtoken:${auth.myStatus.restaurant_global_id}/${token.token}`;

                post(
                  `${localStorage.instance}/login?instance=${localStorage.instance}`,
                  `username=${encodeURIComponent(username)}&password=${encodeURIComponent(token.token)}&user=true`,
                  {},
                  true,
                  0,
                  false,
                  30000
                ).done(() => {

                  addCategory()
                    .done(result => def.resolve(result))
                    .fail(err => def.reject(err));

                }).fail(err => def.reject(err));

              })
              .fail(err => def.reject(err));
          });
      }
    }
    return def.promise();
  }
};

menuitemutil.generateShopLabel = generateShopLabel;

var showManufacturer = false;
var showDescription = false;
var minProfitRatio, maxProfitRatio, averageProfitRatioSum, averageProfitRatioCount, averageProfitRatio;

function findMenuCategory(children, menuCategoryId) {
  if (!children || !children.length) return undefined;

  for (const c of children) {
    if (
      (c.entityType === "MealCategory" || c.entityType === "DrinkCategory") &&
      c.id === menuCategoryId
    ) {
      return c; // direct hit
    }

    if (c.children) {
      const found = findMenuCategory(c.children, menuCategoryId);
      if (found) return found; // return the nested match
    }
  }

  return undefined; // nothing found
}


function getMenuCategory(entity, r) {
  if (r === undefined) r = Number(Object.keys(entity.connectedRestaurants || {})[0]);
  if (!r && (!entity.connectedRestaurants || entity.connectedRestaurants[0])) {
    return admin.getMenuCategoryAdmin(entity.menuCategoryId);
  }
  var data = connectedRestaurants[r];
  const c = findMenuCategory(data.data.children, entity.connectedRestaurants[r].menuCategoryId);
  return c;
}

function updateData(data, level, parent) {
  if (typeof level === "undefined") level = 0;
  if (!data.isActive) data.extraClasses = (data.extraClasses ? data.extraClasses : "") + " itemDeactivated";
  if (data.recordState === "DELETED") {
    data.extraClasses = (data.extraClasses ? data.extraClasses : "") + " deleted";
  }
  data.depth = level;
  if (data.name) {
    data.title = data.name[localStorage.languageSelected] ? data.name[localStorage.languageSelected] : getLocale(data.name);
  }
  data.minProfitRatio = 0;
  data.maxProfitRatio = 0;
  data.averageProfitRatioSum = 0;
  data.averageProfitRatioCount = 0;
  data.averageProfitRatio = 0;
  data.mainCategorySet = !data.availableQuantities || !!data.defaultMainCategoryId || !data.defaultTop || !data.defaultActive;
  data.subCategorySet = !data.availableQuantities || (!!data.defaultSubCategoryId && (!data.mainCategoryId || data.mainCategoryId == getMenuCategory(data)?.defaultMainCategoryId)) || !!data.subCategoryId || !data.defaultTop || !data.defaultActive;
  data.setParentProperty = (property, value) => {
    if (parent) {
      if (!parent[property] || parent[property] < value) {
        parent[property] = value;
        if (parent.setParentProperty)
          parent.setParentProperty(property, value);
      }
    }
  };

  if (data.availableQuantities && data.costEstimation > 0) {
    data.availableQuantities.forEach(quantityAndPrice => {
      if (data.entityType !== menuitemutil.entityType) return;
      var price = quantityAndPrice.price;
      if (price === "") {
        price = data.unitPrice * quantityAndPrice.quantity
      } else {
        price = Number(price);
      }
      if (price > 0 && data.defaultVATCategory) {
        var pricePerCostRatio = 0;
        pricePerCostRatio = Math.round((price / (100 + data.defaultVATCategory.percent) * 100 - data.costEstimation * quantityAndPrice.quantity) / (data.costEstimation * quantityAndPrice.quantity) * 100);
        if (Math.abs(pricePerCostRatio) < 3000) {
          minProfitRatio = minProfitRatio ? Math.min(minProfitRatio, pricePerCostRatio) : pricePerCostRatio;
          maxProfitRatio = maxProfitRatio ? Math.max(maxProfitRatio, pricePerCostRatio) : pricePerCostRatio;
          averageProfitRatioSum += pricePerCostRatio;
          averageProfitRatioCount++;
          data.minProfitRatio = data.minProfitRatio ? Math.min(data.minProfitRatio, pricePerCostRatio) : pricePerCostRatio;
          data.maxProfitRatio = data.maxProfitRatio ? Math.max(data.maxProfitRatio, pricePerCostRatio) : pricePerCostRatio;
          data.averageProfitRatioSum += pricePerCostRatio;
          data.averageProfitRatioCount++;
          data.averageProfitRatio = data.averageProfitRatioSum / data.averageProfitRatioCount;
        }
      }
      if (Object.keys(connectedRestaurants).length > 0 && data.connectedRestaurants && !data.connectedRestaurants?.[0]) {
        return;
      }
      const approvedCost = Math.round(quantityAndPrice.approvedCost * (quantityAndPrice.approvedCost < 10 ? 10 : 1)) / (quantityAndPrice.approvedCost < 10 ? 10 : 1);
      const cost1 =
        data.defaultInventoryItem && quantityAndPrice.inventoryItem ? quantityAndPrice.cost :
          (data.costEstimation < 10
            ? data.costEstimation
            : Math.round(data.costEstimation)) * quantityAndPrice.quantity
      const cost = Math.round(cost1 * (cost1 < 10 ? 10 : 1)) / (cost1 < 10 ? 10 : 1);
      const costChange = Math.abs(cost / approvedCost - 1) * 100;
      const costChangeThreshold = auth?.myStatus?.restaurant_settings["enabled-features"]?.inventory?.costChangeThreshold || 5;
      quantityAndPrice.approvedCost = approvedCost;
      quantityAndPrice.cost = cost;
      quantityAndPrice.costChange = costChange;
      quantityAndPrice.costChangeWarning = costChange > costChangeThreshold;

      if (data.defaultInventoryItem && quantityAndPrice.inventoryItem && quantityAndPrice.costChangeWarning) {
        data.setParentProperty("costChangeWarning", true);
      }

    });
  } else {
    data.minProfitRatio = 0;
    data.maxProfitRatio = 0;
    data.averageProfitRatioSum = 0;
    data.averageProfitRatioCount = 0;
  }
  if (data.shortName) data.title += " (<i>" + data.shortName + "</i>)";
  if (data.children)
    data.children.forEach(function (v) {
      updateData(v, level + 1, data);
      v.key = v.entityType + v.id;
      if (v.manufacturer)
        showManufacturer = true;
      if (v.description && Object.values(v.description).filter(v => !!v).length) {
        showDescription = true;
      }
      if (v.averageProfitRatioCount) {
        data.minProfitRatio = data.minProfitRatio ? Math.min(data.minProfitRatio, v.minProfitRatio) : v.minProfitRatio;
        data.maxProfitRatio = data.maxProfitRatio ? Math.max(data.maxProfitRatio, v.maxProfitRatio) : v.maxProfitRatio;
        data.averageProfitRatioSum += v.averageProfitRatioSum;
        data.averageProfitRatioCount += v.averageProfitRatioCount;
        data.averageProfitRatio = data.averageProfitRatioSum / data.averageProfitRatioCount;
      }
      // v.expanded = true;
    });

  if (data.children && !data.availableQuantities && data.isTop) {
    data.mainCategorySet = data.children.filter(c => !c.mainCategorySet).length == 0;
    data.subCategorySet = data.children.filter(c => !c.subCategorySet).length == 0;
  }

  delete data.setParentProperty;

  /*
  if (parent && !data.mainCategorySet)
    parent.mainCategorySet = false;
  if (parent && !data.subCategorySet)
    parent.subCategorySet = false;
    */
}

var connectedRestaurants = {

}

function setConnectedRestaurant(data, id, self = false) {
  if (data)
    data.forEach(d => {
      d.connectedRestaurants = {};
      d.connectedRestaurants[id] = d;
      if (self)
        d.connectedRestaurants.self = d;
      d.equalRestaurants = [];
      if (d.children)
        setConnectedRestaurant(d.children, id, self);
    })
}

function updateAvailableQuantities(availableQuantities, entity) {
  if (!availableQuantities) return availableQuantities;
  availableQuantities = JSON.parse(JSON.stringify(availableQuantities));
  availableQuantities.forEach(a => {
    delete a.costEstimation;
    delete a.cost;
    delete a.priceEstimation;
    delete a.selected;
    delete a.places;
    delete a.approvedCost;
    delete a.approvedUnitPrice;
    delete a.priceTagUpdated;
    a.promotionName = a.promotionName || "";
    a.promotionPrice = a.promotionPrice || "";
    a.promotionStart = a.promotionStart || "";
    a.promotionEnd = a.promotionEnd || "";
    if (!entity.defaultInventoryItem) {
      delete a.inventoryItem;
    }
    a.settings = { foodpanda: {}, wolt: {}, falatozz: {}, choiceqr: {}, takeaway: {}, webshop: {}, kiosk: {}, ...a.settings };
    //delete settings which are not in menuitemutil.synchronizeProperties
    for (const key in a.settings) {
      if (!menuitemutil.synchronizeProperties.includes(key)) {
        delete a.settings[key];
      }
    }
  })
  return availableQuantities;
}

function compareLocalToRemote(local, remote, entity) {
  var diff = "";
  if (local.timing != remote.timing && menuitemutil.synchronizeProperties.includes("timing")) {
    diff += I18n.t("admin_local.differences_in_timing") + "\n";
    entity.differences["timing"] = true;
  }
  if (JSON.stringify(local.children) != JSON.stringify(remote.children)) {
    diff += I18n.t("admin_local.differences_in_children") + "\n";
    entity.differences["children"] = true;
  }
  if (local.isActive != remote.isActive && menuitemutil.synchronizeProperties.includes("active")) {
    diff += I18n.t("admin_local.differences_in_active") + "\n";
    entity.differences["active"] = true;
  }
  if (local.isTop != remote.isTop && menuitemutil.synchronizeProperties.includes("top")) {
    diff += I18n.t("admin_local.differences_in_top") + "\n";
    entity.differences["top"] = true;
  }
  if (local.pos != remote.pos && menuitemutil.synchronizeProperties.includes("pos")) {
    diff += I18n.t("admin_local.differences_in_pos") + "\n";
    entity.differences["pos"] = true;
  }
  if (local.online != remote.online && menuitemutil.synchronizeProperties.includes("online")) {
    diff += I18n.t("admin_local.differences_in_online") + "\n";
    entity.differences["online"] = true;
  }
  if (local.available != remote.available && menuitemutil.synchronizeProperties.includes("available")) {
    diff += I18n.t("admin_local.differences_in_available") + "\n";
    entity.differences["available"] = true;
  }
  if (local.defaultInventoryItem != remote.defaultInventoryItem && menuitemutil.synchronizeProperties.includes("inventory")) {
    diff += I18n.t("admin_local.differences_in_inventory") + "\n";
    entity.differences["inventory"] = true;
  }

  if (local.kiosk != remote.kiosk && menuitemutil.synchronizeProperties.includes("kiosk")) {
    diff += I18n.t("admin_local.differences_in_kiosk") + "\n";
    entity.differences["kiosk"] = true;
  }
  if ((local.image != remote.image || local.bigImage != remote.bigImage) && menuitemutil.synchronizeProperties.includes("picture")) {
    diff += I18n.t("admin_local.differences_in_image") + "\n";
    entity.differences["picture"] = true;
  }

  if (JSON.stringify(local.productionLines) != JSON.stringify(remote.productionLines) && menuitemutil.synchronizeProperties.includes("productionline")) {
    diff += I18n.t("admin_local.differences_in_productionlines") + "\n";
    entity.differences["productionline"] = true;
  }

  if (local.defaultVATCategory != remote.defaultVATCategory && menuitemutil.synchronizeProperties.includes("vat")) {
    diff += I18n.t("admin_local.differences_in_vat") + "\n";
    entity.differences["vat"] = true;
  }
  var l = local.availableQuantities.map(a => {
    return a.price;
  });
  var r = remote.availableQuantities.map(a => {
    return a.price;
  });
  if ((local.unitPrice != remote.unitPrice || JSON.stringify(l) != JSON.stringify(r)) && menuitemutil.synchronizeProperties.includes("price")) {
    diff += I18n.t("admin_local.differences_in_unitPrice") + "\n";
    entity.differences["price"] = true;
  }

  function checkPromotions(prop) {
    var l = local.availableQuantities.map(a => {
      return a[prop];
    });
    var r = remote.availableQuantities.map(a => {
      return a[prop];
    });
    if (JSON.stringify(l) != JSON.stringify(r) && menuitemutil.synchronizeProperties.includes("promotion")) {
      diff += I18n.t("admin_local.differences_in_" + prop) + "\n";
      entity.differences[prop] = true;
    }
  }

  checkPromotions("promotionName");
  checkPromotions("promotionPrice");
  checkPromotions("promotionStart");
  checkPromotions("promotionEnd");

  if (local.manufacturer != remote.manufacturer && menuitemutil.synchronizeProperties.includes("manufacturer")) {
    diff += I18n.t("admin_local.differences_in_manufacturer") + "\n";
    entity.differences["manufacturer"] = true;
  }
  if ((JSON.stringify(local.name) != JSON.stringify(remote.name) || JSON.stringify(local.shortName) != JSON.stringify(remote.shortName)) && menuitemutil.synchronizeProperties.includes("name")) {
    diff += I18n.t("admin_local.differences_in_name") + "\n";
    entity.differences["name"] = true;
  }
  if (JSON.stringify(local.description) != JSON.stringify(remote.description) && menuitemutil.synchronizeProperties.includes("description")) {
    diff += I18n.t("admin_local.differences_in_description") + "\n";
    entity.differences["description"] = true;
  }
  if (JSON.stringify(local.menuItemAdditions) != JSON.stringify(remote.menuItemAdditions) || JSON.stringify(local.menuCategoryAdditions) != JSON.stringify(remote.menuCategoryAdditions)) {

    function extractAdditionsForComparison(type) {
      if (menuitemutil.synchronizeProperties.includes(type + "options")) {
        const localAdditions = (local.menuItemAdditions || []).filter(a => a.additionType === type).map(a => ({ additionId: a.additionId, additionGlobalId: a.additionGlobalId, quantity: a.quantity }));
        const remoteAdditions = (remote.menuItemAdditions || []).filter(a => a.additionType === type).map(a => ({ additionId: a.additionId, additionGlobalId: a.additionGlobalId, quantity: a.quantity }));
        if (JSON.stringify(localAdditions) != JSON.stringify(remoteAdditions)) {
          console.log(local.name, "localAdditions", localAdditions, "remoteAdditions", remoteAdditions);
          diff += I18n.t("admin_local.differences_in_" + type + "_options") + "\n";
          entity.differences[type + "options"] = true;
        }
        const localCategoryAdditions = (local.menuCategoryAdditions || []).filter(a => a.additionType === type).map(a => ({ additionId: a.additionId, additionGlobalId: a.additionGlobalId }));
        const remoteCategoryAdditions = (remote.menuCategoryAdditions || []).filter(a => a.additionType === type).map(a => ({ additionId: a.additionId, additionGlobalId: a.additionGlobalId }));
        if (JSON.stringify(localCategoryAdditions) != JSON.stringify(remoteCategoryAdditions)) {
          diff += I18n.t("admin_local.differences_in_" + type + "_options") + "\n";
          entity.differences[type + "options"] = true;
        }

      }
    }
    extractAdditionsForComparison("mandatory");
    extractAdditionsForComparison("included");
    extractAdditionsForComparison("optional");
    extractAdditionsForComparison("upsell");

  }

  var l = local.availableQuantities.map(a => {
    a = { ...a };
    delete a.promotionName;
    delete a.promotionPrice;
    delete a.promotionStart;
    delete a.promotionEnd;
    delete a.price;
    return a;
  });

  var r = remote.availableQuantities.map(a => {
    a = { ...a };
    delete a.promotionName;
    delete a.promotionPrice;
    delete a.promotionStart;
    delete a.promotionEnd;
    delete a.price;
    return a;
  });

  if (JSON.stringify(l) != JSON.stringify(r)) {
    console.log(local.name, JSON.stringify(l), JSON.stringify(r));
    diff += I18n.t("admin_local.differences_in_availableQuantities") + "\n";
    entity.differences["availablequantities"] = true;
  }

  if ((local.image != remote.image || local.bigImage != remote.bigImage) && menuitemutil.synchronizeProperties.includes("picture")) {
    diff += I18n.t("admin_local.differences_in_image") + "\n";
    entity.differences["image"] = true;
  }
  if (local.woltImage != remote.woltImage && menuitemutil.synchronizeProperties.includes("wolt") && menuitemutil.synchronizeProperties.includes("picture")) {
    diff += I18n.t("admin_local.differences_in_woltImage") + "\n";
    entity.differences["wolt"] = true;
  }
  if (local.foodpandaImage != remote.foodpandaImage && menuitemutil.synchronizeProperties.includes("foodpanda") && menuitemutil.synchronizeProperties.includes("picture")) {
    diff += I18n.t("admin_local.differences_in_foodpandaImage") + "\n";
    entity.differences["foodpanda"] = true;
  }
  if (local.falatozzImage != remote.falatozzImage && menuitemutil.synchronizeProperties.includes("falatozz") && menuitemutil.synchronizeProperties.includes("picture")) {
    diff += I18n.t("admin_local.differences_in_falatozzImage") + "\n";
    entity.differences["falatozz"] = true;
  }
  if (local.choiceqrImage != remote.choiceqrImage && menuitemutil.synchronizeProperties.includes("choiceqr") && menuitemutil.synchronizeProperties.includes("picture")) {
    diff += I18n.t("admin_local.differences_in_choiceqrImage") + "\n";
    entity.differences["choiceqr"] = true;
  }
  if (local.labels != remote.labels && menuitemutil.synchronizeProperties.includes("labels")) {
    diff += I18n.t("admin_local.differences_in_labels") + "\n";
    entity.differences["labels"] = true;
  }
  if (local.quantityType != remote.quantityType && menuitemutil.synchronizeProperties.includes("quantitytype")) {
    diff += I18n.t("admin_local.differences_in_quantitytype") + "\n";
    entity.differences["quantitytype"] = true;
  }

  function extractSettingsForComparison(platform) {
    if (menuitemutil.synchronizeProperties.includes(platform)) {
      const platformMainSettingLocal = JSON.stringify(local?.settings?.[platform] || {});
      const platformMainSettingRemote = JSON.stringify(remote?.settings?.[platform] || {});
      if (platformMainSettingLocal !== platformMainSettingRemote) {
        diff += I18n.t("admin_local.differences_in_" + platform + "_settings") + "\n";
        entity.differences[platform] = true;
      }
      const platformAvailabilityLocal = local?.availableQuantities.map(q => {
        return {
          quantity: q.quantity, setting: q?.settings?.[platform] ? Object.fromEntries(Object.entries(q?.settings?.[platform])
            .map(([key, value]) => [key,
              { disabled: value.enabled === false }]
            )) : {}
        }
      });
      const platformAvailabilityRemote = remote?.availableQuantities.map(q => {
        return {
          quantity: q.quantity, setting: q?.settings?.[platform] ? Object.fromEntries(Object.entries(q?.settings?.[platform])
            .map(([key, value]) => [key,
              { disabled: value.enabled === false }]
            )) : {}
        }
      });
      if (JSON.stringify(platformAvailabilityLocal) !== JSON.stringify(platformAvailabilityRemote)) {
        diff += I18n.t("admin_local.differences_in_" + platform + "_availability") + "\n";
        entity.differences[platform] = true;
      }
      if (menuitemutil.synchronizeProperties.includes("price")) {
        const platformPriceLocal = local?.availableQuantities.map(q => {
          return {
            quantity: q.quantity, setting: q?.settings?.[platform] ? Object.fromEntries(Object.entries(q?.settings?.[platform])
              .map(([key, value]) => [key,
                { disabled: value.price }]
              )) : {}
          }
        });
        const platformPriceRemote = remote?.availableQuantities.map(q => {
          return {
            quantity: q.quantity, setting: q?.settings?.[platform] ? Object.fromEntries(Object.entries(q?.settings?.[platform])
              .map(([key, value]) => [key,
                { disabled: value.price }]
              )) : {}
          }
        });
        if (JSON.stringify(platformPriceLocal) !== JSON.stringify(platformPriceRemote)) {
          diff += I18n.t("admin_local.differences_in_" + platform + "_price") + "\n";
          entity.differences[platform] = true;
        }
      }
    }
  }
  extractSettingsForComparison("wolt");
  extractSettingsForComparison("foodpanda");
  extractSettingsForComparison("falatozz");
  extractSettingsForComparison("choiceqr");


  return diff;
}

function updateToGlobalIdsLocal(additions) {
  if (!additions) return additions;
  return additions.map(a => {
    var copy = { ...a };
    copy.additionId = copy.additionGlobalId || copy.additionId;
    delete copy.additionGlobalId;
    delete copy.id;
    delete copy.addition;
    return copy;
  })
}
function updateToGlobalIdsRemote(additions) {
  if (!additions) return additions;
  return additions.map(a => {
    var copy = { ...a };
    copy.additionId = copy.additionGlobalId || copy.additionId;
    delete copy.additionGlobalId;
    delete copy.id;
    delete copy.addition;
    return copy;
  })
}

const sortObject = (obj) => {
  if (obj === null || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj.map(sortObject); // Tömböket is rekurzívan rendezzük

  return Object.keys(obj)
    .sort()
    .reduce((acc, key) => {
      acc[key] = sortObject(obj[key]); // Rekurzívan rendezzük az objektumokat is
      return acc;
    }, {});
};

function merge(into, from) {
  from.forEach(f => {
    const found = into.find(i => i.entityType == f.entityType && (i.id == f.globalId || i.globalId == f.id));
    if (found) {
      const processMenuItem = (item, updateToGlobalIdsFn) => {
        let {
          manufacturer, shortName, isActive, isTop, kiosk, online, pos, available, name, availableQuantities, unitPrice, minimumPrice, quantityType,
          settings, labels, defaultInventoryItem,
          menuItemAdditions, menuCategoryAdditions, description, defaultVATCategory,
          mainCategoryId, subCategoryId, timing, productionLines, children, image, bigImage, woltImage, foodpandaImage, falatozzImage, choiceqrImage
        } = item;

        if (menuItemAdditions) {
          menuItemAdditions = updateToGlobalIdsFn(menuItemAdditions).sort((a, b) => a.additionId - b.additionId);
        }
        if (menuCategoryAdditions) {
          menuCategoryAdditions = updateToGlobalIdsFn(menuCategoryAdditions).sort((a, b) => a.additionId - b.additionId);
        }
        availableQuantities = updateAvailableQuantities(availableQuantities, item) || [];

        return sortObject({
          isActive, isTop, kiosk, online, pos, available,
          name, shortName, manufacturer,
          availableQuantities: availableQuantities.map(q => ({
            ...q, id: 0, quantityType: { name: q.quantityType.name }, webshopPrice: 0, takeawayPrice: 0, localPrice: 0, cost: 0
          })),
          labels: labels ? labels.map(l => l.name).sort((a, b) => a.id - b.id).join(",") : "",
          unitPrice,
          settings,
          minimumPrice,
          quantityType,
          menuItemAdditions,
          menuCategoryAdditions,
          description,
          defaultVATCategory: defaultVATCategory?.percent,
          defaultInventoryItem,
          mainCategoryId,
          subCategoryId,
          image: !!image,
          bigImage: !!bigImage,
          woltImage: !!woltImage,
          foodpandaImage: !!foodpandaImage,
          falatozzImage: !!falatozzImage,
          choiceqrImage: !!choiceqrImage,
          timing,
          productionLines: productionLines.map(p => p.name).sort(),
          children: children ? children.map(c => c.name) : undefined
        });
      };

      const left = processMenuItem(found, updateToGlobalIdsLocal);
      const right = processMenuItem(f, updateToGlobalIdsRemote);
      found.connectedRestaurants[Object.keys(f.connectedRestaurants)[0]] = f;
      if (JSON.stringify(left) === JSON.stringify(right)) {
        if (found.children && f.children) {
          found.children = merge(found.children, f.children);
          found.differs = !!found.children.find(c => c.differs);
          if (found.differs) {
            found.compareLocalToRemote = admin_local.differences_in_children + "\n";
          } else {
            found.equalRestaurants.push(Number(Object.keys(f.connectedRestaurants)[0]));
          }
        } else {
          found.equalRestaurants.push(Number(Object.keys(f.connectedRestaurants)[0]));
        }
      } else {
        //found.differs = true;
        found.differences = {};
        found.compareLocalToRemote = compareLocalToRemote(left, right, found);
        found.differs = (Object.keys(found.differences).length > 0);
        if (found.children && f.children) {
          found.children = merge(found.children, f.children);
          found.differs |= !!found.children.find(c => c.differs);
          if (found.differs) {
            found.compareLocalToRemote = admin_local.differences_in_children + "\n";
          }
        }
        if (!found.differs)
          found.equalRestaurants.push(Number(Object.keys(f.connectedRestaurants)[0]));
        /*if (found.children)
          found.children.push(f);*/
      }
    } else {
      into.push(f)
    }
  })
  return into;
}

function mergeWithConnectedRestaurants(data) {
  if (!Object.keys(connectedRestaurants).length)
    return data;
  var d = {
    //eslint-disable-next-line no-undef
    children: structuredClone(data.children)
  };

  setConnectedRestaurant(d.children, 0, true);

  Object.values(connectedRestaurants).forEach(r => {
    setConnectedRestaurant(r.data.children, r.restaurant.globalId, true);

    d.children = merge(d.children, r.data.children);
  })
  return d;
}

const renderCategories = () => {
  // Calculate tmplparams once before rendering
  const params = tmplparams();

  const categories = admin.adminCategories.children.filter(
    (category) =>
      category.entityType === menuitemutil.entityType + "Category" &&
      category.isTop &&
      category.isActive
  );

  // Render the categories using React
  ReactDOM.hydrate(
    <CategoryList type={menuitemutil.entityType.toLowerCase()} categories={categories.filter(item => item.isActive && item.isTop && item.defaultPos)} {...params} />,
    document.getElementById('right_pane')
  );
}

function processMenuItems(data) {
  if (auth?.myStatus?.restaurant_settings?.["shop-mode"])
    $('[data-toggle="tooltip"]').tooltip("hide");
  var menu = $(".tab-pane.menu.active");
  var focus = $(":focus").attr("id");
  //$("#right_pane").empty();

  if (data == undefined) {
    if (!admin.adminCategories)
      return;

    if (!$("#right_pane").hasClass("hidden"))
      renderCategories();


    return;
  }

  admin.adminCategories = {
    children: data.children
  };

  showManufacturer = false;
  showDescription = false;
  minProfitRatio = 0;
  maxProfitRatio = 0;
  averageProfitRatioSum = 0;
  averageProfitRatioCount = 0;

  var mergedData = mergeWithConnectedRestaurants(admin.adminCategories);

  updateData(mergedData);
  averageProfitRatio = averageProfitRatioSum / averageProfitRatioCount;
  if (showManufacturer) {
    $('th.manufacturer').removeClass("hidden");
    //$('table thead tr:nth-child(2) th.name').attr('colspan', 2);
  } else {
    $('th.manufacturer').addClass("hidden");
    $('table thead tr:nth-child(2) th.name').attr('colspan', 1);
  }

  if (showDescription)
    $('th.description').removeClass("hidden");
  else
    $('th.description').addClass("hidden");

  if (!$("#right_pane").hasClass("hidden"))
    renderCategories();

  $(".menuItemHead").each((ind, e) => e.addEventListener("touchstart", touchStart, {
    capture: true,
    passive: false
  }));
  $(".list-group-item.defaultQuantity").each((ind, e) => e.addEventListener("touchstart", touchStart, {
    capture: true,
    passive: false
  }));

  const enabledFeatures = auth.myStatus.restaurant_settings["enabled-features"];
  const costChangeThreshold = auth?.myStatus?.restaurant_settings["enabled-features"]?.inventory?.costChangeThreshold || 5;

  if (menuitemutil.menuItems == null) {
    //floatMenuItemsTableHead();
    menuitemutil.menuItems = createTree($("#menuItemsFreezeTable > table#menuItems"), {
      extensions: auth.device.platform !== "browser" ? ["persist", "table", "filter"] : hasRole("administration.products.fullaccess") ? ["persist", "table", "dnd", "filter", "contextMenu", "edit"] : ["persist", "table", "filter"],
      filter: {
        // override default settings
        counter: false, // No counter badges
        mode: "hide" // "dimm": Grayout unmatched nodes,
        // "hide": remove unmatched nodes
      },
      checkbox: false,
      selectMode: '1',
      source: mergedData,
      icon: false,
      keyboard: false,
      autoScroll: false,
      persist: {
        cookieDelimiter: "~",
        cookiePrefix: "fancytree-1-" + menuitemutil.entityType,
        expandLazy: true,
        overrideSource: true,
        store: "auto",
        //types: "expanded"
        types: "active expanded focus selected"
      },
      table: {
        checkboxColumnIdx: 0,
        indentation: 20,
        nodeColumnIdx: 0,
        iconColumnIdx: 0
        // render node expander, icon, and title to this column
        // (default:
        // #0)
      },
      gridnav: {
        autofocusInput: false, // Focus first embedded input if
        // node
        // gets activated
        handleCursorKeys: true
        // Allow UP/DOWN in inputs to move to prev/next node
      },
      dnd: {
        preventVoidMoves: true, // Prevent dropping nodes
        // 'before self', etc.
        preventRecursions: false, // Prevent dropping
        // nodes on own
        // descendants
        autoExpandMS: 2000,
        autoScroll: true,
        draggable: {
          // zIndex: 1000,
          // appendTo: "body",
          // helper: "clone",
          scroll: true,
          revert: "invalid"
        },
        dragStart: function (node, data, event) {
          var t = $(data.originalEvent.target).parents("td");
          return t.hasClass("dragged") ? "move" : false;
        },
        dragEnter: function (node, data) {
          // Prevent dropping a parent below another parent
          // (only sort
          // nodes under the same parent)
          if (data.node.data.id === data.otherNode.data.id)
            return false;
          const targetType = data.node.data.entityType;
          const draggedType = data.otherNode.data.entityType;
          const parentType = data.node.parent ? data.node.parent.data.entityType : null;
          var res;
          if (data.node === data.otherNode)
            res = [];
          if (draggedType === menuitemutil.entityType) {
            //Dragged is a menu item,
            if (targetType === menuitemutil.entityType) {
              //Target is a menu item
              res = ["before", "after"];
            } else {
              if (parentType) {
                res = ["before", "after", "over"];
              } else {
                //Target is a category item
                res = ["over"];
              }
            }
          } else {
            //Dragged is a category item
            if (targetType === menuitemutil.entityType + "Category") {
              res = ["before", "after", "over"];
            } else {
              if (parentType) {
                //Target is a menu item
                res = ["before", "after"];
              } else {
                //Target is a category item
                res = ["before", "after"];
              }
            }
          }
          return res;
        },
        dragDrop: function (node, data) {
          data.otherNode.moveTo(node, data.hitMode);
          var ids = [];
          if (data.hitMode == "over") {
            if (data.otherNode.data.entityType == menuitemutil.entityType)
              utils.setMenuItemParentCategory(data.otherNode.data.id, node.data.id, function () {
                node.children.forEach(function (d) {
                  ids[ids.length] = d.data.entityType == menuitemutil.entityType ? "0" : "1";
                  ids[ids.length] = d.data.id;
                });
                utils.updateMenuItemOrders(ids, function (data) {
                  processMenuItems(data);
                });
              });
            else
              utils.setMenuCategoryParentCategory(data.otherNode.data.id, node.data.id, function () {
                node.children.forEach(function (d) {
                  ids[ids.length] = d.data.entityType == menuitemutil.entityType ? "0" : "1";
                  ids[ids.length] = d.data.id;
                });
                utils.updateMenuItemOrders(ids, function (data) {
                  processMenuItems(data);
                });
              });
          } else {
            if (data.otherNode.data.entityType == menuitemutil.entityType)
              utils.setMenuItemParentCategory(data.otherNode.data.id, node.parent.data.entityType ? node.parent.data.id : -1, function () {
                node.parent.children.forEach(function (d) {
                  ids[ids.length] = d.data.entityType == menuitemutil.entityType ? 0 : 1;
                  ids[ids.length] = d.data.id;
                });
                utils.updateMenuItemOrders(ids, function (data) {
                  processMenuItems(data);
                });
              });
            else {
              utils.setMenuCategoryParentCategory(data.otherNode.data.id, node.parent.data.entityType ? node.parent.data.id : -1, function () {
                node.parent.children.forEach(function (d) {
                  ids[ids.length] = d.data.entityType == menuitemutil.entityType ? 0 : 1;
                  ids[ids.length] = d.data.id;
                });
                utils.updateMenuItemOrders(ids, function (data) {
                  processMenuItems(data);
                });
              });
            }
          }
        }
      },
      collapse: function (event, data) {
        localStorage.removeItem("categoryexpanded");
        if (window.innerWidth <= 800) {
          var node = data.node;
          if (node.parent.isRoot()) {
            node.tree.clearFilter();
            menuitemutil.filterNodes();
          } else {
            var node = data.node.parent;
            localStorage.categoryexpanded = node.data.id;
            node.tree.filterBranches(
              function (node) {
                if (!localStorage.categoryexpanded)
                  return true;
                if (node.data.entityType.indexOf("Category") === -1) {
                  return node.parent.data.id == localStorage.categoryexpanded;
                }
                return node.data.id == localStorage.categoryexpanded;
              },
              {
                mode: "hide"
              }
            );
          }
          node.makeVisible({ scrollIntoView: true });
        }

      },
      expand: function (event, data) {
        menuitemutil.tablehooks();
        if (window.innerWidth <= 800) {
          var node = data.node;
          if (node.data.entityType.indexOf("Category") === -1)
            return;
          localStorage.categoryexpanded = node.data.id;
          node.tree.filterBranches(
            function (node) {
              if (!localStorage.categoryexpanded)
                return true;
              if (node.data.entityType.indexOf("Category") === -1) {
                return node.parent.data.id == localStorage.categoryexpanded;
              }
              return node.data.id == localStorage.categoryexpanded;
            },
            {
              mode: "hide"
            }
          );
          node.makeVisible({ scrollIntoView: true });
        }
      },
      activate: function (event, data) {
        if (event.isDefaultPrevented())
          return;
        if (event?.originalEvent?.originalEvent?.target?.nodeName === "LABEL" || event?.originalEvent?.originalEvent?.target?.nodeName === "INPUT") {
          event.stopPropagation();
          return;
        }
        // A node was activated: display its title:
        var node = data.node;
        menuitemutil.selected = node.data;
        menuitemutil.populateGraph();
        if (menuitemutil.menuItems)
          menuitemutil.menuItems.activateTimestamp = new Date().getTime();
        $("#addMenuCategory").show();
        if (node.data.entityType.indexOf("Category") == -1) {
          // is menu item
          $("button#editMenuCategory").hide();
          $("button#addMenuCategory").removeAttr("disabled");
          $("button#addMenuItem").removeAttr("disabled");
          $("button#addOption").removeAttr("disabled");
          $("button#editMenuItem").show();
          populateCharts();
        } else {
          // is menu category
          $("button#editMenuCategory").show();
          $("button#addMenuCategory").removeAttr("disabled");
          $("button#addMenuItem").removeAttr("disabled");
          $("button#addOption").removeAttr("disabled");
          $("button#editMenuItem").hide();
          populateCategoryCharts();
        }
        $("#delete").removeAttr("disabled");
        if (node.data.isActive) {
          $("#deactivate").removeAttr("disabled");
          $("#activate").prop("disabled", "true");
        } else {
          $("#deactivate").prop("disabled", "true");
          $("#activate").removeAttr("disabled");
        }
        $(node.tr)
          .parent()
          .find("td.availableQuantity1 select")
          .remove();
        $(node.tr)
          .parent()
          .find("td.availableQuantity1 span#serving")
          .show();
      },
      previousNode: null,
      click: (event, data) => {
        if (!event.originalEvent?.originalEvent)
          return;

        if ($(event?.originalEvent?.originalEvent?.target).hasClass('approve') || $(event?.originalEvent?.originalEvent?.target).parents('.approve').length > 0) {
          return;
        }

        if (event?.originalEvent?.originalEvent?.target?.nodeName === "LABEL" || event?.originalEvent?.originalEvent?.target?.nodeName === "INPUT") {
          event.stopPropagation();
          return;
        }
        if ($(event.originalEvent.target).hasClass('fancytree-expander'))
          return;
        if (menuitemutil.clickTimestamp && event?.originalEvent?.originalEvent?.target === menuitemutil.clickTarget && menuitemutil.selectedNodeKey === data.node.key && new Date().getTime() - menuitemutil.clickTimestamp < 300) {

          if (data.node.data.entityType === "Meal" || data.node.data.entityType === "Drink") {
            $('button#editMenuItem').trigger('click');
            $('button#editMenuItem').trigger('blur');
          } else {
            $('button#editMenuCategory').trigger('click');
            $('button#editMenuCategory').trigger('blur');
          }
          return;
        };
        menuitemutil.clickTimestamp = new Date().getTime();
        menuitemutil.selectedNodeKey = data.node.key;
        menuitemutil.clickTarget = event.originalEvent.originalEvent.target;
        if ($(event.originalEvent.target).hasClass('custom-control-label'))
          return;
        if (event.originalEvent.target.nodeName === "INPUT")
          return;
        if (data.node == menuitemutil.menuItems.previousNode && !$(event.toElement).hasClass("fancytree-expander")) {
          menuitemutil.menuItems.activateKey("");
          event.preventDefault();
          menuitemutil.menuItems.previousNode = null;
          $("#editMenuCategory").hide();
          $("#addMenuItem").attr("disabled", "true");
          $("#addMenuCategory").hide();
          $("#addOption").attr("disabled", "true");
          $("#editMenuItem").hide();
          $("#activate").prop("disabled", "true");
          $("#deactivate").prop("disabled", "true");
          $("#delete").prop("disabled", "true");
        } else {
          menuitemutil.menuItems.previousNode = data.node;
        }
      },
      edit: {
        // Available options with their default:
        adjustWidthOfs: 4, // null: don't adjust input size to content
        inputCss: { minWidth: "3em" },
        triggerStart: ["clickActive", "f2", " ", "shift+click", "mac+enter"],
        beforeEdit: (type, event) => {
          if (Math.min(window.innerHeight, window.innerWidth) <= 800) return false;
          if (new Date().getTime() - menuitemutil.menuItems.activateTimestamp > 100) {
            return true;
          }
          return false;
        }, // Return false to prevent edit mode
        edit: function (event, data) {
          $(data.input).val(data.node.data.name[localStorage.languageSelected]);
        },
        save: function (event, data) {
          var name = $(data.input).val();
          var data = data.node.data;
          data.name[localStorage.languageSelected] = name;
          if (data.entityType == menuitemutil.entityType) {
            utils.modifyMenuItem(
              data.menuCategoryId,
              data,
              d => {
                menuitemutil.updateMenu(d);
              },
              menuitemutil.reload
            );
          } else {
            utils.modifyMenuCategory(
              data,
              d => {
                menuitemutil.updateMenu(d);
              }
            );
          }
        },
        beforeClose: $.noop, // Return false to prevent cancel/save (data.input is available)
        close: $.noop // Editor was removed
      },
      contextMenu: {
        menu: {
          edit: { name: I18n.t("local.modify"), icon: "edit" },
          new_category: { name: I18n.t("admin_local.add_category"), icon: "add" },
          new_menu_item: { name: I18n.t("admin_local.add_item"), icon: "add" },
          new_menu_option: { name: I18n.t("admin_local.add_option"), icon: "add" },
          replace: {
            name: I18n.t("admin_local.replace"),
            icon: "refresh",
            disabled: function () {
              var node = menuitemutil.menuItems.getActiveNode();
              var type = typeof node.data.availableQuantities != "undefined";
              return !type;
            }
          },
          sort_option: {
            name: I18n.t("admin_local.sort_abc"),
            disabled: function () {
              var node = menuitemutil.menuItems.getActiveNode();
              var type = typeof node.data.availableQuantities != "undefined";
              return type;
            }
          },
          sep1: "---------",
          delete: { name: "Delete", icon: "delete" }
        },
        actions: function (node, action, options) {
          var node = menuitemutil.menuItems.getActiveNode();
          var type = typeof node.data.availableQuantities != "undefined";
          switch (action) {
            case "edit": {
              var modal = type ? $("#editMenuItem.modal") : $("#editMenuCategory.modal");
              modal.modal("show", type ? $("button#editMenuItem") : $("button#editMenuCategory"));
              break;
            }
            case "replace": {
              var modal = type ? $("#editMenuItem.modal") : $("#editMenuCategory.modal");
              modal.modal("show", type ? $("button#editMenuItem") : $("button#editMenuCategory"));
              modal.find("input#action").val("replace");
              break;
            }
            case "new_category": {
              var modal = $("#editMenuCategory.modal");
              modal.modal("show", $("button#addMenuCategory"));
              break;
            }
            case "new_menu_item": {
              var modal = $("#editMenuItem.modal");
              modal.modal("show", $("button#addMenuItem"));
              break;
            }
            case "new_menu_option": {
              var modal = $("#editMenuItem.modal");
              modal.modal("show", $("button#addOption"));
              break;
            }
            case "delete": {
              deleteMenuItem();
              break;
            }
            case "sort_option": {
              var node = menuitemutil.menuItems.getActiveNode();
              node.sortChildren((a, b) => {
                var xm = (a.data.manufacturer || "").toLowerCase(),
                  ym = (b.data.manufacturer || "").toLowerCase();
                var x = a.title.toLowerCase(),
                  y = b.title.toLowerCase();

                if (xm && ym && xm.localeCompare(ym))
                  return xm.localeCompare(ym);

                return x.localeCompare(y);

              });
              var ids = [];
              node.children.forEach(function (d) {
                ids.push(d.data.entityType == menuitemutil.entityType ? 0 : 1);
                ids.push(d.data.id);
              });
              utils.updateMenuItemOrders(ids, function (data) {
                processMenuItems(data);
              });
              break;
            }
          }
        }
      },
      renderColumns: function (event, data) {
        var node = data.node,
          $tdList = $(node.tr).find(">td");

        $(node.tr).attr("level", node.data.depth);
        $(node.tr).data('node', data.node);

        node.setSelected(false);

        var editModeEnabled = Math.min(window.innerHeight, window.innerWidth) > 600;

        $(node.tr).attr('menuitem-id', node.data.id);

        var c = 1;

        function setDiffers(tdIndex, property, prop) {
          if (node.data?.differences?.[property] && menuitemutil.synchronizeProperties.includes(prop || property)) {
            $tdList.eq(tdIndex).addClass("differs");
          }
        }

        setDiffers(0, "name");

        if (node.data.manufacturer != null) $tdList.eq(1).prepend($('<span class="manufacturer mobile-only">' + node.data.manufacturer + "</span>"));

        if (node.data.availableQuantities && !node.data.defaultInventoryItem && getMenuItemAdditions(node.data).filter(a => a.additionType === "mandatory" && a.local === a.takeaway).length == 1) {
          const referred = getMenuItemAdditions(node.data).filter(a => a.additionType === "mandatory" && a.local === a.takeaway)[0];
          const path = menuitemutil.getPath(admin.getMenuItemAdmin(referred.additionId));
          $tdList.eq(3).append($('<div class="referred browser-only">&rarr; ' + path + "</div>"));
        }

        setDiffers(c, "manufacturer");

        $tdList.eq(c++).html(node.data.manufacturer);

        if (node.data.connectedRestaurants && !node.data.connectedRestaurants[0]) {
          $tdList.eq(0).find(".fancytree-title").css("text-decoration", "line-through")
        }

        if (editModeEnabled) {
          $tdList.eq(c).find("input").val(node.data.description[localStorage.languageSelected]);
          $tdList.eq(c).find("input").attr("id", "d_" + node.data.entityType + node.data.id);
        } else $tdList.eq(c).html(node.data.description[localStorage.languageSelected]);
        if (!showDescription)
          $tdList.eq(2).addClass('hidden');

        setDiffers(c, "description");

        if (!showManufacturer)
          $tdList.eq(1).addClass('hidden');

        c++;

        c++;
        var mainCategory = admin_local.ntak.main_categories.find(c => c.id == node.data.defaultMainCategoryId);
        var subCategory = mainCategory ? mainCategory.sub_categories.find(c => c.id == node.data.defaultSubCategoryId) : undefined;
        const mainCategoryName = mainCategory ? mainCategory.name : admin_local.ntak.mainCategoryNotSet;
        const subCategoryName = subCategory ? subCategory.name : admin_local.ntak.subCategoryNotSet;
        mainCategory = mainCategory ? mainCategory.shortName ? mainCategory.shortName : mainCategory.name : node.data.mainCategorySet ? "" : "<div class='icon-attention'/>";
        subCategory = subCategory ? subCategory.shortName ? subCategory.shortName : subCategory.name : node.data.subCategorySet ? "" : "<div class='icon-attention'/>";
        var text = "<text data-toggle='tooltip' title='" + mainCategoryName + "' style='" + (node.data.mainCategoryId ? "" : "color:gray") + (node.data.mainCategorySet ? "" : ";background:red;color:yellow") + "'>" + mainCategory + "</text>" +
          "<text data-toggle='tooltip' title='" + subCategoryName + "' style='font-size:.8rem;" + (node.data.subCategoryId ? "" : "color:gray") + (node.data.subCategorySet ? "" : ";background:red;color:yellow") + "'>" + subCategory + "</text>";
        if (!node.data.subCategorySet || !node.data.mainCategorySet) {
          $tdList.eq(c)[0].style.setProperty('background-color', 'red', 'important');
        }

        $tdList.eq(c).html(text);
        c++;
        if (featureEnabled('ordering/menuorder')) {
          if (node.data.preorder !== null) {
            $tdList.eq(c).find("input").prop("checked", node.data.preorder);
          } else {
            $tdList.eq(c).find("input").prop("indeterminate", true);
            if (!node.data.defaultPreorder) {
              $tdList.eq(c).find("input").addClass("parentUnchecked");
            }
          }
          $tdList.eq(c).find("input").attr("id", "pr_" + node.data.entityType + node.data.id);
          $tdList.eq(c).find("label").attr("for", "pr_" + node.data.entityType + node.data.id);
          $tdList.eq(c).find("input").addClass("checkbox");

          setDiffers(c, "fromDate");

          if (node.data.defaultFromDate) {
            $tdList.eq(c).css("background", 'yellow');
            $tdList.eq(c).find(".fromDate").html(moment(node.data.defaultFromDate).format("MM-DD ddd"))
          }
          if (node.data.defaultToDate && node.data.defaultToDate !== node.data.defaultFromDate)
            $tdList.eq(c).find(".toDate").html(moment(node.data.defaultToDate).format("MM-DD ddd"))
          if (!node.data.fromDate)
            $tdList.eq(c).find(".fromDate").css("color", "lightgray");
          if (!node.data.toDate)
            $tdList.eq(c).find(".toDate").css("color", "lightgray");

          c++;
        }

        c++;
        /*if (featureEnabled('inventory')) {
          c++;
        }*/

        if (typeof node.data.menuItems != "undefined") {
          $tdList
            .eq(c)
            .prop("colspan", 4)
            .nextAll()
            .remove();
        }

        $tdList
          .eq(c)
          .html(
            node.data.timing && node.data.timing !== "inherit"
              ? getLocale2(auth.myStatus.restaurant_settings.timings[node.data.timing].langs).name
              : node.data.defaultTiming
                ? "<text style='color:gray'>" + (node.data.defaultTiming === "inherit" ? I18n.t("admin_local.timing_" + node.data.defaultTiming) : getLocale2(auth.myStatus.restaurant_settings.timings[node.data.defaultTiming].langs).name) + "</text>"
                : ""
          );
        if (node.data?.differences?.timing && menuitemutil.synchronizeProperties.includes('timing'))
          $tdList.eq(c).addClass("differs");

        var productionLines = "";
        /*
        if (node.data.productionLines.length > 0) {
          node.data.productionLines.forEach(pl => {
            productionLines += pl.name + "\n";
          });
        } else if (node.data.defaultProductionLineIds) {
          */
        productionLines = "";
        if (node.data.defaultProductionLineIds)
          node.data.defaultProductionLineIds.split(",").forEach(pl => {
            if (isNaN(pl))
              return;
            if (node.data.productionLines.find(p => p.id == pl))
              productionLines += "<text>" + getProductionLine(pl).name + "\n" + "</text>";
            else
              productionLines += "<text style='color:gray'>" + getProductionLine(pl).name + "\n" + "</text>";
          });

        c++;
        $tdList.eq(c).html(productionLines);
        setDiffers(c, "productionline");
        c++;
        $tdList
          .eq(c)
          .html(
            (node.data.vatCategory
              ? "<div>" + (node.data.vatCategory ? (node.data.vatCategory.percent ? " " + node.data.vatCategory.percent + "%" : "TAM") : "") + "</div>"
              : node.data.defaultVATCategory
                ? "<div style='color:gray'>" + (node.data.defaultVATCategory ? (node.data.defaultVATCategory.percent ? " " + node.data.defaultVATCategory.percent + "%" : "TAM") : "") + "</div>"
                : "") +
            (node.data.takeawayVatCategory
              ? "<div class='icon-cup'>" + (node.data.takeawayVatCategory ? (node.data.takeawayVatCategory.percent ? " " + node.data.takeawayVatCategory.percent + "%" : "TAM") : "") + "</div>"
              : "<div class='icon-cup' style='color:gray'>" + (node.data.defaultTakeawayVATCategory ? (node.data.defaultTakeawayVATCategory.percent ? " " + node.data.defaultTakeawayVATCategory.percent + "%" : "TAM") : "27%") + "</div>")
          );
        setDiffers(c, "vat");
        c++;
        if (node.data.isActive) {
          $tdList.eq(c).find("input").prop("checked", node.data.isActive);
          $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.active"));
          if (!node.data.defaultActive) {
            $tdList.eq(c).find("input").prop("checked", false);
            $tdList.eq(c).find("input").prop("disabled", true);
            $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.deactived"));
          }
        } else {
          $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.deactived"));
        }
        setDiffers(c, "active");

        $tdList.eq(c).find("input").attr("id", "a_" + node.data.entityType + node.data.id);
        $tdList.eq(c).find("label").attr("for", "a_" + node.data.entityType + node.data.id);
        $tdList.eq(c).find("input").addClass("checkbox isActive");
        c++;
        if (node.data.isTop) {
          $tdList.eq(c).find("input").prop("checked", node.data.isTop);
          $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.on_menu"));
          if (!node.data.defaultTop) {
            $tdList.eq(c).find("input").prop("checked", false);
            $tdList.eq(c).find("input").prop("disabled", true);
            $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.not_on_menu"));
          }
        } else {
          $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.not_on_menu"));
        }
        setDiffers(c, "top");
        $tdList.eq(c).find("input").attr("id", "t_" + node.data.entityType + node.data.id);
        $tdList.eq(c).find("label").attr("for", "t_" + node.data.entityType + node.data.id);
        $tdList.eq(c).find("input").addClass("checkbox isTop");
        c++;
        if (node.data.pos) {
          $tdList.eq(c).find("input").prop("checked", node.data.pos);
          $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.pos"));
          if (!node.data.defaultPos) {
            $tdList.eq(c).find("input").prop("checked", false);
            $tdList.eq(c).find("input").prop("disabled", true);
            $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.not_pos"));
          }
        } else {
          $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.not_pos"));
        }
        $tdList.eq(c).find("input").attr("id", "po_" + node.data.entityType + node.data.id);
        $tdList.eq(c).find("label").attr("for", "po_" + node.data.entityType + node.data.id);
        $tdList.eq(c).find("input").addClass("checkbox pos");
        setDiffers(c, "pos");
        var cc = c;

        if (featureEnabled('kiosk')) {

          c++;
          if (node.data.kiosk) {
            $tdList.eq(c).find("input").prop("checked", node.data.kiosk);
            $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.on_kiosk"));
            if (!node.data.defaultKiosk) {
              $tdList.eq(c).find("input").prop("checked", false);
              $tdList.eq(c).find("input").prop("disabled", true);
              $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.not_on_kiosk"));
            }
          } else {
            $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.not_on_kiosk"));
          }
          $tdList.eq(c).find("input").attr("id", "k_" + node.data.entityType + node.data.id);
          $tdList.eq(c).find("label").attr("for", "k_" + node.data.entityType + node.data.id);
          $tdList.eq(c).find("input").addClass("checkbox kiosk");
          setDiffers(c, "kiosk");
        }


        if (featureEnabled("wolt")) {
          getPlaces("wolt").filter(p => p.enabled).forEach(p => {
            const act = node.data.mergedSettings.wolt && node.data.mergedSettings.wolt[p.name] && node.data.mergedSettings.wolt[p.name].enabled;
            $tdList.eq(++c).find("input").attr("id", "td_wolt_" + p.name + "_" + node.data.entityType + node.data.id);
            $tdList.eq(c).find("label").attr("for", "td_wolt_" + p.name + "_" + node.data.entityType + node.data.id);
            $tdList.eq(c).find("input").prop("checked", act);
          });
          setDiffers(c, "wolt");
        }
        if (featureEnabled("foodpanda")) {
          getPlaces("foodpanda").filter(p => p.enabled).forEach(p => {
            const act = node.data.settings.foodpanda && node.data.settings.foodpanda[p.name] && node.data.settings.foodpanda[p.name].enabled;
            $tdList.eq(++c).find("input").attr("id", "td_foodpanda_" + p.name + "_" + node.data.entityType + node.data.id);
            $tdList.eq(c).find("label").attr("for", "td_foodpanda_" + p.name + "_" + node.data.entityType + node.data.id);
            $tdList.eq(c).find("input").prop("checked", act);
          });
          setDiffers(c, "foodpanda");
        }
        if (featureEnabled("falatozz")) {
          getPlaces("falatozz").filter(p => p.enabled).forEach(p => {
            const act = node.data.settings.falatozz && node.data.settings.falatozz[p.name] && node.data.settings.falatozz[p.name].enabled;
            $tdList.eq(++c).find("input").attr("id", "td_falatozz_" + p.name + "_" + node.data.entityType + node.data.id);
            $tdList.eq(c).find("label").attr("for", "td_falatozz_" + p.name + "_" + node.data.entityType + node.data.id);
            $tdList.eq(c).find("input").prop("checked", act);
          });
          setDiffers(c, "falatozz");
        }
        if (featureEnabled("choiceqr")) {
          getPlaces("choiceqr").filter(p => p.enabled).forEach(p => {
            const act = node.data.settings.choiceqr && node.data.settings.choiceqr[p.name] && node.data.settings.choiceqr[p.name].enabled;
            $tdList.eq(++c).find("input").attr("id", "td_choiceqr_" + p.name + "_" + node.data.entityType + node.data.id);
            $tdList.eq(c).find("label").attr("for", "td_choiceqr_" + p.name + "_" + node.data.entityType + node.data.id);
            $tdList.eq(c).find("input").prop("checked", act);
          });
          setDiffers(c, "choiceqr");
        }
        if (featureEnabled('ordering') || featureEnabled('foodpanda') || featureEnabled('wolt') || featureEnabled('falatozz') || featureEnabled('choiceqr')) {
          c++;
          if (node.data.online) {
            $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.online"));
            $tdList.eq(c).find("input").prop("checked", node.data.online);
          } else {
            $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.not_online"));
          }
          $tdList.eq(c).find("input").attr("id", "o_" + node.data.entityType + node.data.id);
          $tdList.eq(c).find("label").attr("for", "o_" + node.data.entityType + node.data.id);
          $tdList.eq(c).find("input").addClass("checkbox online");
          setDiffers(c, "online");

          c++;
          if (node.data.available) {
            $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.available_online"));
            $tdList.eq(c).find("input").prop("checked", node.data.available);
          } else {
            $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.not_available_online"));
          }
          $tdList.eq(c).find("input").attr("id", "av_" + node.data.entityType + node.data.id);
          $tdList.eq(c).find("label").attr("for", "av_" + node.data.entityType + node.data.id);
          $tdList.eq(c).find("input").addClass("checkbox available");
          if (!hasRole("administration.products.fullaccess") && !node.data.availableQuantities) {
            $tdList.eq(c).find("input").prop("disabled", true);
          }
          setDiffers(c, "available");
        }
        if (featureEnabled('inventory')) {
          c++;
          if (node.data.inventoryItem !== null) {
            if (node.data.inventoryItem)
              $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.inventory_item"));
            else
              $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.not_inventory_item"));
            $tdList.eq(c).find("input").prop("checked", node.data.inventoryItem);
          } else {
            if (node.data.defaultInventoryItem)
              $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.default_inventory_item"));
            else
              $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.default_not_inventory_item"));
            $tdList.eq(c).find("input").prop("indeterminate", true);
            if (!node.data.defaultInventoryItem) {
              $tdList.eq(c).find("input").addClass("parentUnchecked");
            }
          }
          $tdList.eq(c).find("input").attr("id", "i_" + node.data.entityType + node.data.id);
          $tdList.eq(c).find("label").attr("for", "i_" + node.data.entityType + node.data.id);
          $tdList.eq(c).find("input").addClass("checkbox isInventoryItem");
        }
        setDiffers(c, "inventory");

        c++;
        if (node.data.quantityType != "none") {
          try {
            $tdList.eq(c).find("input").attr("id", "f_" + node.data.entityType + node.data.id);
            $tdList.eq(c).find("label").attr("for", "f_" + node.data.entityType + node.data.id);
            $tdList.eq(c).find("input").addClass("checkbox freeQuantity");

            if (!node.data.freeQuantity) {
              $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.not_free_quantity"));
              $tdList.eq(c).find("input").prop("checked", !node.data.freeQuantity);
            } else {
              $tdList.eq(c).attr("title", I18n.t("admin_local.menuitems.tooltip.free_quantity"));
            }

            if (node.data.quantityType)
              $tdList.eq(c).find('span').text(I18n.t("local." + node.data.quantityType));

          } catch (ex) {
            console.log(ex);
            if (node.data.quantityType)
              $tdList.eq(c).find('span').text(node.data.quantityType);
          }
        } else {
          $tdList.eq(1).addClass("option");
          const hiddenIndexes = [2, 3, 4, 5, 12, 13, 14, 15, 16, 17];

          hiddenIndexes.forEach(index => {
            $tdList.eq(index).find("*").css("visibility", "hidden");
          });
        }
        setDiffers(c, "quantitytype");

        var strQuantity = "";
        var strPrice = "";
        var strPricePerCostRatio = "";
        var strPlatformPrice = { wolt: {}, foodpanda: {}, falatozz: {}, choiceqr: {}, takeaway: {}, webshop: {} };
        var inventoryItemFound = false;
        var promotionName = "";
        var promotionPrice = "";
        var promotionStart = "";
        var promotionEnd = "";

        if (node.data.availableQuantities) {
          node.data.availableQuantities.forEach(function (quantityAndPrice) {
            var label = quantityAndPrice?.quantityType?.name;
            label = label && (label[localStorage.languageSelected] ? label[localStorage.languageSelected] : label["all"] ? "(" + label["all"] + ")" : "");
            if (node.data.quantityType !== "none") {
              var clazz = node.data.defaultInventoryItem && quantityAndPrice.inventoryItem ? 'class="icon-exchange" ' : "";
              if (!quantityAndPrice.onMenu) strQuantity += "<text data-toggle='tooltip' title='" + I18n.t('admin_local.menuitems.tooltip.' + (quantityAndPrice.def ? "def_" : "") + (node.data.defaultInventoryItem && quantityAndPrice.inventoryItem ? 'is_inventory_item' : 'non_inventory_item')) + '" id="' + quantityAndPrice.quantity + "'" + clazz + " style='color:gray;background-color:" + (quantityAndPrice.def && node.data.defaultInventoryItem ? "yellow" : "") + "'>";
              else strQuantity += "<text data-toggle='tooltip' title='" + I18n.t('admin_local.menuitems.tooltip.' + (quantityAndPrice.def ? "def_" : "") + (node.data.defaultInventoryItem && quantityAndPrice.inventoryItem ? 'on_menu_is_inventory_item' : 'on_menu_non_inventory_item')) + "'  id='" + quantityAndPrice.quantity + "'" + clazz + '>';
              if (quantityAndPrice.def) strQuantity += "<b>";
              strQuantity += '<span id="serving">' + label + "</span><span>(" + quantityAndPrice.quantity + " " + I18n.t("local." + node.data.quantityType) + ")" + "</span><br/>";
              var price = quantityAndPrice.price;
              var priceAmount;
              if (price === "") {
                priceAmount = Math.round(node.data.unitPrice * quantityAndPrice.quantity);
                if (editModeEnabled) price = `<input disabled class="unitPrice" style="text-align:right" pattern="[0-9]+\.[0-9]+%?" id="p_${node.data.id}-${quantityAndPrice.quantity}" quantity="${quantityAndPrice.quantity}" value="${priceAmount}" type="text"/>`;
                else
                  price = "<span>" + Math.round(priceAmount) + "</span>";
              } else {
                priceAmount = price;
                if (editModeEnabled) price = `<input ${hasRole("administration.products.fullaccess") ? "" : "disabled"} style="text-align:right" pattern="[0-9]+\.[0-9]+%?" id="p_${node.data.id}-${quantityAndPrice.quantity}" quantity="${quantityAndPrice.quantity}" value="${(isNaN(price) ? price : Math.round(price))}" type="text"/>`;
                else price = `<span>${price}</span>`;
              }
              let labelButton = "";
              if (auth?.myStatus?.restaurant_settings?.["shop-mode"]) {
                const quantityUnit = node.data.quantityType ? I18n.t("local." + node.data.quantityType) : "";
                const quantityText = ((label || "") + " " + quantityAndPrice.quantity + (quantityUnit ? " " + quantityUnit : "")).trim();
                const payload = encodeURIComponent(JSON.stringify({
                  menuItemId: node.data.id,
                  productCode: node.data.globalId || node.data.id,
                  productName: getLocale(node.data.name) || node.data.shortName || ("#" + node.data.id),
                  quantityText,
                  quantityValue: Number(quantityAndPrice.quantity),
                  quantityUnitLabel: quantityUnit,
                  salesUnitLabel: I18n.t("local.pcs") || "db",
                  validUntil: quantityAndPrice.promotionEnd || null,
                  originalPrice: Number(priceAmount)
                }));
                const buttonTitle = admin_local.generate_label || "Generate label";
                labelButton = `<button type="button" class="btn btn-sm btn-outline-primary" style="margin-left:.35rem;padding:.05rem .35rem;line-height:1.2;" data-toggle="tooltip" title="${escapeExcerptHtml(buttonTitle)}" onclick="menuitemutil.generateShopLabel(event, '${payload}')"><span class="icon-print"></span></button>`;
              }
              //if (isNaN(price))
              //  strPrice += quantityAndPrice.localPrice + "<br/>";
              //else
              strPrice += `<div style="display:flex;align-items:center;justify-content:flex-end;">${price}${labelButton}</div>`;
              const promotionClass =
                moment().isSameOrAfter(moment(quantityAndPrice.promotionEnd)) ? "past-promotion" :
                  moment().isSameOrBefore(moment(quantityAndPrice.promotionStart)) ? "future-promotion" :
                    (moment().isSameOrAfter(moment(quantityAndPrice.promotionStart || undefined)) && moment().isSameOrBefore(moment(quantityAndPrice.promotionEnd || undefined))) ? "current-promotion" : "";
              if (quantityAndPrice.promotionPrice !== "" && quantityAndPrice.promotionPrice !== undefined && quantityAndPrice.promotionPrice !== null) {
                promotionName += `<div ${promotionClass ? 'class="' + promotionClass + '"' : ''}><input quantity="${quantityAndPrice.quantity}" type="text" class="form-control" value="${quantityAndPrice.promotionName || ""}" /></div>`;
                promotionPrice += `<div ${promotionClass ? 'class="' + promotionClass + '"' : ''}><input quantity="${quantityAndPrice.quantity}" type="number" class="form-control" value="${quantityAndPrice.promotionPrice !== "" && quantityAndPrice.promotionPrice !== undefined && quantityAndPrice.promotionPrice !== null ? quantityAndPrice.promotionPrice : ""}" /></div>`;
                promotionStart += `<div ${promotionClass ? 'class="' + promotionClass + '"' : ''}><input quantity="${quantityAndPrice.quantity}" required type="date" class="form-control" value="${quantityAndPrice.promotionStart ? moment(quantityAndPrice.promotionStart).format("YYYY-MM-DD") : ""}" /><button type="button" onclick="$(this).prev().val('');">x</button></div>`;
                promotionEnd += `<div ${promotionClass ? 'class="' + promotionClass + '"' : ''}><input quantity="${quantityAndPrice.quantity}" required type="date" class="form-control" value="${quantityAndPrice.promotionEnd ? moment(quantityAndPrice.promotionEnd).format("YYYY-MM-DD") : ""}" /><button type="button" onclick="$(this).prev().val('');">x</button></div>`;
              } else {
                promotionName += `<div><input quantity="${quantityAndPrice.quantity}" type="text" class="form-control" value="${quantityAndPrice.promotionName || ""}" /></div>`;
                promotionPrice += `<div><input quantity="${quantityAndPrice.quantity}" type="number" class="form-control" value="${quantityAndPrice.promotionPrice !== "" && quantityAndPrice.promotionPrice !== undefined && quantityAndPrice.promotionPrice !== null ? quantityAndPrice.promotionPrice : ""}" /></div>`;
                promotionStart += "<div/>";
                promotionEnd += "<div/>";
              }

              if (quantityAndPrice.def) strQuantity += "</b>";
              strQuantity += "</text>";
              if (node.data.costEstimation > 0 && quantityAndPrice.localPrice > 0 && node.data.defaultVATCategory) {
                const pricePerCostRatio = Math.round((quantityAndPrice.localPrice / (100 + node.data.defaultVATCategory.percent) * 100 - node.data.costEstimation * quantityAndPrice.quantity) / (node.data.costEstimation * quantityAndPrice.quantity) * 100);
                const style = "width:100%; background: linear-gradient(90deg, rgb(222 121 45 / 44%) 0%, rgb(222 121 45 / 44%) " + (pricePerCostRatio / maxProfitRatio) * 100 + "%, rgba(0,0,0,0) " + (pricePerCostRatio / maxProfitRatio) * 100 + "%, rgba(0,0,0,0) 100%);";
                strPricePerCostRatio += "<div style=\"" + style + "\">" + pricePerCostRatio + "%</div>";
              }

              if (quantityAndPrice.settings) {

                // Helper function to add platform checkboxes
                function addPlatformCheckboxes(platform, enabledFeatures, quantityAndPrice, node, strPlatformPrice) {
                  enabledFeatures[platform]?.places && enabledFeatures[platform].places
                    .filter(place => place.enabled)
                    .forEach(place => {
                      const { name } = place;
                      const platformSettings = quantityAndPrice.settings?.[platform];
                      const platformNameSettings = platformSettings?.[name];
                      const disabled = platformNameSettings && !platformNameSettings.enabled;

                      const checkBoxId = `${platform}-${name}-${quantityAndPrice.quantity}-${node.data.id}`;
                      const missingImageClass = node.data.defaultActive && node.data.defaultTop && !disabled && !node.data.image && !node.data[platform + "Image"] ? "missing-image" : "";

                      // Ensure the platform key exists within strPlatformPrice
                      if (!strPlatformPrice[platform][name]) {
                        strPlatformPrice[platform][name] = "";
                      }

                      // Append HTML structure to the corresponding platform
                      strPlatformPrice[platform][name] += `
                        <div class="${missingImageClass} custom-control custom-checkbox" style="display: flex; justify-content: center; padding-left: 2.5rem">
                          <input ${hasRole("administration.products.fullaccess") ? "" : "disabled"} type="checkbox" class="custom-control-input checkbox thirdParty" id="${checkBoxId}" ${disabled ? '' : 'checked'} />
                          <label class="custom-control-label" for="${checkBoxId}"></label>
                        </div>`;
                    });
                }

                // Call the helper function for each platform
                ['wolt', 'foodpanda', 'falatozz', 'choiceqr'].forEach(platform => {
                  addPlatformCheckboxes(platform, enabledFeatures, quantityAndPrice, node, strPlatformPrice);
                });


              }
              inventoryItemFound = inventoryItemFound || (node.data.defaultInventoryItem && quantityAndPrice.inventoryItem);
            }
          });


          const inventoryItemCount = node.data.availableQuantities.filter(a => a.inventoryItem).length;
          const nonInventoryItemCount = node.data.availableQuantities.filter(a => !a.inventoryItem).length;
          if (node.data.defaultInventoryItem) {
            if (inventoryItemCount == 0) {
              $(node.tr).find(".availablequantity.availablequantity1").css("background-color", "yellow");
              $(node.tr).find(".availablequantity.availablequantity1").attr("title", I18n.t("admin_local.menuitems.tooltip.no_inventory_quantity_selected"));
            } else if (nonInventoryItemCount > 0 && inventoryItemCount != 1) {
              $(node.tr).find(".availablequantity.availablequantity1").css("background-color", "yellow");
              $(node.tr).find(".availablequantity.availablequantity1").attr("title", I18n.t("admin_local.menuitems.tooltip.to_many_inventory_quantity_selected"));
            }
          }
        } else {
          node.addClass("menu-category");
        }

        if (featureEnabled('inventory')) {
          $tdList.eq(3).css("visibility", "visible");
          if (node.data.availableQuantities && node.data.availableQuantities.length) {
            const parent = getMenuCategory(node.data);
            const isOnMenu = isOnTop(node.data);
            const isKiosk = isOnKiosk(node.data);
            const usedAsMandatoryOrIncluded = menuItemReferences(node.data, ['mandatory', 'included']).length > 0;
            const usedAsOptional = menuItemReferences(node.data, ['optional']).length + menuItemReferences(parent, ['optional']).length > 0;
            const linked = getMenuItemAdditions(node.data).filter(a => a.additionType === "mandatory").length == 1;
            var prefix = "";
            if (isOnMenu)
              prefix = "sold"
            if (inventoryItemFound) {
              prefix += "_inventory" + (usedAsMandatoryOrIncluded ? "_ingredient" : "") + (usedAsOptional ? "_option" : "");
            } else if (getMenuItemAdditions(node.data).length) {
              if (linked)
                prefix += "_linked_product" + (usedAsMandatoryOrIncluded ? "_ingredient" : "") + (usedAsOptional ? "_option" : "");
              else
                prefix += "_complex_product" + (usedAsMandatoryOrIncluded ? "_ingredient" : "") + (usedAsOptional ? "_option" : "");
            } else
              prefix += "_service" + (usedAsMandatoryOrIncluded ? "_ingredient" : "") + (usedAsOptional ? "_option" : "");
            $tdList.eq(3).find("text").html(I18n.t("admin_local.menuitems." + prefix));
            $tdList.eq(3).attr("title", I18n.t("admin_local.menuitems.tooltip." + prefix))
          } else {
            if (node.data.availableQuantities)
              $tdList.eq(3).find("text").html("opció");
            else if (node.data.menuCategoryId)
              $tdList.eq(3).find("text").html("alkategória");
            else
              $tdList.eq(3).find("text").html("főkategória");
            $tdList.eq(3).attr("title", "")
          }
        }


        if (node.data.entityType == "Drink" || node.data.entityType == "Meal") {


          if (node.data.availableQuantities) {
            $tdList.eq(++c).html(strQuantity);
            $tdList.eq(++c).html(strPrice);
            setDiffers(c, "price");

            $tdList.eq(++c).html(promotionName);
            setDiffers(c, "promotionName", "promotion");
            $tdList.eq(++c).html(promotionPrice);
            setDiffers(c, "promotionPrice", "promotion");
            $tdList.eq(++c).html(promotionStart);
            setDiffers(c, "promotionStart", "promotion");
            $tdList.eq(++c).html(promotionEnd);
            setDiffers(c, "promotionEnd", "promotion");

            var costId = c;
            c++;
            if (node.data.cost + node.data.costEstimation > 0) {
              if (true || node.data.defaultInventoryItem && node.data.availableQuantities.filter(q => q.inventoryItem).length > 0 && node.data.defaultInventoryItem && node.data.availableQuantities.filter(q => !q.inventoryItem).length == 0) {
                var t = "";
                node.data.availableQuantities.forEach(qq => {
                  if (node.data.defaultInventoryItem && qq.inventoryItem && qq.costChange) {
                    t +=
                      `<div quantity=${qq.quantity} class="approve" >
                        <div class="a1 ${node.data.costChangeWarning ? "warning" : ""}" data-toggle='tooltip' title='${I18n.t('admin_local.new_purchase_price') + " " + I18n.t('admin_local.approve_it_with_double_click')}'>${qq.cost}</div>
                        <div class="a4 ${node.data.costChangeWarning ? "warning" : ""}">${qq.approvedCost > 0 ? (node.data.costChangeWarning ? "+" + (Math.round(100 * qq.cost / qq.approvedCost) - 100) : -(100 - Math.round(100 * qq.cost / qq.approvedCost))) + "%" : ""}</div>
                        <div class="a2">
                            ↘
                        </div>

                        <div class="a3" data-toggle='tooltip' title='${I18n.t('admin_local.last_approved_purchase_price') + " " + I18n.t('admin_local.approve_it_with_double_click')}'>${qq.approvedCost}</div>
                      </div>`
                  } else {
                    const cost = Math.round(qq.cost * (qq.cost < 10 ? 10 : 1)) / (qq.cost < 10 ? 10 : 1);
                    t += `<div>${cost}</div>`;
                  }
                })
                $tdList.eq(c).html(t);

              } else if (node.data.defaultInventoryItem && node.data.availableQuantities.filter(q => q.inventoryItem).length === 1 && node.data.defaultInventoryItem && node.data.availableQuantities.filter(q => !q.inventoryItem).length > 0) {
                var t = "";
                node.data.availableQuantities.forEach(qq => {
                  t += "<div>" + Math.round(((node.data.costEstimation < 10 ? node.data.costEstimation : Math.round(node.data.costEstimation)) * qq.quantity)) + "</div>";
                })
                $tdList.eq(c).html(t);
              } else {
                $tdList.eq(c).html("<div>" + (node.data.costEstimation < 10 ? node.data.costEstimation : Math.round(node.data.costEstimation)) + "/" + I18n.t("local." + node.data.quantityType) + "</div>");
              }
            }
            c++;
            if (node.data.cost + node.data.costEstimation > 0) {

              if (node.data.defaultTop) {
                var t = "";
                node.data.availableQuantities.filter(q => q.onMenu).forEach(qq => {
                  const p = Math.round(((qq.inventoryItem ? qq.cost : node.data.costEstimation * qq.quantity) * (2 * node.data.defaultPricePerCostRatio)) * (100 + (node.data?.defaultVATCategory?.percent || 0)) / 100);
                  if (p) {
                    t += (node.data.unitPriceEstimation > 0 ? "<div><span data-toggle='tooltip' title='" + I18n.t('admin_local.menuitems.tooltip.suggested_price') + "'>" + p + "</span>" : "") + (node.data.defaultInventoryItem ? "<span data-toggle='tooltip' title='" + I18n.t('admin_local.menuitems.tooltip.expected_profit') + "' style='font-size:.7rem'>(" + (node.data.defaultPricePerCostRatio * 100) + "%)</span></div>" : "");
                    if (p > qq.localPrice)
                      $tdList.eq(c).addClass("warning")
                  } else {
                    t += "<div>1</div>";
                  }
                })
                $tdList.eq(c).html(t);
              } else if (node.data.defaultInventoryItem && node.data.availableQuantities.filter(q => q.inventoryItem).length === 1 && node.data.defaultInventoryItem && node.data.availableQuantities.filter(q => !q.inventoryItem).length > 0) {
                var t = "";
                node.data.availableQuantities.forEach(qq => {
                  //t += "<div>" + Math.round(((node.data.costEstimation < 10 ? node.data.costEstimation : Math.round(node.data.costEstimation)) * qq.quantity)) + "</div>";
                })
                $tdList.eq(c).html(t);
              } else {
                $tdList.eq(c).html("<div>" + (node.data.costEstimation < 10 ? node.data.costEstimation : Math.round(node.data.costEstimation)) + "/" + I18n.t("local." + node.data.quantityType) + "</div>");
              }
              /*
              $tdList.eq(c).html("<div data-toggle='tooltip' title='" + I18n.t('admin_local.menuitems.tooltip.unit_price') + "'>" + Math.round(node.data.unitPrice) + "</div>" +
                (node.data.unitPriceEstimation > 0 ? "<div data-toggle='tooltip' title='" + I18n.t('admin_local.menuitems.tooltip.suggested_price') + "'>(" + Math.round(node.data.unitPriceEstimation) + ")</div>" : "") + (node.data.defaultInventoryItem ? "<div data-toggle='tooltip' title='" + I18n.t('admin_local.menuitems.tooltip.expected_profit') + "' style='font-size:.7rem'>(" + (node.data.defaultPricePerCostRatio * 100) + "%)</div>" : ""));
  
              if (node.data.unitPriceEstimation > 0 && Math.round(node.data.unitPriceEstimation) > Math.round(node.data.unitPrice)) {
                if (isOnTop(node.data) || menuItemReferences(node.data, ['included', 'optional']).length > 0)
                  $tdList.eq(c).addClass("warning")
              }*/
            }

            const parent = getMenuCategory(node.data);
            if (featureEnabled('inventory')) {
              const avg = (parent.averageProfitRatio / maxProfitRatio) * 100;
              const style = "position:absolute; left:0;top:0;width:100%;height:100%;background: linear-gradient(90deg, rgb(0,0,0,0) 0%, rgb(0,0,0,0) " + avg + "%, black " + (avg + 1) + "%, black " + (avg + 1) + "%, rgba(0,0,0,0) " + avg + "%, rgba(0,0,0,0) 100%);";
              $tdList.eq(++c).html("<div style=\"" + style + "\"/>" + strPricePerCostRatio);
            }
            if (featureEnabled("kiosk")) {
              cc++;
            }
            if (featureEnabled("wolt"))
              getPlaces("wolt").filter(p => p.enabled).forEach(p => {
                const act = parent?.settings?.wolt && parent.settings.wolt[p.name] && parent.settings.wolt[p.name].enabled;
                if (act && strPlatformPrice["wolt"][p.name])
                  $tdList.eq(++cc).html(strPlatformPrice["wolt"][p.name]);
                else
                  $tdList.eq(++cc).html("");
              })
            if (featureEnabled("foodpanda"))
              getPlaces("foodpanda").filter(p => p.enabled).forEach(p => {
                const act = parent?.settings?.foodpanda && parent.settings.foodpanda[p.name] && parent.settings.foodpanda[p.name].enabled;
                if (act && strPlatformPrice["foodpanda"][p.name]) {
                  $tdList.eq(++cc).html(strPlatformPrice["foodpanda"][p.name]);
                } else {
                  $tdList.eq(++cc).html("");
                }
              })
            if (featureEnabled("falatozz"))
              getPlaces("falatozz").filter(p => p.enabled).forEach(p => {
                const act = parent?.settings?.falatozz && parent.settings.falatozz[p.name] && parent.settings.falatozz[p.name].enabled;
                if (act && strPlatformPrice["falatozz"][p.name]) {
                  $tdList.eq(++cc).html(strPlatformPrice["falatozz"][p.name]);
                } else {
                  $tdList.eq(++cc).html("");
                }
              })
            if (featureEnabled("choiceqr"))
              getPlaces("choiceqr").filter(p => p.enabled).forEach(p => {
                const act = parent?.settings?.choiceqr && parent.settings.choiceqr[p.name] && parent.settings.choiceqr[p.name].enabled;
                if (act && strPlatformPrice["choiceqr"][p.name]) {
                  $tdList.eq(++cc).html(strPlatformPrice["choiceqr"][p.name]);
                } else {
                  $tdList.eq(++cc).html("");
                }
              })
          }
        } else {
          $tdList.eq(c++).find("*").css("visibility", "hidden");
          $tdList.eq(c++).find("*").css("visibility", "hidden");
          $tdList.eq(c++).find("*").css("visibility", "hidden");
          $tdList.eq(c++).find("*").css("visibility", "hidden");
          $tdList.eq(c++).find("*").css("visibility", "hidden");
          $tdList.eq(c++).find("*").css("visibility", "hidden");
          $tdList.eq(c++).find("*").css("visibility", "hidden");
          if (data.node.data.costChangeWarning) {
            const t =
              `<div class="approveCategory" >
                <div class="a2">${I18n.t('admin_local.cost_change_warning')}
                </div>
                <button class="btn btn-positive">${I18n.t('admin_local.approve')}
                </button>
              </div>`
            $tdList.eq(c++).html(t);
          } else {
            $tdList.eq(c++).find("*").css("visibility", "hidden");
          }

          //$tdList.eq(c++).find("*").css("visibility", "hidden");
          if (featureEnabled('inventory')) {
            const avg = (node.data.averageProfitRatio / maxProfitRatio) * 100;
            const min = (node.data.minProfitRatio / maxProfitRatio) * 100;
            const max = (node.data.maxProfitRatio / maxProfitRatio) * 100;
            const style = "display:flex;justify-content:center;align-items:center;position:absolute; left:0;top:0;width:100%;height:100%;background: linear-gradient(90deg, rgb(222 121 45 / 44%) 0%, rgb(222 121 45 / 44%) " + min + "%, rgb(187 102 64 / 75%) " + min + "%, rgb(187 102 64 / 75%) " + avg + "%, black " + avg + "%, black " + (avg + 1) + "%, rgb(187 102 64 / 75%) " + avg + 1 + "%, rgb(187 102 64 / 75%) " + max + "%, rgba(0,0,0,0) " + max + "%, rgba(0,0,0,0) 100%);";
            $tdList.eq(++c).html("<div style=\"" + style + "\"><text style=\"\">" + Math.round(node.data.averageProfitRatio) + "%</text></div>");
          }
        }

        if (node.title == "???") {
          $tdList.eq(1).addClass("itemWarning");
        }

        var labels = "";
        node.data.labels.forEach(function (label) {
          if (labels != "") labels += ", ";
          labels += label.name;
        });
        c++;
        $tdList.eq(c).text(labels);
        setDiffers(c, "labels");
        var $span = $(node.span);

        if (node.data.defaultColor != "") {
          const td = $(node.tr).find("td.picture");
          td.css("background-color", node.data.defaultColor);
        }

        setDiffers(5, "picture");
        if (node.data.image) {
          const td = $(node.tr).find("td.picture img");
          td.removeClass("hidden");

          function onVisible(element, callback) {
            new IntersectionObserver((entries, observer) => {
              entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                  callback(element);
                  observer.disconnect();
                }
              });
            }).observe(element);
            if (!callback) return new Promise(r => callback = r);
          }
          onVisible(node.tr, () => {
            setTimeout(() => {
              if (!data.node.data.connectedRestaurants || data.node.data.connectedRestaurants[0])
                td.attr("src", auth.server + "/" + auth.war + "/adminService/" + localStorage.restaurantSelected + "/getImage/" + node.data.image + "?timestamp=" + node.data.modificationTimestamp);
              else {
                const r = menuitemutil.getRestaurant(Number(Object.keys(data.node.data.connectedRestaurants)[0]));
                td.attr("src", r.serverUrl + auth.war + "/" + r.instance + "/adminService/" + localStorage.restaurantSelected + "/getImage/" + node.data.image + "?timestamp=" + node.data.modificationTimestamp + "&instance=" + r.instance);
              }
              $tdList.eq(0).find("img").attr("src", auth.server + "/" + auth.war + "/adminService/" + localStorage.restaurantSelected + "/getImage/" + node.data.image + "?timestamp=" + node.data.modificationTimestamp);
            }, Math.random() * 1000);
          })

          $tdList.eq(0).prepend($('<img class="mobile-only" src=""/>'));
          $tdList.eq(0).find("img").removeClass("hidden");

        } else {
          // $span.find("img").attr('src', getImageById(1));
        }
        $span.find("img").attr("style", "width:48px;height:48px");

        const connectedRestaurantCount = menuitemutil.getAvaiableConnectedRestaurants().filter(id => localStorage['restaurant_copy_selected_' + id] == 'true').length;
        var ind = 0;
        menuitemutil.getAvaiableConnectedRestaurants().forEach((r) => {
          c++;
          const lid = "copyto_local_" + data.node.data.entityType + "_from_" + data.node.data?.connectedRestaurants?.[r]?.id;
          const rid = "copyto_local_" + data.node.data.entityType + "_to_" + r + "_" + data.node.data?.connectedRestaurants?.[0]?.id;

          const updateLocal = (event) => {
            if (data.node.children) {
              var update;
              const ask = event.originalEvent ? true : false;

              const t = (choice) => {
                const updateLocalSequentially = (nodes, r) => {
                  if (!nodes.length) {
                    auth.myStatus.restaurant_modification_timestamp++;
                    menuitemutil._reload();
                    //refreshConnectedRestaurants(r, true);
                    return $.when(); // Ha nincs több elem, visszatérünk egy teljesített Promise-zal
                  }

                  const [first, ...rest] = nodes;
                  return menuitemutil.__updateLocal(first.data, r, first).then((data) => {
                    if (data === "refresh") {
                      auth.myStatus.restaurant_modification_timestamp++;
                      admin.getMenuItems((data) => {

                        menuitemutil.filterByType(data);

                        refreshConnectedRestaurants().done(() => {
                          processMenuItems(data);
                          const t = $("#" + lid);
                          t.trigger("click");

                        });

                      }, undefined, menuitemutil.filter.deleted);
                      return;
                    }
                    return updateLocalSequentially(rest, r); // Következő elem hívása
                  });
                };
                update = () => {
                  menuitemutil.__updateLocal(data.node.data, r, data.node).then((d) => {
                    if (d === "refresh") {
                      auth.myStatus.restaurant_modification_timestamp++;
                      admin.getMenuItems((data) => {

                        menuitemutil.filterByType(data);

                        refreshConnectedRestaurants().done(() => {
                          processMenuItems(data);
                          const t = $("#" + lid);
                          t.trigger("click");
                        });

                      }, undefined, menuitemutil.filter.deleted);
                      return;
                    }
                    if (choice == 0) {
                      const collectNodes = (node, collected = []) => {
                        node.children && node.children.forEach(c => {
                          if (!c.data.availableQuantities || c.data.equalRestaurants.indexOf(r) === -1) {
                            collected.push(c);
                          }
                          collectNodes(c, collected);
                        });
                        return collected;
                      };

                      const nodesToUpdate = collectNodes(data.node);
                      return updateLocalSequentially(nodesToUpdate, r, data.node);
                    } else {
                      auth.myStatus.restaurant_modification_timestamp++;
                      menuitemutil._reload();
                    }
                  });
                }
                update();
              }
              if (ask) {
                choiceDialog(I18n.t("local.question"), I18n.t("admin_local.confirmation_copy_all"), I18n.t("admin_local.yes"), I18n.t("admin_local.no")).done(choice => {
                  t(choice)
                });
              } else {
                t(0);
              }
            } else {
              menuitemutil.updateLocal(data.node.data, r);
            }
          }

          const updateRemote = (event) => {
            if (data.node.children) {
              var update;
              const ask = event.originalEvent ? true : false;

              const t = (choice) => {
                const updateRemoteSequentially = (nodes, r) => {
                  if (!nodes.length) {
                    auth.myStatus.restaurant_modification_timestamp++;
                    menuitemutil._reload();
                    //refreshConnectedRestaurants(r, true);
                    return $.when(); // Ha nincs több elem, visszatérünk egy teljesített Promise-zal
                  }

                  const [first, ...rest] = nodes;
                  return menuitemutil._updateRemote(first.data, first.data, r, first).then((data) => {
                    if (data === "refresh") {
                      auth.myStatus.restaurant_modification_timestamp++;
                      admin.getMenuItems((data) => {

                        menuitemutil.filterByType(data);

                        refreshConnectedRestaurants().done(() => {
                          processMenuItems(data);
                          const t = $("#" + rid);
                          t.trigger("click");

                        });

                      }, undefined, menuitemutil.filter.deleted);
                      return;
                    }
                    return updateRemoteSequentially(rest, r); // Következő elem hívása
                  });
                };
                update = () => {
                  menuitemutil._updateRemote(data.node.data, data.node.data, r, data.node).then((d) => {
                    if (d === "refresh") {
                      auth.myStatus.restaurant_modification_timestamp++;
                      admin.getMenuItems((data) => {

                        menuitemutil.filterByType(data);

                        refreshConnectedRestaurants().done(() => {
                          processMenuItems(data);
                          const t = $("#" + rid);
                          t.trigger("click");
                        });

                      }, undefined, menuitemutil.filter.deleted);
                      return;
                    }
                    if (choice == 0) {
                      const collectNodes = (node, collected = []) => {
                        node.children && node.children.forEach(c => {
                          if (!c.data.availableQuantities || c.data.equalRestaurants.indexOf(r) === -1) {
                            collected.push(c);
                          }
                          collectNodes(c, collected);
                        });
                        return collected;
                      };

                      const nodesToUpdate = collectNodes(data.node);
                      return updateRemoteSequentially(nodesToUpdate, r, data.node);
                    } else {
                      auth.myStatus.restaurant_modification_timestamp++;
                      menuitemutil._reload();
                    }
                  });
                }
                update();
              }
              if (ask) {
                choiceDialog(I18n.t("local.question"), I18n.t("admin_local.confirmation_copy_all"), I18n.t("admin_local.yes"), I18n.t("admin_local.no")).done(choice => {
                  t(choice)
                });
              } else {
                t(0);
              }
            } else {
              menuitemutil.updateRemote(data.node.data, r);
            }
          }

          const approveRemoteCost = (e, globalId, quantity) => {
            const ee = e.connectedRestaurants[globalId];
            const entity = {
              menuCategoryId: e.menuCategoryId,
              id: ee.globalId ? 0 : e.id,
              globalId: ee.globalId ? e.id : undefined,
              availableQuantities: [{
                quantity: quantity,
                approvedCost: ee.availableQuantities.find(q => q.quantity == quantity).cost,
                price: ee.availableQuantities.find(q => q.quantity == quantity).price
              }],
              type: e.entityType.toLowerCase()
            }

            const restaurant = menuitemutil.getRestaurant(globalId);

            menuitemutil.getLocalFromGlobal(restaurant).done(id => {
              if (e.connectedRestaurants[restaurant.globalId]) {
                post(restaurant.serverUrl + auth.war + "/" + restaurant.instance + "/mergeService/" + id + "/" + (entity.menuCategoryId || 0) + "/modifyMenuItemPrice?instance=" + restaurant.instance + "&properties=" + menuitemutil.synchronizeProperties.join(","), entity)
                  .done(() => {
                    auth.myStatus.restaurant_modification_timestamp++;
                    menuitemutil._reload();
                  })
                  .fail(() => {
                    auth.ajaxError = false;
                  });
              }

            });
          }

          const updateRemotePrice = (e, globalId, quantity, val) => {
            const ee = e.connectedRestaurants[globalId];
            const entity = {
              menuCategoryId: e.menuCategoryId,
              id: ee.globalId ? 0 : e.id,
              globalId: ee.globalId ? e.id : undefined,
              availableQuantities: [{
                quantity: quantity,
                price: "" + val
              }],
              type: e.entityType.toLowerCase()
            }

            const restaurant = menuitemutil.getRestaurant(globalId);

            menuitemutil.getLocalFromGlobal(restaurant).done(id => {
              if (e.connectedRestaurants[restaurant.globalId]) {
                post(restaurant.serverUrl + auth.war + "/" + restaurant.instance + "/mergeService/" + id + "/" + (entity.menuCategoryId || 0) + "/modifyMenuItemPrice?instance=" + restaurant.instance + "&properties=" + menuitemutil.synchronizeProperties.join(","), entity)
                  .done(() => {
                    auth.myStatus.restaurant_modification_timestamp++;
                    menuitemutil._reload();
                  })
                  .fail(() => {
                    auth.ajaxError = false;
                  });
              }

            });

          }



          const t = $tdList.eq(c);
          const selected = localStorage['restaurant_copy_selected_' + r] == 'true';
          if (!selected)
            t.hide();
          else {
            t.show();
            t.css("--col", connectedRestaurantCount - (ind++) - 1);
            if (data.node.data.connectedRestaurants) {
              if (data.node.data.connectedRestaurants[0] && data.node.data.connectedRestaurants[r]) {
                if (data.node.data.equalRestaurants.indexOf(r) !== -1) {
                  t.find("button.icon-edit").css("color", "mediumseagreen");
                  t.find("button.icon-edit").attr("title", "");
                } else {
                  t.find("button.icon-edit").css("color", "red");
                }
                t.find("button.icon-edit").attr("title", data.node.data.compareLocalToRemote);

                t.find("button.icon-edit").on("click", () => {
                  if (data.node.data.connectedRestaurants[r].availableQuantities) {
                    const modal = $('#editMenuItem.modal');
                    modal.modal("show");
                    populateEditMenuItem(modal, "edit", data.node.data.connectedRestaurants[r], data.node.data.connectedRestaurants[r].menuCategoryId, r);
                  } else {
                    const modal = $('#editMenuCategory.modal');
                    modal.modal("show");
                    populateEditCategory(modal, "edit", data.node.data.connectedRestaurants[r], data.node.data.connectedRestaurants[r].menuCategoryId, r)
                  }
                });
                t.find("button.icon-edit").css("visibility", "visible");
                t.find("button.icon-left-open").prop("disabled", false);
                t.find("button.icon-left-open").attr("id", lid);
                t.find("button.icon-right-open").attr("id", rid);
                t.find("button.icon-right-open").prop("disabled", false);
                t.find("button.icon-left-open").on("click", updateLocal);
                t.find("button.icon-right-open").on("click", updateRemote);

                if (menuitemutil.synchronizeProperties.includes("price") && menuitemutil.synchronizeProperties.length === 1 && data.node.data.availableQuantities) {
                  var d = data.node.data.connectedRestaurants[r];
                  var rprice = ""
                  d.availableQuantities.forEach(q => {
                    const cost = Math.abs(q.cost) < 10 ? Math.round(q.cost * 100) / 100 : Math.round(q.cost);
                    const approvedCost = Math.abs(q.approvedCost) < 10 ? Math.round(q.approvedCost * 100) / 100 : Math.round(q.approvedCost);
                    const costChange = approvedCost > 0 ? (cost > approvedCost ? "+" : "") + (Math.round(100 * cost / approvedCost) - 100) + "%" : "";
                    const warning = Math.abs(costChange.replace("%", "")) > costChangeThreshold ? "warning" : "";
                    if (cost != approvedCost)
                      rprice += `<div class="c"><div class="approve" quantity="${q.quantity}"><div class="a1 ${warning}">${cost}</div><div class="a2">↘</div><div class="a3">${approvedCost}</div><div class="a4">${costChange}</div></div></div>`;
                    else
                      rprice += `<div class="c"><div>${cost}</div></div>`;
                    if (q.price == null || q.price == undefined || q.price == "") {
                      rprice += `<div class="p"><input disabled class="unitPrice" style="text-align:right" pattern="[0-9]+\.[0-9]+%?" id="p_${node.data.id}-${q.quantity}" value="${q.localPrice}" type="text"/></div>`;
                    } else {
                      rprice += `<div class="p"><input ${hasRole("administration.products.fullaccess") ? "" : "disabled"} class="unitPrice" style="text-align:right" pattern="[0-9]+\.[0-9]+%?" id="p_${node.data.id}-${q.quantity}" quantity="${q.quantity}" value="${q.price}" type="text"/></div>`;
                    }
                  });
                  t.find(".remote-price").show();
                  t.find(".remote-price").html(rprice);
                  t.find(".remote-price input").on("change", event => {
                    const val = event.target.value;
                    const quantity = event.target.getAttribute("quantity");
                    if (val && !isNaN(val)) {
                      updateRemotePrice(data.node.data, r, quantity, val);
                    }
                  });
                  t.find(".remote-price .approve").on("dblclick", event => {
                    const quantity = event.currentTarget.getAttribute("quantity");
                    approveRemoteCost(data.node.data, r, quantity);
                  });

                } else {
                  t.find(".remote-price").hide();
                }

              } else if (data.node.data.connectedRestaurants[r]) {
                t.find("button.icon-left-open").prop("disabled", false);
                t.find("button.icon-left-open").on("click", updateLocal);
                t.find("button.icon-left-open").attr("id", lid);
                t.find("button.icon-edit").css("visibility", "hidden");

                if (menuitemutil.synchronizeProperties.includes("price") && menuitemutil.synchronizeProperties.length === 1 && data.node.data.availableQuantities) {
                  var d = data.node.data.connectedRestaurants[r];
                  var rprice = ""
                  d.availableQuantities.forEach(q => {
                    const cost = Math.abs(q.cost) < 10 ? Math.round(q.cost * 100) / 100 : Math.round(q.cost);
                    const approvedCost = Math.abs(q.approvedCost) < 10 ? Math.round(q.approvedCost * 100) / 100 : Math.round(q.approvedCost);
                    const costChange = approvedCost > 0 ? (cost > approvedCost ? "+" : "") + (Math.round(100 * cost / approvedCost) - 100) + "%" : "";
                    const warning = Math.abs(costChange.replace("%", "")) > costChangeThreshold ? "warning" : "";
                    if (cost != approvedCost)
                      rprice += `<div class="c"><div class="approve" quantity="${q.quantity}"><div class="a1 ${warning}">${cost}</div><div class="a2">↘</div><div class="a3">${approvedCost}</div><div class="a4">${costChange}</div></div></div>`;
                    else
                      rprice += `<div class="c"><div>${cost}</div></div>`;
                    if (q.price == null || q.price == undefined || q.price == "") {
                      rprice += `<div class="p"><input disabled class="unitPrice" style="text-align:right" pattern="[0-9]+\.[0-9]+%?" id="p_${node.data.id}-${q.quantity}" value="${q.localPrice}" type="text"/></div>`;
                    } else {
                      rprice += `<div class="p"><input ${hasRole("administration.products.fullaccess") ? "" : "disabled"} class="unitPrice" style="text-align:right" pattern="[0-9]+\.[0-9]+%?" id="p_${node.data.id}-${q.quantity}" quantity="${q.quantity}" value="${q.price}" type="text"/></div>`;
                    }
                  });
                  t.find(".remote-price").show();
                  t.find(".remote-price").html(rprice);
                  t.find(".remote-price input").on("change", event => {
                    const val = event.target.value;
                    const quantity = event.target.getAttribute("quantity");
                    if (val && !isNaN(val)) {
                      updateRemotePrice(data.node.data, r, quantity, val);
                    }
                  });
                  t.find(".remote-price .approve").on("dblclick", event => {
                    const quantity = event.currentTarget.getAttribute("quantity");
                    approveRemoteCost(data.node.data, r, quantity);
                  });

                } else {
                  t.find(".remote-price").hide();
                }

              } else if (data.node.data.connectedRestaurants[0]) {
                t.find("button.icon-right-open").prop("disabled", false);
                t.find("button.icon-right-open").attr("id", rid);
                t.find("button.icon-right-open").on("click", updateRemote);
                t.find("button.icon-edit").css("visibility", "hidden");
              }
            }
          }
        })

        if (!editModeEnabled) $tdList.find('input[type!="checkbox"]').prop("disabled", true);
      }
    });

    menuitemutil.menuItems.filterNodes(function (node) {
      if (node?.data?.entityType && node.data.entityType.startsWith(menuitemutil.entityType)) {
        if (menuitemutil.filter.name) {
          const c = removeAccents(getLocale(node.data.name, localStorage.languageSelected));
          if (c.toLowerCase().indexOf(removeAccents(menuitemutil.filter.name).toLowerCase()) === -1
          )
            return false;
        }
        return true;
      }
      return false
    });

    if (window.innerWidth <= 800 && typeof localStorage.categoryexpanded !== "undefined" && localStorage.categoryexpanded && localStorage.categoryexpanded !== "null") {
      const m = menuitemutil.getMenuItem(localStorage.categoryexpanded);
      if (m && m.entityType.startsWith(menuitemutil.entityType)) {
        menuitemutil.menuItems.filterBranches(
          function (node) {
            if (!localStorage.categoryexpanded)
              return true;
            if (node.data.entityType.indexOf("Category") === -1) {
              return node.parent.data.id == localStorage.categoryexpanded;
            }
            return node.data.id == localStorage.categoryexpanded;
          },
          {
            mode: "hide"
          }
        );
      }
    }

  } else {
    /*
    $("#editMenuCategory").hide();
    $("#editMenuItem").hide();
    $("#addMenuItem").attr("disabled", "true");
    $("#addOption").attr("disabled", "true");
    $("#activate").prop("disabled", "true");
    $("#deactivate").prop("disabled", "true");
    $("#delete").prop("disabled", "true");
    */
    var $container = $("#menuItemsFreezeTable");
    const scroll = $container.scrollTop();
    //eslint-disable-next-line no-undef
    menuitemutil.menuItems.reload(structuredClone(mergedData));
    $container.scrollTop(scroll);
    //$("input#" + focus).focus();
  }
  if (auth?.myStatus?.restaurant_settings?.["shop-mode"])
    tooltip($("[data-toggle = 'tooltip']"));
  menuitemutil.tablehooks();
}

function tooltip(items) {
  if (auth?.myStatus?.restaurant_settings?.["shop-mode"])
    return
  items.tooltip({ trigger: 'hover', html: true });
  items.on('shown.bs.tooltip', function () {
    if (auth.tooltip != this) {
      $(auth.tooltip).tooltip('hide')
      auth.tooltip = this;
      setTimeout(() => {
        $(auth.tooltip).tooltip('hide')
        delete auth.tooltip;
      }, 5000)
    }
  })
}


function handleCheckBoxChange(t, handler) {
  var indeterminate = $(t).prop("indeterminate");
  var checked_old = $(t).prop("checked_old");
  var checked = $(t).prop("checked");
  if ($(t).prop("checked") && checked_old != undefined && (indeterminate == undefined || indeterminate == false)) {
    $(t).prop("indeterminate", true);
    $(t).prop("checked", false);
    $(t).removeProp("checked_old");
    handler(t);
    return;
  }
  $(t).prop("checked_old", $(t).prop("checked"));
  handler(t);
}

var menuItemQuantities = null;
var inventoryItemsCount = 0;
var menuItemQuantitiesData;
function processMenuItemQuantities(data, menuitem) {
  if (data)
    data.forEach(d => {
      d.selected = d.def;
    });
  inventoryItemsCount = 0;
  menuItemQuantitiesData = data;

  const webshopEnabled = featureEnabled('ordering/enabled') && ((featureEnabled('pickup/enabled') && featureEnabled('pickup/webshop')) || (featureEnabled('homedelivery/enabled') && featureEnabled('homedelivery/webshop')));

  const data2 = [];
  data.forEach(d => {
    data2.push(d);
    d.places = [];

    if (webshopEnabled) {
      const p = {
        name: "default"
      }
      d.places.push(p);
      p.type = "webshop";
      d.rowCount++;
    }

    if (featureEnabled("kiosk")) {
      const p = {
        name: "default"
      }
      d.places.push(p);
      p.type = "kiosk";
      d.rowCount++;
    }

    if (featureEnabled("wolt"))
      getPlaces("wolt").forEach(p => {
        d.places.push(p);
        p.type = "wolt";
        d.rowCount++;
      })
    if (featureEnabled("foodpanda"))
      getPlaces("foodpanda").forEach(p => {
        d.places.push(p);
        p.type = "foodpanda";
        d.rowCount++;
      })
    if (featureEnabled("falatozz"))
      getPlaces("falatozz").forEach(p => {
        d.places.push(p);
        p.type = "falatozz";
        d.rowCount++;
      })
    if (featureEnabled("choiceqr"))
      getPlaces("choiceqr").forEach(p => {
        d.places.push(p);
        p.type = "choiceqr";
        d.rowCount++;
      })
  })
  $("div#editMenuItem .price-block").show();
  if (menuItemQuantities == null)
    menuItemQuantities = createTree($("table#menuItemQuantities"), {
      checkbox: "radio",
      titlesTabbable: false, // Add all node titles to
      // TAB chain
      source: data2,
      selectMode: 1,
      zindex: 1000,
      keyboard: false,
      extensions: ["table", "gridnav"],
      icon: false,
      activeVisible: false,
      table: {
        checkboxColumnIdx: 0, // render the checkboxes into
        // into the this
        // column index (default: nodeColumnIdx)
        indentation: 16, // indent every node level
        // by 16px
        nodeColumnIdx: 0,
        // render node expander, icon, and title to this
        // column (default:
        // #0)
      },
      gridnav: {
        autofocusInput: false, // Focus first embedded
        // input if node
        // gets activated
        handleCursorKeys: true,
        scrollIntoView: false,
        // Allow UP/DOWN in inputs to move to prev/next node
      },

      activate: function (event, data) {
        // A node was activated: display its title:
        var node = data.node;
        $("#deleteQuantity").removeAttr("disabled");
        if (node.data.isActive) {
          $("#deactivateQuantity").removeAttr("disabled");
          $("#activateQuantity").prop("disabled", "true");
        } else {
          $("#deactivateQuantity").prop("disabled", "true");
          $("#activateQuantity").removeAttr("disabled");
        }
      },
      previousNode: null,
      click: function (event, data) {
        if (event.ctrlKey != true) return;
        if (menuitemutil.menuItems == null) return;
        if (data.node == menuitemutil.menuItems.previousNode) {
          menuitemutil.menuItems.activateKey("");
          event.preventDefault();
          menuitemutil.menuItems.previousNode = null;
        } else {
          menuitemutil.menuItems.previousNode = data.node;
        }
      },
      renderColumns: function (event, data) {
        var node = data.node,
          $tdList = $(node.tr).find(">td");

        var c = 0;
        var onMenu = node.data.onMenu;
        $tdList
          .eq(++c)
          .find("input.onMenu")
          .attr("id", "m_" + node.key);
        $tdList
          .eq(c)
          .find("input.onMenu")
          .prop("checked", onMenu);
        $tdList
          .eq(c)
          .find("label[for='onMenu'")
          .attr("for", "m_" + node.key);
        $tdList
          .eq(c)
          .find("input")
          .addClass("checkbox");

        var inventory = $tdList.eq(++c).find("input");
        inventory.attr("id", "q_" + node.key);
        inventory.change(function () {
          if ($(this).prop("checked") && price.val() == "" && !isNaN(price.attr("placeholder"))) {
            price.val(price.attr("placeholder"));
          }
        });

        var unitPrice = $("#editMenuItem input#unit_price").val();
        var minimumPrice = $("#editMenuItem input#menuItem_minimumPrice").prop("checked");

        const parentCategoryId = menuitemutil?.data?.menuCategoryId || $("#editMenuItem #parentCategoryId").val();
        const parentCategory = menuitemutil.data ? getMenuCategory(menuitemutil.data) : menuitemutil.getMenuCategory(parentCategoryId);
        const parentCategoryInventoryItem = parentCategory.inventoryItem === null ? parentCategory.defaultInventoryItem : parentCategory.inventoryItem;
        if ($("#editMenuItem #mi_isInventoryItem").prop("checked")) {
          inventory.parent().parent().removeClass("hidden");
          $("th.mi_inventoryItem").removeClass('hidden');
          inventory.prop("checked", node.data.inventoryItem);
          unitPrice = menuitemutil.data ? menuitemutil.data.unitPrice : node.data.unitPrice;
        } else if ($("#editMenuItem #mi_isInventoryItem").prop("indeterminate") && parentCategoryInventoryItem) {
          inventory.parent().parent().removeClass("hidden");
          $("#editMenuItem").removeClass("mi_inventoryItem_hidden")
          $("th.mi_inventoryItem").removeClass('hidden');
          inventory.prop("checked", node.data.inventoryItem);
          unitPrice = menuitemutil.data ? menuitemutil.data.unitPrice : node.data.unitPrice;
        } else {
          inventory.parent().parent().addClass("hidden");
          $("th.mi_inventoryItem").addClass('hidden');
        }
        $tdList.eq(c).find("label").attr("for", "q_" + node.key);
        inventory.addClass("checkbox");

        $tdList.eq(1).find("div.thirdParty").each((ind, d) => {
          const type = $(d).attr('type');
          const name = $(d).attr('name');
          $(d).find("input").prop("id", "onMenu_" + node.data.quantity + "_" + type + "_" + name);
          $(d).find("label").prop("for", "onMenu_" + node.data.quantity + "_" + type + "_" + name);
        })

        function showPlace(key, name) {
          const show = menuitemutil.data && menuitemutil.data.mergedSettings && menuitemutil.data.mergedSettings[key] && menuitemutil.data.mergedSettings[key][name] && menuitemutil.data.mergedSettings[key][name].enabled;
          const checkbox = $tdList.eq(1).find("div[type='" + key + "'][name='" + name + "']");
          const label = $tdList.eq(3).find("label#label_" + key + "_" + name);
          const price = $tdList.eq(5).find("input#menuItem_price_" + key + "_" + name);
          if (show) {
            checkbox.removeClass("hidden");
            label.removeClass("hidden");
            price.removeClass("hidden");
          } else {
            checkbox.addClass("hidden");
            label.addClass("hidden");
            price.addClass("hidden");
          }
          checkbox.find('input').prop('checked', true);
        }

        if (featureEnabled("wolt")) {
          getPlaces("wolt").filter(p => p.enabled).forEach(place => {
            const key = "wolt";
            const name = place.name;
            showPlace(key, name);
          });
        }
        if (featureEnabled("foodpanda")) {
          getPlaces("foodpanda").filter(p => p.enabled).forEach(place => {
            const key = "foodpanda";
            const name = place.name;
            showPlace(key, name);
          });
        }
        if (featureEnabled("falatozz")) {
          getPlaces("falatozz").filter(p => p.enabled).forEach(place => {
            const key = "falatozz";
            const name = place.name;
            showPlace(key, name);
          });
        }
        if (featureEnabled("choiceqr")) {
          getPlaces("choiceqr").filter(p => p.enabled).forEach(place => {
            const key = "choiceqr";
            const name = place.name;
            showPlace(key, name);
          });
        }

        if (node.data.settings)
          Object.keys(node.data.settings).forEach(key => {
            Object.keys(node.data.settings[key]).forEach(name => {
              const checkbox = $tdList.eq(1).find("div[type='" + key + "'][name='" + name + "']");
              const price = $tdList.eq(5).find("input#menuItem_price_" + key + "_" + name);
              checkbox.find('input').prop('checked', node.data.settings[key][name].enabled)
              price.val(node.data.settings[key][name].price)
            });
          });

        const quantity = $($tdList.eq(++c).find("input"));
        quantity.val(node.data.quantity);
        const qt = $('#quantityTypeSelect.filter').val()[0];
        if (qt)
          $tdList.eq(c).find('span').html(I18n.t('local.' + qt));

        ++c;
        if (node.data.quantityType) {
          const option = $($tdList.eq(c).find("select option#" + node.data.quantityType.id));
          option.prop("selected", true);
        }


        var unitCost = menuitemutil.data ? menuitemutil.data.costEstimation * node.data.quantity : 0;

        var price = $($tdList.eq(++c).find("input#menuItem_price"));

        $($tdList.eq(++c).find("input.form-control")).val(node.data.containerCharge);
        $($tdList.eq(c).find("input.checkbox")).prop("checked", node.data.containerChargeOnsite);
        $($tdList.eq(c).find("input.checkbox")).prop("id", "menuItem_containerChargeOnsite_" + node.data.quantity);
        $($tdList.eq(c).find("label")).prop("for", "menuItem_containerChargeOnsite_" + node.data.quantity);
        $($tdList.eq(++c).find("input.form-control")).val(node.data.labelCount);

        var costAndPriceRation = $($tdList.eq(++c).find("input"));
        if (node.data.price) price.val(node.data.price);
        if (menuitemutil.data && menuitemutil.data.defaultVATCategory) {
          if (typeof node.data.price == "undefined" || node.data.price == "") {
            var v = Math.round(1000 * unitPrice * node.data.quantity) / 1000;
            price.attr("placeholder", v);
            costAndPriceRation.val(Math.round((v / (100 + menuitemutil.data.defaultVATCategory.percent) * 100 - unitCost) / unitCost * 100));
          } else
            costAndPriceRation.val(Math.round((node.data.price / (100 + menuitemutil.data.defaultVATCategory.percent) * 100 - unitCost) / unitCost * 100));
          quantity.change(event => {
            var v = event.target.value;
            var unitCost = menuitemutil.data.costEstimation * v;
            costAndPriceRation.val(Math.round((price.val() / (100 + menuitemutil.data.defaultVATCategory.percent) * 100 - unitCost) / unitCost * 100));
          });
          price.change(event => {
            var v = event.target.value;
            var unitCost = menuitemutil.data.costEstimation * quantity.val();
            costAndPriceRation.val(Math.round((v / (100 + menuitemutil.data.defaultVATCategory.percent) * 100 - unitCost) / unitCost * 100));
          });
          costAndPriceRation.change(event => {
            var v = event.target.value;
            var unitCost = menuitemutil.data.costEstimation * quantity.val();
            price.val(Math.round(unitCost * (Number(v) + 100) / 100) * (100 + menuitemutil.data.defaultVATCategory.percent) / 100);
          });
        }
        $($tdList.eq(++c).find("input")).val(Math.round(1000 * node.data.priceEstimation) / 1000);
        $($tdList.eq(++c).find("input")).val(node.data.cost);
        if (typeof node.data.menuItems != "undefined") {
          $tdList
            .eq(c)
            .prop("colspan", 4)
            .nextAll()
            .remove();
        }
        if (auth?.myStatus?.restaurant_settings?.["shop-mode"])
          tooltip($(node.tr).find("[data-toggle = 'tooltip']"));
        c++;
        $($tdList.eq(++c).find("input")).val(node.data.promotionName);
        $($tdList.eq(++c).find("input")).val(node.data.promotionPrice);
        if (node.data.promotionStart)
          $($tdList.eq(++c).find("input")).val(moment(node.data.promotionStart).format("YYYY-MM-DD"));
        if (node.data.promotionEnd)
          $($tdList.eq(++c).find("input")).val(moment(node.data.promotionEnd).format("YYYY-MM-DD"));

      }
    });
  else {
    menuItemQuantities.reload(data);
  }

}
menuitemutil.processMenuItemQuantities = processMenuItemQuantities;

menuitemutil.addBarcode = (e) => {
  $('#barcodeTemplate').tmpl({ id: "" }).appendTo($(e).parent().prev());
}


function addQuantity() {
  var v = menuItemQuantities;
  var rootNode = menuItemQuantities.getRootNode();
  var childNode = rootNode.addChildren({
    title: "",
    folder: false,
    label: {},
    quantity: 1,
    price: 0,
    quantityType: {},
    onMenu: true
  });
}
menuitemutil.addQuantity = addQuantity;

function deleteQuantity() {
  if (menuItemQuantities.getActiveNode())
    menuItemQuantities.getActiveNode().remove();
}
menuitemutil.deleteQuantity = deleteQuantity;

menuitemutil.hooks = function () {

  $("#item_additions_mandatory,#category_additions_mandatory,#category_additions_included,#category_additions_optional,#item_additions_included,#item_additions_optional").on("tokenize:tokens:added", function (e, id) {
    syncTokenizerTokenClass(e.target);
    const item = $(e.target)
      .next()
      .find('li[data-value = "' + id + '"] input');
    if (item.is(":visible")) {
      setTimeout(() => {
        $(item).focus();
        $(item).select();
      }, 100);
    }
    if (auth?.myStatus?.restaurant_settings?.["shop-mode"])
      tooltip($(e.target).next().find("[data-toggle = 'tooltip']"));

  });

  $("#unit_price").change(function (e, item) {
    menuItemQuantities.reload(menuItemQuantitiesData);
  });

  $("#category_additions_optional,#item_additions_optional").on("tokenize:tokens:added", function (e, id) {
    const item = e.target;
    if (id.startsWith("menuCategory")) {
      const reductionTitle = admin_local.reduce_optional_options || admin_local.filter || I18n.t("admin_local.filter") || "Reduce options";
      var radioButton =
        '<div class="custom-control custom-checkbox" data-toggle="tooltip" data-placement="bottom" title="' +
        I18n.t("admin_local.checkbox_option") +
        '" style="padding-left:2rem;padding-right:0rem;">' +
        '<input type="radio" class="custom-control-input" id="check' +
        id +
        '" name="coption' +
        id +
        '">' +
        '<label class="custom-control-label" for="check' +
        id +
        '"></label>' +
        "</div>" +
        '<div class="custom-control custom-checkbox" data-toggle="tooltip" style="display:flex" data-placement="bottom" title="' +
        I18n.t("admin_local.checkbox_option2") +
        '" style="padding-left:2rem;padding-right:0rem;">' +
        '<input type="radio" class="custom-control-input check2" id="check2' +
        id +
        '" name="coption' +
        id +
        '">' +
        '<label class="custom-control-label" for="check2' +
        id +
        '"></label>' +
        menuitemutil.getMinMaxOption() +
        "</div>" +
        '<div class="custom-control custom-radio" data-toggle="tooltip" data-placement="bottom" title="' +
        I18n.t("admin_local.optional_radio_option") +
        '" style="padding-left: 1.5rem;">' +
        '<input type="radio" class="custom-control-input" id="radio' +
        id +
        '" name="coption' +
        id +
        '">' +
        '<label class="custom-control-label" for="radio' +
        id +
        '"></label>' +
        "</div>" +
        '<div class="custom-control custom-radio compulsory" data-toggle="tooltip" data-placement="bottom" title="' +
        I18n.t("admin_local.mandatory_radio_option") +
        '" style="">' +
        '<input type="radio" class="custom-control-input" id="radio2' +
        id +
        '" name="coption' +
        id +
        '">' +
        '<label class="custom-control-label" for="radio2' +
        id +
        '"></label>' +
        "</div>" +
        '<button type="button" class="btn btn-light btn-sm menuitem-optional-reduction" data-token-value="' +
        encodeURIComponent(id) +
        '" data-select-id="' +
        item.id +
        '" data-toggle="tooltip" data-placement="bottom" title="' +
        reductionTitle +
        '" style="padding:.08rem .35rem;line-height:1.15;min-height:1.40rem;display:inline-flex;align-items:center;">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="11" y1="18" x2="13" y2="18"/></svg>' +
        "</button>";
      var $radioButton = $(radioButton);
      var h = $(item)
        .next("div")
        .find('li[data-value = "' + id + '"]');
      h.append($radioButton);
      //$radioButton.insertAfter($(item).find("abbr"));
      $radioButton.find('input[id="check2' + id + '"]').prop("checked", true);
      if (auth?.myStatus?.restaurant_settings?.["shop-mode"])
        tooltip($radioButton);
    }
    if (auth?.myStatus?.restaurant_settings?.["shop-mode"])
      tooltip($(e.target).find("[data-toggle = 'tooltip']"));
  });

  $(document).off("click.optionalReduction", ".menuitem-optional-reduction").on("click.optionalReduction", ".menuitem-optional-reduction", function (event) {
    event.preventDefault();
    const button = $(this);
    const tokenValue = decodeURIComponent(button.data("tokenValue") || "");
    const selectId = button.data("selectId");
    if (!tokenValue || !selectId) {
      return;
    }
    const select = $("#" + selectId);
    if (!select.length) {
      return;
    }
    openOptionalReductionDialog(select, tokenValue);
  });

  $(document).off("click.optionalReductionApply", "#" + optionalReductionDialogId + " .optional-reduction-apply")
    .on("click.optionalReductionApply", "#" + optionalReductionDialogId + " .optional-reduction-apply", function () {
      applyOptionalReductionDialogSelection();
    });

  $(document).off("change.categoryOptionTypeSync", "li.token[data-value] input.custom-control-input[id^='radio']")
    .on("change.categoryOptionTypeSync", "li.token[data-value] input.custom-control-input[id^='radio']", function () {
      const selected = $(this);
      if (!selected.prop("checked")) {
        return;
      }

      const controlId = (selected.attr("id") || "").toString();
      const tokenNode = selected.closest("li.token[data-value]");
      if (!tokenNode.length) {
        return;
      }

      const minInput = tokenNode.find("input#min").first();
      const maxInput = tokenNode.find("input#max").first();
      if (!minInput.length || !maxInput.length) {
        return;
      }

      if (controlId.startsWith("radio2")) {
        minInput.val("1");
        maxInput.val("1");
      } else if (controlId.startsWith("radio")) {
        minInput.val("0");
        maxInput.val("1");
      } else {
        return;
      }

      minInput.trigger("input").trigger("change");
      maxInput.trigger("input").trigger("change");
    });

  $("#item_additions_mandatory,#category_additions_mandatory,#category_additions_included,#category_additions_optional,#item_additions_included,#item_additions_optional").each((_, input) => {
    syncTokenizerTokenClass(input);
  });

  menuItemQuantities = null;
  $("input#pricePerCostRatio").each((ind, item) => {
    $(item).data(
      "cleave",
      new Cleave($(item), {
        numeral: true,
        numeralThousandsGroupStyle: "thousand",
        numeralPositiveOnly: true,
        numeralDecimalScale: 0,
        delimiter: " "
      })
    );
  });

  var barcodeOptions = {
    placeholder: I18n.t("local.enter_barcode"),
    tokensAllowCustom: true,
    sortable: true,
    searchMinLength: 1,
    searchHighlight: false,
    dataSource: function (term, object) {
      var p = $(object.element);
      object.trigger("tokenize:dropdown:fill", [menuitemutil.findBarcodes(term)]);
    },
    displayNoResultsMessage: true,
    noResultsMessageText: I18n.t("local.noResultsMessageText"),
    dropdownMaxItems: 200,
    searchFromStart: false,
  };


  var options = {
    placeholder: I18n.t("local.enter_additions"),
    tokensAllowCustom: false,
    sortable: true,
    searchMinLength: 1,
    searchHighlight: false,
    dataSource: function (term, object) {
      var p = $(object.element);
      object.trigger("tokenize:dropdown:fill", [menuitemutil.getMenuItems(term, true, p.attr("id").split("_")[2])]);
    },
    displayNoResultsMessage: true,
    noResultsMessageText: I18n.t("local.noResultsMessageText"),
    dropdownMaxItems: 200,
    searchFromStart: false,
    ondblclick: menuitemutil.openItem
  };

  var optionsc = {
    ...options,
    ondblclick: menuitemutil.openItemCategory
  };
  var optionsUnproportional = {
    placeholder: I18n.t("local.enter_additions"),
    tokensAllowCustom: false,
    sortable: true,
    searchMinLength: 1,
    searchHighlight: false,
    dataSource: function (term, object) {
      var p = $(object.element);
      object.trigger("tokenize:dropdown:fill", [menuitemutil.getMenuItems(term, false, p.attr("id").split("_")[2])]);
    },
    displayNoResultsMessage: true,
    noResultsMessageText: I18n.t("local.noResultsMessageText"),
    dropdownMaxItems: 200,
    searchFromStart: false,
    ondblclick: menuitemutil.openItem
  };
  var optionsUnproportionalc = {
    ...optionsUnproportional,
    ondblclick: menuitemutil.openItemCategory
  };
  var options1 = {
    placeholder: I18n.t("local.inherited_additions"),
    tokensAllowCustom: true,
    searchMinLength: 1,
    searchHighlight: false,
    dataSource: function (term, object) {
      var p = $(object.element);
      object.trigger("tokenize:dropdown:fill", [menuitemutil.getMenuItems(term, p.attr("id").split("_")[2])]);
    },
    displayNoResultsMessage: true,
    noResultsMessageText: I18n.t("local.noResultsMessageText"),
    dropdownMaxItems: 200,
    searchFromStart: false,
    ondblclick: menuitemutil.openItem
  };
  var options4 = {
    tokensAllowCustom: true,
    searchMinLength: 1,
    searchHighlight: false,
    dataSource: function (term, object) {
      var p = $(object.element);
      object.trigger("tokenize:dropdown:fill", [menuitemutil.getMenuItems(term, p.attr("id").split("_")[2])]);
    },
    displayNoResultsMessage: true,
    noResultsMessageText: I18n.t("local.noResultsMessageText"),
    dropdownMaxItems: 200,
    searchFromStart: false,
    ondblclick: menuitemutil.openItem
  };
  var options4c = {
    ...options4,
    ondblclick: menuitemutil.openItemCategory
  };
  var optionsUpsell = {
    placeholder: I18n.t("admin_local.upsell_items"),
    tokensAllowCustom: false,
    searchMinLength: 1,
    searchHighlight: false,
    dataSource: function (term, object) {
      var element = $(object.element);
      var currentItemId = element.closest(".modal").find("#id").val();
      var base = element.data("upsellBase") || admin.adminCategories;
      var normalizedTerm = (term || "").toLowerCase();
      var options = getUpsellMenuItemOptions(base).filter(option => {
        const optionValueParts = String(option.value || "").split(";");
        if (currentItemId && optionValueParts[0] === "menuItem" && String(optionValueParts[2]) === String(currentItemId)) {
          return false;
        }
        if (!normalizedTerm) {
          return true;
        }
        return String(option.text || "").toLowerCase().indexOf(normalizedTerm) !== -1;
      }).map(option => {
        return {
          ...option,
          text: wrapTokenizerLabelText(option.text)
        };
      });
      object.trigger("tokenize:dropdown:fill", [options]);
    },
    displayNoResultsMessage: true,
    noResultsMessageText: I18n.t("local.noResultsMessageText"),
    dropdownMaxItems: 200,
    searchFromStart: false,
    ondblclick: menuitemutil.openItem
  };
  var optionsUpsellc = {
    ...optionsUpsell,
    ondblclick: menuitemutil.openItemCategory
  };
  var options2 = {
    placeholder: I18n.t("admin_local.enter_labels"),
    tokensAllowCustom: true,
    searchHighlight: false,
    searchMinLength: 1,
    dataSource: function (term, object) {
      object.trigger("tokenize:dropdown:fill", [menuitemutil.getLabels(term)]);
    },
    displayNoResultsMessage: true,
    noResultsMessageText: I18n.t("local.noResultsMessageText"),
    dropdownMaxItems: 200,
    searchFromStart: false,
    ondblclick: menuitemutil.openItem
  };
  var options2c = {
    ...options2,
    ondblclick: menuitemutil.openItemCategory
  };
  $("div#editMenuItem #item_barcodes").tokenize2(barcodeOptions);
  $("div#editMenuItem #item_additions_mandatory").tokenize2(options);
  $("div#editMenuItem #item_additions_included").tokenize2(options);


  $("div#editMenuItem #item_additions_optional").tokenize2(optionsUnproportional);
  $("div#editMenuItem #item_labels").tokenize2(options2);
  $("div#editMenuItem #inherited_item_additions_mandatory").tokenize2(options1);
  $("div#editMenuItem #inherited_item_additions_included").tokenize2(options1);
  $("div#editMenuItem #inherited_item_additions_optional").tokenize2(options1);
  $("div#editMenuItem #references").tokenize2(options4);
  $("div#editMenuItem #category_references").tokenize2(options4);
  $("div#editMenuItem #upsellMenuItems").tokenize2(optionsUpsell);

  $("div#editMenuCategory #category_additions_mandatory").tokenize2(optionsc);
  $("div#editMenuCategory #category_additions_included").tokenize2(optionsc);
  $("div#editMenuCategory #category_additions_optional").tokenize2(optionsUnproportionalc);
  $("div#editMenuCategory #category_labels").tokenize2(options2c);
  $("div#editMenuCategory #category_references").tokenize2(options4c);
  $("div#editMenuCategory #upsellMenuItems").tokenize2(optionsUpsellc);

  $("input#pricePerCostRatio").each((ind, item) => {
    $(item).data(
      "cleave",
      new Cleave($(item), {
        numeral: true,
        numeralThousandsGroupStyle: "thousand",
        numeralPositiveOnly: true,
        numeralDecimalScale: 0,
        delimiter: " "
      })
    );
  });

  $("#mi_isInventoryItem").change(function (data) {
    if ($(this).prop("changeForced")) {
      $(this).prop("changeForced", false);
    } else {
      if ($(this).prop("checked") && !($(this).prop("checked_old") == undefined && $(this).prop("checked_old") == "") && !$(this).prop("indeterminate")) {
        $(this).prop("indeterminate", true);
        $(this).prop("checked", false);
        $(this).removeProp("checked_old");
        $(this).prop("changeForced", true);
      }
      $(this).prop("checked_old", $(this).prop("checked"));
    }

    const parentCategoryId = $("#editMenuItem #parentCategoryId").val();
    const parentCategory = menuitemutil.getMenuCategory(parentCategoryId);
    const parentCategoryInventoryItem = parentCategory.defaultInventoryItem;
    var modal = $("div#editMenuItem");
    var i = $(this).prop("indeterminate") ? parentCategoryInventoryItem : $(this).prop("checked");
    if (i === true) {
      modal.addClass("inventory");
      $("td .inventoryItem.checkbox").parent().parent().removeClass("hidden");
      $("th.mi_inventoryItem").removeClass('hidden');
      $("td .inventoryItem.checkbox").prop("disabled", null);
      if ($("td .inventoryItem.checkbox").length === 1) {
        $("td .inventoryItem.checkbox").prop('checked', true)
      }
      $("input#unit_price").parent().addClass("hidden");
      $("#editMenuItem input#menuItem_minimumPrice").parent().addClass("hidden");
      $("input#unit_cost").parent().addClass("hidden");
      $("input#pricePerCostRatio").parent().removeClass("hidden");
      //$(".input-group-mandatory").addClass("hidden");
      //$(".input-group-included").addClass("hidden");
      //clearTokens(modal.find("#item_additions_mandatory").tokenize2());
      //clearTokens(modal.find("#item_additions_included").tokenize2());
    } else {
      modal.removeClass("inventory");
      $("td .inventoryItem.checkbox").parent().parent().addClass('hidden');
      $("th.mi_inventoryItem").addClass('hidden');
      $("td .inventoryItem.checkbox").prop("disabled", true);
      $("td .inventoryItem.checkbox").prop('checked', false)
      $("input#unit_price").parent().removeClass("hidden");
      $("#editMenuItem input#menuItem_minimumPrice").parent().removeClass("hidden");
      $("input#unit_cost").parent().removeClass("hidden");
      $("input#pricePerCostRatio").parent().addClass("hidden");
      $(".input-group-mandatory").removeClass("hidden");
      //$(".input-group-included").removeClass("hidden");
    }
  });

  $("#mc_isInventoryItem").change(function (data) {
    if ($(this).prop("changeForced")) {
      $(this).prop("changeForced", false);
    } else {
      if ($(this).prop("checked") && !($(this).prop("checked_old") == undefined && $(this).prop("checked_old") == "") && !$(this).prop("indeterminate")) {
        $(this).prop("indeterminate", true);
        $(this).prop("checked", false);
        $(this).removeProp("checked_old");
        $(this).prop("changeForced", true);
      }
      $(this).prop("checked_old", $(this).prop("checked"));
    }
  });
  $("#mc_preorder").change(function (data) {
    if ($(this).prop("changeForced")) {
      $(this).prop("changeForced", false);
    } else {
      if ($(this).prop("checked") && !($(this).prop("checked_old") == undefined && $(this).prop("checked_old") == "") && !$(this).prop("indeterminate")) {
        $(this).prop("indeterminate", true);
        $(this).prop("checked", false);
        $(this).removeProp("checked_old");
        $(this).prop("changeForced", true);
      }
      $(this).prop("checked_old", $(this).prop("checked"));
    }
  });
  $("#m_preorder").change(function (data) {
    if ($(this).prop("changeForced")) {
      $(this).prop("changeForced", false);
    } else {
      if ($(this).prop("checked") && !($(this).prop("checked_old") == undefined && $(this).prop("checked_old") == "") && !$(this).prop("indeterminate")) {
        $(this).prop("indeterminate", true);
        $(this).prop("checked", false);
        $(this).removeProp("checked_old");
        $(this).prop("changeForced", true);
      }
      $(this).prop("checked_old", $(this).prop("checked"));
    }
  });
  $("div#editMenuItem").on("hide.bs.modal", function (event) {
    var modal = $(this);
    var sm = $(modal.find("img#smallImage"));
    if ($.data(sm.get(0), "rcrop")) {
      crop(sm);
    }
  });
  $("div#editMenuCategory").on("hide.bs.modal", function (event) {
    var modal = $(this);
    var sm = $(modal.find("img#smallImage"));
    if ($.data(sm.get(0), "rcrop")) {
      crop(sm);
    }
  });

  if ($("#menuItemsFreezeTable > table#menuItems").length > 0) {
    $("div#editMenuCategory").on("show.bs.modal", function (event) {
      $("#menuItemList").hide();
      var modal = $(this);
      var button = $(event.relatedTarget); // Button that triggered
      // the
      // modal
      var recipient = button.data("whatever"); // Extract info from
      if (!recipient) return;
      // data-*
      // attributes
      var node = menuitemutil.menuItems.getActiveNode();
      if (node && node.data.entityType.indexOf("Category") === -1 && recipient !== "edit") {
        node = node.parent;
      }
      const top = button.attr("id") === "addTopMenuCategory";
      if (top) recipient = "new";
      populateEditCategory(modal, recipient, recipient == "edit" ? node?.data : null, top ? 0 : recipient == "edit" ? node?.data?.menuCategoryId : node != null ? node?.data?.id : 0, node?.data?.connectedRestaurants && !node?.data?.connectedRestaurants?.[0] ? Number(Object.keys(node?.data?.connectedRestaurants)[0]) : null);

      bindMenuEditorChangeTracking(modal);
    });

    $("div#editMenuCategory").on("shown.bs.modal", function (event) {
      var modal = $(this);

      bindColorPalette(modal);
      modal.find(".modal-body").scrollTop(0);
      bindMenuitemSectionSpy(modal, menucategorySections);
      bindMenuitemSectionHelp(modal);
      bindMenuitemExcerpt(modal);
    });

    $("div#editMenuCategory").on("hidden.bs.modal", function (event) {
      $("#menuItemList").show();
      const modal = $(this);
      const cleanup = modal.data("menuitemSectionSpyCleanup");
      if (cleanup) {
        cleanup();
        modal.removeData("menuitemSectionSpyCleanup");
      }
      const helpCleanup = modal.data("menuitemSectionHelpCleanup");
      if (helpCleanup) {
        helpCleanup();
        modal.removeData("menuitemSectionHelpCleanup");
      }
      const excerptObserver = modal.data("menuitemExcerptObserver");
      if (excerptObserver) {
        excerptObserver.disconnect();
        modal.removeData("menuitemExcerptObserver");
      }
      const excerptTimer = modal.data("menuitemExcerptRefreshTimer");
      if (excerptTimer) {
        clearTimeout(excerptTimer);
        modal.removeData("menuitemExcerptRefreshTimer");
      }
      modal.off(".menuitemExcerpt");
      unbindMenuEditorChangeTracking(modal);
    });

    $("div#editMenuItem").on("show.bs.modal", function (event) {
      $("#menuItemList").hide();
      var modal = $(this);
      var button = $(event.relatedTarget); // Button that triggered
      // the
      // modal
      var recipient = button.data("whatever"); // Extract info from
      if (!recipient) return;
      // attributes
      var node = menuitemutil.menuItems.getActiveNode();
      if (node && node.data.entityType.indexOf("Category") === -1 && recipient !== "edit") {
        node = node.parent;
      }
      if (node)
        populateEditMenuItem(modal, recipient, recipient === "edit" ? node.data : null, recipient === "edit" ? node.data.menuCategoryId : node.data.id, node.data.connectedRestaurants && !node.data.connectedRestaurants?.[0] ? Number(Object.keys(node.data.connectedRestaurants)[0]) : null);

      bindMenuEditorChangeTracking(modal);
    });
    $("div#editMenuItem").on("shown.bs.modal", function (event) {
      var modal = $(this);

      bindColorPalette(modal);
      /*scroll modal body to top */
      modal.find(".modal-body").scrollTop(0);
      bindMenuitemSectionSpy(modal);
      bindMenuitemSectionHelp(modal);
      bindMenuitemExcerpt(modal);
    });

    $("div#editMenuItem").on("hidden.bs.modal", function (event) {
      const modal = $(this);
      $("#menuItemList").show();
      const cleanup = modal.data("menuitemSectionSpyCleanup");
      if (cleanup) {
        cleanup();
        modal.removeData("menuitemSectionSpyCleanup");
      }
      const helpCleanup = modal.data("menuitemSectionHelpCleanup");
      if (helpCleanup) {
        helpCleanup();
        modal.removeData("menuitemSectionHelpCleanup");
      }
      const excerptObserver = modal.data("menuitemExcerptObserver");
      if (excerptObserver) {
        excerptObserver.disconnect();
        modal.removeData("menuitemExcerptObserver");
      }
      const excerptTimer = modal.data("menuitemExcerptRefreshTimer");
      if (excerptTimer) {
        clearTimeout(excerptTimer);
        modal.removeData("menuitemExcerptRefreshTimer");
      }
      modal.off(".menuitemExcerpt");
      unbindMenuEditorChangeTracking(modal);
    });


  }

  $("#download").click(function (e) {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    var node = menuitemutil.menuItems.getActiveNode();
    get("adminService/" + localStorage.restaurantSelected + "/getStores").done(stores => {
      get("adminService/" + localStorage.restaurantSelected + "/getStocks").done(stock => {
        var ws;
        var name = "";
        if (node) {
          var menuCategory = admin.getMenuCategoryAdmin(node.data.id);
          if (!menuCategory)
            return;
          name = "_" + menuitemutil._getPath(menuCategory).replace(/\//g, "_");
          ws = window.XLSX.utils.json_to_sheet(menuitemutil.export(menuitemutil.getFlatMenuItems([], menuCategory.children), stores, stock));
        } else {
          ws = window.XLSX.utils.json_to_sheet(menuitemutil.export(menuitemutil.getFlatMenuItems([], admin.categories.activeMenuCategories), stores, stock));
        }
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = window.XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });

        saveAs(data, auth.myStatus.restaurant_name + "_" + menuitemutil.entityType + name + "s.xlsx");
      });
    });

  });

  menuitemutil.export = (array, stores, stocks) => {

    const wolt = featureEnabled("wolt");
    const foodpanda = featureEnabled("foodpanda");
    const falatozz = featureEnabled("falatozz");
    const choiceqr = featureEnabled("choiceqr");
    const takeaway = settingEnabled("takeaway/price");

    const quantities = [];
    array.forEach(m => {
      m.availableQuantities.forEach(q => {
        const qq = q;
        if (wolt && qq && qq.settings && qq.settings.wolt) {
          Object.keys(qq.settings.wolt).forEach(key => {
            if (quantities.indexOf(key + "_a " + qq.quantity) === -1) {
              quantities.push("wolt_" + key + "_a " + qq.quantity);
              quantities.push("wolt_" + key + "_p " + qq.quantity);
            }
          });
        }
        if (foodpanda && qq && qq.settings && qq.settings.foodpanda) {
          Object.keys(qq.settings.foodpanda).forEach(key => {
            if (quantities.indexOf(key + "_a " + qq.quantity) === -1) {
              quantities.push("wolt_" + key + "_a " + qq.quantity);
              quantities.push("wolt_" + key + "_p " + qq.quantity);
            }
          });
        }
        if (falatozz && qq && qq.settings && qq.settings.falatozz) {
          Object.keys(qq.settings.falatozz).forEach(key => {
            if (quantities.indexOf(key + "_a " + qq.quantity) === -1) {
              quantities.push("wolt_" + key + "_a " + qq.quantity);
              quantities.push("wolt_" + key + "_p " + qq.quantity);
            }
          });
        }
        if (choiceqr && qq && qq.settings && qq.settings.choiceqr) {
          Object.keys(qq.settings.choiceqr).forEach(key => {
            if (quantities.indexOf(key + "_a " + qq.quantity) === -1) {
              quantities.push("choiceqr_" + key + "_a " + qq.quantity);
              quantities.push("choiceqr_" + key + "_p " + qq.quantity);
            }
          });
        }
        if (takeaway && qq && qq.settings && qq.settings.takeaway) {
          Object.keys(qq.settings.takeaway).forEach(key => {
            if (quantities.indexOf(key + "_a " + qq.quantity) === -1) {
              quantities.push("takeaway_" + key + "_a " + qq.quantity);
              quantities.push("takeaway_" + key + "_p " + qq.quantity);
            }
          });
        }
        if (m.defaultInventoryItem && q.quantity == menuitemutil.getInventoryQuantity(m))
          return;
        if (quantities.indexOf(q.quantity) === -1) {
          quantities.push(q.quantity)
        }

      })
    });
    stores.forEach(store => {
      quantities.push("a_" + store.name);
    })
    quantities.sort((a, b) => ("" + a).localeCompare("" + b));
    return array.map(m => {
      const path = menuitemutil._getPath(m).split("/");
      getLocale(m.name).split("/").forEach(() => path.pop());
      const iq = m.availableQuantities.find(q => q.quantity == menuitemutil.getInventoryQuantity(m));
      const c = {
        id: m.id,
        productOnMenu: m.isTop ? "yes" : "no",
        category: path.join("/"),
        name: getLocale(m.name),
        shortName: m.shortName,
        description: getLocale(m.description),
        manufacturer: m.manufacturer,
        quantityType: m.quantityType,
        freeQuantity: m.freeQuantity,
        imageSrc: m.image ? auth.server + "/eatwithme.server/tableService/1/getImage/" + m.image + "?instance=" + localStorage.instance : "",
        woltImageSrc: m.woltImage ? auth.server + "/eatwithme.server/tableService/1/getImage/" + m.woltImage + "?instance=" + localStorage.instance : "",
        foodpandaImageSrc: m.foodpandaImage ? auth.server + "/eatwithme.server/tableService/1/getImage/" + m.foodpandaImage + "?instance=" + localStorage.instance : "",
        falatozzImageSrc: m.falatozzImage ? auth.server + "/eatwithme.server/tableService/1/getImage/" + m.falatozzImage + "?instance=" + localStorage.instance : "",
        choiceqrImageSrc: m.choiceqrImage ? auth.server + "/eatwithme.server/tableService/1/getImage/" + m.choiceqrImage + "?instance=" + localStorage.instance : "",
        smallImageSrc: m.smallImage ? auth.server + "/eatwithme.server/tableService/1/getImage/" + m.smallImage + "?instance=" + localStorage.instance : "",
        fromDate: m.fromDate ? moment(m.fromDate).format("YYYY-MM-DD") : null,
        inventory: m.inventoryItem === true ? 'YES' : m.inventoryItem === false ? 'NO' : m.defaultInventoryItem ? 'yes' : 'no',
        "inventory quantity unit": menuitemutil.getInventoryQuantity(m),
        "inventory quantity price": iq && iq.localPrice,
        "inventory quantity price margin": iq && (iq.localPrice / iq.cost),
        "inventory quantity takeaway price": iq && iq.takeawayPrice,
        "inventory quantity takeaway price margin": iq && (iq.takeawayPrice / iq.cost),
        onMenu: !iq || iq.onMenu ? "yes" : "no",
        cost: iq ? iq.cost : 0,
        price: iq && iq.price ? iq.price : m.unitPrice ? m.unitPrice : 0,
        serving_name: getLocale(iq?.quantityType.name),
        label: m.labels.map(l => l.name).join(" / ")
      }
      stores.forEach(store => {
        const stock = stocks.find(stock => stock.menuItem.id === m.id && stock.store.id === store.id);
        if (stock) {
          c["s_" + store.name] = stock.count;
        }
      })
      quantities.forEach(quantity => {
        if (isNaN(quantity)) {
          c[quantity] = "";
          return;
        }
        c["qa " + quantity] = "-";
        c["qp " + quantity] = "";
        c["qs " + quantity] = "";
        const qq = m.availableQuantities.find(q => q.quantity == quantity);
        if (qq) {
          c["qa " + quantity] = qq.onMenu ? "yes" : "no";
          c["qp " + quantity] = qq.price;
          c["qs " + quantity] = getLocale(qq.quantityType.name);

        }
      })

      function f(quantity, settings, platform) {
        Object.keys(settings[platform]).forEach(key => {
          c[platform + "_" + key + "_a " + quantity] = settings[platform][key].enabled ? "yes" : "";
          c[platform + "_" + key + "_p " + quantity] = settings[platform][key].price;
        });
      }

      quantities.forEach(quantity => {
        if (isNaN(quantity)) return;
        const qq = m.availableQuantities.find(q => q.quantity == quantity);
        if (wolt && qq && qq.settings && qq.settings.wolt) {
          f(quantity, qq.settings, "wolt");
        }
        if (foodpanda && qq && qq.settings && qq.settings.foodpanda) {
          f(quantity, qq.settings, "foodpanda");
        }
        if (falatozz && qq && qq.settings && qq.settings.falatozz) {
          f(quantity, qq.settings, "falatozz");
        }
        if (choiceqr && qq && qq.settings && qq.settings.choiceqr) {
          f(quantity, qq.settings, "choiceqr");
        }
        if (takeaway && qq && qq.settings && qq.settings.takeaway) {
          f(quantity, qq.settings, "takeaway");
        }
      })

      const qq = m.availableQuantities.find(q => q.quantity == menuitemutil.getInventoryQuantity(m));
      if (wolt && qq && qq.settings && qq.settings.wolt) {
        f(qq.quantity, qq.settings, "wolt");
      }
      if (foodpanda && qq && qq.settings && qq.settings.foodpanda) {
        f(qq.quantity, qq.settings, "foodpanda");
      }
      if (falatozz && qq && qq.settings && qq.settings.falatozz) {
        f(qq.quantity, qq.settings, "falatozz");
      }
      if (choiceqr && qq && qq.settings && qq.settings.choiceqr) {
        f(qq.quantity, qq.settings, "choiceqr");
      }
      if (takeaway && qq && qq.settings && qq.settings.takeaway) {
        f(qq.quantity, qq.settings, "takeaway");
      }

      return c;
    })
  }

  $("#translate").click(function () {
    var node = menuitemutil.menuItems.getActiveNode();
    if (node) {
      if (node.data.entityType == menuitemutil.entityType + "Category") {
        get("restaurantService/" + localStorage.restaurantSelected + "/translateCategory/" + node.data.id + "/" + localStorage.languageSelected).done(data => {
          menuitemutil._reload(data);
        })
      } else {
        get("restaurantService/" + localStorage.restaurantSelected + "/translateMenuitem/" + node.data.id + "/" + localStorage.languageSelected).done(data => {
          menuitemutil._reload([data]);
        })
      }
    } else {
      get("restaurantService/" + localStorage.restaurantSelected + "/translateAll/" + localStorage.languageSelected).done(data => {
        menuitemutil._reload([data]);
      })
    }
  })

  $("#permanent-delete").click(function () {
    get("restaurantService/" + localStorage.restaurantSelected + "/permanent-delete", undefined, undefined, 200000, undefined, undefined, undefined, undefined, undefined, false).done(data => {
      menuitemutil._reload([data]);
    })
  });


  $("#upload").click(function () {
    $("#file").attr("files", "");
    $("#file").get(0).value = null;
    $("#file").click();
  });
  $("#foodorasync").click(function () {
    $("#foodorafile").attr("files", "");
    $("#foodorafile").get(0).value = null;
    $("#foodorafile").click();
  });
  $("#woltsync").click(function () {
    $("#woltfile").attr("files", "");
    $("#woltfile").get(0).value = null;
    $("#woltfile").click();
  });

  $("#foodorafile").change(foodorasync);
  $("#woltfile").change(woltsync);

  $("#file").change(function () {
    if (document.getElementById("file").files[0] == "") return;
    var reader = new FileReader();
    const fileName = document.getElementById("file").files[0].name;

    const fileNameShort = (fileName.indexOf(".") > -1 ? fileName.substring(0, fileName.lastIndexOf(".")) : fileName).replace(/[ ’'&]/g, "_").toLowerCase().normalize();

    const woltPlaces = auth.myStatus.restaurant_settings["enabled-features"]?.wolt?.places;
    const places = woltPlaces ? woltPlaces.map(w => w.name) : [];

    const woltName = woltPlaces ? woltPlaces.find(w => {
      const name = w.name.toLowerCase().replace(/[ ’'&]/g, "_").normalize();
      const equal = name == fileNameShort;
      return equal;
    })?.name.replace(/[ '&]/g, "_") || "wolt" : "wolt";
    reader.onload = () => {
      try {


        if (fileName.endsWith(".json")) {
          try {
            const json = JSON.parse(reader.result);
            // Directly process the JSON as menu data
            // Assume json.menu.categories and json.menu.items structure
            admin.getMenuItems((data) => {
              let categories = data.children;
              const menuCategories = json.menu.categories || [];
              const menuItems = json.items || json.menu.items || [];

              // Add categories from JSON if not present
              menuCategories.forEach(cat => {
                let categoryName = cat.name[0]?.value.replace(/\p{Emoji}/gu, "").trim();
                let category = categories.find(c => c.name && getLocale(c.name).toLowerCase() === (categoryName || '').toLowerCase());
                if (!category) {
                  category = {
                    recordState: "ACTIVE",
                    isActive: true,
                    isTop: true,
                    pos: true,
                    id: 0,
                    "settings": {
                      "wolt": { [woltName]: { enabled: true } },
                      "foodpanda": {},
                      "falatozz": {}
                    },
                    name: { "all": categoryName },
                    description: { "all": cat.description ? cat.description[0]?.value || '' : '' },
                    entityType: cat.drink ? "DrinkCategory" : "MealCategory",
                    children: [],
                    menuItems: []
                  };
                  categories.push(category);
                } else {
                  category.isActive = true;
                  category.isTop = true;
                  if (!category.settings) category.settings = {
                    "wolt": {},
                    "foodpanda": {},
                    "falatozz": {}
                  };
                  if (category.settings?.wolt) {
                    if (category.settings.wolt[woltName])
                      category.settings.wolt[woltName].enabled = true;
                    else
                      category.settings.wolt[woltName] = { enabled: true };
                  } else {
                    category.settings.wolt = { [woltName]: { enabled: true } };
                  }
                }
              });

              // Add menu items from JSON if not present
              menuItems.forEach(item => {
                const product = item.product || item;
                // Find category for this item
                let catId = null;
                for (const cat of menuCategories) {
                  if (item?._id?.$oid) {
                    if (cat.items.find(i => i.item_id.$oid === item?._id?.$oid)) {
                      catId = cat.name[0]?.value.trim().replace(/\p{Emoji}/gu, "") || '';
                      break;
                    }
                  } else if (cat.item_bindings && cat.item_bindings.some(b => b.item_id === item.id)) {
                    catId = cat.name[0]?.value.trim().replace(/\p{Emoji}/gu, "") || '';
                    break;
                  }
                }
                let category = categories.find(c => c.name && getLocale(c.name).toLowerCase() === (catId || '').toLowerCase());
                if (!category) {
                  // fallback: put in first category
                  category = categories[0];
                }
                if (!category) {
                  return;
                }
                let menuItem = category.children
                  ? category.children.find(m => m.name && getLocale(m.name).toLowerCase() === (product.name[0]?.value || '').toLowerCase())
                  : undefined;
                if (!menuItem) {
                  console.log("Menu item not found:", product.name[0]?.value || '');
                  menuItem = {
                    recordState: "ACTIVE",
                    id: 0,
                    isActive: true,
                    isTop: true,
                    pos: true,
                    name: { "all": product.name[0]?.value || '' },
                    description: { "all": product.description ? product.description[0]?.value || '' : '' },
                    //woltImageSrc: product.image_url || product.image || '',
                    imageSrc: product.image_url || product.image || '',
                    bigImageSrc: product.image_url || product.image || '',
                    entityType: category.entityType === "DrinkCategory" ? "Drink" : "Meal",
                    menuItemAdditions: [],
                    barcodes: [],
                    quantityType: "pcs",
                    availableQuantities:
                      [
                        {
                          "quantity": 1,
                          "price": "" + (item.price || item.baseprice) / 100,
                          "cost": 0,
                          "def": true,
                          "onMenu": true,
                          "online": true,
                          "available": true,
                          "inventoryItem": false,
                          "quantityType": {
                            "id": 1,
                            "name": {
                              "all": "portion",
                              "en": "portion",
                              "hu": "adag"
                            }
                          },
                          "settings": {
                            "wolt": { [woltName]: { enabled: true, price: "" + (item.price || item.baseprice) / 100 } },
                            "foodpanda": {},
                            "falatozz": {}
                          },
                          "containerCharge": 0,
                          "containerChargeOnsite": true,
                          "labelCount": 0,
                          "localPrice": 0,
                          "takeawayPrice": 0,
                          "costEstimation": 0,
                          "priceEstimation": 0,
                          "webshopPrice": 0
                        }
                      ]
                  }
                  if (!category.children) category.children = [];
                  category.children.push(menuItem);
                } else {
                  menuItem.isActive = true;
                  menuItem.isTop = true;
                  if (menuItem.availableQuantities && menuItem.availableQuantities.length == 0) {
                    menuItem.availableQuantities = [
                      {
                        "quantity": 1,
                        "price": "" + item.price / 100,
                        "cost": 0,
                        "def": true,
                        "onMenu": true,
                        "online": true,
                        "available": true,
                        "inventoryItem": false,
                        "quantityType": {
                          "id": 1,
                          "name": {
                            "all": "portion",
                            "en": "portion",
                            "hu": "adag"
                          }
                        },
                        "settings": {
                          "wolt": { [woltName]: { enabled: true, price: "" + item.price / 100 } },
                          "foodpanda": {}
                        },
                        "containerCharge": 0,
                        "containerChargeOnsite": true,
                        "labelCount": 0,
                        "localPrice": 0,
                        "takeawayPrice": 0,
                        "costEstimation": 0,
                        "priceEstimation": 0,
                        "webshopPrice": 0
                      }
                    ]
                  } else {
                    const quantity = menuItem.availableQuantities.find(q => q.quantity == 1) ? 1 : menuItem.availableQuantities[0]?.quantity || 1;
                    //menuItem.woltImageSrc = product.image_url || '';
                    if (!menuItem.quantityType)
                      menuItem.quantityType = "pcs";
                    if (!menuItem.availableQuantities.find(q => q.quantity == quantity).settings) {
                      menuItem.availableQuantities.find(q => q.quantity == quantity).settings = {
                        "wolt": {},
                        "foodpanda": {},
                        "falatozz": {}
                      };
                    }
                    if (menuItem.availableQuantities.find(q => q.quantity == quantity).settings?.wolt) {
                      if (menuItem.availableQuantities.find(q => q.quantity == quantity).settings?.wolt?.[woltName]) {
                        menuItem.availableQuantities.find(q => q.quantity == quantity).settings.wolt[woltName].price = "" + item.price / 100;
                        menuItem.availableQuantities.find(q => q.quantity == quantity).settings.wolt[woltName].enabled = true;
                      } else {
                        menuItem.availableQuantities.find(q => q.quantity == quantity).settings.wolt[woltName] = { enabled: true, price: "" + item.price / 100 };
                      }

                    } else {
                      menuItem.availableQuantities.find(q => q.quantity == quantity).settings.wolt = { [woltName]: { enabled: true, price: "" + item.price / 100 } };
                    }
                  }
                }
              });

              // Transform and upload
              function transform(menuCategories) {
                return menuCategories.map(existingCateg => {
                  var category = Object.assign({}, existingCateg);
                  category.menuCategories = category.children
                    ? transform(category.children.filter(c => c.entityType.endsWith("Category")))
                    : [];
                  category.menuItems = category.children
                    ? category.children.filter(c => c.entityType.endsWith("Category") === false).map(m => {
                      m.mainCategory = m.mainCategoryId;
                      m.subCategory = m.subCategoryId;
                      m.type = (m.entityType || menuitemutil.entityType).toLowerCase();
                      m.woltImageSrc = m.woltImageSrc || m.woltImage;
                      m.foodpandaImageSrc = m.foodpandaImageSrc || m.foodpandaImage;
                      m.falatozzImageSrc = m.falatozzImageSrc || m.falatozzImage;
                      m.imageSrc = m.imageSrc || m.image;
                      m.bigImageSrc = m.bigImageSrc || m.bigImage;
                      if (category.settings?.wolt?.[woltName]?.enabled === true) {
                        places.forEach(key => {
                          if (key != woltName) {
                            const quantity = m.availableQuantities.find(q => q.quantity == 1) ? 1 : m.availableQuantities[0]?.quantity || 1;
                            if (m.availableQuantities.length > 0) {
                              if (m.availableQuantities.find(q => q.quantity == quantity).settings?.wolt[key]?.enabled !== true) {
                                m.availableQuantities.find(q => q.quantity == quantity).settings.wolt[key] = { enabled: false, price: "" };
                              }
                            }
                          }
                        });
                      }
                      return m;
                    }) : [];
                  category.mainCategory = category.mainCategoryId;
                  category.subCategory = category.subCategoryId;
                  delete category.children;
                  category.type = (category.entityType || (menuitemutil.entityType + 'category')).toLowerCase();
                  return category;
                });
              }

              let base = transform(categories.filter(c => c.children.length > 0 && c.entityType === menuitemutil.entityType + "Category"));

              post("restaurantService/" + localStorage.restaurantSelected + "/update" + menuitemutil.entityType + "s", { menuCategories: base }, undefined, undefined, 2, undefined, 60000).done(function (data) {
                menuitemutil.reload();
              });
            });

            return;
          } catch (e) {
            console.error("Invalid JSON file:", e);
            return;
          }
        }
        if (fileName.endsWith(".csv")) {
          const workbook = window.XLSX.read(reader.result, {
            type: "string",
            FS: ";",
            RS: "\n",
            raw: true
          });
          var rowObject = [];
          workbook.SheetNames.forEach(sheet => {
            let json = window.XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]);
            console.log("Process worksheet " + sheet + " with " + json.length + " elements");
            admin.getMenuItems((data) => {
              let categories = data.children;
              var mainCategory = null;
              var subCategory = null;
              var lastMainCategoryName = null;
              var lastSubCategoryName = null;
              json.forEach((row, ind) => {
                if (ind % 100 === 0) console.log("Processing row " + ind + "/" + (json.length - 1));
                //console.log(row);

                const category1 = row.category1;
                const category2 = row.category2;
                mainCategory = category1 === lastMainCategoryName ? mainCategory :
                  categories.find(c => c.type === (menuitemutil.entityType.toLowerCase() + "category") && c.name && getLocale(c.name).toLowerCase() === (category1 || '').toLowerCase());
                if (!mainCategory) {
                  mainCategory = {
                    recordState: "ACTIVE",
                    type: (menuitemutil.entityType + "Category").toLowerCase(),
                    isActive: true,
                    isTop: true,
                    pos: true,
                    id: 0,
                    "settings": {
                      "wolt": { [woltName]: { enabled: true } },
                      "foodpanda": {},
                      "falatozz": {}
                    },
                    name: { "all": category1 || 'Uncategorized' },
                    description: { "all": '' },
                    entityType: menuitemutil.entityType + "Category",
                    children: [],
                  };
                  categories.push(mainCategory);
                }
                subCategory = category1 === lastMainCategoryName && category2 === lastSubCategoryName ? subCategory :
                  mainCategory.children.find(c => c.type === (menuitemutil.entityType.toLowerCase() + "category") && c.name && getLocale(c.name).toLowerCase() === (category2 || '').toLowerCase());
                lastMainCategoryName = category1;
                lastSubCategoryName = category2;
                if (!subCategory) {
                  subCategory = {
                    recordState: "ACTIVE",
                    type: (menuitemutil.entityType + "Category").toLowerCase(),
                    isActive: true,
                    isTop: true,
                    pos: true,
                    id: 0,
                    "settings": {
                      "wolt": { [woltName]: { enabled: true } },
                      "foodpanda": {},
                      "falatozz": {}
                    },
                    name: { "all": category2 || 'Uncategorized' },
                    description: { "all": '' },
                    entityType: menuitemutil.entityType + "Category",
                    children: []
                  };
                  mainCategory.children.push(subCategory);
                }

                if (!row?.quantity_type || row?.quantity_type.toLowerCase().trim() === "db") {
                  row.quantity_type = "pcs";
                }

                if (!availableQuantities.all.includes(row.quantity_type.toLowerCase().trim())) {
                  row.quantity_type = "pcs";
                }

                if (row.name.startsWith("\"") && row.name.endsWith("\"")) {
                  row.name = row.name.substring(1, row.name.length - 1);
                }

                row.name = row.name.replace(/\\/gu, "").trim();
                row.price = parseFloat(row.price.replace(/ /g, ""));
                row.cost = parseFloat(row.cost.replace(/ /g, ""));
                row.quantity = parseFloat(row.quantity.replace(/ /g, ""));

                var menuItem = subCategory.children.find(m => m.type === menuitemutil.entityType.toLowerCase() && m.name && getLocale(m.name).toLowerCase() === (row.name || '').toLowerCase());
                var barcode = [];
                if (row.barcode) {
                  barcode.push({ id: row.barcode });
                }
                if (row.quickcode) {
                  barcode.push({ id: row.quickcode });
                }
                if (!menuItem) {
                  menuItem = {
                    recordState: "ACTIVE",
                    type: menuitemutil.entityType.toLowerCase(),
                    entityType: menuitemutil.entityType,
                    id: 0,
                    isActive: true,
                    isTop: true,
                    pos: true,
                    name: { "all": row.name || '' },
                    description: { "all": row.description || '' },
                    //woltImageSrc: row.woltImageSrc || '',
                    imageSrc: row.imageSrc || '',
                    bigImageSrc: row.bigImageSrc || '',
                    menuItemAdditions: [],
                    barcodes: barcode,
                    quantityType: row?.quantity_type?.toLowerCase(),
                    vatCategory: auth.myStatus.restaurant_vat_categories.find(v => v.percent === Number(row.vat)),
                    availableQuantities: [{
                      "quantity": row.quantity || 1,
                      "price": "" + (row.price || 0),
                      "cost": row.cost,
                      "def": true,
                      "onMenu": true,
                      "online": true,
                      "available": true,
                      "inventoryItem": false,
                      "quantityType": {
                        "id": 13,
                      },
                      "settings": {
                        "wolt": { [woltName]: { enabled: true, price: row.price || 0 } },
                        "foodpanda": {},
                        "falatozz": {}
                      },
                    }],
                  };
                  subCategory.children.push(menuItem);
                } else {
                  menuItem.vatCategory = auth.myStatus.restaurant_vat_categories.find(v => v.percent === Number(row.vat));
                  menuItem.barcodes = barcode;
                  menuItem.availableQuantities = [{
                    "quantity": row.quantity || 1,
                    "price": row.price || 0,
                    "cost": row.cost,
                    "def": true,
                    "onMenu": true,
                    "online": true,
                    "available": true,
                    "inventoryItem": false,
                    "quantityType": {
                      "id": 13,
                    },
                    "settings": {
                      "wolt": { [woltName]: { enabled: true, price: row.price || 0 } },
                      "foodpanda": {},
                      "falatozz": {}
                    }
                  }];
                }
              });

              function transform(menuCategories) {
                return menuCategories.map(existingCateg => {
                  var category = Object.assign({}, existingCateg);
                  category.menuCategories = transform(category.children.filter(c => c.entityType === menuitemutil.entityType + "Category"));
                  category.menuItems = category.children.filter(c => c.entityType === menuitemutil.entityType).map(m => {
                    m.mainCategory = m.mainCategoryId;
                    m.subCategory = m.subCategoryId;
                    return m;
                  });
                  category.mainCategory = category.mainCategoryId;
                  category.subCategory = category.subCategoryId;
                  delete category.children;
                  return category;
                })
              }

              categories = transform(categories);
              /*
              function transform2(menuCategories) {
                return menuCategories.filter(c => c.recordState !== "DELETED").map(category => {
                  category.menuItems = category.menuItems.filter(c => c.recordState !== "DELETED");
                  category.menuCategories = transform2(category.menuCategories.filter(c => c => c.recordState !== "DELETED"));
                  return category;
                })
              }
              categories = { menuCategories: transform2(categories) };*/
              post("restaurantService/" + localStorage.restaurantSelected + "/update" + menuitemutil.entityType + "s", { menuCategories: categories }, undefined, undefined, 2, undefined, 60000).done(function (data) {
                menuitemutil.reload();
              });
            });

          }, undefined, true);
          return;
        }

        var node = menuitemutil.menuItems.getActiveNode();
        var menuCategory = node ? admin.getMenuCategoryAdmin(node.data.id) : null;

        var workbook = window.XLSX.read(reader.result, { type: "binary" });

        admin.getMenuItems((data) => {

          let rowObject = [];

          if (workbook.SheetNames.find(sheet => sheet === "Adatbázis1")) {
            console.log("this is a planteen worksheet");
            var log = "";
            workbook.SheetNames.filter(sheet => sheet.startsWith("P")).forEach(s => {
              const sheet = workbook.Sheets[s];
              const name = sheet.B2.v.trim();
              const receiptUnit = sheet.B8.v;
              var menuItem = findMenuItemByName(data.children, name);
              if (!menuItem) {
                menuItem = findMenuItemByName(data.children, name, true);
              }
              if (menuItem) {
                console.log(">>>", name, receiptUnit, menuItem)
                menuItem.menuItemAdditions = data.menuItemAdditions ? menuItem.menuItemAdditions.filter(a => a.additionType != "mandatory") : [];
                for (let rownr = 11; sheet["A" + rownr] && sheet["B" + rownr]; rownr++) {
                  try {
                    const ingredient = sheet["A" + rownr].v.trim();
                    const quantity = sheet["B" + rownr].v;
                    const ingredientMenuItem = findMenuItemByName(data.children, ingredient);
                    if (ingredientMenuItem) {
                      console.log(ingredient, quantity);
                      menuItem.mandatory_volume = receiptUnit ? receiptUnit : 1;
                      menuItem.menuItemAdditions.push(
                        {
                          "id": 0,
                          "type": "meal_addition",
                          "quantity": quantity,
                          "additionType": "mandatory",
                          "proportional": true,
                          "takeaway": true,
                          "local": true,
                          "order": menuItem.menuItemAdditions.length,
                          "addition": {
                            "type": ingredientMenuItem.entityType.toLowerCase(),
                            "id": ingredientMenuItem.id
                          }
                        });

                    } else {
                      console._error("Ingredient not found for ", "'" + ingredient + "'");
                      log += "Ingredient not found for '" + ingredient + "'<br/>";
                    }
                  } catch (ex) {
                    console._error(ex);
                    console.log("B" + rownr, sheet["B" + rownr])
                    log += "B" + rownr + " error: " + ex + "\n";
                  }
                }
                console.log(">>>>>>", name, receiptUnit, menuItem)
              } else {
                console._error(s, "Menu item not found with name", "'" + name + "'");
                log += s + ": Menu item not found with name '" + name + "'<br/>"
              }

            });

            function transform(menuCategories) {
              return menuCategories.map(existingCateg => {
                var category = Object.assign({}, existingCateg);
                category.menuCategories = transform(category.children.filter(c => c.entityType === menuitemutil.entityType + "Category"));
                category.menuItems = category.children.filter(c => c.entityType === menuitemutil.entityType).map(m => {
                  m.type = m.entityType.toLowerCase();
                  m.mainCategory = m.mainCategoryId;
                  m.subCategory = m.subCategoryId;
                  if (m.image && !m.imageSrc)
                    m.imageSrc = menuitemutil.getImageUrl(m.image)
                  if (m.bigImage && !m.bigImageSrc)
                    m.bigImageSrc = menuitemutil.getImageUrl(m.bigImage)
                  return m;
                });
                if (category.image && !category.imageSrc)
                  category.imageSrc = menuitemutil.getImageUrl(category.image)
                category.mainCategory = category.mainCategoryId;
                category.subCategory = category.subCategoryId;
                delete category.children;
                category.type = category.entityType.toLowerCase();
                return category;
              })
            }
            confirmDialog(I18n.t("local.error_message"), log).done(() => {

              post("restaurantService/" + localStorage.restaurantSelected + "/update" + menuitemutil.entityType + "s", { menuCategories: transform(data.children) }, undefined, undefined, 2, undefined, 60000).done(function (data) {
                // eslint-disable-next-line no-restricted-globals
                menuitemutil.reload();
              });
            });
            return;
          }

          workbook.SheetNames.forEach(sheet => {
            let json = window.XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]);
            console.log("Process worksheet " + sheet + " with " + json.length + " elements");
            json.forEach(a => rowObject.push(a));
          }, undefined, true);

          var base = [];

          var node = menuitemutil.menuItems.getActiveNode();
          if (node) {
            const menuCategory = admin.getMenuCategoryAdmin(node.data.id);

            base = Object.assign([], data.children);
          }


          function transform(menuCategories) {
            return menuCategories.map(existingCateg => {
              var category = Object.assign({}, existingCateg);
              category.menuCategories = transform(category.children.filter(c => c.entityType === menuitemutil.entityType + "Category"));
              category.menuItems = category.children.filter(c => c.entityType === menuitemutil.entityType).map(m => {
                m.type = m.entityType.toLowerCase();
                m.mainCategory = m.mainCategoryId;
                m.subCategory = m.subCategoryId;
                return m;
              });
              category.mainCategory = category.mainCategoryId;
              category.subCategory = category.subCategoryId;
              delete category.children;
              category.type = category.entityType.toLowerCase();
              return category;
            })
          }

          base = transform(base);

          if (menuCategory) {
            const path = menuitemutil._getPath(menuCategory);
            rowObject.forEach(row => { row.category = row.category.trim() });
            rowObject = rowObject.filter(row => row.category.startsWith(path));
          }

          let jsonObject = convert(rowObject, data.children, base);

          function transform2(menuCategories) {
            return menuCategories.filter(c => c.recordState !== "DELETED").map(category => {
              category.menuItems = category.menuItems.filter(c => c.recordState !== "DELETED");
              category.menuCategories = transform2(category.menuCategories.filter(c => c => c.recordState !== "DELETED"));
              return category;
            })
          }
          jsonObject = { menuCategories: transform2(jsonObject.menuCategories) };

          post("restaurantService/" + localStorage.restaurantSelected + "/update" + menuitemutil.entityType + "s", jsonObject, undefined, undefined, 2, undefined, 60000).done(function (data) {
            // eslint-disable-next-line no-restricted-globals
            menuitemutil.reload();
          });

        });


        /*
          const newmenuItems = JSON.parse(reader.result);
          */
      } catch (ex) {
        console.error(ex);
      }

    }


    //if (file) {
    if (fileName.endsWith(".json") || fileName.endsWith(".csv")) {
      reader.readAsText(document.getElementById("file").files[0]);
    } else {
      reader.readAsBinaryString(document.getElementById("file").files[0]);
    }
  });
};

function extractProductsToCSV(menuJson, lang = "hu") {
  const categories = menuJson.menu.categories;
  const items = menuJson.menu.items;

  // Map item_id to category info
  const itemToCategory = {};
  categories.forEach(cat => {
    if (cat.item_bindings) {
      cat.item_bindings.forEach(binding => {
        itemToCategory[binding.item_id] = {
          category: (cat.name.find(n => n.lang === lang) || cat.name[0]).value,
          categoryDescription: cat.description
            ? (cat.description.find(d => d.lang === lang) || cat.description[0]).value
            : "",
          categoryImage: cat.image_url || ""
        };
      });
    }
  });

  // Prepare CSV header
  let csv = "Product Name,Category,Category Description,Product Description,Image URL\n";

  items.forEach(item => {
    const product = item.product;
    const name = (product.name.find(n => n.lang === lang) || product.name[0]).value;
    const description = product.description
      ? (product.description.find(d => d.lang === lang) || product.description[0]).value
      : "";
    const image = product.image_url || "";
    const catInfo = itemToCategory[item.id] || { category: "", categoryDescription: "", categoryImage: "" };

    csv += `"${name}","${catInfo.category}","${catInfo.categoryDescription}","${description}","${image}"\n`;
  });

  return csv;
}

const convert = (menuItems, menuCategories, base = []) => {
  const categories = { menuCategories: base };
  menuItems.forEach(menuitem => {
    var categs = categories.menuCategories;
    var category;
    var children = menuCategories;
    menuitem.category.split("/").forEach(categname => {
      const existingCateg = categs.find(c => c.entityType === menuitemutil.entityType + "Category" && getLocale(c.name) === getLocale(categname));
      if (!existingCateg) {
        category = findOrCreateCategory(categname, children);
        category.type = menuitemutil.entityType.toLowerCase() + "category";
        delete category.children;
        category.menuItems = [];
        category.menuCategories = [];
        children = category.oldMenuCategories;
        categs.push(category);
      } else {
        category = existingCateg;
        children = existingCateg.oldMenuCategories;
      }
      categs = category.menuCategories;
    })
    const m = findOrCreateMenuItem(menuitem, menuCategories);
    var existing = category.menuItems.find(m1 => (m1.id && m.id && m1.id === m.id) || getLocale(m.name) === getLocale(m1.name));
    if (existing)
      category.menuItems = category.menuItems.map(m1 => (m1.id && m.id && m1.id === m.id) || getLocale(m.name) === getLocale(m1.name) ? m : m1);
    else category.menuItems.push(m);
  })
  return categories;
}

function findOrCreateCategory(name, categories) {
  const category = categories?.find(c => getLocale(c.name) === name && c.entityType === menuitemutil.entityType + "Category");
  if (category) {
    const catcopy = JSON.parse(JSON.stringify(category));
    catcopy.oldMenuCategories = catcopy.children;
    return catcopy;
  }
  const n = {};
  n[localStorage.language] = name;
  const newcat = {
    name: n,
    isActive: true,
    isTop: true,
    kiosk: true,
    entityType: menuitemutil.entityType + "Category",
    oldMenuCategories: []
  }
  // categories.push(newcat);
  return newcat;
}

function _findOrCreateMenuItem(menuitem, categories, base) {
  var m;

  categories.forEach(c_m => {
    if (c_m.entityType === menuitemutil.entityType + "Category") {
      var m1 = _findOrCreateMenuItem(menuitem, c_m.children, base);
      if (m1) {
        if (!m || !m.id)
          m = m1;
      }
    } else if (c_m.entityType === menuitemutil.entityType) {
      if (c_m.id === menuitem.id || (!c_m.id && menuitemutil.getPath(c_m, { children: base }) + c_m.dateFrom === menuitem.category + "/" + menuitem.name)) {
        if (!m || !m.id) {
          m = c_m;
        }
      }
    }
  })

  return m;
}

function findOrCreateMenuItem(menuitem, categories) {
  var m = _findOrCreateMenuItem(menuitem, categories, categories);

  if (m) {
    m = JSON.parse(JSON.stringify(m));
    m.type = menuitemutil.entityType.toLowerCase();
  } else {
    m = {
      "recordState": "ACTIVE",
      "name": {},
      "settings": {
        "foodpanda": {},
        "wolt": {},
        "falatozz": {},
        "choiceqr": {},
        "takeaway": {}
      },
      shortName: "",
      "available": true,
      "freeQuantity": false,
      barcodes: [],
      "inventoryItem": null,
      "timing": "inherit",
      "productionLines": [],
      "vatCategory": null,
      "takeawayVatCategory": null,
      "availableQuantities": [],
      "hasImage": false,
      "type": menuitemutil.entityType.toLowerCase(),
      isActive: true
    };
  }
  m.recordState = "ACTIVE";
  m.manufacturer = menuitem.manufacturer;
  m.name[localStorage.language] = menuitem.name;
  m.quantityType = menuitem.quantityType;
  m.image = menuitem.image ? getImageById(menuitem.image) : null;
  m.bigImage = menuitem.bigImage ? getImageById(menuitem.bigImage) : null;
  m.unitPrice = Number(menuitem.price);
  if (menuitem.freeQuantity === false)
    m.freeQuantity = false;
  else if (menuitem.freeQuantity === true)
    m.freeQuantity = true;

  if (typeof menuitem.shortName !== "undefined" || menuitem.shortName !== undefined) {
    m.shortName = menuitem.shortName
  } else {
    m.shortName = "";
  }

  if (menuitem.fromDate) {
    if (isNaN(menuitem.fromDate)) {
      const d = moment(menuitem.fromDate).startOf("day");
      m.fromDate = d.valueOf();
    } else {
      const d = moment('1900-01-01').add(Number(menuitem.fromDate - 2), "day");
      m.fromDate = d.valueOf();
    }
  }

  m.inventoryItem = menuitem.inventory == "yes" ? true : menuitem.inventory == "no" ? false : null;
  m.labels = [];
  if (menuitem.label)
    menuitem.label.split("/").forEach(l => {
      if (l.trim()) {
        l = l.trim();
        if (m.labels.find(label => label.name.trim() === l))
          return;
        m.labels.push({ name: l })
      }
    })
  const inventoryQuantity = Number(menuitem["inventory quantity unit"]);
  var q = menuitemutil.getInventoryQuantity(m, inventoryQuantity);
  if (!q)
    q = inventoryQuantity;
  m.availableQuantities = [];
  if (q && !isNaN(inventoryQuantity)) {
    const qq = m.availableQuantities.find(qq => qq.quantity === q);
    if (qq) {
      qq.price = Number(menuitem.price);
      qq.cost = Number(menuitem.cost);
      qq.quantity = inventoryQuantity;
      qq.onMenu = menuitem.onMenu === "yes";
      qq.def = true;
      qq.quantityType = auth.myStatus.restaurant_quantity_types.find(q => getLocale(q.name) === menuitem.serving_name)
    } else {
      const quantityType = auth.myStatus.restaurant_quantity_types.find(q => getLocale(q.name) === menuitem.serving_name);
      m.availableQuantities.push(
        {
          "quantity": inventoryQuantity,
          "price": menuitem.price ? Number(menuitem.price) : "",
          cost: Number(menuitem.cost),
          "onMenu": menuitem.onMenu === undefined || menuitem.onMenu === "yes",
          "online": false,
          "available": true,
          "inventoryItem": true,
          def: true,
          quantityType: quantityType ? quantityType : { id: 1 },
          "settings": {
            "foodpanda": {},
            "wolt": {},
            "falatozz": {}
          },
        }
      )
    }
  }

  Object.keys(menuitem).forEach(key => {
    if (key.startsWith("qa")) {
      var quantity = Number(key.split(" ")[1]);
      const qq = m.availableQuantities.find(qq => qq.quantity === quantity);
      if (qq) {
        if (menuitem[key] === "-") {
          m.availableQuantities = m.availableQuantities.filter(qqq => qqq !== qq);
          return;
        } else {
          qq.onMenu = menuitem[key] === "yes";
          qq.price = "";
        }
      } else if (menuitem[key] !== "-") {
        if (!quantity || isNaN(quantity)) {
          console.log("hoppa");
        }
        const serving_name = menuitem[key.replace(/qa/g, "qs")];
        const quantityType = auth.myStatus.restaurant_quantity_types.find(q => getLocale(q.name) === serving_name);
        m.availableQuantities.push(
          {
            "quantity": quantity,
            "price": "",
            "onMenu": menuitem[key] === "yes",
            "online": false,
            "available": true,
            "inventoryItem": false,
            "quantityType": quantityType ? quantityType : {
              "id": 1
            },
            "settings": {
              "foodpanda": {},
              "wolt": {},
              "falatozz": {}
            },
          }
        )
      }
    }
    if (key.startsWith("qp")) {
      const keys = key.split(" ");
      const pp = keys[1];
      const quantity = Number(pp);
      const qq = m.availableQuantities.find(qq => qq.quantity === quantity);
      if (qq) {
        if (menuitem[key])
          qq.price = Number(menuitem[key]);
        else
          qq.price = "";
      }
    }
  })

  const columns = ["id", "category", "name", "manufacturer", "quantityType", "inventory quantity", "cost", "price", "description"];

  Object.keys(menuitem).forEach(key => {
    if (key.startsWith("qa") || key.startsWith("qp") || columns.indexOf(key) !== -1)
      return;
    const platform = key.split(" ")[0].split("_")[0];
    if (platform != "takeaway" && platform != "wolt" && platform != "foodpanda" && platform != "falatozz" && platform != "choiceqr")
      return;
    var thirdpartyname = key.split(" ")[0].split("_")[1];
    const thirdpartyfield = key.split(" ")[0].split("_")[2];
    var thirdpartyquantity = key.split(" ")[1];

    if (!thirdpartyname)
      thirdpartyname = platform;

    if (!thirdpartyquantity)
      thirdpartyquantity = inventoryQuantity;

    const quantity = Number(thirdpartyquantity);
    const qq = m.availableQuantities.find(qq => qq.quantity === quantity);
    if (qq) {
      if (!qq.settings) {
        qq.settings = { foodpanda: {}, wolt: {}, takeaway: {}, falatozz: {}, choiceqr: {} };
      }
      if (!qq.settings[platform]) qq.settings[platform] = {};
      if (thirdpartyfield === "a" && menuitem[key]) {
        qq.settings[platform][thirdpartyname] = { enabled: menuitem[key] === "yes", price: "" };
      } else if (thirdpartyfield === "p" && menuitem[key])
        if (qq.settings[platform][thirdpartyname])
          qq.settings[platform][thirdpartyname].price = menuitem[key];
    }
  })
  m.isTop = menuitem.productOnMenu === undefined || menuitem.productOnMenu === "yes";
  m.name[localStorage.language] = menuitem.name;
  if (menuitem.description) {
    if (!m.description) m.description = {};
    m.description[localStorage.language] = menuitem.description;
  }

  if (menuitem.imageSrc) {
    m.imageSrc = menuitem.imageSrc;
  }
  if (menuitem.foodpandaImageSrc) {
    m.foodpandaImageSrc = menuitem.foodpandaImageSrc;
  }
  if (menuitem.woltImageSrc) {
    m.woltImageSrc = menuitem.woltImageSrc;
  }
  if (menuitem.falatozzImageSrc) {
    m.falatozzImageSrc = menuitem.falatozzImageSrc;
  }
  if (menuitem.smallImageSrc) {
    m.smallImageSrc = menuitem.smallImageSrc;
  }
  if (menuitem.choiceqrImageSrc) {
    m.choiceqrImageSrc = menuitem.choiceqrImageSrc;
  }

  return m;
}

function findMenuItemByName(children, name, startWith) {
  for (let i in children) {
    const c = children[i];
    if (c.entityType === menuitemutil.entityType) {
      //console.log(getLocale(c.manufacturer+" "+c.name, "hu").trim().toLowerCase(), "?=", name);
      if (startWith) {
        var n = ((c?.manufacturer || "").toLowerCase() + " " + getLocale(c.name, "hu")).replace(/ /g, "").trim().replace(/\(\d+\)/g, "").replace(/ +,/g, ",").trim().toLowerCase();
        n = n.trim();
        //console.log(n);
        if (n.startsWith(name.trim().replace(/ /g, "").toLowerCase()) || name.replace(/ /g, "").trim().toLowerCase().startsWith(n)) {
          return c;
        }
        var m1 = getLocale(c.name, "hu").match(/(\d+) /);
        var m2 = name.match(/(\d+) /);
        if (m1 && m2 && m1[1] == m2[1]) {
          return c;
        }
      } else if ((c.manufacturer + " " + getLocale(c.name, "hu")).trim().toLowerCase() === name.toLowerCase()) {
        return c;
      }
    } else if (c.entityType === menuitemutil.entityType + "Category") {
      const r = findMenuItemByName(c.children, name, startWith);
      if (r)
        return r;
    }
  }
}

function foodorasync() {
  if (document.getElementById("foodorafile").files[0] == "") return;
  var reader = new FileReader();

  reader.onload = () => {
    try {

      function replaceCommasInQuotes(text) {
        return text.replace(/"([^"\n\r]*)"/g, (match, p1) => `"${p1.replace(/,/g, '###')}"`);
      }

      const text = replaceCommasInQuotes(reader.result).replaceAll('"', "");
      //console.log(text);

      var workbook = window.XLSX.read(text, { type: "binary", raw: false, /*codepage: 65001*/ });




      admin.getMenuItems((data) => {
        let rowObject = [];
        const encoder = new TextEncoder("UTF-8");
        const decoder = new TextDecoder();
        workbook.SheetNames.forEach(sheet => {
          let json = window.XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]);
          console.log("Process worksheet " + sheet + " with " + json.length + " elements");
          json.forEach(a => rowObject.push(a));

        }, undefined, true);


        rowObject.filter(row => {
          var name = row.Title_hu_HU;
          if (!name) {
            console.log("Row skipped", row);
            return;
          }
          name = name.replaceAll("###", ",").trim();
          var menuItem = findMenuItemByName(data.children, name);
          if (!menuItem) {
            menuItem = findMenuItemByName(data.children, name, true);
          }
          if (menuItem) {
            if (row.Description_hu_HU)
              menuItem.description.hu = row.Description_hu_HU.replaceAll("###", ",");
            if (row.Description_en) {
              menuItem.description.en = row.Description_en.replaceAll("###", ",");
            }
            if (!menuItem.name.en && row.Title_en) {
              menuItem.name.en = row.Title_en.replaceAll("###", ",");
            }

            var image = row.Image_URL;

            if (!image || !image.indexOf || image.indexOf("https:") === -1) {
              image = Object.values(row).find(v => v.indexOf && v.indexOf("https:") >= 0);
            }
            console.log(name, image, row);

            if (image && !menuItem.image) {
              menuItem.foodpandaImageSrc = image;
            } else {
              menuItem.foodpandaImageSrc = menuItem.foodpandaImage;
            }

            const aq = (menuItem.availableQuantities.find(q => q.quantity == 1));

            if (aq && row.Price) {
              const place = getFeature("foodpanda")?.places?.[0]?.name;
              var setting = aq?.settings?.foodpanda?.[place];
              if (!setting) {
                if (!aq?.settings) {
                  aq.settings = { foodpanda: {}, wolt: {}, falatozz: {}, choiceqr: {}, takeaway: {}, webshop: {} };
                }
                if (!aq.settings.foodpanda[place])
                  setting = aq.settings.foodpanda[place] = {
                    enabled: true,
                  }
              }
              setting.price = row.Price
              setting.enabled = true
            }
            //console.log(name, "=>", menuItem?.id, row, menuItem);
          } else
            if (row.Image_URL)
              console.log(name, "=> not found but has image in foodora");
        })

        function transform(menuCategories) {
          return menuCategories.map(existingCateg => {
            var category = Object.assign({}, existingCateg);
            category.menuCategories = transform(category.children.filter(c => c.entityType === menuitemutil.entityType + "Category"));
            category.menuItems = category.children.filter(c => c.entityType === menuitemutil.entityType).map(m => {
              m.type = m.entityType.toLowerCase();
              m.mainCategory = m.mainCategoryId;
              m.subCategory = m.subCategoryId;
              if (m.image && !m.imageSrc)
                m.imageSrc = menuitemutil.getImageUrl(m.image)
              if (m.bigImage && !m.bigImageSrc)
                m.bigImageSrc = menuitemutil.getImageUrl(m.bigImage)
              if (m.woltImage && !m.woltImageSrc) m.woltImageSrc = m.woltImage;
              if (m.foodpandaImage && !m.foodpandaImageSrc) m.foodpandaImageSrc = m.foodpandaImage;
              m.falatozzImageSrc = m.falatozzImage;
              return m;
            });
            if (category.image && !category.imageSrc)
              category.imageSrc = menuitemutil.getImageUrl(category.image)
            category.mainCategory = category.mainCategoryId;
            category.subCategory = category.subCategoryId;
            delete category.children;
            category.type = category.entityType.toLowerCase();
            return category;
          })
        }

        post("restaurantService/" + localStorage.restaurantSelected + "/update" + menuitemutil.entityType + "s", { menuCategories: transform(data.children) }, undefined, undefined, 2, undefined, 60000).done(function (data) {
          // eslint-disable-next-line no-restricted-globals
          menuitemutil.reload();
        });
      });
    } catch (ex) {
      console.log(ex);
    }

  }

  if (document.getElementById("foodorafile").files[0].type === "text/csv")
    reader.readAsText(document.getElementById("foodorafile").files[0]);
  else
    reader.readAsBinaryString(document.getElementById("foodorafile").files[0]);

}

function woltsync() {
  if (document.getElementById("woltfile").files[0] == "") return;
  var reader = new FileReader();

  reader.onload = () => {
    try {

      var workbook = window.XLSX.read(reader.result, { type: "binary", raw: false, /*codepage: 65001*/ });

      admin.getMenuItems((data) => {
        let rowObject = [];
        const encoder = new TextEncoder("UTF-8");
        const decoder = new TextDecoder();
        workbook.SheetNames.forEach(sheet => {
          let json = window.XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]);
          console.log("Process worksheet " + sheet + " with " + json.length + " elements");
          json.forEach(a => rowObject.push(a));

        }, undefined, true);

        rowObject.filter(row => {
          const name = row.name;
          if (!name) {
            console.log("Row skipped", row);
            return;
          }
          var menuItem = findMenuItemByName(data.children, name);
          if (!menuItem) {
            console.log("Not found " + name);
            menuItem = findMenuItemByName(data.children, name, true);
          }
          if (menuItem) {
            if (!menuItem.description.hu && row.description)
              menuItem.description.hu = row.description;


            if (row.image_url/* && !menuItem.woltImage*/) {
              menuItem.woltImageSrc = row.image_url;
            } else {
              menuItem.woltImageSrc = menuItem.woltImage;
            }

            const aq = (menuItem.availableQuantities.find(q => q.quantity == 1));

            if (aq && row.price) {
              const place = getFeature("wolt")?.places?.[0]?.name;
              var setting = aq?.settings?.wolt?.[place];
              if (!setting) {
                if (!aq?.settings) {
                  aq.settings = { wolt: {}, wolt: {}, falatozz: {}, takeaway: {}, webshop: {} };
                }
                if (!aq.settings.wolt[place])
                  setting = aq.settings.wolt[place] = {
                    enabled: true,
                  }
              }
              setting.price = row.price
              setting.enabled = true
            }
            //console.log(name, "=>", menuItem?.id, row, menuItem);
          } else
            if (row.image_url)
              console.log(name, "=> not found but has image in wolt");
        })

        function transform(menuCategories) {
          return menuCategories.map(existingCateg => {
            var category = Object.assign({}, existingCateg);
            category.menuCategories = transform(category.children.filter(c => c.entityType === menuitemutil.entityType + "Category"));
            category.menuItems = category.children.filter(c => c.entityType === menuitemutil.entityType).map(m => {
              m.type = m.entityType.toLowerCase();
              m.mainCategory = m.mainCategoryId;
              m.subCategory = m.subCategoryId;
              if (m.image && !m.imageSrc)
                m.imageSrc = menuitemutil.getImageUrl(m.image)
              if (m.bigImage && !m.bigImageSrc)
                m.bigImageSrc = menuitemutil.getImageUrl(m.bigImage)
              if (m.woltImage && !m.woltImageSrc) m.woltImageSrc = m.woltImage;
              if (m.foodpandaImage && !m.foodpandaImageSrc) m.foodpandaImageSrc = m.foodpandaImage;
              m.falatozzImageSrc = m.falatozzImage;
              return m;
            });
            if (category.image && !category.imageSrc)
              category.imageSrc = menuitemutil.getImageUrl(category.image)
            category.mainCategory = category.mainCategoryId;
            category.subCategory = category.subCategoryId;
            delete category.children;
            category.type = category.entityType.toLowerCase();
            return category;
          })
        }

        post("restaurantService/" + localStorage.restaurantSelected + "/update" + menuitemutil.entityType + "s", { menuCategories: transform(data.children) }, undefined, undefined, 2, undefined, 60000).done(function (data) {
          // eslint-disable-next-line no-restricted-globals
          menuitemutil.reload();
        });
      });
    } catch (ex) {
      console.log(ex);
    }

  }

  if (document.getElementById("woltfile").files[0].type === "text/csv")
    reader.readAsText(document.getElementById("woltfile").files[0]);
  else
    reader.readAsBinaryString(document.getElementById("woltfile").files[0]);

}


function activateMenuItem(active) {
  var data = menuitemutil.menuItems.getActiveNode().data;
  if (data.entityType.indexOf("Category") < 0) {
    utils.activateMenuItem(data.id, active, menuitemutil.reload);
  } else {
    utils.activateMenuCategory(data.id, active, menuitemutil.reload);
  }
}

function deleteMenuItem() {
  var data = menuitemutil.menuItems.getActiveNode().data;
  if (data.entityType.indexOf("Category") < 0) {
    utils.deleteMenuItem(data.id, menuitemutil.reload);
  } else {
    utils.deleteMenuCategory(data.id, menuitemutil.reload);
  }
}
menuitemutil.deleteMenuItem = deleteMenuItem;

menuitemutil.getImageUrl = (id) => {
  return auth.server + "/" + auth.war + "/adminService/" + localStorage.restaurantSelected + "/getImage/" + id;
}

function getActiveModal(selector) {
  const visibleModal = $(selector).filter(":visible").last();
  if (visibleModal.length) {
    return visibleModal;
  }
  return $(selector).last();
}

function isModalTransitioning(modal) {
  if (!modal || !modal.length) {
    return false;
  }

  const bsModal = modal.data("bs.modal") || modal.data("modal");
  if (!bsModal) {
    return false;
  }

  return !!(bsModal._isTransitioning || bsModal.isTransitioning || bsModal.transitioning);
}

function hideModalWhenReady(modal, timeoutMs = 10000) {
  const startedAt = Date.now();

  const tick = () => {
    if (!modal || !modal.length) {
      return;
    }

    const elapsed = Date.now() - startedAt;
    if (!isModalTransitioning(modal) || elapsed >= timeoutMs) {
      modal.modal("hide");
      return;
    }

    setTimeout(tick, 25);
  };

  tick();
}

function saveMenuCategory(onsave, test = false) {
  var modal = getActiveModal("div#editMenuCategory");
  var sm = $(modal.find("img#smallImage"));
  if ($.data(sm.get(0), "rcrop")) {
    crop(sm);
  }
  var id = modal.find("#cid").val();
  var globalId = modal.find("#calias").val();
  var parentCategoryId = Number(modal.find("#cparentCategoryId").val());
  var name = {};
  modal.find(".categoryName").each(function (ind, v) {
    if ($(v).val() != "") {
      name[$(v).attr("lang")] = $(v).val();
    }
  });

  if (!name.all && !name[auth.myStatus.restaurant_settings["default-language"]]) {
    modal.find(".categoryName[lang='all']").removeClass("highlight-3");
    modal.find(".categoryName[lang='" + auth.myStatus.restaurant_settings["default-language"] + "']").removeClass("highlight-3");
    setTimeout(() => {
      modal.find(".categoryName[lang='all']").addClass("highlight-3");
      modal.find(".categoryName[lang='" + auth.myStatus.restaurant_settings["default-language"] + "']").addClass("highlight-3");
      modal.find(".categoryName[lang='all']").focus();
    }, 10);
    modal.find(".categoryName[lang='all']").focus();
    return;
  }


  var description = {};
  modal.find(".description").each(function (ind, v) {
    if ($(v).val() != "") {
      description[$(v).attr("lang")] = $(v).val();
    }
  });
  var timing = modal.find("#ctiming").val()[0];
  if (timing === "") {
    timing = null;
  }
  if (!parentCategoryId && (!timing || timing === "inherit")) {
    modal.find("#ctiming").removeClass("highlight-3");
    setTimeout(() => {
      modal.find("#ctiming").addClass("highlight-3");
      modal.find("#ctiming").focus();
    }, 10);
    return;
  }
  var production_lines = [];
  modal.find("div#production_lines input:checked").each(function (ind, pl) {
    production_lines.push(
      $(pl)
        .attr("id")
        .substring(4)
    );
  });

  var mainCategory = modal.find("#cntak_main_category").val();
  if (!mainCategory) mainCategory = 0;
  var subCategory = modal.find("#cntak_sub_category").val();
  if (!subCategory) subCategory = 0;

  var vat_category = modal.find("#cvat_category").val()[0];
  if (!vat_category) vat_category = -1;

  if (!parentCategoryId && vat_category === -1) {
    modal.find("#cvat_category").removeClass("highlight-3");
    setTimeout(() => {
      modal.find("#cvat_category").addClass("highlight-3");
      modal.find("#cvat_category").focus();
    }, 10);
    return;
  }

  var takeaway_vat_category = modal.find("#ctakeaway_vat_category").val()[0];
  if (!takeaway_vat_category) takeaway_vat_category = -1;

  var image = $(modal.find("#smallImage")).attr("src");
  if (image == "") image = null;
  var active = modal.find("#mc_active").prop("checked");
  var type = modal.find("#modal-type").val();
  var isTop = modal.find("#mc_isTop").prop("checked");
  var pos = modal.find("#mc_pos").prop("checked");
  var kiosk = modal.find("#mc_kiosk").prop("checked");
  var above18 = modal.find("#mc_above18").prop("checked");
  var online = modal.find("#mc_online").prop("checked");
  var local = modal.find("#mc_local").prop("checked");
  var takeaway = modal.find("#mc_takeaway").prop("checked");
  var settings = { wolt: {}, foodpanda: {}, falatozz: {}, choiceqr: {} };
  modal.find(".onMenuThirdParty:checked").each((ind, item) => {
    settings[$(item).attr("party")][item.name] = { enabled: true };
  })

  var fromDate = moment(modal.find('input#from_date').val()).toDate().getTime();
  var toDate = moment(modal.find('input#to_date').val()).toDate().getTime();
  var preorder = modal.find("#mc_preorder").prop("indeterminate") ? null : modal.find("#mc_preorder").prop("checked");

  var allergens = modal.find("#category_allergens >*.has:not(.removable)").map((ind, item) => item.id).toArray();
  var removable_allergens = modal.find("#category_allergens >*.has.removable").map((ind, item) => item.id).toArray();

  var available = modal.find("#mc_available").prop("checked");
  var inventoryItem = modal.find("#mc_isInventoryItem").prop("indeterminate") ? null : modal.find("#mc_isInventoryItem").prop("checked");
  var pricePerCostRatio = menuitemutil.parseNumber(modal.find("input#cpricePerCostRatio").val()) / 100;
  var color = modal.find("#color").find("input#colorCheckbox").prop('checked') ? modal.find("#color").find("input#color").val() : null;
  if (color == "") color = null;
  var menuItemAdditions = [];
  var menuCategoryAdditions = [];
  var a = modal.find("#category_additions_mandatory");
  var ok = true;
  var order = 0;
  modal
    .find("#category_additions_mandatory")
    .tokenize2()
    .toArray()
    .forEach(function (addition) {
      var quantity = modal.find("#category_additions_mandatory");
      quantity = quantity.next();
      quantity = modal.find('li.token[data-value="' + addition + '"] input').val();
      var id = addition.split(";");
      id.push(quantity);
      if (id[0] == "menuItem") {
        var quantity = modal.find('li[data-value="' + addition + '"] input#quantity').val();
        if (typeof quantity == "undefined") quantity = id[3];
        if (!quantity || isNaN(quantity) || quantity == 0) {
          ok = false;
          modal.find('li[data-value="' + addition + '"]').removeClass("highlight-3");
          setTimeout(() => {
            modal.find('li[data-value="' + addition + '"]').addClass("highlight-3");
            modal.find('li[data-value="' + addition + '"] input#quantity').focus();
          }, 100)

        }
        var menuItem = menuitemutil.getMenuItem(id[2]);
        if (menuItem)
          menuItemAdditions.push({
            id: id[1],
            addition: {
              id: id[2],
              type: menuItem.entityType.toLowerCase()
            },
            order: order++,
            proportional: modal.find('li.token[data-value="' + addition + '"] input.proportional').prop('checked'),
            local: modal.find('li.token[data-value="' + addition + '"] input.local').prop('checked'),
            takeaway: modal.find('li.token[data-value="' + addition + '"] input.takeaway').prop('checked'),
            type: menuItem.entityType.toLowerCase() + "_addition",
            additionType: "mandatory",
            quantity: quantity
          });
      } else {
        var menuItem = menuitemutil.getMenuCategory(id[2]);
        menuCategoryAdditions.push({
          id: id[1],
          addition: {
            id: id[2],
            type: menuItem.entityType.toLowerCase()
          },
          order: order++,
          proportional: modal.find('li.token[data-value="' + addition + '"] input.proportional').prop('checked'),
          type: menuItem.entityType.toLowerCase() + "_addition",
          additionType: "mandatory",
          min: modal.find('li.token[data-value="' + addition + '"] input#min').val(),
          max: modal.find('li.token[data-value="' + addition + '"] input#max').val()
        });
      }
    });
  order = 0;
  modal
    .find("#category_additions_included")
    .tokenize2()
    .toArray()
    .forEach(function (addition) {
      var id = addition.split(";");
      if (id[0] == "menuItem") {
        var quantity = modal.find('li[data-value="' + addition + '"] input#quantity').val();
        if (typeof quantity == "undefined") quantity = id[3];
        if (!quantity || isNaN(quantity) || quantity == 0) {
          ok = false;
          modal.find('li[data-value="' + addition + '"]').removeClass("highlight-3");
          setTimeout(() => {
            modal.find('li[data-value="' + addition + '"]').addClass("highlight-3");
            modal.find('li[data-value="' + addition + '"] input#quantity').focus();
          }, 100)
        }
        var menuItem = menuitemutil.getMenuItem(id[2]);
        if (menuItem)
          menuItemAdditions.push({
            id: id[1],
            addition: {
              id: id[2],
              type: menuItem.entityType.toLowerCase()
            },
            order: order++,
            proportional: modal.find('li.token[data-value="' + addition + '"] input.proportional').prop('checked'),
            local: modal.find('li.token[data-value="' + addition + '"] input.local').prop('checked'),
            takeaway: modal.find('li.token[data-value="' + addition + '"] input.takeaway').prop('checked'),
            type: menuItem.entityType.toLowerCase() + "_addition",
            additionType: "included",
            quantity: quantity
          });
      } else {
        var menuItem = menuitemutil.getMenuCategory(id[2]);
        if (menuItem)
          menuCategoryAdditions.push({
            id: id[1],
            addition: {
              id: id[2],
              type: menuItem.entityType.toLowerCase()
            },
            order: order++,
            proportional: modal.find('li.token[data-value="' + addition + '"] input.proportional').prop('checked'),
            type: menuItem.entityType.toLowerCase() + "_addition",
            additionType: "included",
            min: modal.find('li.token[data-value="' + addition + '"] input#min').val(),
            max: modal.find('li.token[data-value="' + addition + '"] input#max').val()
          });
      }
    });
  order = 0;
  modal
    .find("#category_additions_optional")
    .tokenize2()
    .toArray()
    .forEach(function (addition) {
      var id = addition.split(";");
      if (id[0] == "menuItem") {
        var menuItem = menuitemutil.getMenuItem(id[2]);
        var quantity = modal.find('li[data-value="' + addition + '"] input#quantity').val();
        if (typeof quantity == "undefined") quantity = id[3];
        if (!quantity || isNaN(quantity) || quantity == 0) {
          ok = false;
          modal.find('li[data-value="' + addition + '"]').removeClass("highlight-3");
          setTimeout(() => {
            modal.find('li[data-value="' + addition + '"]').addClass("highlight-3");
            modal.find('li[data-value="' + addition + '"] input#quantity').focus();
          }, 100)
        }
        menuItemAdditions.push({
          id: id[1],
          addition: {
            id: id[2],
            type: id[4].toLowerCase()
          },
          order: order++,
          proportional: modal.find('li.token[data-value="' + addition + '"] input.proportional').prop('checked'),
          local: modal.find('li.token[data-value="' + addition + '"] input.local').prop('checked'),
          takeaway: modal.find('li.token[data-value="' + addition + '"] input.takeaway').prop('checked'),
          type: id[4].toLowerCase() + "_addition",
          additionType: "optional",
          quantity: quantity
        });
      } else {
        var menuItem = menuitemutil.getMenuCategory(id[2]);
        var optionType = modal.find('input[id="check' + addition + '"]').prop("checked") ? "multiple" :
          modal.find('input[id="check2' + addition + '"]').prop("checked") ? "separate" :
            modal.find('input[id="radio' + addition + '"]').prop("checked") ? "maxone" : "one";
        menuCategoryAdditions.push({
          id: id[1],
          addition: {
            id: id[2],
            type: id[4].toLowerCase()
          },
          order: order++,
          proportional: modal.find('li.token[data-value="' + addition + '"] input.proportional').prop('checked'),
          type: id[4].toLowerCase() + "_addition",
          additionType: "optional",
          optionType: optionType,
          min: modal.find('li.token[data-value="' + addition + '"] input#min').val(),
          max: modal.find('li.token[data-value="' + addition + '"] input#max').val()
        });
      }
    });
  appendUpsellAdditionsFromSelection(modal, menuItemAdditions, menuCategoryAdditions);
  var labels = [];
  modal
    .find("#category_labels")
    .tokenize2({
      tokensAllowCustom: true
    })
    .toArray()
    .forEach(function (addition) {
      if (addition.indexOf(";") !== -1) {
        var id = addition.split(";");
        labels.push({
          id: id[1]
        });
      } else {
        labels.push({
          id: 0,
          name: addition
        });
      }
    });


  if (test) {
    const r = {
      name,
      globalId,
      parentCategoryId,
      description,
      image,
      timing,
      productionLines: production_lines,
      vatCategory: { id: vat_category },
      takeawayVatCategory: { id: takeaway_vat_category },
      isActive: active,
      isTop,
      pos,
      kiosk,
      above18,
      online,
      local,
      takeaway,
      available,
      inventoryItem,
      menuItemAdditions,
      menuCategoryAdditions,
      labels,
      pricePerCostRatio,
      color,
      settings,
      fromDate,
      toDate,
      preorder,
      mainCategory,
      subCategory,
      allergens,
      removable_allergens
    };
    return r;
  }

  if (!ok)
    return;
  if (id) {
    const d = {
      id,
      type: type.toLowerCase(),
      globalId: globalId || null,
      name,
      description,
      image,
      timing,
      productionLines: production_lines,
      vatCategory: { id: vat_category },
      takeawayVatCategory: { id: takeaway_vat_category },
      isActive: active,
      isTop,
      pos,
      kiosk,
      above18,
      online,
      local,
      takeaway,
      available,
      inventoryItem,
      menuItemAdditions,
      menuCategoryAdditions,
      labels,
      pricePerCostRatio,
      color,
      settings,
      fromDate,
      toDate,
      preorder,
      mainCategory,
      subCategory,
      allergens,
      removable_allergens
    };

    if (menuitemutil.restaurantToUpdate) {
      menuitemutil.getLocalFromGlobal({ globalId: menuitemutil.restaurantToUpdate }).done(id => {
        const { restaurant, data } = connectedRestaurants[menuitemutil.restaurantToUpdate];
        const categoryId = getMenuCategory(menuitemutil.data)?.globalId;
        post(restaurant.serverUrl + auth.war + "/" + restaurant.instance + "/mergeService/" + id + "/" + (categoryId || 0) + "/modifyCategory?instance=" + restaurant.instance, d).done(() => {
          hideModalWhenReady(modal);
          menuitemutil._reload();
        });
      });
    } else {
      const oldParentCategoryId = menuitemutil.data && menuitemutil.data.menuCategoryId !== undefined && menuitemutil.data.menuCategoryId !== null
        ? Number(menuitemutil.data.menuCategoryId)
        : Number(JSON.parse(menuitemutil.oldMenuCategoryData || "{}").parentCategoryId || 0);
      const newParentCategoryId = Number(parentCategoryId || 0);
      const shouldMoveParent = oldParentCategoryId !== newParentCategoryId;

      const getSiblingOrderIds = targetParentCategoryId => {
        const ids = [];
        const tree = menuitemutil.menuItems;
        if (!tree || !tree.getRootNode) {
          return ids;
        }

        const rootNode = tree.getRootNode();
        let parentNode = rootNode;

        if (targetParentCategoryId > 0) {
          rootNode.visit(node => {
            if (node?.data?.id === targetParentCategoryId && node?.data?.entityType?.indexOf("Category") >= 0) {
              parentNode = node;
              return false;
            }
            return true;
          });
        }

        (parentNode.children || []).forEach(node => {
          ids.push(node.data.entityType == menuitemutil.entityType ? 0 : 1);
          ids.push(node.data.id);
        });

        return ids;
      };

      utils.modifyMenuCategory(
        d,
        function (savedCategory) {
          const finishSave = () => {
            hideModalWhenReady(modal);
            onsave();
          };

          if (!shouldMoveParent) {
            finishSave();
            return;
          }

          // The move endpoint expects top-level as -1.
          const setParentCategoryId = newParentCategoryId > 0 ? newParentCategoryId : -1;
          utils.setMenuCategoryParentCategory(savedCategory.id, setParentCategoryId, () => {
            const ids = getSiblingOrderIds(newParentCategoryId);
            if (!ids.length) {
              finishSave();
              return;
            }
            utils.updateMenuItemOrders(ids, finishSave, finishSave);
          }, finishSave);
        }
      );
    }
  } else {
    utils.addMenuCategory(
      parentCategoryId,
      {
        globalId,
        name,
        description,
        image,
        timing,
        productionLines: production_lines,
        vatCategory: { id: vat_category },
        takeawayVatCategory: { id: takeaway_vat_category },
        isActive: active,
        isTop,
        pos,
        kiosk,
        above18,
        online,
        local,
        takeaway,
        available,
        inventoryItem,
        menuItemAdditions,
        menuCategoryAdditions,
        labels,
        pricePerCostRatio,
        color,
        settings,
        fromDate,
        toDate,
        preorder,
        mainCategory,
        subCategory,
        allergens,
        removable_allergens
      },
      function (data) {
        hideModalWhenReady(modal);
        onsave().done(() => {
          menuitemutil.menuItems.activateKey(data.entityType + data.id);
        });
      }
    );
  }
}
menuitemutil.saveMenuCategory = saveMenuCategory;

function saveMenuItemAndNew(onsave) {
  saveMenuItem(onsave, true).done(() => {
    var modal = $("div#editMenuItem");
    modal.find(".menuItemName").each(function (ind, v) {
      $(v).val("");
    });
    modal.find("textarea.description").each(function (ind, v) {
      $(v).val("");
    });
    modal.find("#id").val("");
    modal.find("#alias").val("");
    modal.find("#smallImage").attr("src", null);
    modal.find("input#short_name").val("");
  });
}

menuitemutil.saveMenuItemAndNew = saveMenuItemAndNew;

function saveMenuItem(onsave, keep, test = false, force = {}) {
  const def = $.Deferred();
  if (keep == undefined) keep = false;
  var modal = getActiveModal("div#editMenuItem");
  var sm = $(modal.find("img#smallImage"));
  if ($.data(sm.get(0), "rcrop")) {
    crop(sm);
  }
  var id = modal.find("#id").val();
  var type = modal.find("#modal-type").val();
  var globalId = modal.find("#alias").val() || null;
  var action = modal.find("#action").val();
  var parentCategoryId = modal.find("#parentCategoryId").val();
  var shortName = modal.find("input#short_name").val();
  var manufacturer = modal.find("input#manufacturer").val();
  var mandatory_volume = Number(modal.find("input#mandatory_volume").val());
  var name = {};
  modal.find(".menuItemName").each(function (ind, v) {
    if ($(v).val() != "") {
      name[$(v).attr("lang")] = $(v).val();
    }
  });
  var description = {};
  modal.find(".description").each(function (ind, v) {
    if ($(v).val() != "") {
      description[$(v).attr("lang")] = $(v).val();
    }
  });
  var timing = modal.find("#timing").val()[0];
  var production_lines = [];
  modal.find("div#production_lines input:checked").each(function (ind, pl) {
    production_lines.push(
      $(pl)
        .attr("id")
        .substring(4)
    );
  });
  var mainCategory = modal.find("#mntak_main_category").val();
  if (!mainCategory) mainCategory = 0;
  var subCategory = modal.find("#mntak_sub_category").val();
  if (!subCategory) subCategory = 0;

  var vat_category = modal.find("#vat_category").val()[0];
  if (!vat_category) vat_category = -1;
  var takeaway_vat_category = modal.find("#takeaway_vat_category").val()[0];
  if (!takeaway_vat_category) takeaway_vat_category = -1;
  var quantityType = menuitemutil.getQuantityType ? menuitemutil.getQuantityType(modal) : (modal.find("#quantityTypeSelect").val() || [])[0];
  var unitPrice = modal.find("#unit_price").val();
  var minimumPrice = $("#editMenuItem input#menuItem_minimumPrice").prop("checked");
  var cost = modal.find("#unit_cost").val();
  var image = $(modal.find("#smallImage")).attr("src");
  if (image == "") image = null;
  var allergens = modal.find("#allergens >*.has:not(.removable)").map((ind, item) => item.id).toArray();
  var removable_allergens = modal.find("#allergens >*.has.removable").map((ind, item) => item.id).toArray();
  var calorie = modal.find('input#calorie').val();

  var woltImage = $(modal.find("#smallImageWolt")).attr("src");
  if (woltImage == "") woltImage = null;

  var foodpandaImage = $(modal.find("#smallImageFoodpanda")).attr("src");
  if (foodpandaImage == "") foodpandaImage = null;

  var falatozzImage = $(modal.find("#smallImageFalatozz")).attr("src");
  if (falatozzImage == "") falatozzImage = null;

  var choiceqrImage = $(modal.find("#smallImageChoiceqr")).attr("src");
  if (choiceqrImage == "") choiceqrImage = null;

  var bigImage = $(modal.find("#smallImage")).data("bigImage");
  var active = modal.find("#mi_active").prop("checked");
  var isTop = modal.find("#mi_isTop").prop("checked");
  var pos = modal.find("#mi_pos").prop("checked");
  var kiosk = modal.find("#mi_kiosk").prop("checked");
  var above18 = modal.find("#above18").prop("checked");
  var freeQuantity = !modal.find("#mi_freequantity").prop("checked");
  var online = modal.find("#mi_online").prop("checked");
  var available = modal.find("#mi_available").prop("checked");
  var color = modal.find("#color").find("input#colorCheckbox").prop('checked') ? modal.find("#color").find("input#color").val() : null;
  if (color == "") color = null;
  var inventoryItem = modal.find("#mi_isInventoryItem").prop("indeterminate") ? undefined : modal.find("#mi_isInventoryItem").prop("checked");
  var pricePerCostRatio = menuitemutil.parseNumber(modal.find("input#pricePerCostRatio").val()) / 100;
  var availableQuantities = [];

  var fromDate = moment(modal.find('input#m_from_date').val()).toDate().getTime();
  var toDate = moment(modal.find('input#m_to_date').val()).toDate().getTime();
  var preorder = modal.find("#m_preorder").prop("indeterminate") ? null : modal.find("#m_preorder").prop("checked");


  const places = { foodpanda: {}, wolt: {}, falatozz: {}, choiceqr: {}, kiosk: {} };

  if (!name.all && !name[auth.myStatus.restaurant_settings["default-language"]]) {
    modal.find(".menuItemName[lang='all']").removeClass("highlight-3");
    modal.find(".menuItemName[lang='" + auth.myStatus.restaurant_settings["default-language"] + "']").removeClass("highlight-3");
    setTimeout(() => {
      modal.find(".menuItemName[lang='all']").addClass("highlight-3");
      modal.find(".menuItemName[lang='" + auth.myStatus.restaurant_settings["default-language"] + "']").addClass("highlight-3");
      modal.find(".menuItemName[lang='all']").focus();
    }, 10);
    modal.find(".menuItemName[lang='all']").focus();
    return def.promise();
  }

  const menuCategory = admin.getMenuCategoryAdmin(parentCategoryId);

  if (quantityType == null) {
    modal.find("#quantityType").removeClass("highlight-3");
    setTimeout(() => {
      modal.find("#quantityType").addClass("highlight-3");
      modal.find("#quantityType").focus();
    }, 10);
    modal.find("#quantityType").focus();
    return def.promise();
  }

  var quantities = [];
  var ok = true;
  var barcodes = [];
  if (menuItemQuantities.getRootNode().getChildren() != null)
    menuItemQuantities
      .getRootNode()
      .getChildren()
      .forEach(function (node) {
        if (!ok) return;
        var labels = {};

        if ($(node.tr).find("td").length <= 1) {
          return;
        } 

        $(node.tr)
          .find("input.menuItemTypeName")
          .each(function (ind, n) {
            if ($(n).val() != null && $(n).val() != "") labels[$(n).attr("lang")] = $(n).val();
          });
        var q = $(node.tr)
          .find("#menuItem_quantity")
          .val();

        if (quantities.indexOf(q) != -1) {
          messageDialog(I18n.t("local.error_message"), I18n.t("admin_local.quantity_must_be_unique")).done(() => {
            $("#editMenuItem #menuItem_quantity").removeClass("highlight-3");
            setTimeout(() => {
              $("#editMenuItem #menuItem_quantity").addClass("highlight-3");
              $("#editMenuItem #menuItem_quantity").focus();
            }, 10);
          });
          ok = false;
          return;
        }
        quantities.push(q);

        var p = $(node.tr)
          .find("#menuItem_price")
          .val();
        if (p == 0) {
          p = "";
        }
        var cost = $(node.tr).find("#menuItem_cost").val();
        var inventoryItem = $(node.tr).find("input.inventoryItem").prop("checked");
        var onMenu = $(node.tr).find("input.onMenu").prop("checked");
        var def = node.selected == true ? true : false;
        var quantityType2 = $(node.tr).find("#quantityType option:selected").attr("id");
        const settings = { foodpanda: {}, wolt: {}, falatozz: {}, choiceqr: {}, takeaway: {}, webshop: {}, kiosk: {} };
        var containerCharge = $(node.tr).find("input.menuItem_containerCharge").val() || undefined;
        var containerChargeOnsite = $(node.tr).find("input.menuItem_containerChargeOnsite").prop("checked");
        var labelCount = $(node.tr).find("input.menuItem_labelCount").val() || 0;

        $(node.tr).find(".thirdParty[type='checkbox']").each((ind, item) => {
          const parent = $(item).parent();
          const type = parent.attr('type');
          const name = $(item).parent().attr("name");
          if (type)
            settings[type][name] = {
              enabled: $(item).prop("checked"),
              price: $(item).parents("tr").find("input#menuItem_price_" + type + "_" + name).val()
            };
        });

        var promotionName = $(node.tr).find("input#menuItem_promotional_name").val();
        var promotionPrice = $(node.tr).find("input#menuItem_promotional_price").val();
        var promotionStart = $(node.tr).find("input#menuItem_promotional_start_date").val();
        var promotionEnd = $(node.tr).find("input#menuItem_promotional_end_date").val();

        if (q)
          availableQuantities.push({
            quantity: q,
            price: p,
            quantityType: { id: quantityType2 },
            def: def,
            onMenu: onMenu,
            inventoryItem: inventoryItem,
            cost: cost,
            settings: settings,
            containerCharge: containerCharge,
            containerChargeOnsite: containerChargeOnsite,
            labelCount: labelCount,
            promotionName,
            promotionPrice,
            promotionStart,
            promotionEnd
          });
        else {
          /* this is an error, quantity must be defined */
          ok = false;
          $(node.tr).find('input#menuItem_quantity').removeClass("highlight-3");
          setTimeout(() => {
            $(node.tr).find('input#menuItem_quantity').addClass("highlight-3");
            $(node.tr).find('input#menuItem_quantity').focus();
          }, 100);
        }
      });

  if (!test && quantityType !== "none" && inventoryItem !== false && (inventoryItem === true || menuCategory.defaultInventoryItem) && availableQuantities.filter(q => q.inventoryItem).length == 0) {
    messageDialog(I18n.t("local.error_message"), I18n.t("admin_local.no_inventory_quantity_selected"));
    modal.find("input.inventoryItem + label").removeClass("highlight-3");
    setTimeout(() => {
      modal.find("input.inventoryItem + label").addClass("highlight-3");
      modal.find("input.inventoryItem").focus();
    }, 100);
    return;
  }

  if (!test && !force.inventoryItem && inventoryItem !== false && (inventoryItem === true || menuCategory.defaultInventoryItem) && availableQuantities.filter(q => q.inventoryItem).length > 1) {
    const new_q = availableQuantities.filter(q => q.inventoryItem).length;
    const old_q = id && admin.getMenuItemAdmin(id).availableQuantities.filter(q => q.inventoryItem).length;
    if (new_q != old_q) {
      modal.find("input.inventoryItem + label").removeClass("highlight-3");
      setTimeout(() => {
        modal.find("input.inventoryItem + label").addClass("highlight-3");
        modal.find("input.inventoryItem").focus();
      }, 100);
      confirmDialog(I18n.t("local.error_message"), I18n.t("admin_local.multiple_inventory_quantity_selected")).done(() => {
        saveMenuItem(onsave, keep, test, { ...force, inventoryItem: true });
      });
      return;
    }
  }

  modal
    .find("#item_barcodes")
    .tokenize2()
    .toArray()
    .forEach(function (barcode, ind) {
      barcodes.push({ id: barcode.replace("`", "0"), quantity: 0 })
    });

  if (!ok && !test) return def.promise();
  var menuItemAdditions = [];
  var menuCategoryAdditions = [];
  var order = 0;
  modal
    .find("#item_additions_mandatory")
    .tokenize2()
    .toArray()
    .forEach(function (addition, ind) {
      var quantity = modal.find("#item_additions_mandatory");
      quantity = quantity.next();
      quantity = modal.find('li.token[data-value="' + addition + '"] input').val();
      var id = addition.split(";");
      id.push(quantity);
      if (id[0] == "menuItem") {
        var quantity = modal.find('li[data-value="' + addition + '"] input#quantity').val();
        if (typeof quantity == "undefined") quantity = id[3];
        if (!quantity || isNaN(quantity) || quantity == 0) {
          ok = false;
          modal.find('li[data-value="' + addition + '"]').removeClass("highlight-3");
          setTimeout(() => {
            modal.find('li[data-value="' + addition + '"]').addClass("highlight-3");
            modal.find('li[data-value="' + addition + '"] input#quantity').focus();
          }, 100)
        }
        menuItemAdditions.push({
          id: id[1],
          addition: {
            id: id[2],
            type: id[4].toLowerCase()
          },
          order: order++,
          proportional: modal.find('li.token[data-value="' + addition + '"] input.proportional').prop('checked'),
          local: modal.find('li.token[data-value="' + addition + '"] input.local').prop('checked'),
          takeaway: modal.find('li.token[data-value="' + addition + '"] input.takeaway').prop('checked'),
          type: id[4].toLowerCase() + "_addition",
          additionType: "mandatory",
          quantity: quantity / mandatory_volume
        });
      } else {
        menuCategoryAdditions.push({
          id: id[1],
          addition: {
            id: id[2],
            type: id[4].toLowerCase()
          },
          order: order++,
          proportional: modal.find('li.token[data-value="' + addition + '"] input.proportional').prop('checked'),
          type: id[4].toLowerCase() + "_addition",
          additionType: "mandatory",
          min: modal.find('li.token[data-value="' + addition + '"] input#min').val(),
          max: modal.find('li.token[data-value="' + addition + '"] input#max').val()
        });
      }
    });
  order = 0;
  modal
    .find("#item_additions_included")
    .tokenize2()
    .toArray()
    .forEach(function (addition) {
      var quantity = modal.find('li[data-value="' + addition + '"] input#quantity').val();
      var id = addition.split(";");
      if (id[0] == "menuItem") {
        if (typeof quantity == "undefined") {
          quantity = id[3];
        } else if (!quantity || isNaN(quantity) || quantity == 0) {
          ok = false;
          modal.find('li[data-value="' + addition + '"]').removeClass("highlight-3");
          setTimeout(() => {
            modal.find('li[data-value="' + addition + '"]').addClass("highlight-3");
            modal.find('li[data-value="' + addition + '"] input#quantity').focus();
          }, 100)
        }
        menuItemAdditions.push({
          id: id[1],
          addition: {
            id: id[2],
            type: id[4].toLowerCase()
          },
          order: order++,
          proportional: modal.find('li.token[data-value="' + addition + '"] input.proportional').prop('checked'),
          local: modal.find('li.token[data-value="' + addition + '"] input.local').prop('checked'),
          takeaway: modal.find('li.token[data-value="' + addition + '"] input.takeaway').prop('checked'),
          type: id[4].toLowerCase() + "_addition",
          additionType: "included",
          quantity: quantity
        });
      } else {
        menuCategoryAdditions.push({
          id: id[1],
          addition: {
            id: id[2],
            type: id[4].toLowerCase()
          },
          order: order++,
          proportional: modal.find('li.token[data-value="' + addition + '"] input.proportional').prop('checked'),
          type: id[4].toLowerCase() + "_addition",
          additionType: "included",
          min: modal.find('li.token[data-value="' + addition + '"] input#min').val(),
          max: modal.find('li.token[data-value="' + addition + '"] input#max').val()
        });
      }
    });
  order = 0;
  modal
    .find("#item_additions_optional")
    .tokenize2()
    .toArray()
    .forEach((addition, ind) => {
      var quantity = modal.find('li[data-value="' + addition + '"] input#quantity').val();
      var id = addition.split(";");
      if (id[0] == "menuItem") {
        if (typeof quantity == "undefined") {
          quantity = id[3];
        } else if (!quantity || isNaN(quantity) || quantity == 0) {
          ok = false;
          modal.find('li[data-value="' + addition + '"]').removeClass("highlight-3");
          setTimeout(() => {
            modal.find('li[data-value="' + addition + '"]').addClass("highlight-3");
            modal.find('li[data-value="' + addition + '"] input#quantity').focus();
          }, 100)
        }
        menuItemAdditions.push({
          id: id[1],
          addition: {
            id: id[2],
            type: id[4].toLowerCase()
          },
          order: order++,
          proportional: modal.find('li.token[data-value="' + addition + '"] input.proportional').prop('checked'),
          local: modal.find('li.token[data-value="' + addition + '"] input.local').prop('checked'),
          takeaway: modal.find('li.token[data-value="' + addition + '"] input.takeaway').prop('checked'),
          type: id[4].toLowerCase() + "_addition",
          additionType: "optional",
          quantity: quantity
        });
      } else {
        var optionType = modal.find('input[id="check' + addition + '"]').prop("checked") ? "multiple" :
          modal.find('input[id="check2' + addition + '"]').prop("checked") ? "separate" :
            modal.find('input[id="radio' + addition + '"]').prop("checked") ? "maxone" : "one";
        menuCategoryAdditions.push({
          id: id[1],
          addition: {
            id: id[2],
            type: id[4].toLowerCase()
          },
          order: order++,
          proportional: modal.find('li.token[data-value="' + addition + '"] input.proportional').prop('checked'),
          type: id[4].toLowerCase() + "_addition",
          additionType: "optional",
          optionType: optionType,
          min: modal.find('li.token[data-value="' + addition + '"] input#min').val(),
          max: modal.find('li.token[data-value="' + addition + '"] input#max').val()
        });
      }
    });
  appendUpsellAdditionsFromSelection(modal, menuItemAdditions, menuCategoryAdditions);
  var labels = [];
  modal
    .find("#item_labels")
    .tokenize2({
      tokensAllowCustom: true
    })
    .toArray()
    .forEach(function (addition) {
      if (addition.indexOf(";") !== -1) {
        var id = addition.split(";");
        labels.push({
          id: id[1]
        });
      } else {
        labels.push({
          id: 0,
          name: addition
        });
      }
    });
  if (!ok && !test) return def.promise();

  const newContent = {
    id,
    parentCategoryId,
    globalId,
    barcodes,
    action,
    shortName,
    manufacturer,
    name,
    description,
    image,
    bigImage,
    quantityType,
    cost,
    unitPrice,
    availableQuantities,
    timing,
    productionLines: production_lines,
    vatCategory: { id: vat_category },
    takeawayVatCategory: { id: takeaway_vat_category },
    active,
    isTop,
    pos,
    kiosk,
    above18,
    online,
    available,
    inventoryItem,
    freeQuantity,
    menuItemAdditions,
    menuCategoryAdditions,
    labels,
    pricePerCostRatio,
    color,
    mandatory_volume,
    places,
    preorder,
    toDate,
    fromDate,
    mainCategory,
    subCategory,
    woltImage,
    foodpandaImage,
    falatozzImage,
    choiceqrImage,
    minimumPrice,
    allergens,
    removable_allergens,
    calorie
  }

  if (test) {
    return newContent;
  }

  modal.find('#save').prop('disabled', true);
  modal.find('#saveAndNew').prop('disabled', true);
  modal.find('#saveAndOpen').prop('disabled', true);

  if (id != "") {
    const newMenuItemAdditionReceipe = newContent.menuItemAdditions && newContent.menuItemAdditions.filter(a => a.additionType === "mandatory" || a.additionType === "included").filter(a => admin.getMenuItemAdmin(a.addition.id).defaultInventoryItem);
    var oldMenuItemAdditionReceipe = {};
    try {
      oldMenuItemAdditionReceipe = JSON.parse(menuitemutil.oldMenuItemData).menuItemAdditions.filter(a => a.additionType === "mandatory" || a.additionType === "included").filter(a => admin.getMenuItemAdmin(a.addition.id).defaultInventoryItem);
    } catch (ex) { }
    if (menuitemutil.oldMenuItemData !== JSON.stringify(newContent)) {
      const send = (recalculateInventory = false) => {
        const d = {
          type: type.toLowerCase(),
          id,
          globalId,
          barcodes,
          action,
          shortName,
          manufacturer,
          name,
          description,
          image,
          bigImage,
          quantityType,
          cost,
          unitPrice,
          availableQuantities,
          timing,
          productionLines: production_lines,
          vatCategory: { id: vat_category },
          takeawayVatCategory: { id: takeaway_vat_category },
          isActive: active,
          isTop,
          pos,
          kiosk,
          above18,
          online,
          available,
          inventoryItem,
          freeQuantity,
          menuItemAdditions,
          menuCategoryAdditions,
          labels,
          pricePerCostRatio,
          color,
          mandatory_volume,
          places,
          preorder,
          toDate,
          fromDate,
          mainCategory,
          subCategory,
          woltImage,
          foodpandaImage,
          falatozzImage,
          choiceqrImage,
          minimumPrice,
          allergens,
          removable_allergens,
          calorie
        }
        if (menuitemutil.restaurantToUpdate) {
          menuitemutil.getLocalFromGlobal({ globalId: menuitemutil.restaurantToUpdate }).done(id => {
            const { restaurant, data } = connectedRestaurants[menuitemutil.restaurantToUpdate];
            const categoryId = getMenuCategory(menuitemutil.data).globalId;
            post(restaurant.serverUrl + auth.war + "/" + restaurant.instance + "/mergeService/" + id + "/" + categoryId + "/modifyMenuItem?instance=" + restaurant.instance + "&properties=" + menuitemutil.synchronizeProperties.join(","), d).done(() => {
              modal.find('#save').prop('disabled', false);
              modal.find('#saveAndNew').prop('disabled', false);
              modal.find('#saveAndOpen').prop('disabled', false);
              if (!keep) {
                hideModalWhenReady(modal);
              }
              menuitemutil._reload();
              def.resolve();
            }).fail(() => {
              auth.ajaxError = false;
            });
          });
        } else
          utils.modifyMenuItem(
            parentCategoryId,
            d,
            function (data) {
              const oldMenuItemData = JSON.parse(menuitemutil.oldMenuItemData || "{}");
              const oldParentCategoryId = Number(oldMenuItemData.parentCategoryId || 0);
              const newParentCategoryId = Number(parentCategoryId || 0);
              const parentChanged = oldParentCategoryId !== newParentCategoryId;

              const finishSave = () => {
                modal.find('#save').prop('disabled', false);
                modal.find('#saveAndNew').prop('disabled', false);
                modal.find('#saveAndOpen').prop('disabled', false);
                if (!keep) {
                  hideModalWhenReady(modal);
                }
                onsave([data]);
                if (quantityType != oldMenuItemData.quantityType || parentChanged) {
                  menuitemutil._reload();
                }
                def.resolve();
              };

              if (!parentChanged) {
                finishSave();
                return;
              }

              const getSiblingOrderIds = (targetParentCategoryId, movedItemId) => {
                const ids = [];
                const tree = menuitemutil.menuItems;
                if (!tree || !tree.getRootNode) {
                  return ids;
                }

                const rootNode = tree.getRootNode();
                let parentNode = rootNode;

                if (targetParentCategoryId > 0) {
                  rootNode.visit(node => {
                    if (node?.data?.id === targetParentCategoryId && node?.data?.entityType?.indexOf("Category") >= 0) {
                      parentNode = node;
                      return false;
                    }
                    return true;
                  });
                }

                let hasMovedItem = false;
                (parentNode.children || []).forEach(node => {
                  ids.push(node.data.entityType == menuitemutil.entityType ? 0 : 1);
                  ids.push(node.data.id);
                  if (node.data.entityType == menuitemutil.entityType && Number(node.data.id) === Number(movedItemId)) {
                    hasMovedItem = true;
                  }
                });

                if (!hasMovedItem && movedItemId) {
                  ids.push(0);
                  ids.push(Number(movedItemId));
                }

                return ids;
              };

              const ids = getSiblingOrderIds(newParentCategoryId, data.id);
              if (!ids.length) {
                finishSave();
                return;
              }

              utils.updateMenuItemOrders(ids, finishSave, finishSave);
            },
            () => {
              modal.find('#save').prop('disabled', false);
              modal.find('#saveAndNew').prop('disabled', false);
              modal.find('#saveAndOpen').prop('disabled', false);
            },
            recalculateInventory
          )
      }

      if (JSON.stringify(oldMenuItemAdditionReceipe) !== JSON.stringify(newMenuItemAdditionReceipe)) {
        choiceDialog2(I18n.t("local.question"), I18n.t("admin_local.product_receipe_modified_recalculate_it"), [I18n.t("admin_local.yes"), I18n.t("admin_local.no")]).done(choice => {
          switch (choice) {
            case 0:
              send(true);
              break;
            case 1:
              send(false);
              break;
            default:
          }
        });
      } else
        send();

    }
    else {
      modal.find('#save').prop('disabled', false);
      modal.find('#saveAndNew').prop('disabled', false);
      modal.find('#saveAndOpen').prop('disabled', false);
      if (!keep) {
        hideModalWhenReady(modal);
      }
      onsave([menuitemutil.data]);
      def.resolve();
    }
    return def.promise();
  } else {
    menuItemAdditions.forEach(a => delete a.id);
    menuCategoryAdditions.forEach(a => delete a.id);
    utils.addMenuItem(
      parentCategoryId,
      {
        globalId,
        barcodes,
        shortName,
        manufacturer,
        name,
        description,
        image,
        bigImage,
        quantityType,
        cost,
        unitPrice,
        availableQuantities,
        timing,
        productionLines: production_lines,
        vatCategory: { id: vat_category },
        takeawayVatCategory: { id: takeaway_vat_category },
        isActive: active,
        isTop,
        pos,
        kiosk,
        above18,
        online,
        available,
        inventoryItem,
        freeQuantity,
        menuItemAdditions,
        menuCategoryAdditions,
        labels,
        pricePerCostRatio,
        color,
        mandatory_volume,
        places,
        preorder,
        toDate,
        fromDate,
        mainCategory,
        subCategory,
        woltImage,
        foodpandaImage,
        falatozzImage,
        choiceqrImage,
        minimumPrice,
        allergens,
        removable_allergens,
        calorie
      },
      function (data) {
        modal.find('#save').prop('disabled', false);
        modal.find('#saveAndNew').prop('disabled', false);
        modal.find('#saveAndOpen').prop('disabled', false);
        if (!keep) {
          hideModalWhenReady(modal);
        }
        $('#editMenuItem .modal-body #id').val(data.id);
        const res = onsave([data]);
        res && res?.done && res.done(() => {
          menuitemutil.menuItems.activateKey(data.entityType + data.id);
        });
        def.resolve();
      },
      () => {
        modal.find('#save').prop('disabled', false);
        modal.find('#saveAndNew').prop('disabled', false);
        modal.find('#saveAndOpen').prop('disabled', false);
      }
    );
    return def.promise();
  }
}

menuitemutil.saveMenuItem = saveMenuItem;

function clearTokens(tokenizer) {
  if (tokenizer == null) return;
  tokenizer.options.sortable = false;
  tokenizer.trigger("tokenize:clear");
  // Some tokenize instances can keep a stale token after clear; force-remove leftovers.
  const remainingTokens = tokenizer.toArray();
  if (remainingTokens && remainingTokens.length) {
    remainingTokens.forEach(tokenValue => {
      tokenizer.trigger("tokenize:tokens:remove", tokenValue);
    });
    tokenizer.trigger("tokenize:clear");
  }
  tokenizer.options.sortable = true;
}

var deletedMenuItems = {}
menuitemutil.getMenuItem2 = (id, handler) => {
  var menuItem = menuitemutil._getMenuItem(id, admin.adminCategories.activeMenuCategories ? admin.adminCategories.activeMenuCategories : admin.adminCategories.children);
  if (menuItem === null || menuItem === '') {
    if (deletedMenuItems[id]) {
      handler(deletedMenuItems[id]);
      return deletedMenuItems[id];
    }
    getMenuItemById(id, menuItem => {
      menuItem.type = 'deleted';
      menuItem.name = admin_local.deleted + ' --- ' + getLocale(menuItem.name) + " --- ";
      deletedMenuItems[id] = menuItem;
      menuitemutil.getMenuCategory2(menuItem.menuCategoryId, cat => {
        handler(menuItem);
      })
    });
    return;
  }
  handler(menuItem);
  return menuItem;
}

var deletedMenuCategories = {}
menuitemutil.getMenuCategory2 = (id, handler) => {
  var menuItem = menuitemutil._getMenuCategory(id, admin.categories.activeMenuCategories ? admin.categories.activeMenuCategories : admin.categories.children);
  if (menuItem === null || menuItem === '') {
    if (deletedMenuCategories[id]) {
      handler(deletedMenuCategories[id]);
      return deletedMenuCategories[id];
    }
    getMenuCategoryById(id, menuItem => {
      menuItem.type = 'deleted';
      menuItem.name = admin_local.deleted + ' --- ' + getLocale(menuItem.name) + " --- ";
      deletedMenuCategories[id] = menuItem;
      if (menuItem.menuCategoryId)
        menuitemutil.getMenuCategory2(menuItem.menuCategoryId, cat => {
          handler(menuItem);
        })
      else
        handler(menuItem);

    });
    return;
  }
  handler(menuItem);
  return menuItem;
}

menuitemutil.getMenuItem = function (id, base = admin.adminCategories) {
  var menuItem = menuitemutil._getMenuItem(id, base.activeMenuCategories ? base.activeMenuCategories : base.children);
  if (menuItem == "") {
    console.log("failed to find menu item " + id);
    return null;
  }
  return menuItem;
};

menuitemutil._getMenuItem = function (id, categories) {
  var val = null;
  categories.forEach(function (item) {
    if (val != null) return;
    if (item.entityType.indexOf("Category") < 0 && item.id == id) {
      val = item;
    } else {
      if (item.activeMenuCategories && item.activeMenuCategories.length > 0) val = menuitemutil._getMenuItem(id, item.activeMenuCategories);
      if (val == null && item.activeMenuItems && item.activeMenuItems.length > 0) val = menuitemutil._getMenuItem(id, item.activeMenuItems);
      if (val == null && item.children && item.children.length > 0) val = menuitemutil._getMenuItem(id, item.children);
    }
  });
  return val;
};

menuitemutil.getMenuCategory = function (id, base = (admin.adminCategories || admin.categories)) {
  var menuItem = menuitemutil._getMenuCategory(id, base.activeMenuCategories ? base.activeMenuCategories : base.children);
  if (!menuItem) {
    if (deletedMenuCategories[id]) {
      return deletedMenuCategories[id];
    }
    console.log("failed to find menu category " + id);
    return null;
  }
  return menuItem;
};

menuitemutil._getMenuCategory = function (id, categories) {
  var val = null;
  categories.forEach(function (item) {
    if (val != null) return;
    if (item.entityType.indexOf("Category") > 0 && item.id == id) {
      val = item;
    } else {
      if (item.activeMenuCategories && item.activeMenuCategories.length > 0) val = menuitemutil._getMenuCategory(id, item.activeMenuCategories);
      if (val == null && item.activeMenuItems && item.activeMenuItems.length > 0) val = menuitemutil._getMenuCategory(id, item.activeMenuItems);
      if (val == null && item.children && item.children.length > 0) val = menuitemutil._getMenuCategory(id, item.children);
    }
  });
  return val;
};

var modalOpen = null;

const singleSelectionListboxSelectors = [
  "select.single-select-rowflow",
  "#timing",
  "#ctiming",
  "#vat_category",
  "#takeaway_vat_category",
  "#cvat_category",
  "#ctakeaway_vat_category"
];

function enforceSingleSelection(select, values) {
  if (!Array.isArray(values) || values.length <= 1) return values;

  const previousValues = $(select).data("previousSelectedValues") || [];
  const newlySelected = values.find(v => previousValues.indexOf(v) === -1);
  const keepValue = newlySelected || values[values.length - 1];
  const normalized = [keepValue];
  $(select).val(normalized);
  return normalized;
}

function setupSingleSelectionListboxes(modal) {
  singleSelectionListboxSelectors.forEach(selector => {
    const select = modal.find(selector);
    if (!select.length) return;

    // Keep row-flow controls as compact selects; show listbox mode for the rest.
    if (select.is("select.single-select-rowflow")) {
      const optionCount = Math.max(2, select.find("option").length);
      select.attr("size", optionCount);
    } else {
      select.attr("size", 1);
    }

    const currentValue = select.val();
    const initialValues = Array.isArray(currentValue) ? currentValue : (currentValue ? [currentValue] : []);
    const normalizedInitialValues = enforceSingleSelection(select, initialValues);
    $(select).data("previousSelectedValues", normalizedInitialValues || initialValues);

    select.off("change.singleSelection").on("change.singleSelection", function () {
      const nextValue = $(this).val();
      const selectedValues = Array.isArray(nextValue) ? nextValue : (nextValue ? [nextValue] : []);
      const normalizedValues = enforceSingleSelection(this, selectedValues) || selectedValues;
      $(this).data("previousSelectedValues", normalizedValues);
    });
  });
}

function paste(event) {
  if (modalOpen == null) return;
  const modal = modalOpen;
  var items = (event.clipboardData || event.originalEvent.clipboardData).items;
  for (let index in items) {
    var item = items[index];
    if (item.kind === "file") {
      var blob = item.getAsFile();
      var reader = new FileReader();
      reader.onload = function (event) {
        $(modal.find("#smallImageDiv")).removeClass("hidden");
        $(modal.find("#smallImageDiv i")).removeClass("hidden");
        onPhotoDataSuccess(event.target.result, $(modal.find("#smallImageDiv img")), 160, 160, 160, 160, true);
      }; // data url!
      reader.readAsDataURL(blob);
    }
  }
}

const MENU_CHANGE_HISTORY_PAGE_SIZE = 5;
const MENU_CHANGE_HISTORY_DEFAULT_DAYS = 30;

// datetime-local value (local time, yyyy-MM-ddTHH:mm) of the start of the default period
function menuChangeHistoryDefaultFrom() {
  const date = new Date(Date.now() - MENU_CHANGE_HISTORY_DEFAULT_DAYS * 24 * 60 * 60 * 1000);
  const pad = n => (n < 10 ? "0" : "") + n;
  return date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate()) + "T" + pad(date.getHours()) + ":" + pad(date.getMinutes());
}
const MENU_CHANGE_HISTORY_MODIFICATION_TYPES = ["CREATE", "UPDATE", "DELETE", "RESTORE", "ACTIVATE", "DEACTIVATE", "MOVE", "REORDER"];

function menuChangeHistoryText(key) {
  return I18n.t("admin_local.menu_change_log." + key);
}

const CHATGPT_BUBBLE_MAX_ENTRIES = 5;
const CHATGPT_BUBBLE_MAX_CHANGES = 4;
const CHATGPT_BUBBLE_VISIBLE_MS = 30000;
const CHATGPT_BUBBLE_FOCUSABLE = ["Meal", "Drink", "MealCategory", "DrinkCategory"];

// A bubble in the corner of the menu editor which lists what ChatGPT changed (read from the menu change log). since: the
// server time (ms) of the first change of the batch. Closed by the user, or after a while when the mouse is not over it.
function showChatgptChangesBubble(since) {
  const from = new Date((since || Date.now()) - 15000).toISOString();
  get("adminService/" + localStorage.restaurantSelected + "/getMenuChangeLog?from=" + encodeURIComponent(from) + "&limit=50", null, null, undefined, false)
    .done(result => {
      const entries = ((result && result.entries) || []).filter(entry => String(entry.source).toUpperCase() === "MCP").reverse();
      if (!entries.length) {
        return;
      }
      $(".menuitem-chatgpt-bubble").remove();
      const bubble = $('<div class="menuitem-chatgpt-bubble" role="status" style="position:fixed;right:1rem;bottom:1rem;z-index:5000;width:26rem;max-width:calc(100vw - 2rem);max-height:60vh;overflow-y:auto;background:#fffdf0;color:#333;border:1px solid #e0c34a;border-radius:.75rem;box-shadow:0 4px 18px rgba(0,0,0,.3);padding:.6rem .8rem;font-size:.85rem;"></div>');
      const close = $('<button type="button" aria-label="close" style="position:absolute;top:.2rem;right:.5rem;border:0;background:transparent;font-size:1.2rem;line-height:1;cursor:pointer;">\u00D7</button>');
      bubble.append(close, $('<div style="font-weight:bold;margin:0 1.2rem .3rem 0;"></div>').text(menuChangeHistoryText("chatgpt_bubble_title")));
      entries.slice(0, CHATGPT_BUBBLE_MAX_ENTRIES).forEach(entry => {
        const focusable = entry.entityId > 0 && CHATGPT_BUBBLE_FOCUSABLE.indexOf(entry.entityType) >= 0;
        const block = $('<div style="border-top:1px solid rgba(0,0,0,.12);padding:.3rem 0;"></div>');
        const title = [menuChangeHistoryText(entry.modificationType), menuChangeHistoryText(entry.entityType)].filter(Boolean).join(" - ") + (entry.entityName ? ": " + formatEntityName(entry.entityName) : "");
        block.append($('<div style="font-weight:bold;"></div>').text(title));
        const changes = entry.changes || [];
        changes.slice(0, CHATGPT_BUBBLE_MAX_CHANGES).forEach(change => {
          block.append($('<div style="word-break:break-word;"></div>').text(formatChangeField(change.field) + ": " + formatChangeValue(change, "from") + " \u2192 " + formatChangeValue(change, "to")));
        });
        if (changes.length > CHATGPT_BUBBLE_MAX_CHANGES) {
          block.append($('<div style="opacity:.7;"></div>').text("+" + (changes.length - CHATGPT_BUBBLE_MAX_CHANGES) + " " + menuChangeHistoryText("more")));
        }
        if (focusable) {
          // a click focuses the item or category in the menu tree
          block.css("cursor", "pointer").on("click", () => {
            menuitemutil.pendingChangedNodes = { nodes: [{ entityType: entry.entityType, id: entry.entityId }], focus: true };
            menuitemutil.highlightChangedNodes();
          });
        }
        bubble.append(block);
      });
      if (entries.length > CHATGPT_BUBBLE_MAX_ENTRIES) {
        bubble.append($('<div style="opacity:.7;border-top:1px solid rgba(0,0,0,.12);padding-top:.3rem;"></div>').text("+" + (entries.length - CHATGPT_BUBBLE_MAX_ENTRIES) + " " + menuChangeHistoryText("more")));
      }
      let timer;
      const remove = () => {
        clearTimeout(timer);
        bubble.remove();
      };
      const arm = () => {
        clearTimeout(timer);
        timer = setTimeout(remove, CHATGPT_BUBBLE_VISIBLE_MS);
      };
      close.on("click", remove);
      bubble.on("mouseenter", () => clearTimeout(timer)).on("mouseleave", arm);
      $("body").append(bubble);
      arm();
    });
}

function renderMenuChangeHistory(container, result) {
  const results = container.find(".menuitem-history-results").empty();
  const entries = result.entries || [];
  const modifierSelect = container.find(".menuitem-history-modifier");
  if (modifierSelect.find("option").length <= 1) {
    (result.modifiers || []).forEach(modifier => {
      modifierSelect.append($("<option>").attr("value", modifier.value).text(formatModifierOption(modifier)));
    });
  }
  if (!entries.length) {
    results.append($("<div>").text(menuChangeHistoryText("no_results")));
  }
  entries.forEach(entry => {
    const block = $('<div class="menuitem-history-entry" style="border-top:1px solid rgba(0,0,0,.12);padding:.4rem 0;"></div>');
    const header = [
      entry.time ? new Date(entry.time).toLocaleString() : "",
      formatModifier(entry),
      menuChangeHistoryText(entry.modificationType),
      entry.source ? "(" + menuChangeHistoryText("source_" + entry.source) + ")" : ""
    ].filter(Boolean).join(" - ");
    block.append($('<div style="font-weight:bold;"></div>').text(header));
    const changes = entry.changes || [];
    if (changes.length) {
      const table = $('<table style="width:100%;border-collapse:collapse;font-size:.85rem;"></table>');
      changes.forEach(change => {
        const row = $("<tr></tr>");
        row.append($('<td style="padding:.1rem .4rem .1rem 0;vertical-align:top;"></td>').text(formatChangeField(change.field)));
        row.append($('<td style="padding:.1rem .4rem;vertical-align:top;word-break:break-word;"></td>').text(formatChangeValue(change, "from")));
        row.append($('<td style="padding:.1rem 0 .1rem .4rem;vertical-align:top;word-break:break-word;"></td>').text("\u2192 " + formatChangeValue(change, "to")));
        table.append(row);
      });
      block.append(table);
    }
    results.append(block);
  });

  const offset = result.offset || 0;
  const total = result.total || 0;
  const paging = container.find(".menuitem-history-paging").empty();
  if (total > 0) {
    const previous = $('<button type="button" class="btn btn-light btn-sm"></button>').text(menuChangeHistoryText("previous")).prop("disabled", offset <= 0);
    const next = $('<button type="button" class="btn btn-light btn-sm"></button>').text(menuChangeHistoryText("next")).prop("disabled", offset + MENU_CHANGE_HISTORY_PAGE_SIZE >= total);
    previous.on("click", () => loadMenuChangeHistory(container, Math.max(0, offset - MENU_CHANGE_HISTORY_PAGE_SIZE)));
    next.on("click", () => loadMenuChangeHistory(container, offset + MENU_CHANGE_HISTORY_PAGE_SIZE));
    paging.append(previous, $("<span></span>").text(" " + (offset + 1) + " - " + (offset + entries.length) + " / " + total + " "), next);
  }
}

function loadMenuChangeHistory(container, offset) {
  const entityId = container.data("historyEntityId");
  if (!entityId) {
    return;
  }
  const params = ["entityType=" + container.data("historyGroup"), "entityId=" + entityId, "offset=" + (offset || 0), "limit=" + MENU_CHANGE_HISTORY_PAGE_SIZE];
  const filters = { from: ".menuitem-history-from", to: ".menuitem-history-to", modifier: ".menuitem-history-modifier", modificationType: ".menuitem-history-type" };
  Object.keys(filters).forEach(key => {
    const value = container.find(filters[key]).val();
    if (value) {
      params.push(key + "=" + encodeURIComponent(value));
    }
  });
  const token = (container.data("historyRequest") || 0) + 1;
  container.data("historyRequest", token);
  get("adminService/" + localStorage.restaurantSelected + "/getMenuChangeLog?" + params.join("&"), null, null, undefined, false)
    .done(result => {
      if (container.data("historyRequest") === token && container.data("historyEntityId") === entityId) {
        renderMenuChangeHistory(container, result || {});
      }
    })
    .fail(() => {
      if (container.data("historyRequest") === token) {
        container.find(".menuitem-history-results").empty().append($("<div>").text(menuChangeHistoryText("load_failed")));
        container.find(".menuitem-history-paging").empty();
      }
    });
}

// The history of the edited product or category (change log of the menu structure). group: "item" or "category".
function refreshMenuChangeHistory(modal, data, group, restaurantId) {
  const container = modal.find(".menuitem-history-container");
  if (!container.length) {
    return;
  }
  const entityId = data && data.id ? data.id : null;
  const visible = !!entityId && !restaurantId;
  modal.find(".menuitem-history-panel").toggle(visible);
  modal.find(".menuitem-history-tab").toggle(visible);
  container.empty().removeData("historyEntityId");
  if (!visible) {
    return;
  }
  container.data("historyEntityId", entityId).data("historyGroup", group);

  const field = (label, input) => $('<label style="display:flex;flex-direction:column;font-size:.8rem;margin:0;"></label>').append($("<span></span>").text(label)).append(input);
  const filters = $('<div style="display:flex;flex-wrap:wrap;gap:.5rem;align-items:flex-end;margin-bottom:.5rem;"></div>');
  const typeSelect = $('<select class="form-control form-control-sm menuitem-history-type"></select>').append($("<option>").attr("value", "").text(menuChangeHistoryText("all_modification_types")));
  MENU_CHANGE_HISTORY_MODIFICATION_TYPES.forEach(type => typeSelect.append($("<option>").attr("value", type).text(menuChangeHistoryText(type))));
  const modifierSelect = $('<select class="form-control form-control-sm menuitem-history-modifier"></select>').append($("<option>").attr("value", "").text(menuChangeHistoryText("all_modifiers")));
  const search = $('<button type="button" class="btn btn-primary btn-sm"></button>').text(menuChangeHistoryText("search"));
  filters.append(
    field(menuChangeHistoryText("time_from"), $('<input type="datetime-local" class="form-control form-control-sm menuitem-history-from">').val(menuChangeHistoryDefaultFrom())),
    field(menuChangeHistoryText("time_to"), $('<input type="datetime-local" class="form-control form-control-sm menuitem-history-to">')),
    field(menuChangeHistoryText("modifier"), modifierSelect),
    field(menuChangeHistoryText("modification_type"), typeSelect),
    search
  );
  search.on("click", () => loadMenuChangeHistory(container, 0));
  container.append(filters, $('<div class="menuitem-history-results" style="max-height:20rem;overflow-y:auto;"></div>'), $('<div class="menuitem-history-paging" style="margin-top:.5rem;"></div>'));
  loadMenuChangeHistory(container, 0);
}

export const populateEditCategory = (modal, recipient, data, menuCategoryId, restaurantId) => {
  if (!recipient) return;
  menuitemutil.restaurantToUpdate = restaurantId;

  const imageUrl = (restaurantId ? connectedRestaurants[restaurantId].restaurant.serverUrl : auth.server + "/") + auth.war + "/tableService/" + (restaurantId ? connectedRestaurants[restaurantId].restaurant.localId : localStorage.restaurantSelected) + "/getImage/";

  const instance = restaurantId ? connectedRestaurants[restaurantId].restaurant.instance : localStorage.instance;

  // Bind happens after populate in modal show handlers.
  // resetMenuEditorChangeTrackingOnRepopulation at the end captures post-populate baseline.
  //bindMenuEditorChangeTracking(modal);

  menuitemutil.data = data;
  refreshMenuChangeHistory(modal, recipient === "edit" ? data : null, "category", restaurantId);
  if (typeof menuitemutil.entityType == "undefined" && data != null) {
    menuitemutil.entityType = data.entityType;
    if (data.entityType == "Drink" || data.entityType == "DrinkCategory") {
      menuitemutil.entityType = "drink";
      menuitemutil.entityType = "Drink";
    } else {
      menuitemutil.entityType = "meal";
      menuitemutil.entityType = "Meal";
    }
  }

  modalOpen = modal;
  $("body").unbind("paste");
  $("body").on("paste", paste);

  modal.find("#save").prop("disabled", false);
  modal.find("#saveAndOpen").prop("disabled", false);
  modal.find("#saveAndNew").prop("disabled", false);

  $("#crop").hide();

  if (data && data.color) {
    applyColorSelection(modal, data.color);
  } else {
    applyColorSelection(modal, null);
  }
  modal.find("#input#color").find("input").change(() => { });

  modal.find(".highlight-3").removeClass("highlight-3");

  clearTokens(modal.find("#category_additions_mandatory").tokenize2());
  clearTokens(modal.find("#category_additions_included").tokenize2());
  clearTokens(modal.find("#category_additions_optional").tokenize2());
  clearTokens(modal.find("#category_labels").tokenize2());
  clearTokens(modal.find("#category_references").tokenize2());
  clearTokens(modal.find("#upsellMenuItems").tokenize2());
  modal.find("div#production_lines input").prop("checked", false);
  modal.find("div#production_lines input").parent().removeClass("active");
  modal.find("div#production_lines input").parent().attr("default", false);
  modal.find(".onMenuThirdParty").prop('checked', false);
  modal.find(".onMenuThirdParty").removeClass("active");
  modal.find("#modal-type").val(menuitemutil.entityType + "Category");

  modal.find('input.datepicker').val("");
  modal.find('input.datepicker').prop("placeholder", "");

  modal.find("#cntak_main_category").val("");
  menuitemutil.updateNtakCategories("c", modal, data);
  modal.find("#cntak_sub_category").val("");
  modal.find("#cparentCategoryId").val(menuCategoryId || 0);
  modal.find("#cvat_category").val("");
  modal.find("#ctakeaway_vat_category").val("");
  modal.find("#category_allergens > *").removeClass("has");
  modal.find("#category_allergens > *").removeClass("removable");
  modal.find("#category_allergens > *").removeClass("inherited");

  const getCategoryEditorBase = () => {
    if (restaurantId && connectedRestaurants[restaurantId]?.data) {
      return connectedRestaurants[restaurantId].data;
    }
    return admin.adminCategories || admin.categories;
  };

  const collectCategoryOptions = (nodes, categoryType, base, options = [], visited = new Set()) => {
    if (!Array.isArray(nodes)) return options;
    nodes.forEach(node => {
      if (!node || !node.entityType || node.entityType.indexOf("Category") < 0) return;
      if (visited.has(node.id)) return;
      visited.add(node.id);

      if (!categoryType || node.entityType === categoryType) {
        options.push({
          id: String(node.id),
          text: menuitemutil._getPath(node, base)
        });
      }

      const childCandidates = [];
      if (Array.isArray(node.activeMenuCategories)) childCandidates.push(...node.activeMenuCategories);
      if (Array.isArray(node.children)) childCandidates.push(...node.children);
      collectCategoryOptions(childCandidates, categoryType, base, options, visited);
    });
    return options;
  };

  const collectCategoryAndDescendantIds = (category, ids = new Set()) => {
    if (!category || !category.id || ids.has(category.id)) return ids;
    ids.add(category.id);
    const childCategories = [];
    if (Array.isArray(category.activeMenuCategories)) childCategories.push(...category.activeMenuCategories);
    if (Array.isArray(category.children)) childCategories.push(...category.children.filter(c => c?.entityType && c.entityType.indexOf("Category") >= 0));
    childCategories.forEach(child => collectCategoryAndDescendantIds(child, ids));
    return ids;
  };

  const refreshCategoryHeaderContext = () => {
    const base = getCategoryEditorBase();
    const parentCategoryId = Number(modal.find("#cparentCategoryId").val()) || 0;
    const parentCategory = parentCategoryId ? menuitemutil.getMenuCategory(parentCategoryId, base) : null;
    const parentPath = parentCategory ? menuitemutil._getPath(parentCategory, base) : "";

    const inputNameMap = getLocalizedNameFromInputs(modal, "#cname_");
    const nameSource = Object.keys(inputNameMap).length ? inputNameMap : (data?.name || {});
    const localizedName = Object.keys(nameSource).length ? (getLocale(nameSource) || nameSource.all || "") : "";

    setModalHeaderContext(modal, parentPath, localizedName, []);
  };

  const updateCategoryParentContext = selectedParentCategoryId => {
    const numericParentCategoryId = selectedParentCategoryId !== undefined && selectedParentCategoryId !== null && selectedParentCategoryId !== "" ? Number(selectedParentCategoryId) : 0;
    modal.find("#cparentCategoryId").val(numericParentCategoryId);

    const base = getCategoryEditorBase();
    const parentCategory = numericParentCategoryId ? menuitemutil.getMenuCategory(numericParentCategoryId, base) : null;

    if (parentCategory) {
      modal.find("#ctiming option[value='inherit']").html(admin_local.inherit + (parentCategory.defaultTiming && parentCategory.defaultTiming !== "inherit" ? "(" + getLocale2(auth.myStatus.restaurant_settings.timings[parentCategory.defaultTiming].langs).name + ")" : ""));
      if (parentCategory.defaultVATCategory) {
        const vatOptionText = modal.find("#cvat_category option[value='" + parentCategory.defaultVATCategory.id + "']").first().text();
        modal.find("#cvat_category option[value='']").html(admin_local.inherit + (vatOptionText ? "(" + vatOptionText + ")" : ""));
      } else {
        modal.find("#cvat_category option[value='']").html(admin_local.inherit);
      }
      if (parentCategory.defaultTakeawayVATCategory) {
        const takeawayVatOptionText = modal.find("#ctakeaway_vat_category option[value='" + parentCategory.defaultTakeawayVATCategory.id + "']").first().text();
        modal.find("#ctakeaway_vat_category option[value='']").html(admin_local.inherit + (takeawayVatOptionText ? "(" + takeawayVatOptionText + ")" : ""));
      } else {
        modal.find("#ctakeaway_vat_category option[value='']").html(admin_local.inherit);
      }
    } else {
      modal.find("#ctiming option[value='inherit']").html(admin_local.inherit);
      modal.find("#cvat_category option[value='']").html(admin_local.inherit);
      modal.find("#ctakeaway_vat_category option[value='']").html(admin_local.inherit);
    }

    modal.find("#ctiming option[value='inherit']").prop("disabled", !numericParentCategoryId);
    modal.find("#cvat_category option[value='']").prop("disabled", !numericParentCategoryId);

    refreshCategoryHeaderContext();
  };

  const categoryBase = getCategoryEditorBase();
  applyUpsellMenuItems(modal, recipient === "edit" ? null : data, categoryBase);
  const rootCategories = categoryBase?.activeMenuCategories || categoryBase?.children || [];
  const categoryType = menuitemutil.entityType ? menuitemutil.entityType + "Category" : undefined;
  const disallowedCategoryIds = recipient === "edit" && data ? collectCategoryAndDescendantIds(data) : new Set();
  const categoryOptions = collectCategoryOptions(rootCategories, categoryType, categoryBase).filter(option => !disallowedCategoryIds.has(Number(option.id)));
  const categoryParentSelect = modal.find("select#cparent_category");

  if (categoryParentSelect.hasClass("select2-hidden-accessible")) {
    categoryParentSelect.select2("destroy");
  }

  categoryParentSelect.empty();
  categoryParentSelect.append($("<option></option>").attr("value", "0").text(admin_local.top_category));
  categoryOptions.forEach(option => {
    categoryParentSelect.append($("<option></option>").attr("value", option.id).text(option.text));
  });

  categoryParentSelect.select2({
    width: "100%",
    dropdownParent: modal,
    placeholder: admin_local.select_a_category,
    minimumResultsForSearch: 8
  });

  const selectedParentCategoryId = menuCategoryId != null ? String(menuCategoryId) : "0";
  if (categoryParentSelect.find("option[value='" + selectedParentCategoryId + "']").length) {
    categoryParentSelect.val(selectedParentCategoryId);
  } else {
    categoryParentSelect.val("0");
  }

  categoryParentSelect.trigger("change.select2");
  updateCategoryParentContext(categoryParentSelect.val());

  categoryParentSelect.off("change.menuCategoryParent").on("change.menuCategoryParent", function () {
    updateCategoryParentContext($(this).val());
  });

  modal.off("input.menuitemCategoryHeaderName", "input[id^='cname_'], input#cname_all").on("input.menuitemCategoryHeaderName", "input[id^='cname_'], input#cname_all", function () {
    refreshCategoryHeaderContext();
  });


  if (recipient == "edit") {
    modal.find("#cid").val(data.id);
    modal.find("#modal-type").val(data.entityType);
    modal.find("#calias").val(data.globalId);
    auth.myStatus.restaurant_languages.forEach(function (lang) {
      modal.find("#cname_" + lang).val(data.name[lang]);
      modal.find("#cdescription_" + lang).val(data.description[lang]);
    });
    if (data.image && data.image != "") {
      modal.find("#smallImage").attr("src", imageUrl + data.image + "?timestamp=" + data.imageTimestamp + "&instance=" + instance);
      $(modal.find("#smallImageDiv")).removeClass("hidden");
      $(modal.find("#smallImageDiv i")).removeClass("hidden");
    } else {
      modal.find("#smallImage").attr("src", "");
      $(modal.find("#smallImageDiv i")).addClass("hidden");
    }
    data.inheritedAllergens && data.inheritedAllergens.forEach(function (allergen) {
      modal.find("#category_allergens #" + allergen).addClass("inherited");
    });
    data.menuItemAdditions && data.menuItemAdditions.filter(addition => addition.additionType === "included").forEach(addition => {
      admin.getMenuItemAdmin(addition.addition.id).allergens && admin.getMenuItemAdmin(addition.addition.id).allergens.forEach(allergen => {
        modal.find("#category_allergens #" + allergen).addClass("inherited");
      })
    })
    data.allergens && data.allergens.forEach(function (allergen) {
      modal.find("#category_allergens #" + allergen).addClass("has");
    });
    data.removable_allergens && data.removable_allergens.forEach(function (allergen) {
      modal.find("#category_allergens #" + allergen).addClass("has");
      modal.find("#category_allergens #" + allergen).addClass("removable");
    });

    modal.find("#ctiming").val(data.timing);
    data.productionLines.forEach(function (pl) {
      modal.find("div#production_lines input#cpl_" + pl.id).prop("checked", "true");
      modal.find("div#production_lines input#cpl_" + pl.id).parent().addClass("active");
    });
    if (data.defaultProductionLineIds)
      data.defaultProductionLineIds.split(",").forEach(function (pl) {
        modal.find("div#production_lines input#cpl_" + pl).parent().attr("default", "true");
      });

    if (data.settings) {
      if (data.settings.wolt)
        Object.keys(data.settings.wolt).forEach(key => {
          modal.find(".onMenuThirdParty#conMenu_wolt_" + key).prop('checked', data.settings.wolt[key].enabled);
        })
      if (data.settings.foodpanda)
        Object.keys(data.settings.foodpanda).forEach(key => {
          modal.find(".onMenuThirdParty#conMenu_foodpanda_" + key).prop('checked', data.settings.foodpanda[key].enabled);
        })
      if (data.settings.choiceqr)
        Object.keys(data.settings.choiceqr).forEach(key => {
          modal.find(".onMenuThirdParty#conMenu_choiceqr_" + key).prop('checked', data.settings.choiceqr[key].enabled);
        })
    }


    modal.find("#cvat_category").val(data.vatCategory ? data.vatCategory.id : "");
    modal.find("#ctakeaway_vat_category").val(data.takeawayVatCategory ? data.takeawayVatCategory.id : "");
    modal.find("#cname_all").val(data.name["all"]);
    modal.find("#cdescription_all").val(data.description["all"]);
    if (data.pricePerCostRatio)
      new Cleave(modal.find("#cpricePerCostRatio"), {
        numeral: true
      }).onInput("" + data.pricePerCostRatio * 100);
    else
      new Cleave(modal.find("#cpricePerCostRatio"), {
        numeral: true
      }).onInput("");

    modal.find("#cpricePerCostRatio").attr("placeholder", "");
    if (menuCategoryId) {
      var menuCategory = data ? getMenuCategory(data) : admin.getMenuCategoryAdmin(menuCategoryId);
      modal.find("#cpricePerCostRatio").attr("placeholder", menuCategory.defaultPricePerCostRatio * 100);
    }

    modal.find("#cntak_main_category").val(data.mainCategoryId);
    menuitemutil.updateNtakCategories("c", modal);
    modal.find("#cntak_sub_category").val(data.subCategoryId);

    const additions = [...(data?.menuItemAdditions || []), ...(data?.menuCategoryAdditions || [])];
    additions.sort((a, b) => a.order - b.order);
    const upsellTokenizerValues = new Set();
    var local = true;
    var takeaway = true;
    additions.forEach((addition, ind) => {
      if (addition.type === "meal_addition" || addition.type === "drink_addition") {
        if (addition.additionType === "upsell") {
          menuitemutil.getMenuItem2(addition.additionId, menuItem => {
            const entityType = (addition.type.split("_")[0] || "").toLowerCase();
            const tokenValue = "menuItem;" + (addition.id || -1) + ";" + menuItem.id + ";" + (addition.quantity || 1) + ";" + entityType;
            const dedupeKey = "menuItem:" + menuItem.id;
            const upsellTokenizer = modal.find("#upsellMenuItems");
            upsellTokenizer.tokenize2().toArray().forEach(existingToken => {
              const parts = String(existingToken || "").split(";");
              if (parts[0] === "menuItem" && Number(parts[2]) === Number(menuItem.id) && existingToken !== tokenValue) {
                upsellTokenizer.trigger("tokenize:tokens:remove", [existingToken]);
              }
            });
            if (upsellTokenizerValues.has(dedupeKey)) {
              return;
            }
            upsellTokenizerValues.add(dedupeKey);
            upsellTokenizer.trigger("tokenize:tokens:add", [
              tokenValue,
              wrapTokenizerLabelText(menuitemutil.getPath(menuItem)),
              true
            ]);
          });
          return;
        }
        menuitemutil.getMenuItem2(addition.additionId, menuItem => {
          const quantity = Math.round(1000 * parseFloat(addition.quantity)) / 1000 * (addition.additionType === "mandatory" && data.mandatory_volume ? data.mandatory_volume : 1);
          modal
            .find("#category_additions_" + addition.additionType)
            .trigger("tokenize:tokens:add", [
              "menuItem;" + addition.id + ";" + menuItem.id + ";" + (addition.additionType == "mandatory" ? "" : (quantity)) + ";" + addition.type.split("_")[0],
              wrapTokenizerLabelText(menuitemutil.getPath(menuItem)) +
              menuitemutil.getLocalOption("al_" + ind, addition.local) +
              menuitemutil.getTakeawayOption("at_" + ind, addition.takeaway) +
              menuitemutil.getProportionalOption("aa_" + ind, addition.proportional) +
              "\n" +
              menuitemutil.getQuantityLabel2(addition.additionType, quantity, menuItem.quantityType, getLocale(getNameForQuantity(menuItem, quantity))) +
              (menuItem.costEstimation * quantity > 0 ? "<span class='cost'>&nbsp;(" + Math.round(menuItem.costEstimation * quantity * 1000) / 1000 + " " + auth.myStatus.restaurant_base_currency.name + ")</span>" : "<span/>") +
              "<span class='calorie'>&nbsp;(" + Math.round(menuItem.calorie * quantity * 10) / 10 + " kcal)</span>",
              true
            ]);
          modal.find("#category_additions_" + addition.additionType).trigger("tokenize:tokens:reorder");
          const it = modal.find("#category_additions_" + addition.additionType).parent().find("span#" + "aa_" + ind + " , " + "span#" + "al_" + ind + " , " + "span#" + "at_" + ind);
          if (auth?.myStatus?.restaurant_settings?.["shop-mode"])
            tooltip(it);
        });
      } else {
        if (addition.additionType === "upsell") {
          menuitemutil.getMenuCategory2(addition.additionId, menuCategory => {
            const entityType = (addition.type.split("_")[0] || "").toLowerCase();
            const tokenValue = "menuCategory;" + (addition.id || -2) + ";" + menuCategory.id + ";;" + entityType;
            const dedupeKey = "menuCategory:" + menuCategory.id;
            const upsellTokenizer = modal.find("#upsellMenuItems");
            upsellTokenizer.tokenize2().toArray().forEach(existingToken => {
              const parts = String(existingToken || "").split(";");
              if (parts[0] === "menuCategory" && Number(parts[2]) === Number(menuCategory.id) && existingToken !== tokenValue) {
                upsellTokenizer.trigger("tokenize:tokens:remove", [existingToken]);
              }
            });
            if (upsellTokenizerValues.has(dedupeKey)) {
              return;
            }
            upsellTokenizerValues.add(dedupeKey);
            upsellTokenizer.trigger("tokenize:tokens:add", [
              tokenValue,
              wrapTokenizerLabelText(menuitemutil.getPath(menuCategory)),
              true,
              "category",
              true
            ]);
          });
          return;
        }
        menuitemutil.getMenuCategory2(addition.additionId, menuCategory => {
          modal.find("#category_additions_" + addition.additionType).trigger("tokenize:tokens:add", [
            "menuCategory;" + addition.id + ";" + menuCategory.id + ";;" + addition.type.split("_")[0],
            wrapTokenizerLabelText(menuitemutil.getPath(menuCategory)) + menuitemutil.getProportionalOption("aaa_" + ind, addition.proportional),
            true,
            "category",
            true]
          );
          modal.find("#category_additions_" + addition.additionType).trigger("tokenize:tokens:reorder");
          const it = modal.find("#category_additions_" + addition.additionType).parent().find("span#" + "aaa_" + ind);
          if (auth?.myStatus?.restaurant_settings?.["shop-mode"])
            tooltip(it);
          if (addition.optionType) {
            switch (addition.optionType) {
              case "separate":
                modal.find('input[id="check2' + "menuCategory;" + addition.id + ";" + menuCategory.id + ';;' + addition.type.split("_")[0] + '"]').prop("checked", true);
                modal.find('input[id="check2' + "menuCategory;" + addition.id + ";" + menuCategory.id + ';;' + addition.type.split("_")[0] + '"] ~ span > input#min').val(addition.min);
                modal.find('input[id="check2' + "menuCategory;" + addition.id + ";" + menuCategory.id + ';;' + addition.type.split("_")[0] + '"] ~ span > input#max').val(addition.max);
                break;
              case "maxone":
                modal.find('input[id="radio' + "menuCategory;" + addition.id + ";" + menuCategory.id + ';;' + addition.type.split("_")[0] + '"]').prop("checked", true);
                break;
              case "one":
                modal.find('input[id="radio2' + "menuCategory;" + addition.id + ";" + menuCategory.id + ';;' + addition.type.split("_")[0] + '"]').prop("checked", true);
                break;
              default:
                modal.find('input[id="check' + "menuCategory;" + addition.id + ";" + menuCategory.id + ';;' + addition.type.split("_")[0] + '"]').prop("checked", true);
                break;
            }
          }
        });
      }

    });
    modal.find("#upsellMenuItems").trigger("tokenize:tokens:reorder");

    menuItemReferences(data).forEach(({ menuItem, addition }, ind) => {
      const key = (menuItem.entityType.indexOf("Category") === -1 ? "menuItem" : "menuCategory") + ";" + addition.id + ";" + menuItem.id + ";" + (addition.additionType == "mandatory" ? "" : addition.quantity) + ";" + addition.type.split("_")[0];
      if (menuItem) {
        modal
          .find("#category_references")
          .trigger("tokenize:tokens:add", [
            key,
            wrapTokenizerLabelText(menuitemutil.getPath(menuItem)),
            true,
            "category"
          ]);
      }
      const it = modal.find("#category_references").next().find("*[data-value = '" + key + "']");
      it.find('input').remove();
      it.find('.dismiss').remove();
    });
    modal.find("#category_references").next().find(".token-search input").remove();

    if (data.labels)
      data.labels.forEach(function (label) {
        modal.find("#category_labels").trigger("tokenize:tokens:add", ["label;" + label.id + ";", label.name]);
      });
    if (data.isActive == true) modal.find("#mc_active").prop("checked", "true");
    else modal.find("#mc_active").prop("checked", false);
    if (data.above18 == true) modal.find("#mc_above18").prop("checked", "true") && modal.find("label[for = 'mc_above18']").addClass("active");
    else modal.find("#mc_above18").prop("checked", false) && modal.find("label[for = 'mc_above18']").removeClass("active");
    if (data.defaultAbove18 == true) modal.find("label[for = 'mc_above18']").attr("default", "true");
    else modal.find("label[for = 'mc_above18']").attr("default", "false");
    if (data.isTop == true) modal.find("#mc_isTop").prop("checked", "true");
    else modal.find("#mc_isTop").prop("checked", false);
    if (data.pos == true) modal.find("#mc_pos").prop("checked", "true");
    else modal.find("#mc_pos").prop("checked", false);
    if (data.kiosk == true) modal.find("#mc_kiosk").prop("checked", "true");
    else modal.find("#mc_kiosk").prop("checked", false);
    if (data.freeQuantity == true) modal.find("#mc_freequantity").prop("checked", false);
    else modal.find("#mc_freequantity").prop("checked", true);
    if (data.online == true) modal.find("#mc_online").prop("checked", "true");
    else modal.find("#mc_online").prop("checked", false);
    if (data.local == true) modal.find("#mc_local").prop("checked", "true");
    else modal.find("#mc_local").prop("checked", false);
    if (data.takeaway == true) modal.find("#mc_takeaway").prop("checked", "true");
    else modal.find("#mc_takeaway").prop("checked", false);
    if (data.available == true) modal.find("#mc_available").prop("checked", "true");
    else modal.find("#mc_available").prop("checked", false);
    if (data.inventoryItem != undefined) {
      if (data.inventoryItem == true) modal.find("#mc_isInventoryItem").prop("checked", true);
      else modal.find("#mc_isInventoryItem").prop("checked", false);
      modal.find("#mc_isInventoryItem").prop("indeterminate", false);
    } else {
      modal.find("#mc_isInventoryItem").prop("indeterminate", true);
      modal.find("#mc_isInventoryItem").prop("checked", false);
    }
    if (data.preorder != undefined) {
      if (data.preorder == true) modal.find("#mc_preorder").prop("checked", true);
      else modal.find("#mc_preorder").prop("checked", false);
      modal.find("#mc_preorder").prop("indeterminate", false);
    } else {
      modal.find("#mc_preorder").prop("indeterminate", true);
      modal.find("#mc_preorder").prop("checked", false);
    }
    if (data.toDate) {
      var formattedDate = moment(data.toDate).format('YYYY-MM-DD');
      modal.find('input#to_date').val(formattedDate);
    }
    if (data.defaultToDate) {
      formattedDate = moment(data.defaultToDate).format('YYYY-MM-DD');
      modal.find('input#to_date').attr("placeholder", formattedDate);
    }
    if (data.fromDate) {
      var formattedDate = moment(data.fromDate).format('YYYY-MM-DD');
      modal.find('input#from_date').val(formattedDate);
    }
    if (data.defaultFromDate) {
      formattedDate = moment(data.defaultFromDate).format('YYYY-MM-DD');
      modal.find('input#from_date').attr("placeholder", formattedDate);
    }

  } else {
    modal.find("#smallImage").attr("src", "");
    $(modal.find("#smallImageDiv")).removeClass("hidden");
    $(modal.find("#smallImageDiv i")).addClass("hidden");

    auth.myStatus.restaurant_languages.forEach(function (lang) {
      modal.find("#cname_" + lang).val("");
      modal.find("#cdescription_" + lang).val("");
    });
    modal.find("#cname_all").val("");
    modal.find("#cdescription_all").val("");
    modal.find("#production_line").val("");
    modal.find("#cvat_category").val("");
    modal.find("#ctakeaway_vat_category").val("");
    modal.find("#cid").val("");
    modal.find("#calias").val("");
    modal.find("#mc_active").prop("checked", "true");
    modal.find("#mc_isTop").prop("checked", menuCategoryId ? false : true);
    modal.find("#mc_pos").prop("checked", "true");
    modal.find("#mc_kiosk").prop("checked", menuCategoryId ? false : true);
    modal.find("#mc_online").prop("checked", "true");
    modal.find("#mc_available").prop("checked", "true");
    modal.find("#mc_isInventoryItem").prop("checked", null);
    modal.find("#mc_isInventoryItem").prop("indeterminate", true);
    modal.find("#mc_preorder").prop("checked", null);
    modal.find("#mc_preorder").prop("indeterminate", true);
    modal.find("#mc_local").prop("checked", true);
    modal.find("#mc_takeaway").prop("checked", true);

    new Cleave(modal.find("#cpricePerCostRatio"), {}).onInput("");
    modal.find("#cpricePerCostRatio").attr("placeholder", "");
    if (menuCategoryId) {
      var menuCategory = data ? getMenuCategory(data) : admin.getMenuCategoryAdmin(menuCategoryId);
      if (menuCategory.defaultProductionLineIds)
        menuCategory.defaultProductionLineIds.split(",").forEach(function (pl) {
          modal.find("div#production_lines input#cpl_" + pl).parent().attr("default", "true");
        });
      modal.find("#cpricePerCostRatio").attr("placeholder", menuCategory.defaultPricePerCostRatio * 100);
      modal.find("#ctiming").val("inherit");

      if (menuCategory.defaultToDate) {
        formattedDate = moment(menuCategory.defaultToDate).format('YYYY-MM-DD');
        modal.find('input#to_date').attr("placeholder", formattedDate);
      }
      if (menuCategory.defaultFromDate) {
        formattedDate = moment(menuCategory.defaultFromDate).format('YYYY-MM-DD');
        modal.find('input#from_date').attr("placeholder", formattedDate);
      }

    } else {
      modal.find("#ctiming").val(auth.myStatus.restaurant_timings[0]);
    }
  }

  const currentParentCategoryId = Number(modal.find("#cparentCategoryId").val()) || 0;
  $("#ctiming option[value='inherit']").prop("disabled", !currentParentCategoryId);
  $("#cvat_category option[value='']").prop("disabled", !currentParentCategoryId);
  refreshCategoryHeaderContext();
  setupQuantityTypeSelector(modal);
  setupSingleSelectionListboxes(modal);

  menuitemutil.oldMenuCategoryData = JSON.stringify(saveMenuCategory(undefined, true));

  invokeMenuitemAutomation("initializeAutomationValueAttributes", [modal]);

  resetMenuEditorChangeTrackingOnRepopulation(modal);



};

export const populateEditMenuItem = (modal, recipient, data, menuCategoryId, restaurantId) => {
  if (!recipient)
    return;
  menuitemutil.restaurantToUpdate = restaurantId;

  _log("populateEditMenuItem");

  const imageUrl = (restaurantId ? connectedRestaurants[restaurantId].restaurant.serverUrl : auth.server + "/") + auth.war + "/tableService/" + (restaurantId ? connectedRestaurants[restaurantId].restaurant.localId : localStorage.restaurantSelected) + "/getImage/";

  const instance = restaurantId ? connectedRestaurants[restaurantId].restaurant.instance : localStorage.instance;

  // Bind happens after populate in modal show handlers.
  // resetMenuEditorChangeTrackingOnRepopulation at the end captures post-populate baseline.
  //bindMenuEditorChangeTracking(modal);

  modal.find('#save').prop('disabled', false);
  modal.find('#saveAndNew').prop('disabled', false);
  modal.find('#saveAndOpen').prop('disabled', false);

  menuitemutil.data = data;
  refreshMenuChangeHistory(modal, recipient === "edit" ? data : null, "item", restaurantId);
  menuitemutil.references = menuitemutil.getRecursiveReferencers(data, [data]);

  if (typeof menuitemutil.entityType == "undefined" && data != null) {
    menuitemutil.entityType = data.entityType;
    if (data.entityType == "Drink") {
      menuitemutil.entitytype = "drink";
      //utils = drinkutils;
    } else {
      menuitemutil.entitytype = "meal";
      //utils = mealutils;
    }
  }

  modal.find(".highlight-3").removeClass("highlight-3");

  //menuitemEdited = data;

  modalOpen = modal;
  $("body").unbind("paste");
  $("body").on("paste", paste);

  $("#crop").hide();
  if (data && data.color) {
    applyColorSelection(modal, data.color);
  } else {
    applyColorSelection(modal, null);
  }

  modal.find("#modal-type").val(menuitemutil.entityType);
  modal.find("#smallImage").attr("src", "");
  modal.find("#smallImage").data("bigImage", null)

  modal.find("#smallImageWolt").attr("src", "");
  modal.find("#smallImageFoodpanda").attr("src", "");
  modal.find("#smallImageFalatozz").attr("src", "");
  modal.find("#smallImageChoiceqr").attr("src", "");
  modal.find("#smallImageDiv i").addClass("hidden");
  modal.find("#smallImageWoltDiv i").addClass("hidden");
  modal.find("#smallImageFoodpandaDiv i").addClass("hidden");
  modal.find("#smallImageChoiceqrDiv i").addClass("hidden");

  modal.find("#input#color").find("input").change(() => { });

  admin.initializeSelect2($('#editMenuItem select.select2'));
  admin.initializeSelect2($('#editMenuCategory select.select2'));

  clearTokens(modal.find("#item_barcodes").tokenize2());
  clearTokens(modal.find("#item_additions_mandatory").tokenize2());
  clearTokens(modal.find("#item_additions_included").tokenize2());
  clearTokens(modal.find("#item_additions_optional").tokenize2());
  clearTokens(modal.find("#inherited_item_additions_mandatory").tokenize2());
  clearTokens(modal.find("#inherited_item_additions_included").tokenize2());
  clearTokens(modal.find("#inherited_item_additions_optional").tokenize2());
  clearTokens(modal.find("#item_labels").tokenize2());
  clearTokens(modal.find("#references").tokenize2());
  clearTokens(modal.find("#upsellMenuItems").tokenize2());
  if (data) {
    modal.find("#modal-type").val(data.entityType);
    if (data.inventoryItem === true || (data.inventoryItem !== false && data.defaultInventoryItem === true)) {
      modal.addClass("inventory");
      $("td .inventoryItem.checkbox").parent().parent().removeClass("hidden");
      $("th.mi_inventoryItem").removeClass('hidden');
      $("input#unit_price").parent().addClass("hidden");
      $("input#unit_cost").parent().addClass("hidden");
      $("input#pricePerCostRatio").parent().removeClass("hidden");
      //$(".input-group-mandatory").addClass("hidden");
      //$(".input-group-included").addClass("hidden");
      //clearTokens(modal.find("#item_additions_mandatory").tokenize2());
      //clearTokens(modal.find("#item_additions_included").tokenize2());
    } else {
      modal.removeClass("inventory");
      $("td .inventoryItem.checkbox").parent().parent().addClass("hidden");
      $("th.mi_inventoryItem").addClass('hidden');
      $("input#unit_price").parent().removeClass("hidden");
      $("input#unit_cost").parent().addClass("hidden");
      $("input#pricePerCostRatio").parent().addClass("hidden");
      $(".input-group-mandatory").removeClass("hidden");
      //$(".input-group-included").removeClass("hidden");
    }
  } else {
    const parentCategory = menuitemutil.getMenuCategory(menuCategoryId);
    const parentCategoryInventoryItem = parentCategory.defaultInventoryItem;
    if (parentCategoryInventoryItem) {
      modal.addClass("inventory");
      $("td .inventoryItem.checkbox").parent().parent().removeClass("hidden");
      $("th.mi_inventoryItem").removeClass('hidden');
      $("input#unit_price").parent().addClass("hidden");
      $("input#unit_cost").parent().addClass("hidden");
      $("input#pricePerCostRatio").parent().removeClass("hidden");
      //$(".input-group-mandatory").addClass("hidden");
      //$(".input-group-included").addClass("hidden");
      //clearTokens(modal.find("#item_additions_mandatory").tokenize2());
      //clearTokens(modal.find("#item_additions_included").tokenize2());
    } else {
      modal.removeClass("inventory");
      $("td .inventoryItem.checkbox").parent().parent().addClass("hidden");
      $("th.mi_inventoryItem").addClass('hidden');
      $("input#unit_price").parent().removeClass("hidden");
      $("input#unit_cost").parent().addClass("hidden");
      $("input#pricePerCostRatio").parent().addClass("hidden");
      $(".input-group-mandatory").removeClass("hidden");
      //$(".input-group-included").removeClass("hidden");
    }
  }
  modal.find("textarea").css("height", "");
  modal.find("div#production_lines input").prop("checked", false);
  modal.find("div#production_lines input").parent().removeClass("active");
  modal.find("div#production_lines input").parent().attr("default", false);
  modal.find("#action").val("");

  modal.find("#crop").hide();
  modal.find("#cost_estimation").val(0);
  modal.find("#unit_price_estimation").val(0);
  modal.find("#menuItem_minimumPrice").prop("checked", false);
  modal.find("#save").prop("disabled", false);
  modal.find("#saveAndOpen").prop("disabled", false);
  modal.find("#saveAndNew").prop("disabled", false);
  modal.find("#vat_category").val("");
  modal.find("#takeaway_vat_category").val("");

  const getEditorCategoryBase = () => {
    if (restaurantId && connectedRestaurants[restaurantId]?.data) {
      return connectedRestaurants[restaurantId].data;
    }
    return admin.adminCategories || admin.categories;
  };

  const collectCategoryOptions = (nodes, categoryType, base, options = [], visited = new Set()) => {
    if (!Array.isArray(nodes)) return options;
    nodes.forEach(node => {
      if (!node || !node.entityType || node.entityType.indexOf("Category") < 0) return;
      if (visited.has(node.id)) return;
      visited.add(node.id);

      if (!categoryType || node.entityType === categoryType) {
        options.push({
          id: String(node.id),
          text: menuitemutil._getPath(node, base)
        });
      }

      const childCandidates = [];
      if (Array.isArray(node.activeMenuCategories)) childCandidates.push(...node.activeMenuCategories);
      if (Array.isArray(node.children)) childCandidates.push(...node.children);
      collectCategoryOptions(childCandidates, categoryType, base, options, visited);
    });
    return options;
  };

  const refreshMenuItemHeaderContext = () => {
    const base = getEditorCategoryBase();
    const parentCategoryId = Number(modal.find("#parentCategoryId").val()) || 0;
    const parentCategory = parentCategoryId ? menuitemutil.getMenuCategory(parentCategoryId, base) : null;
    const parentPath = parentCategory ? menuitemutil._getPath(parentCategory, base) : "";

    const inputNameMap = getLocalizedNameFromInputs(modal, "#name_");
    const liveMenuItemData = menuitemutil.data || data;
    const nameSource = Object.keys(inputNameMap).length ? inputNameMap : (liveMenuItemData?.name || {});
    const localizedName = Object.keys(nameSource).length ? (getLocale(nameSource) || nameSource.all || "") : "";
    const priceEntries = getMenuItemHeaderPriceEntries(modal, liveMenuItemData);

    setModalHeaderContext(modal, parentPath, localizedName, priceEntries);
  };

  const updateParentCategoryContext = selectedCategoryId => {
    const numericCategoryId = selectedCategoryId ? Number(selectedCategoryId) : undefined;
    modal.find("#parentCategoryId").val(numericCategoryId || "");

    const base = getEditorCategoryBase();
    const menuCategory = numericCategoryId ? menuitemutil.getMenuCategory(numericCategoryId, base) : null;

    if (menuCategory) {
      modal.find("#timing option[value='inherit']").html(admin_local.inherit + (menuCategory.defaultTiming && menuCategory.defaultTiming !== "inherit" ? "(" + getLocale2(auth.myStatus.restaurant_settings.timings[menuCategory.defaultTiming].langs).name + ")" : ""));
      if (menuCategory.defaultVATCategory) {
        const vatOptionText = modal.find("#vat_category option[value='" + menuCategory.defaultVATCategory.id + "']").first().text();
        modal.find("#vat_category option[value='']").html(admin_local.inherit + (vatOptionText ? "(" + vatOptionText + ")" : ""));
      } else {
        modal.find("#vat_category option[value='']").html(admin_local.inherit);
      }
      if (menuCategory.defaultTakeawayVATCategory) {
        const takeawayVatOptionText = modal.find("#takeaway_vat_category option[value='" + menuCategory.defaultTakeawayVATCategory.id + "']").first().text();
        modal.find("#takeaway_vat_category option[value='']").html(admin_local.inherit + (takeawayVatOptionText ? "(" + takeawayVatOptionText + ")" : ""));
      } else {
        modal.find("#takeaway_vat_category option[value='']").html(admin_local.inherit);
      }
    } else {
      modal.find("#timing option[value='inherit']").html(admin_local.inherit);
      modal.find("#vat_category option[value='']").html(admin_local.inherit);
      modal.find("#takeaway_vat_category option[value='']").html(admin_local.inherit);
    }

    refreshMenuItemHeaderContext();
  };

  const base = getEditorCategoryBase();
  applyUpsellMenuItems(modal, recipient === "edit" ? null : data, base);
  const rootCategories = base?.activeMenuCategories || base?.children || [];
  const categoryType = menuitemutil.entityType ? menuitemutil.entityType + "Category" : undefined;
  const categoryOptions = collectCategoryOptions(rootCategories, categoryType, base);
  const parentCategorySelect = modal.find("select#parent_category");

  if (parentCategorySelect.hasClass("select2-hidden-accessible")) {
    parentCategorySelect.select2("destroy");
  }

  parentCategorySelect.empty();
  categoryOptions.forEach(option => {
    parentCategorySelect.append($("<option></option>").attr("value", option.id).text(option.text));
  });

  parentCategorySelect.select2({
    width: "100%",
    dropdownParent: modal,
    placeholder: admin_local.select_a_category,
    minimumResultsForSearch: 8
  });

  const selectedCategoryId = menuCategoryId != null ? String(menuCategoryId) : "";
  if (selectedCategoryId && parentCategorySelect.find("option[value='" + selectedCategoryId + "']").length) {
    parentCategorySelect.val(selectedCategoryId);
  } else if (parentCategorySelect.find("option").length) {
    parentCategorySelect.prop("selectedIndex", 0);
  }

  parentCategorySelect.trigger("change.select2");

  updateParentCategoryContext(parentCategorySelect.val());

  parentCategorySelect.off("change.menuitemParentCategory").on("change.menuitemParentCategory", function () {
    updateParentCategoryContext($(this).val());
  });

  modal.off("input.menuitemHeaderName", "input[id^='name_'], input#name_all").on("input.menuitemHeaderName", "input[id^='name_'], input#name_all", function () {
    refreshMenuItemHeaderContext();
  });

  modal.off("input.menuitemHeaderPrice change.menuitemHeaderPrice", "input#unit_price, #menuItemQuantities input, #menuItemQuantities select")
    .on("input.menuitemHeaderPrice change.menuitemHeaderPrice", "input#unit_price, #menuItemQuantities input, #menuItemQuantities select", function () {
      refreshMenuItemHeaderContext();
    });
  const barcodes = modal.find("div.barcodes");
  barcodes.empty();
  menuitemutil.oldMenuItemData = "{menuItemAdditions:[]}";

  modal.find('input.datepicker').val("");
  modal.find('input.datepicker').prop("placeholder", "");

  modal.find("#mntak_main_category").val("");
  menuitemutil.updateNtakCategories("m", modal, data);
  modal.find("#mntak_sub_category").val("");
  modal.find("#allergens > *").removeClass("has");
  modal.find("#allergens > *").removeClass("removable");
  modal.find("#allergens > *").removeClass("inherited");
  modal.find("input#calorie").val(0);

  if (recipient == "edit") {

    modal.find("#id").val(data.id);
    modal.find("#alias").val(data.globalId);
    modal.find("#short_name").val(data.shortName);
    modal.find("#manufacturer").val(data.manufacturer);
    data.inheritedRemovableAllergens && data.inheritedRemovableAllergens.forEach(function (allergen) {
      modal.find("#allergens #" + allergen).addClass("inherited");
      modal.find("#allergens #" + allergen).addClass("removable");
    });
    data.inheritedAllergens && data.inheritedAllergens.forEach(function (allergen) {
      modal.find("#allergens #" + allergen).addClass("inherited");
      modal.find("#allergens #" + allergen).removeClass("removable");
    });
    data.menuItemAdditions && data.menuItemAdditions.filter(addition => addition.additionType === "included").forEach(addition => {
      admin.getMenuItemAdmin(addition.addition.id).allergens && admin.getMenuItemAdmin(addition.addition.id).allergens.forEach(allergen => {
        modal.find("#allergens #" + allergen).addClass("inherited");
        modal.find("#allergens #" + allergen).addClass("removable");
      })
    })
    data.removable_allergens && data.removable_allergens.forEach(function (allergen) {
      modal.find("#allergens #" + allergen).addClass("has");
      modal.find("#allergens #" + allergen).addClass("removable");
    });
    data.allergens && data.allergens.forEach(function (allergen) {
      modal.find("#allergens #" + allergen).addClass("has");
      modal.find("#allergens #" + allergen).removeClass("removable");
    });
    modal.find("input#calorie").val(Math.round(data.calorie * 10) / 10);
    modal.find("input#calories_of_ingredients").val(Math.round(10 * (data.defaultCalorie - data.calorie)) / 10);
    modal.find("input#calories_sum").val(Math.round(data.defaultCalorie * 10) / 10);
    auth.myStatus.restaurant_languages.forEach(function (lang) {
      modal.find("#name_" + lang).val(data.name[lang]);
      modal.find("#description_" + lang).val(data.description[lang]);
    });
    if (data.image && data.image != "") {
      if (data.bigImage && data.bigImage != "") modal.find("#smallImage").attr("src",
        imageUrl + data.bigImage + "?timestamp=" + data.bigImageTimestamp + "&instance=" + instance);
      else modal.find("#smallImage").attr("src", imageUrl + data.image + "?timestamp=" + data.imageTimestamp + "&instance=" + instance);
      $(modal.find("#smallImageDiv")).removeClass("hidden");
      $(modal.find("#smallImageDiv i")).removeClass("hidden");
    } else {
      modal.find("#smallImage").attr("src", "");
      $(modal.find("#smallImageDiv")).removeClass("hidden");
      $(modal.find("#smallImageDiv i")).addClass("hidden");
    }

    if (data.woltImage && data.woltImage != "") {
      modal.find("#smallImageWolt").attr("src", imageUrl + data.woltImage + "?instance=" + instance + "&timestamp=" + new Date().getTime());
      $(modal.find("#smallImageWoltDiv i")).removeClass("hidden");
    }

    if (data.foodpandaImage && data.foodpandaImage != "") {
      modal.find("#smallImageFoodpanda").attr("src", imageUrl + data.foodpandaImage + "?instance=" + instance + "&timestamp=" + new Date().getTime());
      $(modal.find("#smallImageFoodpandaDiv i")).removeClass("hidden");
    }
    if (data.falatozzImage && data.falatozzImage != "") {
      modal.find("#smallImageFalatozz").attr("src", imageUrl + data.falatozzImage + "?instance=" + instance + "&timestamp=" + new Date().getTime());
      $(modal.find("#smallImageFalatozzDiv i")).removeClass("hidden");
    }
    if (data.choiceqrImage && data.choiceqrImage != "") {
      modal.find("#smallImageChoiceqr").attr("src", imageUrl + data.choiceqrImage + "?instance=" + instance + "&timestamp=" + new Date().getTime());
      $(modal.find("#smallImageChoiceqrDiv i")).removeClass("hidden");
    }

    modal.find("#name_all").val(data.name["all"]);
    modal.find("#description_all").val(data.description["all"]);
    if (data.isActive == true) modal.find("#mi_active").prop("checked", "true");
    else modal.find("#mi_active").prop("checked", false);
    if (data.above18 == true) modal.find("#above18").prop("checked", "true") && modal.find("label[for = 'above18']").addClass("active");
    else modal.find("#above18").prop("checked", false) && modal.find("label[for = 'above18']").removeClass("active");
    if (data.defaultAbove18 == true) modal.find("label[for = 'above18']").attr("default", "true");
    else modal.find("label[for = 'above18']").attr("default", "false");
    if (data.isTop == true) modal.find("#mi_isTop").prop("checked", "true");
    else modal.find("#mi_isTop").prop("checked", false);
    if (data.pos == true) modal.find("#mi_pos").prop("checked", "true");
    else modal.find("#mi_pos").prop("checked", false);
    if (data.kiosk == true) modal.find("#mi_kiosk").prop("checked", "true");
    else modal.find("#mi_kiosk").prop("checked", false);
    if (data.freeQuantity == true) modal.find("#mi_freequantity").prop("checked", false);
    else modal.find("#mi_freequantity").prop("checked", true);
    if (data.online == true) modal.find("#mi_online").prop("checked", "true");
    else modal.find("#mi_online").prop("checked", false);
    if (data.available == true) modal.find("#mi_available").prop("checked", "true");
    else modal.find("#mi_available").prop("checked", false);
    if (data.inventoryItem !== undefined && data.inventoryItem !== null) {
      modal.find("#mi_isInventoryItem").prop("checked", data.inventoryItem);
      modal.find("#mi_isInventoryItem").prop("indeterminate", false);
    } else {
      modal.find("#mi_isInventoryItem").prop("indeterminate", true);
      modal.find("#mi_isInventoryItem").prop("checked", false);
    }
    modal.find("#mi_isDefaultInventoryItem").prop("checked", data.defaultInventoryItem);
    menuitemutil.setQuantityType(modal, data.quantityType, false);
    modal.find('span.q_quantity_type').html(I18n.t('local.' + data.quantityType));
    modal.find('input#mandatory_volume').val(data.mandatory_volume ? data.mandatory_volume : 1);

    modal.find("#timing").val(data.timing);
    data.productionLines.forEach(function (pl) {
      modal.find("div#production_lines input#mpl_" + pl.id).prop("checked", "true");
      modal.find("div#production_lines input#mpl_" + pl.id).parent().addClass("active");
    });
    if (data.defaultProductionLineIds)
      data.defaultProductionLineIds.split(",").forEach(function (pl) {
        modal.find("div#production_lines input#mpl_" + pl).parent().attr("default", "true");
      });
    modal.find("#vat_category").val(data.vatCategory ? data.vatCategory.id : "");
    modal.find("#takeaway_vat_category").val(data.takeawayVatCategory ? data.takeawayVatCategory.id : "");
    modal.find("#unit_cost").val(data.cost);
    modal.find("#cost_estimation").val(Math.round((data.costEstimation) * 1000) / 1000);
    modal.find("#unit_price").val(Math.round(data.unitPrice * 1000) / 1000);
    modal.find("#menuItem_minimumPrice").prop("checked", data.minimumPrice);
    modal.find("#unit_price_estimation").val(Math.round(data.unitPriceEstimation * 1000) / 1000);

    modal.find("#mntak_main_category").val(data.mainCategoryId);
    menuitemutil.updateNtakCategories("m", modal, data);
    modal.find("#mntak_sub_category").val(data.subCategoryId);


    if (data.barcodes)
      data.barcodes.forEach(barcode => {
        //$('#barcodeTemplate').tmpl(barcode).appendTo(barcodes);

        modal
          .find("#item_barcodes")
          .trigger("tokenize:tokens:add", [
            barcode.id,
            barcode.name ?
              barcode.name + " " + barcode.quantity + "cl (" + barcode.id + ")" : "" + barcode.id
          ]);


      });


    processMenuItemQuantities(data.availableQuantities, data);
    $("#saveAndNew").addClass("hidden");

    const upsellTokenizerValues = new Set();
    const categoryTokenizerValues = new Set();

    function populateAdditions(item, prefix) {

      const itemId = Number(item?.id);
      const isDirectAddition = addition => {
        const ownerId = addition?.menuItemId ?? addition?.menuItem?.id;
        if (ownerId !== undefined && ownerId !== null && ownerId !== "") {
          return Number(ownerId) === itemId;
        }
        return true;
      };
      const additions = [...item.menuItemAdditions, ...item.menuCategoryAdditions].filter(isDirectAddition);
      additions.sort((a, b) => a.order - b.order);

      additions.forEach((addition, ind) => {
        if (addition.type === "meal_addition" || addition.type === "drink_addition") {
          if (addition.additionType === "upsell") {
            menuitemutil.getMenuItem2(addition.additionId, menuItem => {
              const entityType = (addition.type.split("_")[0] || "").toLowerCase();
              const tokenValue = "menuItem;" + (addition.id || -1) + ";" + menuItem.id + ";" + (addition.quantity || 1) + ";" + entityType;
              const dedupeKey = "menuItem:" + menuItem.id;
              const upsellTokenizer = modal.find("#upsellMenuItems");
              upsellTokenizer.tokenize2().toArray().forEach(existingToken => {
                const parts = String(existingToken || "").split(";");
                if (parts[0] === "menuItem" && Number(parts[2]) === Number(menuItem.id) && existingToken !== tokenValue) {
                  upsellTokenizer.trigger("tokenize:tokens:remove", [existingToken]);
                }
              });
              if (upsellTokenizerValues.has(dedupeKey)) {
                return;
              }
              upsellTokenizerValues.add(dedupeKey);
              upsellTokenizer.trigger("tokenize:tokens:add", [
                tokenValue,
                wrapTokenizerLabelText(menuitemutil.getPath(menuItem)),
                true
              ]);
            });
            return;
          }
          menuitemutil.getMenuItem2(addition.additionId, menuItem => {
            const quantity = Math.round(1000 * parseFloat(addition.quantity) * (addition.additionType === "mandatory" && data.mandatory_volume ? data.mandatory_volume : 1)) / 1000;
            modal
              .find("#" + prefix + "item_additions_" + addition.additionType)
              .trigger("tokenize:tokens:add", [
                "menuItem;" + addition.id + ";" + menuItem.id + ";" + (addition.additionType == "mandatory" ? "" : (quantity)) + ";" + addition.type.split("_")[0],
                wrapTokenizerLabelText(menuitemutil.getPath(menuItem)) +
                menuitemutil.getLocalOption("al_" + ind, addition.local) +
                menuitemutil.getTakeawayOption("at_" + ind, addition.takeaway) +
                menuitemutil.getProportionalOption("aa_" + ind, addition.proportional) +
                "\n" +
                menuitemutil.getQuantityLabel2(addition.additionType, quantity, menuItem.quantityType, getLocale(getNameForQuantity(menuItem, quantity))) +
                (menuItem.costEstimation * quantity > 0 ? "<span class='cost'>&nbsp;" + Math.round(menuItem.costEstimation * quantity * 1000) / 1000 + " " + auth.myStatus.restaurant_base_currency.name + "</span>" : "<span/>") +
                "<span class='calorie'>&nbsp;" + Math.round(menuItem.calorie * quantity * 10) / 10 + " kcal</span>",
                true
              ]);
            const it = modal.find("#" + prefix + "item_additions_" + addition.additionType).next().find("span#" + "aa_" + ind + " , " + "span#" + "al_" + ind + " , " + "span#" + "at_" + ind);
            if (prefix)
              it.find('input.proportional').parent().remove();
            if (auth?.myStatus?.restaurant_settings?.["shop-mode"])
              tooltip(it);
            if (prefix)
              modal.find("#" + prefix + "item_additions_" + addition.additionType).next().find('.token-search input').remove();
          });
        } else {
          if (addition.additionType === "upsell") {
            menuitemutil.getMenuCategory2(addition.additionId, menuCategory => {
              const entityType = (addition.type.split("_")[0] || "").toLowerCase();
              const tokenValue = "menuCategory;" + (addition.id || -2) + ";" + menuCategory.id + ";;" + entityType;
              const dedupeKey = "menuCategory:" + menuCategory.id;
              const upsellTokenizer = modal.find("#upsellMenuItems");
              upsellTokenizer.tokenize2().toArray().forEach(existingToken => {
                const parts = String(existingToken || "").split(";");
                if (parts[0] === "menuCategory" && Number(parts[2]) === Number(menuCategory.id) && existingToken !== tokenValue) {
                  upsellTokenizer.trigger("tokenize:tokens:remove", [existingToken]);
                }
              });
              if (upsellTokenizerValues.has(dedupeKey)) {
                return;
              }
              upsellTokenizerValues.add(dedupeKey);
              upsellTokenizer.trigger("tokenize:tokens:add", [
                tokenValue,
                wrapTokenizerLabelText(menuitemutil.getPath(menuCategory)),
                true,
                "category",
                true
              ]);
            });
            return;
          }
          try {
            menuitemutil.getMenuCategory2(addition.additionId, menuCategory => {
              const tokenValue = "menuCategory;" + addition.id + ";" + menuCategory.id + ";;" + addition.type.split("_")[0];
              const tokenizerBucket = prefix + "item_additions_" + addition.additionType;
              const dedupeKey = tokenizerBucket + "|menuCategory:" + menuCategory.id;
              if (categoryTokenizerValues.has(dedupeKey)) {
                return;
              }
              categoryTokenizerValues.add(dedupeKey);
              modal.find("#" + tokenizerBucket).trigger("tokenize:tokens:add", [
                tokenValue,
                wrapTokenizerLabelText(menuitemutil.getPath(menuCategory)) + (!prefix ? menuitemutil.getProportionalOption("aaa_" + ind) : ""),
                true,
                "category",
                true
              ]);
              if (!prefix)
                modal.find("#" + tokenizerBucket).trigger("tokenize:tokens:reorder");
              const select = $(modal.find("#" + tokenizerBucket).next().get(0));
              const it = select.find("span#" + "aaa_" + ind);
              if (prefix) {
                select.find('.dismiss').remove();
                select.find('input.proportional').parent().remove();
                select.find('.token-search input').remove();
              } else {
                it.find('input.proportional').prop('checked', addition.proportional);
              }
              if (auth?.myStatus?.restaurant_settings?.["shop-mode"])
                tooltip(it);
              if (addition.optionType) {
                switch (addition.optionType) {
                  case "separate":
                    select.find('input[id="check2' + "menuCategory;" + addition.id + ";" + menuCategory.id + ';;' + addition.type.split("_")[0] + '"]').prop("checked", true);
                    select.find('input[id="check2' + "menuCategory;" + addition.id + ";" + menuCategory.id + ';;' + addition.type.split("_")[0] + '"] ~ span > input#min').val(addition.min);
                    select.find('input[id="check2' + "menuCategory;" + addition.id + ";" + menuCategory.id + ';;' + addition.type.split("_")[0] + '"] ~ span > input#max').val(addition.max);
                    break;
                  case "maxone":
                    select.find('input[id="radio' + "menuCategory;" + addition.id + ";" + menuCategory.id + ';;' + addition.type.split("_")[0] + '"]').prop("checked", true);
                    break;
                  case "one":
                    select.find('input[id="radio2' + "menuCategory;" + addition.id + ";" + menuCategory.id + ';;' + addition.type.split("_")[0] + '"]').prop("checked", true);
                    break;
                  default:
                    select.find('input[id="check' + "menuCategory;" + addition.id + ";" + menuCategory.id + ';;' + addition.type.split("_")[0] + '"]').prop("checked", true);
                    break;
                }
              }
            });
          } catch (ex) {
            console.log(ex);
          }

        }
      });
      if (prefix === "") {
        modal.find("#" + prefix + "item_additions_mandatory").trigger("tokenize:tokens:reorder");
        modal.find("#" + prefix + "item_additions_included").trigger("tokenize:tokens:reorder");
        modal.find("#" + prefix + "item_additions_optional").trigger("tokenize:tokens:reorder");
        modal.find("#upsellMenuItems").trigger("tokenize:tokens:reorder");
      }

      if (prefix && item.menuCategoryId && !settingEnabled("shop-mode")) {
        populateAdditions(getMenuCategory(item), prefix);
      }

    }


    if (!settingEnabled("shop-mode")) {
      populateAdditions(data, "");
      const parentCategory = getMenuCategory(data);
      if (parentCategory) {
        populateAdditions(parentCategory, "inherited_");
      }
    }

    menuItemReferences(data).forEach(({ menuItem, addition }, ind) => {
      const key = (menuItem.entityType.indexOf("Category") === -1 ? "menuItem" : "menuCategory") + ";" + addition.id + ";" + menuItem.id + ";" + (addition.additionType == "mandatory" ? "" : addition.quantity) + ";" + addition.type.split("_")[0];
      if (menuItem != null) {
        modal
          .find("#references")
          .trigger("tokenize:tokens:add", [
            key,
            wrapTokenizerLabelText(menuitemutil.getPath(menuItem)) +
            "\n<span class='cost'>&nbsp;" +
            menuitemutil.getQuantityLabel2(addition.additionType, Math.round(1000 * parseFloat(addition.quantity)) / 1000, data.quantityType, getLocale(getNameForQuantity(data, addition.quantity)), true) + "</span>"
          ]);
      }
      const it = modal.find("#references").next().find("*[data-value = '" + key + "']");
      it.find('input').remove();
      it.find('.dismiss').remove();
    });
    modal.find("#references").next().find(".token-search input").remove();


    if (data.labels)
      data.labels.forEach(function (label) {
        modal.find("#item_labels").trigger("tokenize:tokens:add", ["label;" + label.id + ";", label.name]);
      });

    if (data.pricePerCostRatio) new Cleave(modal.find("#pricePerCostRatio"), { numeral: true }).onInput("" + data.pricePerCostRatio * 100);
    else new Cleave(modal.find("#pricePerCostRatio"), { numeral: true }).onInput("");
    modal.find("#pricePerCostRatio").attr("placeholder", "");
    if (menuCategoryId) {
      var menuCategory = data ? getMenuCategory(data) : admin.getMenuCategoryAdmin(menuCategoryId);
      modal.find("#pricePerCostRatio").attr("placeholder", menuCategory.defaultPricePerCostRatio * 100);
    }
    if (data.quantityType == "none") {
      menuitemutil.setQuantityType(modal, "none", false);
      menuitemutil.setQuantityTypeDisabled(modal, true);
      $(".menuItemSpecific").hide();
      $(".optionSpecific").show();
      modal.find('select#quantityTypeSelect option[value="none"]').prop("disabled", null);
    } else {
      menuitemutil.setQuantityType(modal, data.quantityType, false);
      menuitemutil.setQuantityTypeDisabled(modal, false);
      $(".optionSpecific").hide();
      $(".menuItemSpecific").show();
      modal.find('select#quantityTypeSelect option[value="none"]').prop("disabled", true);
    }
    if (data.preorder != undefined) {
      if (data.preorder == true) modal.find("#m_preorder").prop("checked", true);
      else modal.find("#m_preorder").prop("checked", false);
      modal.find("#m_preorder").prop("indeterminate", false);
    } else {
      modal.find("#m_preorder").prop("indeterminate", true);
      modal.find("#m_preorder").prop("checked", false);
    }
    if (data.toDate) {
      var formattedDate = moment(data.toDate).format('YYYY-MM-DD');
      modal.find('input#m_to_date').val(formattedDate);
    }
    if (data.defaultToDate) {
      formattedDate = moment(data.defaultToDate).format('YYYY-MM-DD');
      modal.find('input#m_to_date').attr("placeholder", formattedDate);
    }
    if (data.fromDate) {
      var formattedDate = moment(data.fromDate).format('YYYY-MM-DD');
      modal.find('input#m_from_date').val(formattedDate);
    }
    if (data.defaultFromDate) {
      formattedDate = moment(data.defaultFromDate).format('YYYY-MM-DD');
      modal.find('input#m_from_date').attr("placeholder", formattedDate);
    }

  } else {
    modal.find("#id").val("");
    auth.myStatus.restaurant_languages.forEach(function (lang) {
      modal.find("#name_" + lang).val("");
      modal.find("#description_" + lang).val("");
    });
    modal.find("#short_name").val("");
    modal.find("#manufacturer").val("");
    modal.find("#name_all").val("");
    modal.find("#description_all").val("");
    if (recipient == "new-option") {
      menuitemutil.setQuantityType(modal, "none", false);
      menuitemutil.setQuantityTypeDisabled(modal, true);
    }
    modal.find("#unit_price").val("");
    modal.find("#unit_cost").val("");
    modal.find("#timing").val("inherit");
    modal.find("#production_line").val("");
    modal.find("#vat_category").val("");
    modal.find("#smallImage").attr("src", "");
    $(modal.find("#smallImageDiv")).removeClass("hidden");
    $(modal.find("#smallImageDiv i")).addClass("hidden");
    auth.myStatus.restaurant_languages.forEach(function (lang) {
      modal.find("#name_" + lang).val("");
    });
    modal.find("#mi_active").prop("checked", "true");
    modal.find("#mi_isTop").prop("checked", "true");
    modal.find("#mi_pos").prop("checked", "true");
    modal.find("#mi_kiosk").prop("checked", "true");
    modal.find("#mi_freequantity").prop("checked", true);
    modal.find("#mi_online").prop("checked", "true");
    modal.find("#mi_available").prop("checked", "true");
    modal.find("#mi_isInventoryItem").prop("checked", null);
    modal.find("#mi_isInventoryItem").prop("indeterminate", true);
    menuitemutil.setQuantityType(modal, "", false);
    modal.find("#unit_price").val(0);
    modal.find('span.q_quantity_type').html("")
    modal.find('input#mandatory_volume').val(1);

    var menuCategory = data ? getMenuCategory(data) : admin.getMenuCategoryAdmin(menuCategoryId);

    if (menuCategory.defaultToDate) {
      formattedDate = moment(menuCategory.defaultToDate).format('YYYY-MM-DD');
      modal.find('input#m_to_date').attr("placeholder", formattedDate);
    }
    if (menuCategory.defaultFromDate) {
      formattedDate = moment(menuCategory.defaultFromDate).format('YYYY-MM-DD');
      modal.find('input#m_from_date').attr("placeholder", formattedDate);
    }

    if (menuCategory.defaultProductionLineIds)
      menuCategory.defaultProductionLineIds.split(",").forEach(function (pl) {
        modal.find("div#production_lines input#mpl_" + pl).parent().attr("default", "true");
      });
    modal.find("#pricePerCostRatio").attr("placeholder", menuCategory.defaultPricePerCostRatio * 100);
    if (recipient == "new-option") {
      modal.find("#mi_isTop").prop("checked", null);
      modal.find("#mi_kiosk").prop("checked", null);
      modal.find("#mi_online").prop("checked", null);
      modal.find("#mi_available").prop("checked", null);
      menuitemutil.setQuantityType(modal, "none", false);
      menuitemutil.setQuantityTypeDisabled(modal, true);
      processMenuItemQuantities([], {});
      $(".menuItemSpecific").hide();
      $(".optionSpecific").show();
      modal.find('select#quantityTypeSelect option[value="none"]').prop("disabled", null);
    } else {
      modal.find("#mi_isTop").prop("checked", "true");
      modal.find("#mi_kiosk").prop("checked", "true");
      modal.find("#mi_online").prop("checked", "true");
      modal.find("#mi_available").prop("checked", "true");
      menuitemutil.setQuantityTypeDisabled(modal, false);
      processMenuItemQuantities(
        [
          {
            title: "",
            folder: false,
            label: {},
            quantity: 1,
            price: undefined,
            def: true,
            inventoryItem: menuCategory.defaultInventoryItem
          }
        ],
        {}
      );
      $(".optionSpecific").hide();
      $(".menuItemSpecific").show();
      modal.find('select#quantityTypeSelect option[value="none"]').prop("disabled", true);
    }
    new Cleave(modal.find("#pricePerCostRatio"), {}).onInput("");
    modal.find("#pricePerCostRatio").attr("placeholder", "");
  }

  refreshMenuItemHeaderContext();
  $("#saveAndNew").removeClass("hidden");

  setupQuantityTypeSelector(modal);
  setupSingleSelectionListboxes(modal);

  menuitemutil.oldMenuItemData = JSON.stringify(saveMenuItem(undefined, true, true));

  invokeMenuitemAutomation("initializeAutomationValueAttributes", [modal]);

  resetMenuEditorChangeTrackingOnRepopulation(modal);

  // Function to make tokens draggable
  function makeTokensDraggable(tokenizeElement) {
    tokenizeElement.find('.tokens-container .token').draggable({
      //helper: 'clone',
      revert: 'invalid',
      start: function (event, ui) {
        ui.helper.addClass('dragging');
      },
      stop: function (event, ui) {
        ui.helper.removeClass('dragging');
      }
    });
  }

  // Function to make containers droppable
  function makeContainersDroppable(tokenizeElement) {

    tokenizeElement.find('+').find(".tokens-container").droppable({
      accept: '.tokens-container .token',
      drop: function (event, ui) {

        var originalTokenizeElement = ui.helper.closest('.tokenize').prev('select');

        if (originalTokenizeElement.get(0) == tokenizeElement.get(0))
          return;

        var tokenValue = ui.helper.data('value');
        var tokenLabel = ui.helper.get(0).cloneNode(true);
        $(tokenLabel).css("left", "");
        $(tokenLabel).css("top", "");
        $(tokenLabel).css("width", "");
        $(tokenLabel).css("height", "");
        $(tokenLabel).removeClass("dragged");
        setTimeout(() => {
          // Remove token from the original container
          originalTokenizeElement.trigger('tokenize:tokens:remove', [tokenValue]);
          originalTokenizeElement.trigger("tokenize:tokens:reorder");
        }, 100);

        // Add token to the dropped container
        tokenizeElement.trigger('tokenize:tokens:add', [tokenValue, tokenLabel, true]);
        tokenizeElement.trigger("tokenize:tokens:reorder");

        makeTokensDraggable($("div#editMenuItem #item_additions_mandatory").parent());
        makeTokensDraggable($("div#editMenuItem #item_additions_included").parent());

      }
    });

  }
  makeTokensDraggable($("div#editMenuItem #item_additions_mandatory").parent());
  makeTokensDraggable($("div#editMenuItem #item_additions_included").parent());
  makeContainersDroppable($("div#editMenuItem #item_additions_mandatory"));
  makeContainersDroppable($("div#editMenuItem #item_additions_included"));

  // Add tokens dynamically
  $("div#editMenuItem #item_additions_mandatory").on('tokenize:tokens:add tokenize:tokens:remove', function () {
    makeTokensDraggable($(this).parent());
  });

  $("div#editMenuItem #item_additions_included").on('tokenize:tokens:add tokenize:tokens:remove', function () {
    makeTokensDraggable($(this).parent());
  });

};

menuitemutil.getProportionalOption = (id, value = false) => {
  const icon = require("../../img/icon-proportional.svg");
  return '<span class="proportional" id="' + id + '" data-toggle="tooltip" data-placement="bottom" data-original-title="' + I18n.t('admin_local.proportional_addition_tooltip') + '"><span aria-hidden="true" style="display:inline-flex;align-items:center;justify-content:center;width:1rem;height:1rem;margin-right:.15rem;"><img src="' + icon + '" alt="" style="width:1rem;height:1rem;display:block;"/></span><input type="checkbox" class="checkbox proportional" id="' + id + '" style="height: 1rem;align-self: center;" ' + (value ? 'checked' : '') + '></span>';
  //return '<div class="custom-control custom-checkbox" style="display: flex;justify-content: center;padding-left:2.5rem"><input type="checkbox" class="custom-control-input checkbox isActive" id="a_' + id + '"><label class="custom-control-label" for="a_' + id + '">aaa</label></div>';
}

menuitemutil.getMinMaxOption = () => {
  return '<span class="min" id="min" data-toggle="tooltip" data-placement="bottom" data-original-title="' + I18n.t('admin_local.min_addition_tooltip') + '"><input type="number" class="checkbox proportional" id="min" style="height: 1rem;align-self: center;"><small class="minmax-label">min</small></span><span class="minmax-separator">-</span>' +
    '<span class="max" id="max" data-toggle="tooltip" data-placement="bottom" data-original-title="' + I18n.t('admin_local.max_addition_tooltip') + '"><input type="number" class="checkbox proportional" id="max" style="height: 1rem;align-self: center;"><small class="minmax-label">max</small></span>';
  //return '<div class="custom-control custom-checkbox" style="display: flex;justify-content: center;padding-left:2.5rem"><input type="checkbox" class="custom-control-input checkbox isActive" id="a_' + id + '"><label class="custom-control-label" for="a_' + id + '">aaa</label></div>';
}

menuitemutil.getLocalOption = (id, value = false) => {
  const icon = require("../../img/icon-local.svg");
  return '<span class="local" id="' + id + '" data-toggle="tooltip" data-placement="bottom" data-original-title="' + I18n.t('admin_local.local_addition_tooltip') + '"><span aria-hidden="true" style="display:inline-flex;align-items:center;justify-content:center;width:1rem;height:1rem;margin-right:.15rem;"><img src="' + icon + '" alt="" style="width:1rem;height:1rem;display:block;"/></span><input type="checkbox" class="checkbox local" id="' + id + '" style="height: 1rem;align-self: center;" ' + (value ? 'checked' : '') + '></span>';
}
menuitemutil.getTakeawayOption = (id, value = false) => {
  return '<span class="takeaway" id="' + id + '" data-toggle="tooltip" data-placement="bottom" data-original-title="' + I18n.t('admin_local.takeaway_addition_tooltip') + '"><span class="i_takeaway" aria-hidden="true" style="display:inline-flex;align-items:center;justify-content:center;width:1rem;height:1rem;margin-right:.15rem;"></span><input type="checkbox" class="checkbox takeaway" id="' + id + '" style="height: 1rem;align-self: center;" ' + (value ? 'checked' : '') + '></span>';
}

function getTokenizerTokenClass(tokenValue) {
  if (tokenValue.startsWith("menuItem")) {
    return "menu-item";
  }
  if (tokenValue.startsWith("menuCategory")) {
    return "menu-category";
  }
  return "";
}

function syncTokenizerTokenClass(input) {
  $(input)
    .next()
    .find("li[data-value]")
    .each((_, token) => {
      const className = getTokenizerTokenClass($(token).data("value") + "");
      if (className) {
        $(token).addClass(className);
      }
    });
}


menuitemutil.getQuantityLabel2 = function (additionType, quantity, quantityType, label, showQuantity = false) {
  var res;
  if (label !== undefined && label !== "")
    label = " (" + label + ")";
  else
    label = ""
      ; if (quantityType == "none") return "";

  if (!label) label = "";

  if (additionType == "mandatory" || additionType == "included" || additionType == "optional")
    res = '<input id="quantity" type="number" value="' + quantity + '"></input><span class="quantity">' + (showQuantity ? quantity + " " : "") + (quantityType == "none" ? I18n.t("local.pcs") : I18n.t("local." + quantityType)) + "</span>";
  else res = quantityType == "pcs" && quantity == 1 ? "" : quantity + (quantityType == "none" ? I18n.t("local.pcs") : " " + I18n.t("local." + quantityType));
  return res;
};

menuitemutil.getQuantityLabel3 = function (additionType, quantity, quantityType) {
  var res;
  if (quantityType == "none") return "";
  if (additionType == "mandatory" || additionType == "included") res = quantity + " " + (quantityType == "none" ? "" : I18n.t("local." + quantityType));
  else res = quantityType == "pcs" && quantity == 1 ? "" : quantity + (quantityType == "none" ? "" : " " + I18n.t("local." + quantityType));
  return res;
};

menuitemutil.parseNumber = function (number) {
  if (typeof number == "undefined") return "";
  if (typeof number == "number") return number;
  number = number.replace(" ", "");
  number = number.replace(",", ".");
  number = Number(number);
  return number;
};

menuitemutil.handleFilterDeletedChange = event => {
  const t = event.target;
  var checked = $(t).prop("checked");
  menuitemutil.filter.deleted = checked;
  $("#showDeleted").toggleClass("active", checked).attr("aria-pressed", checked ? "true" : "false");
  menuitemutil.reload();
};
menuitemutil.handleFilterCheckBoxChange = event => {
  const t = event.target;
  const attr = $(t)
    .parents("th")
    .attr("class");
  var indeterminate = $(t).prop("indeterminate");
  var checked_old = $(t).prop("checked_old");
  var checked = $(t).prop("checked");
  if (checked && checked_old != undefined && (indeterminate == undefined || indeterminate == false)) {
    $(t).prop("indeterminate", true);
    $(t).prop("checked", false);
    $(t).removeProp("checked_old");
  } else {
    $(t).prop("checked_old", $(t).prop("checked"));
  }
  var indeterminate = $(t).prop("indeterminate");
  var checked = $(t).prop("checked");
  menuitemutil.filter[attr] = indeterminate ? undefined : checked;
  const allCheckBoxes = $("table thead tr th." + attr + " input[type = 'checkbox']");
  allCheckBoxes.prop("checked", checked);
  allCheckBoxes.prop("indeterminate", indeterminate);
  menuitemutil.filterNodes();
};

menuitemutil.filterNode = (node) => {
  if (!menuitemutil.entityType || (node.data.entityType && node.data.entityType.startsWith(menuitemutil.entityType))) {
    if (menuitemutil.filter.name) {
      if (
        removeAccents(node.data.manufacturer + " " + getLocale(node.data.name, localStorage.languageSelected))
          .toLowerCase()
          .indexOf(removeAccents(menuitemutil.filter.name).toLowerCase()) === -1
      )
        return false;
    }
    /*
    if (menuitemutil.filter.manufacturer && node.data.manufacturer) {
      var c = removeAccents(node.data.manufacturer ? node.data.manufacturer : "").toLowerCase();
      if (c.indexOf(removeAccents(menuitemutil.filter.manufacturer).toLowerCase()) === -1)
        return false;
    }*/
    if (menuitemutil.filter.labels) {
      var ok = false;
      node.data.labels.forEach(l => {
        if (removeAccents(l.name).toLowerCase().indexOf(removeAccents(menuitemutil.filter.labels)).toLowerCase() !== -1)
          ok = true;
      });
      return ok;
    }
    if (menuitemutil.filter.active !== undefined) {
      if (menuitemutil.filter.active !== Boolean(node.data.isActive)) return null;
    }
    if (menuitemutil.filter.inventory !== undefined) {
      if (node.data.inventoryItem !== undefined) {
        if (menuitemutil.filter.inventory !== node.data.inventoryItem) return false;
      } else if (menuitemutil.filter.inventory !== node.data.defaultInventoryItem) return false;
    }
    if (menuitemutil.filter.top !== undefined) {
      if (menuitemutil.filter.top !== node.data.isTop) {
        return null;
      }
    }
    if (menuitemutil.filter.kiosk !== undefined) {
      if (menuitemutil.filter.kiosk !== node.data.kiosk) {
        return null;
      }
    }
    if (menuitemutil.filter.online !== undefined) {
      if (menuitemutil.filter.online !== node.data.online) return null;
    }
    if (menuitemutil.filter.availablequantity !== undefined) {
      const v = node.data.availableQuantities ? node.data.availableQuantities.length > 0 : false;
      if (!node.data.availableQuantities || menuitemutil.filter.availablequantity !== v) return false;
    }
    if (menuitemutil.filter.cost !== undefined) {
      if (!node.data.availableQuantities) return false;
      if (node.data.defaultInventoryItem) {
        const res = node.data.availableQuantities.filter(q => q.inventoryItem).filter(qq => {
          const approvedCost = Math.round(qq.approvedCost * (qq.approvedCost < 10 ? 10 : 1)) / (qq.approvedCost < 10 ? 10 : 1);
          const cost1 =
            node.data.defaultInventoryItem && qq.inventoryItem ? qq.cost :
              (node.data.costEstimation < 10
                ? node.data.costEstimation
                : Math.round(node.data.costEstimation)) * qq.quantity
          const cost = Math.round(cost1 * (cost1 < 10 ? 10 : 1)) / (cost1 < 10 ? 10 : 1);
          const costChangeThreshold = auth?.myStatus?.restaurant_settings["enabled-features"]?.inventory?.costChangeThreshold || 5;
          const costChange = Math.abs(cost / approvedCost - 1) * 100;
          if ((!cost && !approvedCost) || costChange <= costChangeThreshold) {
            return menuitemutil.filter.cost;
          }
          return !menuitemutil.filter.cost;
        }).length > 0;
        /* lest check the connected restaurants as well */

        if (!res && node.data.connectedRestaurants)
          return Object.keys(node.data.connectedRestaurants).filter(r1 => {
            if (r1 > 0) {
              const r = node.data.connectedRestaurants[r1];
              if (r.availableQuantities) {
                const res2 = r.availableQuantities.filter(q => q.inventoryItem).filter(qq => {
                  const approvedCost = Math.round(qq.approvedCost * (qq.approvedCost < 10 ? 10 : 1)) / (qq.approvedCost < 10 ? 10 : 1);
                  const cost1 =
                    node.data.defaultInventoryItem && qq.inventoryItem ? qq.cost :
                      (node.data.costEstimation < 10
                        ? node.data.costEstimation
                        : Math.round(node.data.costEstimation)) * qq.quantity;
                  const cost = Math.round(cost1 * (cost1 < 10 ? 10 : 1)) / (cost1 < 10 ? 10 : 1);
                  const costChangeThreshold = auth?.myStatus?.restaurant_settings["enabled-features"]?.inventory?.costChangeThreshold || 5;
                  const costChange = Math.abs(cost / approvedCost - 1) * 100;
                  if ((!cost && !approvedCost) || costChange <= costChangeThreshold) {
                    return menuitemutil.filter.cost;
                  }
                  return !menuitemutil.filter.cost;
                }).length > 0;
                return res2;
              }
            }
            return false;
          }).length > 0;


        return res;
      } else {
        return false;
      }
    }
    return true;
  }
  return false;
}

menuitemutil.filterNode2 = (node) => {
  const rest = menuitemutil.filterNode(node);
  if (rest === null)
    return false;
  if (rest)
    return true;
  if (node.parent && node.parent.data && node.parent.data.name)
    return menuitemutil.filterNode2(node.parent);
  return false;
}

menuitemutil.filterNodes = () => {
  menuitemutil.menuItems && menuitemutil.menuItems.filterNodes(function (node) {
    return menuitemutil.filterNode2(node);

  });
};

export const filterChanged = e => {
  menuitemutil.filter["name"] = e.target.value.toLowerCase();
  menuitemutil.filter["manufacturer"] = e.target.value.toLowerCase();
  menuitemutil.filterNodes();
};

var myChart;
var chartUrl;
var isCategory = false;
function populateCharts() {
  if ($("#chart-block").hasClass("hidden")) return;
  isCategory = false;
  var menuItem = menuitemutil.menuItems.getActiveNode();
  if (menuItem === null)
    return;
  chartUrl = "adminService/" + localStorage.restaurantSelected + "/getComponentStockHistory/" + 0 + "/" + menuItem.data.id + "?from=" + localStorage.menuitems_start + "&to=" + localStorage.menuitems_end;
  var chartUrl2 = chartUrl;
  get(chartUrl, false).done(function (data) {
    if (chartUrl == chartUrl2) drawChart(data);
  });
}

var menuItemIds = [];
function populateCategoryCharts() {
  if ($("#chart-block").hasClass("hidden")) return;
  isCategory = true;
  var category = menuitemutil.menuItems.getActiveNode();
  menuItemIds = [];
  function addChildren(category) {
    category.children.forEach(c => {
      if (c.data.availableQuantities)
        menuItemIds.push(c.data.id);
      if (c.children)
        addChildren(c);
    });
  }
  if (category.children)
    addChildren(category);
  chartUrl = "adminService/" + localStorage.restaurantSelected + "/getMenuItemsHistory/0?from=" + localStorage.menuitems_start + "&to=" + moment(Number(localStorage.menuitems_end)).endOf("day").valueOf() + "&timestamp=" + new Date().getTime();
  var chartUrl2 = chartUrl;
  post(chartUrl, menuItemIds, undefined, false).done(function (data) {
    if (chartUrl == chartUrl2) drawChart(data);
  });
}

function trimDate(date, range) {
  date = new Date(date);
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
  if (range == "week") {
    date = getMonday(date);
    return date;
  } else if (range == "month") {
    date = new Date(date.getFullYear(), date.getMonth(), 1);
    return date;
  }
  return date;
}

var oldData;

function drawChart(data) {
  if ($("#chart-block").hasClass("hidden")) return;
  var range = $("[name='range']:checked").attr("id");
  ajaxCallStart("processing");
  setTimeout(() => {
    try {
      if (typeof data == "undefined") data = oldData;
      else oldData = data;
      if (!menuitemutil.menuItems.getActiveNode())
        return;
      var menuItem = menuitemutil.menuItems.getActiveNode().data;
      var $tdList = $(menuitemutil.menuItems.getActiveNode().tr).find(">td");
      var currentQuantityType = [];
      //$tdList.eq(3).html();
      //if (currentQuantityType.split(" ")[0] == 1) currentQuantityType = currentQuantityType.split(" ")[1];

      var focus = localStorage["menuitems_dataset_focus"] == "true";

      var ctx = document.getElementById("myChart").getContext("2d");
      var historyData = [];
      var datasets = {};
      var stores = [];
      data.CostAndPriceHistory.forEach(h => {
        h.trimmed_date = trimDate(h.date, range);
        if (stores.indexOf(h.store.id) == -1) stores.push(h.store.id);
      });

      var consumptionsPerOrder = {};
      data.ConsumptionStockEntry.forEach(c => {
        c.trimmed_date = trimDate(c.date, range);
        var cs = consumptionsPerOrder[c.order.id];
        if (cs == undefined) consumptionsPerOrder[c.order.id] = [c];
        else cs.push(c);
      });

      var label = I18n.t("admin_local.stock");
      datasets["k"] = { yAxisID: "y-axis-1", steppedLine: "middle", type: "line", label: label, data: [], fill: false, backgroundColor: colors[0] };

      data.Orders.forEach(h => {
        h.trimmed_created = trimDate(h.created, range);
      });

      //currentQuantityType = [];
      data.Orders.forEach(h => {
        var menuItem = admin.getMenuItemAdmin(h.menuItemId);
        if (currentQuantityType.indexOf(I18n.t("local." + menuItem.quantityType)) == -1) currentQuantityType.push(I18n.t("local." + menuItem.quantityType));
        var key = "f";
        if (datasets[key]) {
        } else {
          var label = I18n.t("admin_local.consumption");
          datasets[key] = { yAxisID: "y-axis-1", pointRadius: 3, lineTension: 0.1, borderWidth: 3, pointStyle: "rect", type: "bar", label: label, data: [], fill: false, backgroundColor: colors[1] };
        }
        var date = h.trimmed_created;
        if (datasets[key].data.length > 0) {
          var dd = datasets[key].data[datasets[key].data.length - 1];
          if (dd.x.getTime() == date.getTime()) {
            dd.y += h.quantity;
          } else {
            var hh = Object.assign({}, h);
            hh.date = date;
            datasets[key].data.push({ x: date, y: h.quantity, data: hh, currentQuantityType: I18n.t("local." + menuItem.quantityType) });
          }
        } else {
          var hh = Object.assign({}, h);
          datasets[key].data.push({ x: date, y: h.quantity, data: hh, currentQuantityType: I18n.t("local." + menuItem.quantityType) });
        }
      });

      if (!isCategory)
        data.Orders.forEach(h => {
          var key = "p";
          if (datasets[key]) {
          } else {
            var label = I18n.t("admin_local.price");
            datasets[key] = { yAxisID: "y-axis-2", pointRadius: 5, lineTension: 0.1, pointStyle: "rect", type: "line", label: label, data: [], fill: true, borderColor: colors[2] };
          }
          var date = h.trimmed_created;
          var fullPrice = h.fullPrice - h.discount - h.tableMateDiscount;
          if (datasets[key].data.length > 0) {
            var dd = datasets[key].data[datasets[key].data.length - 1];
            if (dd.x.getTime() == date.getTime()) {
              dd.totalPrice += fullPrice;
              dd.totalCount += h.quantity;
              dd.y = Math.round((1000 * dd.totalPrice) / dd.totalCount) / 1000;
            } else {
              var hh = Object.assign({}, h);
              hh.date = date;
              datasets[key].data.push({ x: date, y: Math.round((1000 * fullPrice) / h.quantity) / 1000, totalPrice: fullPrice, totalCount: h.quantity, data: hh });
            }
          } else {
            var hh = Object.assign({}, h);
            datasets[key].data.push({ x: date, y: Math.round((1000 * fullPrice) / h.quantity) / 1000, totalPrice: fullPrice, totalCount: h.quantity, data: hh });
          }
        });

      if (!isCategory)
        data.Orders.forEach(h => {
          var key = "r";

          if (datasets[key]) {
          } else {
            var label = I18n.t("admin_local.price_goal");
            datasets[key] = { yAxisID: "y-axis-2", borderDash: [10, 5], borderWidth: 1, pointRadius: 0, lineTension: 0.1, pointStyle: "rectRot", type: "line", label: label, data: [], fill: true, borderColor: colors[3] };
          }
          var cost = 0;
          var quantity = 0;
          var cs = consumptionsPerOrder[h.id];
          if (cs != undefined)
            cs.forEach(c => {
              cost += c.cost;
            });
          var date = h.trimmed_created;
          if (datasets[key].data.length > 0) {
            var dd = datasets[key].data[datasets[key].data.length - 1];
            if (dd.x.getTime() == date.getTime()) {
              dd.totalCost += cost * menuItem.defaultPricePerCostRatio;
              dd.totalCount += h.quantity;
              dd.y = Math.round((1000 * dd.totalCost) / dd.totalCount) / 1000;
            } else {
              var hh = Object.assign({}, h);
              hh.date = date;
              datasets[key].data.push({ x: date, y: cost * menuItem.defaultPricePerCostRatio, totalCost: cost * menuItem.defaultPricePerCostRatio, totalCount: h.quantity, data: hh });
            }
          } else {
            var hh = Object.assign({}, h);
            datasets[key].data.push({ x: date, y: cost * menuItem.defaultPricePerCostRatio, totalCost: cost * menuItem.defaultPricePerCostRatio, totalCount: h.quantity, data: hh });
          }
        });

      if (!isCategory)
        data.Orders.forEach(h => {
          var key = "c";
          if (datasets[key]) {
          } else {
            var label = I18n.t("admin_local.cost");
            datasets[key] = { yAxisID: "y-axis-2", pointRadius: 5, borderWidth: 2, lineTension: 0.1, pointStyle: "rectRot", type: "line", label: label, data: [], fill: true, borderColor: colors[4] };
          }
          var cost = 0;
          var quantity = 0;
          var cs = consumptionsPerOrder[h.id];
          if (cs != undefined)
            cs.forEach(c => {
              cost += c.cost;
            });
          var date = h.trimmed_created;
          if (datasets[key].data.length > 0) {
            var dd = datasets[key].data[datasets[key].data.length - 1];
            if (dd.x.getTime() == date.getTime()) {
              dd.totalCost += cost;
              dd.totalCount += h.quantity;
              dd.y = Math.round((1000 * dd.totalCost) / dd.totalCount) / 1000;
            } else {
              var hh = Object.assign({}, h);
              hh.date = date;
              datasets[key].data.push({ x: date, y: cost, totalCost: cost, totalCount: h.quantity, data: hh });
            }
          } else {
            var hh = Object.assign({}, h);
            datasets[key].data.push({ x: date, y: cost, totalCost: cost, totalCount: h.quantity, data: hh });
          }
        });

      //Bevétel - income
      data.Orders.forEach(h => {
        var key = "o";
        if (datasets[key]) {
        } else {
          var label = I18n.t("admin_local.income");
          datasets[key] = { yAxisID: "y-axis-2", pointRadius: 5, pointStyle: "rect", lineTension: 0.1, type: "line", label: label, data: [], fill: true, borderColor: colors[5] };
        }
        var fullPrice = h.fullPrice - h.discount - h.tableMateDiscount;
        var date = h.trimmed_created;
        if (datasets[key].data.length > 0) {
          var dd = datasets[key].data[datasets[key].data.length - 1];
          if (dd.x.getTime() == date.getTime()) {
            dd.y += fullPrice;
          } else {
            datasets[key].data.push({ x: date, y: fullPrice });
          }
        } else {
          datasets[key].data.push({ x: date, y: fullPrice });
        }
      });

      //Árrés - profit margin
      data.Orders.forEach(h => {
        var key = "m";
        if (datasets[key]) {
        } else {
          var label = I18n.t("admin_local.profit_margin");
          datasets[key] = { yAxisID: "y-axis-2", pointRadius: 5, pointStyle: "rect", lineTension: 0.1, type: "line", label: label, data: [], fill: true, borderColor: colors[6] };
        }
        var fullPrice = h.fullPrice - h.discount - h.tableMateDiscount;
        var cost = 0;
        var quantity = 0;
        var cs = consumptionsPerOrder[h.id];
        if (cs != undefined)
          cs.forEach(c => {
            cost += c.cost;
          });
        var date = h.trimmed_created;
        if (datasets[key].data.length > 0) {
          var dd = datasets[key].data[datasets[key].data.length - 1];
          if (dd.x.getTime() == date.getTime()) {
            dd.y += fullPrice - cost;
          } else {
            datasets[key].data.push({ x: date, y: fullPrice - cost });
          }
        } else {
          datasets[key].data.push({ x: date, y: fullPrice - cost });
        }
      });

      //Árrés - profit margin %
      data.Orders.forEach(h => {
        var key = "pr";
        if (datasets[key]) {
        } else {
          var label = I18n.t("admin_local.profit_margin") + " %";
          datasets[key] = { yAxisID: "y-axis-5", pointRadius: 5, borderWidth: 2, pointStyle: "rectRot", lineTension: 0.1, type: "line", label: label, data: [], fill: true, borderColor: colors[7] };
        }
        var fullPrice = h.fullPrice - h.discount - h.tableMateDiscount;
        var cost = 0;
        var quantity = 0;
        var cs = consumptionsPerOrder[h.id];
        if (cs != undefined)
          cs.forEach(c => {
            cost += c.cost;
          });
        var date = h.trimmed_created;
        if (datasets[key].data.length > 0) {
          var dd = datasets[key].data[datasets[key].data.length - 1];
          if (dd.x.getTime() == date.getTime()) {
            dd.totalPrice += fullPrice;
            dd.totalCost += cost;
          } else {
            datasets[key].data.push((dd = { x: date, totalPrice: fullPrice, totalCost: cost }));
          }
        } else {
          datasets[key].data.push((dd = { x: date, totalPrice: fullPrice, totalCost: cost }));
        }
        dd.y = dd.totalCost == 0 ? 100 : Math.round(((dd.totalPrice - dd.totalCost) / dd.totalCost) * 100);
      });

      if (!isCategory)
        data.IncomingStockEntry.forEach(h => {
          var key = "b-" + h.store.id;
          if (datasets[key]) {
          } else {
            var label = stores.length == 1 ? I18n.t("admin_local.incoming_stock") : getStore(h.store.id).name + " " + I18n.t("admin_local.incoming_stock").toLowerCase();
            datasets[key] = { yAxisID: "y-axis-1", type: "bar", label: label, data: [], fill: false, backgroundColor: getStore(h.store.id).color };
          }
          var date = trimDate(h.date, range);
          if (datasets[key].data.length > 0) {
            var dd = datasets[key].data[datasets[key].data.length - 1];
            if (dd.x.getTime() == date.getTime()) {
              var hh = Object.assign({}, h);
              //datasets[key].data.push({ x: date, y: h.count * h.quantity, data: hh });
              dd.y += h.count * h.quantity;
              dd.data.net_unit_price = (dd.data.count * dd.data.net_unit_price + h.count * h.net_unit_price) / (dd.data.count + h.count);
              dd.data.count += h.count * h.quantity;
            } else {
              var hh = Object.assign({}, h);
              hh.date = date;
              datasets[key].data.push({ x: date, y: h.count * h.quantity, data: hh });
            }
          } else {
            var hh = Object.assign({}, h);
            datasets[key].data.push({ x: date, y: h.count * h.quantity, data: hh });
          }
        });

      if (!isCategory)
        data.InventoryEntry.forEach(h => {
          var key = "i-" + h.store.id;
          if (datasets[key]) {
          } else {
            var label = stores.length == 1 ? I18n.t("admin_local.inventory") : getStore(h.store.id).name + " " + I18n.t("admin_local.inventory").toLowerCase();
            datasets[key] = {
              yAxisID: "y-axis-1",
              type: "bar",
              label: label,
              data: [],
              fill: false,
              backgroundColor: darken(getStore(h.store.id).color, 20)
            };
          }
          var date = trimDate(h.date, range);
          datasets[key].data.push({ x: date, y: h.count - h.originalCount, data: h });
        });

      var yaxes = [];
      var datas = [];
      var datasetsSelected = 0;
      var mainFocusPrefix = "";
      Object.keys(datasets).forEach((key, index) => {
        datasets[key].hidden = localStorage["menuitems_dataset_" + key] == "true";
        datas.push(datasets[key]);
        if (!(localStorage["menuitems_dataset_" + key] == "true")) {
          datasetsSelected++;
          mainFocusPrefix = key.split("-")[0];
        } else {
          if (focus) datasets[key].hidden = true;
        }
      });

      if (datasetsSelected != 1) {
        localStorage["menuitems_dataset_focus"] = false;
      }

      function getEntry(data, x) {
        var v = 0;
        var index = 0;
        data.forEach((d, ind) => {
          if (d.x.getTime() == x.getTime()) {
            v = d;
            index = ind;
          }
        });
        return { index: index, value: v };
      }
      var dates = new SortedSet({ comparator: function (a, b) { return a.getTime() - b.getTime(); } });
      data.CostAndPriceHistory.forEach(h => {
        if (SortedSet.find(dates, h.trimmed_date) === null) {
          dates.insert(h.trimmed_date);
        }
      });
      var dataExample = [];
      dates.forEach(d => {
        dataExample.push({ x: d, y: 0 });
      });

      var getKey = function (focusPrefix, menuItem, quantity) {
        if (menuItem.defaultInventoryItem) {
          return focusPrefix + "-" + menuItem.id + "-" + menuitemutil.getInventoryQuantity(menuItem, quantity);
        } else return focusPrefix + "-" + menuItem.id;
      };
      var getLabel = function (focusPrefix, menuItem, quantity) {
        //if (menuItem.defaultInventoryItem) return getLocale(menuItem.name) + /*" " + menuitemutil.getInventoryQuantity(menuItem, quantity) + " " + I18n.t("local." + menuItem.quantityType)*/;
        //else 
        return getLocale(menuItem.name);
      };

      var focusPrefix = "";
      var previousEntry = null;
      if (datasetsSelected == 1 && mainFocusPrefix == "k" && focus) {
        currentQuantityType = [];
        focusPrefix = "kk";
        datasets["k"].data = [];
        datasets["k"].yAxisID = "y-axis-6";
        data.CostAndPriceHistory.forEach(h => {
          var menuItem = admin.getMenuItemAdmin(h.menuItem);
          if (currentQuantityType.indexOf(I18n.t("local." + menuItem.quantityType)) == -1) currentQuantityType.push(I18n.t("local." + menuItem.quantityType));
          h.count = Math.round(h.count * 1000) / 1000;
          var quantity = Math.abs(h.quantity);
          var key = getKey(focusPrefix, menuItem, quantity);
          var dataset = datasets[key];
          if (!dataset) {
            let datas = $.extend(true, [], dataExample);
            var label = getLabel(focusPrefix, menuItem, quantity);
            datasets[key] = dataset = {
              yAxisID: "y-axis-6",
              type: "line",
              lineTension: 0.1,
              showLine: true,
              pointBorderColor: colors[Object.keys(datasets).length],
              pointStyle: "circle",
              pointBackgroundColor: colors[Object.keys(datasets).length],
              lineWidth: 0,
              pointBorderWidth: 0,
              borderWidth: 0,
              label: label,
              data: datas,
              fill: false,
              backgroundColor: colors[Object.keys(datasets).length],
              borderColor: colors[Object.keys(datasets).length]
            };
          }
          var date = h.trimmed_date;
          var entry = getEntry(dataset.data, date);
          var dd = entry.value;
          if (previousEntry !== entry && previousEntry !== null) {
            for (let index = previousEntry.index; index < entry.index; index++) {
              dataset.data[index].y = previousEntry.value.y;
            }
          }
          previousEntry = entry;
          dd.y = h.count * h.quantity;
          dd.currentQuantityType = I18n.t("local." + menuItem.quantityType);
          for (let index = entry.index + 1; index < dataset.data.length; index++) {
            dataset.data[index].y = previousEntry.value.y;
          }

        });
      } else if (datasetsSelected == 1 && mainFocusPrefix == "f" && focus) {
        currentQuantityType = [];
        datasets["f"].data = [];
        datasets["f"].yAxisID = "y-axis-6";
        focusPrefix = "ff";
        data.Orders.forEach(h => {
          var menuItem = admin.getMenuItemAdmin(h.menuItemId, true);
          if (currentQuantityType.indexOf(I18n.t("local." + menuItem.quantityType)) == -1) currentQuantityType.push(I18n.t("local." + menuItem.quantityType));
          var quantity = Math.abs(h.quantity);
          var key = getKey(focusPrefix, menuItem, quantity);
          if (datasets[key]) {
          } else {
            var label = getLabel(focusPrefix, menuItem, quantity);
            datasets[key] = {
              yAxisID: "y-axis-6",
              pointRadius: 3,
              lineTension: 0.1,
              borderWidth: 3,
              pointStyle: "rect",
              type: "line",
              label: label,
              data: [],
              fill: false,
              backgroundColor: colors[Object.keys(datasets).length],
              borderColor: colors[Object.keys(datasets).length]
            };
          }
          var date = h.trimmed_created;
          if (datasets[key].data.length > 0) {
            var dd = datasets[key].data[datasets[key].data.length - 1];
            if (dd.x.getTime() == date.getTime()) {
              dd.y += h.quantity;
            } else {
              var hh = Object.assign({}, h);
              hh.date = date;
              datasets[key].data.push({ x: date, y: quantity, data: hh, currentQuantityType: I18n.t("local." + menuItem.quantityType) });
            }
          } else {
            var hh = Object.assign({}, h);
            datasets[key].data.push({ x: date, y: h.quantity, data: hh, currentQuantityType: I18n.t("local." + menuItem.quantityType) });
          }
        });
      } else if (datasetsSelected == 1 && mainFocusPrefix == "m" && focus) {
        currentQuantityType = [];
        datasets["mm"].data = [];
        datasets["mm"].yAxisID = "y-axis-2";
        focusPrefix = "mm";
        data.Orders.forEach(h => {
          var menuItem = admin.getMenuItemAdmin(h.menuItemId, true);
          if (currentQuantityType.indexOf(I18n.t("local." + menuItem.quantityType)) == -1) currentQuantityType.push(I18n.t("local." + menuItem.quantityType));
          var quantity = Math.abs(h.quantity);
          var fullPrice = h.fullPrice - h.discount - h.tableMateDiscount;
          var key = getKey(focusPrefix, menuItem, quantity);
          if (datasets[key]) {
          } else {
            var label = getLabel(focusPrefix, menuItem, quantity);
            datasets[key] = {
              yAxisID: "y-axis-2",
              pointRadius: 3,
              lineTension: 0.1,
              borderWidth: 3,
              pointStyle: "rect",
              type: "line",
              label: label,
              data: [],
              fill: false,
              backgroundColor: colors[Object.keys(datasets).length],
              borderColor: colors[Object.keys(datasets).length]
            };
          }

          var fullPrice = h.fullPrice - h.discount - h.tableMateDiscount;
          var cost = 0;
          var quantity = 0;
          var cs = consumptionsPerOrder[h.id];
          if (cs != undefined)
            cs.forEach(c => {
              cost += c.cost;
            });
          var date = h.trimmed_created;
          if (datasets[key].data.length > 0) {
            var dd = datasets[key].data[datasets[key].data.length - 1];
            if (dd.x.getTime() == date.getTime()) {
              dd.y += fullPrice - cost;
            } else {
              datasets[key].data.push({ x: date, y: fullPrice - cost });
            }
          } else {
            datasets[key].data.push({ x: date, y: fullPrice - cost });
          }

          /*
      	
      	
        var date = h.trimmed_created;
        if (datasets[key].data.length>0) {
          var dd = datasets[key].data[datasets[key].data.length-1];
          if (dd.x.getTime()==date.getTime()) {
            dd.count += quantity;
            dd.totalPrice += fullPrice*quantity;
            dd.y = Math.round(dd.totalPrice/dd.count);
          } else {
            var hh = Object.assign({}, h);
            hh.date=date;
            datasets[key].data.push({ x: date, y: fullPrice*quantity, totalPrice:fullPrice*quantity, count:quantity, currentQuantityType : local[menuItem.quantityType]} );
          }
        } else {
          var hh = Object.assign({}, h);
          datasets[key].data.push({ x: date, y: h.fullPrice*quantity, totalPrice:fullPrice*quantity, count:quantity, currentQuantityType : local[menuItem.quantityType]} );
        }
        */
        });
      } else if (datasetsSelected == 1 && mainFocusPrefix == "o" && focus) {
        currentQuantityType = [];
        datasets["o"].data = [];
        datasets["o"].yAxisID = "y-axis-2";
        focusPrefix = "oo";
        data.Orders.forEach(h => {
          var menuItem = admin.getMenuItemAdmin(h.menuItemId, true);
          if (currentQuantityType.indexOf(I18n.t("local." + menuItem.quantityType)) == -1) currentQuantityType.push(I18n.t("local." + menuItem.quantityType));
          var quantity = Math.abs(h.quantity);
          var key = getKey(focusPrefix, menuItem, quantity);
          var fullPrice = h.fullPrice - h.discount - h.tableMateDiscount;

          if (datasets[key]) {
          } else {
            var label = getLabel(focusPrefix, menuItem, quantity);
            datasets[key] = {
              yAxisID: "y-axis-2",
              pointRadius: 3,
              lineTension: 0.1,
              borderWidth: 3,
              pointStyle: "rect",
              type: "line",
              label: label,
              data: [],
              fill: false,
              backgroundColor: colors[Object.keys(datasets).length],
              borderColor: colors[Object.keys(datasets).length]
            };
          }
          var date = h.trimmed_created;
          if (datasets[key].data.length > 0) {
            var dd = datasets[key].data[datasets[key].data.length - 1];
            if (dd.x.getTime() == date.getTime()) {
              dd.y += h.fullPrice;
            } else {
              var hh = Object.assign({}, h);
              hh.date = date;
              datasets[key].data.push({ x: date, y: h.fullPrice, data: hh, currentQuantityType: I18n.t("local." + menuItem.quantityType) });
            }
          } else {
            var hh = Object.assign({}, h);
            datasets[key].data.push({ x: date, y: h.fullPrice, data: hh, currentQuantityType: I18n.t("local." + menuItem.quantityType) });
          }
        });
      } else if (datasetsSelected == 1 && mainFocusPrefix == "c" && focus) {
        datasets["c"].data = [];
        datasets["c"].yAxisID = "y-axis-4";
        data.ConsumptionStockEntry.forEach(h => {
          h.count = Math.round(h.count * 1000) / 1000;
          var quantity = Math.abs(h.quantity);
          var key = getKey(focusPrefix, menuItem, quantity);
          var dataset = datasets[key];
          if (!dataset) {
            let datas = $.extend(true, [], dataExample);
            var label = getLabel(focusPrefix, menuItem, quantity);
            datasets[key] = dataset = {
              yAxisID: "y-axis-4",
              type: "line",
              lineTension: 0.1,
              showLine: true,
              pointBorderColor: colors[Object.keys(datasets).length],
              pointStyle: "circle",
              pointBackgroundColor: colors[Object.keys(datasets).length],
              lineWidth: 0,
              pointBorderWidth: 0,
              borderWidth: 0,
              label: label,
              data: datas,
              fill: true,
              backgroundColor: colors[Object.keys(datasets).length]
            };
          }
          var date = h.trimmed_date;

          var dd = getEntry(dataset.data, date).value;
          if (typeof dd.totalCost == "undefined") {
            dd.totalCost = 0;
            dd.totalQuantity = 0;
          }
          dd.totalCost += h.cost;
          dd.totalQuantity += 1;
          dd.y = dd.totalCost / dd.totalQuantity;
        });
        focusPrefix = "pc";
      } else if (datasetsSelected == 1 && mainFocusPrefix == "oo" && focus) {
        data.ConsumptionStockEntry.forEach(h => {
          datasets["oo-" + h.stock.store.id].data = [];
          datasets["oo-" + h.stock.store.id].yAxisID = "y-axis-4";
          h.count = Math.round(h.count * 1000) / 1000;
          var quantity = Math.abs(h.quantity);
          var key = getKey(focusPrefix, menuItem, quantity);
          var dataset = datasets[key];
          if (!dataset) {
            let datas = $.extend(true, [], dataExample);
            var label = getLabel(focusPrefix, menuItem, quantity);
            datasets[key] = dataset = {
              yAxisID: "y-axis-4",
              type: "bar",
              lineTension: 0.1,
              showLine: true,
              pointBorderColor: colors[Object.keys(datasets).length],
              pointStyle: "circle",
              pointBackgroundColor: colors[Object.keys(datasets).length],
              lineWidth: 0,
              pointBorderWidth: 0,
              borderWidth: 0,
              label: label,
              data: datas,
              fill: true,
              backgroundColor: colors[Object.keys(datasets).length]
            };
          }
          var date = h.trimmed_date;

          var dd = getEntry(dataset.data, date).value;
          dd.y += h.price - h.cost;
        });
        focusPrefix = "pc";
      } else if (datasetsSelected == 1 && mainFocusPrefix == "pr" && focus) {
        data.ConsumptionStockEntry.forEach(h => {
          datasets["pr-" + h.stock.store.id].data = [];
          datasets["pr-" + h.stock.store.id].yAxisID = "y-axis-5";
          h.count = Math.round(h.count * 1000) / 1000;
          var quantity = Math.abs(h.quantity);
          var key = getKey(focusPrefix, menuItem, quantity);
          var dataset = datasets[key];
          if (!dataset) {
            let datas = $.extend(true, [], dataExample);
            var label = getLabel(focusPrefix, menuItem, quantity);
            datasets[key] = dataset = {
              yAxisID: "y-axis-5",
              type: "line",
              lineTension: 0.1,
              showLine: true,
              pointBorderColor: colors[Object.keys(datasets).length],
              pointStyle: "circle",
              pointBackgroundColor: colors[Object.keys(datasets).length],
              lineWidth: 3,
              pointBorderWidth: 2,
              borderWidth: 3,
              label: label,
              data: datas,
              fill: false,
              backgroundColor: colors[Object.keys(datasets).length]
            };
          }
          var date = h.trimmed_date;
          var dd = getEntry(dataset.data, date).value;
          dd.totalPrice = (dd.totalPrice ? dd.totalPrice : 0) + h.price;
          dd.totalCost = (dd.totalCost ? dd.totalCost : 0) + h.cost;
          dd.y = Math.round((100 * dd.totalPrice) / dd.totalCost);
        });
        focusPrefix = "ppr";
        Object.keys(datasets).forEach(key => {
          if (key.split("-")[0] == "ppr") {
            var dataset = datasets[key];
            var data2 = [];
            dataset.data.forEach(d => {
              if (d.y > 0) {
                data2.push(d);
              }
            });
            dataset.data = data2;
          }
        });
      }

      var datas = [];
      Object.keys(datasets).forEach((key, index) => {
        datasets[key].hidden = localStorage["menuitems_dataset_" + key] == "true";
        datasets[key].key = key;
        if (!datasets[key].hidden) {
          datas.push(datasets[key]);
          yaxes.push(datasets[key].yAxisID);
        } else {
          if (!focus || key.split("-")[0] == focusPrefix) datas.push(datasets[key]);
        }
      });

      datas.sort(function (a, b) {
        var aid = a.key;
        var bid = b.key;
        var aa = a.key.split("-");
        var bb = b.key.split("-");
        var aMenuItem = aa.length == 3 ? aa[1] : null;
        var bMenuItem = bb.length == 3 ? bb[1] : null;
        if (aMenuItem == null && bMenuItem == null) return aid - bid;
        if (aMenuItem == null) return -1;
        if (bMenuItem == null) return 1;
        var r = menuItemIds.indexOf(Number(aMenuItem)) - menuItemIds.indexOf(Number(bMenuItem));
        if (r == 0) {
          return aa[2] - bb[2];
        } else {
          return r;
        }
      });

      applyNightChartDatasetColors(datas);

      if (myChart) myChart.destroy();
      myChart = new Chart(ctx, {
        type: "bar",
        data: {
          datasets: datas
        },
        events: {
          redraw: function () {
            ajaxCallEnd("processing");
          }
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          scales: {
            xAxes: [
              {
                type: "time",
                time: {
                  //parser: timeFormat,
                  tooltipFormat: "ll",
                  unit: $("[name='range']:checked").attr("id"),
                  //min: Number(localStorage.menuitems_start),
                  max: Number(localStorage.menuitems_end)
                },
                scaleLabel: {
                  display: true,
                  labelString: "Date"
                },
                gridLines: {
                  offsetGridLines: true
                },
                stacked: focus,
                barPercentage: 0.9,
                categoryPercentage: 1,
                offset: true
                //barThickness: '70%',
              }
            ],
            yAxes: [
              {
                type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                display: yaxes.indexOf("y-axis-1") >= 0 && !focus,
                position: "left",
                id: "y-axis-1",
                scaleLabel: {
                  display: !focus,
                  labelString: currentQuantityType
                },
                ticks: {
                  beginAtZero: true
                }
              },
              {
                type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                display: yaxes.indexOf("y-axis-3") >= 0,
                position: "left",
                id: "y-axis-3",
                stacked: true,
                scaleLabel: {
                  display: true,
                  labelString: currentQuantityType
                },
                ticks: {
                  beginAtZero: true
                }
              },
              {
                type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                display: yaxes.indexOf("y-axis-6") >= 0,
                position: "left",
                id: "y-axis-6",
                scaleLabel: {
                  display: true,
                  labelString: currentQuantityType
                },
                ticks: {
                  beginAtZero: true
                }
              },
              {
                //type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                display: yaxes.indexOf("y-axis-2") >= 0,
                position: "right",
                id: "y-axis-2",
                scaleLabel: {
                  display: true,
                  labelString: auth.myStatus.restaurant_base_currency.name
                },
                gridLines: {
                  drawOnChartArea: false
                },
                ticks: {
                  beginAtZero: true
                }
              },
              {
                //type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                display: yaxes.indexOf("y-axis-4") >= 0,
                position: "right",
                id: "y-axis-4",
                stacked: true,
                scaleLabel: {
                  display: true,
                  labelString: auth.myStatus.restaurant_base_currency.name
                },
                gridLines: {
                  drawOnChartArea: false
                }
              },
              {
                //type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                display: yaxes.indexOf("y-axis-5") >= 0,
                position: "right",
                id: "y-axis-5",
                stacked: false,
                scaleLabel: {
                  display: true,
                  labelString: "%"
                },
                gridLines: {
                  drawOnChartArea: true
                },
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var d = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].data;
                var dd = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                var key = data.datasets[tooltipItem.datasetIndex].key.split("-")[0];
                var label;
                switch (key) {
                  case "p": // ár
                  case "c": // költség
                  case "m": // árrés
                  case "mm": // árrés
                  case "pc":
                  case "o":
                  case "oo":
                  case "opc":
                    label = data.datasets[tooltipItem.datasetIndex].label + ":" + Math.round(tooltipItem.value * 1000) / 1000 + " " + auth.myStatus.restaurant_base_currency.name;
                    break;
                  case "k": // készlet
                  case "cc":
                  case "f": // forgalom
                  case "ff": // forgalom
                  case "kk": // forgalom
                  case "b": // bevét
                    label = data.datasets[tooltipItem.datasetIndex].label + ":" + Math.round(tooltipItem.value * 1000) / 1000 + " " + dd.currentQuantityType;
                    break;
                  case "i": // leltár
                    var label = [data.datasets[6].label + ":" + d.count];
                    if (d.count - d.originalCount > 0) label.push(I18n.t("admin_local.inventory_surplus") + ":" + (d.count - d.originalCount));
                    else if (d.count - d.originalCount < 0) label.push(I18n.t("admin_local.inventory_shortage") + ":" + (-d.count + d.originalCount));
                    //else label = data.datasets[tooltipItem.datasetIndex].label + ":" + Math.round(tooltipItem.value * 1000) / 1000 + " " + dd.currentQuantityType;
                    break;
                  case "ppr":
                  case "pr":
                    label = data.datasets[tooltipItem.datasetIndex].label + ":" + Math.round(tooltipItem.value * 1000) / 1000 + " %";
                    break;
                }
                return label;
              }
            }
          },
          legend: {
            labels: {
              filter: function (item, chart) {
                return true;
              }
            },
            onClick: function (e, legendItem) {
              var index = legendItem.datasetIndex;
              var key = datas[index].key.split("-")[0];
              var hidden = localStorage["menuitems_dataset_" + datas[index].key] == "true";

              if (key == "k" && !focus) {
                ["k", "f", "o", "p", "pr", "oo", "c"].forEach(i => {
                  localStorage["menuitems_dataset_" + i] = true;
                });
                localStorage["menuitems_dataset_" + datas[index].key] = !hidden;
                localStorage["menuitems_dataset_focus"] = hidden;
                drawChart();
                return;
              } else if (datasetsSelected == 1 && (key == "p" || key == "c" || key == "k") && !focus && !hidden) {
                localStorage["menuitems_dataset_focus"] = true;
                drawChart();
                return;
              } else if (isCategory == true && datasetsSelected == 1 && (key == "f" || key == "o") && !focus && !hidden) {
                localStorage["menuitems_dataset_focus"] = true;
                drawChart();
                return;
              }
              if (e.ctrlKey == true) {
                if (key != focusPrefix) {
                  //unhide all
                  datas.forEach(data => {
                    if (data.key.split("-")[0] == focusPrefix) localStorage["menuitems_dataset_" + data.key] = false;
                  });
                } else {
                  //hide all but the one selected
                  datas.forEach(data => {
                    if (data.key.split("-")[0] == focusPrefix) localStorage["menuitems_dataset_" + data.key] = true;
                  });
                  localStorage["menuitems_dataset_" + datas[index].key] = false;
                }
              } else if (key != focusPrefix && focus) {
                localStorage["menuitems_dataset_" + datas[index].key] = true;
                localStorage["menuitems_dataset_focus"] = false;
                drawChart();
                return;
              } else {
                localStorage["menuitems_dataset_" + datas[index].key] = !hidden;
              }
              drawChart();
            }
          }
        }
      });
    } finally {
      ajaxCallEnd("processing");
    }
  }, 20);
}

function getStore(id) {
  return admin.stores.find(store => store.id == id);
}

function getMonday(date) {
  var day = date.getDay() || 7;
  if (day !== 1) date.setHours(-24 * (day - 1));
  return date;
}

menuitemutil.parseNumber = function (number) {
  if (typeof number == "undefined") return "";
  if (typeof number == "number") return number;
  number = number.replace(" ", "");
  number = number.replace(",", ".");
  number = Number(number);
  return number;
};

function random_bg_color() {
  var x = Math.floor(Math.random() * 256);
  var y = Math.floor(Math.random() * 256);
  var z = Math.floor(Math.random() * 256);
  return "rgb(" + x + "," + y + "," + z + ")";
}

var quantityCache = {};
menuitemutil.getInventoryQuantity = function (menuItem, quantity) {
  var ret = quantityCache[menuItem.id + "-" + quantity];
  if (ret != undefined) return ret;
  menuItem.availableQuantities.forEach(q => {
    if (q.inventoryItem && q.quantity == quantity) ret = quantity;
  });
  if (ret != undefined && ret != "") {
    quantityCache[menuItem.id + "-" + quantity] = ret;
    return ret;
  }
  for (let i = menuItem.availableQuantities.length; i > 0; i--) {
    var q = menuItem.availableQuantities[i - 1];
    if (q.inventoryItem) ret = q.quantity;
  }
  if (ret == undefined) {
    if (menuItem.entityType == "Drink") ret = "1";
    else ret = "";
  }
  quantityCache[menuItem.id + "-" + quantity] = ret;
  return ret;
};

menuitemutil.updateQuantityType = (t, event) => {
  var newValue = $(t).val();
  var oldValue = $(t).data('oldValue');
  if (typeof newValue !== "string")
    newValue = newValue[0];
  if (oldValue && typeof oldValue !== "string")
    oldValue = oldValue[0];
  if (oldValue == newValue)
    return;
  $(t).data('oldValue', newValue);
  var newQuantityTypeQuantity = 1000;
  var oldQuantityTypeQuantity = 1000;
  switch (newValue) {
    case 'ml':
    case 'g':
      newQuantityTypeQuantity = 1;
      break;
    case 'cl':
    case 'dkg':
      newQuantityTypeQuantity = 10;
      break;
    case 'dl':
      newQuantityTypeQuantity = 100;
      break;
    case 'kg':
    case 'l':
      newQuantityTypeQuantity = 1000;
      break;
  }
  switch (oldValue) {
    case 'ml':
    case 'g':
      oldQuantityTypeQuantity = 1;
      break;
    case 'dkg':
    case 'cl':
      oldQuantityTypeQuantity = 10;
      break;
    case 'dl':
      oldQuantityTypeQuantity = 100;
      break;
    case 'kg':
    case 'l':
      oldQuantityTypeQuantity = 1000;
      break;
  }
  if (newValue)
    $('span.q_quantity_type').html(I18n.t('local.' + newValue))
  $('td input#menuItem_quantity').each((ind, e) => {
    e.value = Math.round(e.value * oldQuantityTypeQuantity / newQuantityTypeQuantity * 1000) / 1000;
  })
}

menuitemutil.syncQuantityTypeSelector = (modal) => {
  const container = modal.find("#quantityType");
  const select = modal.find("#quantityTypeSelect");
  if (!container.length || !select.length) return;

  const selected = select.val();
  const selectedValue = Array.isArray(selected) ? selected[0] : selected;
  container.find(".quantity-type-option").removeClass("active");
  if (selectedValue) {
    container.find('.quantity-type-option[data-value="' + selectedValue + '"]').addClass("active");
  }
  container.toggleClass("disabled", !!select.prop("disabled"));
};

menuitemutil.getQuantityType = (modal) => {
  const select = modal.find("#quantityTypeSelect");
  const selected = select.val();
  return Array.isArray(selected) ? selected[0] : selected;
};

menuitemutil.setQuantityType = (modal, value, triggerUpdate = false) => {
  const select = modal.find("#quantityTypeSelect");
  if (!select.length) return;
  select.val(value ? [value] : []);
  if (triggerUpdate) {
    menuitemutil.updateQuantityType(select.get(0));
  } else {
    select.data("oldValue", value || "");
  }
  menuitemutil.syncQuantityTypeSelector(modal);
};

menuitemutil.setQuantityTypeDisabled = (modal, disabled) => {
  const select = modal.find("#quantityTypeSelect");
  select.prop("disabled", !!disabled);
  menuitemutil.syncQuantityTypeSelector(modal);
};

function setupQuantityTypeSelector(modal) {
  const container = modal.find("#quantityType");
  const select = modal.find("#quantityTypeSelect");
  if (!container.length || !select.length) return;

  if (!container.find(".quantity-type-option").length) {
    const buttons = [];
    select.find("option").each(function () {
      const value = $(this).val();
      const label = $(this).text();
      buttons.push('<button type="button" class="quantity-type-option" data-value="' + value + '">' + label + '</button>');
    });
    container.html(buttons.join(""));
  }

  container.off("click.quantityType").on("click.quantityType", ".quantity-type-option", function () {
    if (container.hasClass("disabled")) return;
    const value = $(this).attr("data-value");
    select.val([value]);
    menuitemutil.updateQuantityType(select.get(0));
    menuitemutil.syncQuantityTypeSelector(modal);
  });

  menuitemutil.syncQuantityTypeSelector(modal);
}

menuitemutil.generateBarCode = (e) => {
  const v = $(e).val();
  if (v)
    JsBarcode($(e).next().get(0), v, { height: 30 });
  else
    $(e).next().attr('src', '');
}

menuitemutil.scanbarcode = (e) => {
  //eslint-disable-next-line no-undef
  const cor = cordova;
  cor.plugins.barcodeScanner.scan(
    function (result) {
      if (!result.cancelled) {
        if (!isNaN(result.text)) {
          $(e).next().val(result.text);
          //qrcode_callback(result.text);
        }
      }
      if (cor.plugins.backgroundMode)
        setTimeout(() => { cor.plugins.backgroundMode.enableOverrideBackButton = true }, 1000);
    },
    function (error) {
      alert("Scanning failed: " + error);
      if (cor.plugins.backgroundMode)
        setTimeout(() => { cor.plugins.backgroundMode.enableOverrideBackButton = true }, 1000);
    }
  );
}

function getMenuItemAdditions(item) {
  const additions = [];
  if (item.menuItemAdditions) {
    item.menuItemAdditions.filter(addition => addition.additionType === "mandatory" || addition.additionType === "included").forEach(a => {
      additions.push(a)
    }
    );
  }
  if (item.menuCategoryId) {
    const parentCategory = getMenuCategory(item);
    if (parentCategory)
      getMenuItemAdditions(parentCategory).forEach(a => additions.push(a));
    else {
      getMenuCategory(item);
    }
  }

  return additions;
}

function isOnTop(item) {
  if (item.menuCategoryId)
    return item.isTop && isOnTop(getMenuCategory(item));
  else
    return item.isTop;

}
function isOnKiosk(item) {
  if (item.menuCategoryId)
    return item.kiosk && isOnKiosk(getMenuCategory(item));
  else
    return item.kiosk;

}

export const getPlaces = (platform) => {
  return auth.myStatus.restaurant_settings["enabled-features"][platform]?.places || []
}

export const refreshConnectedRestaurants = (globalId, refresh = false) => {
  var def = $.Deferred();
  if (!featureEnabled('franchize')) {
    def.resolve();
    return def.promise();
  }
  $(".connectedRestaurant").show();
  const unselected = hasRole("administration.products.fullaccess") ? menuitemutil.getAvaiableConnectedRestaurants().filter(id => localStorage['restaurant_copy_selected_' + id] != 'true') : [];
  const selected = hasRole("administration.products.fullaccess") ? menuitemutil.getAvaiableConnectedRestaurants().filter(id => localStorage['restaurant_copy_selected_' + id] == 'true') : [];
  if (menuitemutil.getAvaiableConnectedRestaurants().filter(id => localStorage['restaurant_copy_selected_' + id] == 'true').length - unselected.length <= 0) {
    $(".connectedRestaurants").hide();
  } else {
    $(".connectedRestaurants").show();
  }
  unselected.forEach(id => {
    $(".connectedRestaurant_" + id).hide();
  })
  const connectedRestaurantCount = menuitemutil.getAvaiableConnectedRestaurants().filter(id => localStorage['restaurant_copy_selected_' + id] == 'true').length;
  selected.forEach((id, ind) => {
    $(".connectedRestaurant_" + id).show();
    $(".connectedRestaurant_" + id).css("--col", connectedRestaurantCount - ind - 1);
  })
  if (globalId) {
    delete connectedRestaurants[globalId];
  } else
    connectedRestaurants = {};
  var count = selected.map(id => menuitemutil.getRestaurant(id)).filter(r => !globalId || globalId == r.globalId).length;
  //connectedRestaurants = { 0: { restaurant: {}, data: { data: children : admin.categories } } };
  selected.map(id => menuitemutil.getRestaurant(id)).filter(r => !globalId || globalId == r.globalId).forEach(restaurant => {
    function getMenuItems() {
      menuitemutil.getLocalFromGlobal(restaurant).done(id => {
        get(restaurant.serverUrl +
          "eatwithme.server/" + restaurant.instance + "/restaurantService/" + id + "/getMenuItems?" + (typeof lang === "undefined" ? "" : "lang=" + localStorage.language) + "&deleted=" + false + "&active=" + false + "&instance=" + restaurant.instance, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false
        ).done(function (data) {
          restaurant.localId = id;
          connectedRestaurants[restaurant.globalId] = {
            restaurant,
            data
          };
          count--;
          if (!count) {
            if (refresh)
              processMenuItems(admin.adminCategories);
            def.resolve();
          }
        }).fail(data => {
          auth.ajaxError = false;
          login();
        });
      }).fail(data => {
        auth.ajaxError = false;
        login();
      });
    }
    /* make login executed only when the previous login is finished, to avoid multiple parallel logins when multiple restaurants are connected */
    function login() {
      if (menuitemutil.loginInProgress) {
        setTimeout(login, 300);
        return;
      }
      menuitemutil.loginInProgress = true;
      getGlobal("login/getLoginTokenNew/" + restaurant.globalId + "?l=menuitem").done(token => {
      //var loginUrl = serv + "/eatwithme.server/login?token=" + encodeURIComponent(token.token) + "&globalId=" + (restaurant.globalId ? restaurant.globalId : 0) + "&localId=" + (restaurant.id ? restaurant.id : 0) + "&user=true";
        //get(loginUrl, undefined, undefined, 30000)
        post(restaurant.serverUrl + "eatwithme.server/" + restaurant.instance + "/login?instance=" + restaurant.instance, "username=" + encodeURIComponent("authtoken:" + restaurant.globalId + "/" + token.token) + "&password=" + encodeURIComponent(token.token) + "&user=true", {}, true, 0, false, 30000).done(() => {
          menuitemutil.loginInProgress = false;
          getMenuItems();
        }).fail(data => {
          menuitemutil.loginInProgress = false;
          auth.ajaxError = false;
        });
      })
    }
    getMenuItems();
  });
  if (!count) {
    $("#root > div:not(.menuItemHeader)").removeClass("synchronizingPrice");
    $("#root > div:not(.menuItemHeader)").removeClass("syncronizing");
    if (admin?.categories?.children)
      processMenuItems({ children: admin.categories.children });
    def.resolve();
  } else {
    $("#root > div:not(.menuItemHeader)").addClass("syncronizing");
  }
  if (menuitemutil.synchronizeProperties.includes("price") && menuitemutil.synchronizeProperties.length === 1) {
    $("#root > div:not(.menuItemHeader)").addClass("synchronizingPrice");
  } else {
    $("#root > div:not(.menuItemHeader)").removeClass("synchronizingPrice");
  }
  return def.promise();
}

export const toggleAllergen = ({ currentTarget }) => {
  var has = $(currentTarget).hasClass("has");
  var removable = $(currentTarget).hasClass("removable");
  if (has) {
    if (removable) {
      $(currentTarget).removeClass("has");
      $(currentTarget).removeClass("removable");
    } else {
      $(currentTarget).addClass("removable");
    }
  } else {
    $(currentTarget).addClass("has");
  }
}

/**
 * Generates and downloads a scale file with 999 rows, formatted for ASC import.
 * Each row corresponds to a menuitem with a barcode, formatted as:
 * <barcode>;<name>;<price>;<quantity>;<unit>
 * Barcodes are matched from menuitemutil.barcodes and menuitems.
 * The file is saved as scale_asc.txt.
 */
menuitemutil.downloadScaleASC = () => {
  // Ensure barcodes and menuitems are loaded
  const menuItems = menuitemutil.getFlatMenuItems();
  const rows = [];
  let count = 0;

  // Helper to find menuitem by barcode id
  function findMenuItemByBarcode(barcodeId) {
    return menuItems.find(item =>
      item.barcodes && item.barcodes.some(b => b.id == barcodeId || String(b.id) == String(barcodeId))
    );
  }

  for (let barcode = 1; barcode <= 999; barcode++) {
    const menuItem = findMenuItemByBarcode(barcode);
    const barcodeSrc = barcode.toString().padStart(6, '0');
    const barcodeSrc2 = barcode.toString().padStart(8, '0');
    let nameSrc, priceSrc;
    if (menuItem) {
      // Find the quantity object with the matching barcode
      const quantityObj = menuItem.availableQuantities.find(q => q.barcode == barcode || q.barcode == String(barcode));
      let name = getLocale(menuItem.name);
      name = name.normalize('NFC');
      // Truncate or pad name to 22 chars (exact spacing)
      nameSrc = name.length > 22 ? name.substring(0, 22) : name.padEnd(22, ' ');
      let price = quantityObj && quantityObj.price ? quantityObj.price : menuItem.unitPrice || 0;
      price = Math.round(Number(price));
      priceSrc = price.toString().padStart(6, '0');
      // Format: S 00 <barcode> 0 0 <name> <price> 00 <barcodeSrc2>
      rows.push(`S 00 ${barcodeSrc} 0 0 ${nameSrc} ${priceSrc} 00 ${barcodeSrc2}`);
    } else {
      nameSrc = ''.padEnd(22, ' ');
      priceSrc = '0'.padStart(6, '0');
      rows.push(`S 00 ${barcodeSrc} 0 0 ${nameSrc} ${priceSrc} 00 ${barcodeSrc2}`);
    }
  }

  // Join rows with Windows CRLF (\r\n)
  const fileContent = rows.join('\r\n');
  // Use latin1 encoding for binary compatibility
  function encodeLatin1(str) {
    return new Uint8Array([...str].map(c => c.charCodeAt(0) < 256 ? c.charCodeAt(0) : 63));
  }
  const uint8array = encodeLatin1(fileContent);
  const blob = new Blob([uint8array], { type: 'application/octet-stream' });
  saveAs(blob, 'PLCW.ASC');
}

menuitemutil.getAvaiableConnectedRestaurants = () => {
  return auth.myStatus.restaurant_copies.filter(r => menuitemutil?.props?.restaurants && menuitemutil.props.restaurants.find(rr => rr.globalId == r));
}

menuitemutil.selectNodeByName = (tree = menuitemutil.menuItems, name) => {
  let node = null;

  // 1. find node (search in full tree, not only visible part)
  tree.visit(function (n) {
    if (n.title === name) {
      node = n;
      return false; // stop iteration
    }
  });

  if (!node) {
    console.warn("Node not found:", name);
    return;
  }

  // 2. expand all parents until root
  let p = node.parent;
  while (p && p.key !== "root") {
    p.setExpanded(true);
    p = p.parent;
  }

  // 3. make sure tree renders updated visibility
  tree.render(true);

  // 4. now select + scroll
  node.setActive(true);
  node.setFocus(true);
  node.makeVisible();
}

export default menuitemutil;
